'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var web = require('@dls/web');
var styled = require('styled-components');
var ReactDOM = require('react-dom');
var helpers = require('@wec-core/helpers');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n["default"] = e;
    return Object.freeze(n);
}

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var ReactDOM__default = /*#__PURE__*/_interopDefaultLegacy(ReactDOM);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var AddGeneric_1$1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const AddGeneric = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  d: "M12.75 11.25H16c.41 0 .75.34.75.75s-.34.75-.75.75h-3.25V16c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-3.25H8c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3.25V8c0-.41.34-.75.75-.75s.75.34.75.75z"
}), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M1 12C1 5.93 5.93 1 12 1s11 4.93 11 11-4.93 11-11 11S1 18.07 1 12m1.5 0c0 5.24 4.26 9.5 9.5 9.5s9.5-4.26 9.5-9.5-4.26-9.5-9.5-9.5S2.5 6.76 2.5 12",
  clipRule: "evenodd"
}));
exports.default = AddGeneric;
AddGeneric.displayName = 'AddGeneric';
});

unwrapExports(AddGeneric_1$1);

var AddonProduct_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const AddonProduct = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  d: "M15 9h3.25c.41 0 .75.34.75.75s-.34.75-.75.75H15v3.25c0 .41-.34.75-.75.75s-.75-.34-.75-.75V10.5h-3.25c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3.25V5.75c0-.41.34-.75.75-.75s.75.34.75.75z"
}), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M7.39 1h13.73c1.04 0 1.89.85 1.89 1.89v13.73c0 1.04-.85 1.89-1.89 1.89h-2.61v2.61c0 1.04-.85 1.89-1.89 1.89H2.89c-1.04 0-1.89-.85-1.89-1.89V7.39c0-1.04.85-1.89 1.89-1.89H5.5V2.89C5.5 1.85 6.35 1 7.39 1m9.22 20.5c.22 0 .39-.18.39-.39V18.5H7.39c-1.04 0-1.89-.85-1.89-1.89V7H2.89a.39.39 0 0 0-.39.39v13.72c0 .22.18.39.39.39zm4.5-4.5c.22 0 .39-.18.39-.39h.01V2.89a.39.39 0 0 0-.39-.39H7.39a.39.39 0 0 0-.39.39v13.72c0 .22.18.39.39.39z",
  clipRule: "evenodd"
}));
exports.default = AddonProduct;
AddonProduct.displayName = 'AddonProduct';
});

unwrapExports(AddonProduct_1);

var Announcement_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Announcement = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: props.color || "#222222",
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.64 3.74c-.09 0-.19-.02-.28-.06l-.01.01a.746.746 0 0 1-.41-.98l.36-.87c.16-.39.6-.57.98-.41.39.16.57.6.41.98l-.36.87c-.12.29-.4.46-.69.46"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M14.85 1.85c.5.04.94.33 1.17.78l.02-.01 4.81 9.41c.24.46.21.99-.06 1.43-.28.44-.75.71-1.27.68-1.46-.04-4.05.07-6.48.99l3.05 3.63c.86 1.04.79 2.53-.16 3.48-.49.49-1.14.76-1.83.76s-1.34-.27-1.83-.76l-4.49-4.49-1.37.7c-.31.15-.63.23-.96.23-.22 0-.44-.03-.65-.1a2.08 2.08 0 0 1-1.23-1.04l-2.24-4.38c-.26-.5-.3-1.06-.13-1.6s.54-.97 1.04-1.23l5.51-2.82.02-.011c.286-.158 3.526-1.941 5.8-5.059.3-.41.78-.63 1.28-.59M5.26 17.16c.15.05.32.03.46-.04l4.84-2.48-2.79-5.46-4.84 2.48a.6.6 0 0 0-.3.35c-.05.15-.03.32.04.46l2.24 4.39c.07.14.2.25.35.3m8.06 4.02c.41.41 1.12.41 1.53 0 .4-.4.43-1.03.07-1.46l-3.31-3.94-2.44 1.25zM9.08 8.47l2.83 5.52c2.84-1.24 5.95-1.38 7.63-1.34l-4.83-9.28c-1.93 2.66-4.46 4.39-5.63 5.1",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "m22.3 8.05-.92-.07a.756.756 0 0 0-.8.69c-.03.41.28.77.69.8l.92.07h.06c.39 0 .72-.3.75-.69a.75.75 0 0 0-.69-.8zM20.09 6.55c-.27 0-.54-.15-.67-.41a.76.76 0 0 1 .33-1.01l1.78-.91c.37-.18.82-.04 1.01.33.18.37.04.82-.33 1.01l-1.78.91c-.11.05-.22.08-.34.08"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "white",
  d: "M0 0h24v24H0z"
}))));
exports.default = Announcement;
Announcement.displayName = 'Announcement';
});

unwrapExports(Announcement_1);

var Attachment_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Attachment = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  d: "M9.28 22.79a6.86 6.86 0 0 1-4.88-2.03 6.86 6.86 0 0 1-2.01-4.88c0-1.84.73-3.57 2.03-4.86l8.35-8.3c.98-.97 2.28-1.51 3.66-1.51h.01c1.38 0 2.69.55 3.66 1.53 2.02 2.03 2.01 5.32-.02 7.33l-7.66 7.62c-.66.65-1.53 1.01-2.45 1.01a3.486 3.486 0 0 1-2.45-5.95l5.22-5.19c.29-.29.77-.29 1.06 0s.29.77 0 1.06l-5.22 5.19c-.77.77-.78 2.03 0 2.8.37.38.87.58 1.4.58s1.02-.21 1.4-.58l7.66-7.62a3.68 3.68 0 0 0 .01-5.21 3.68 3.68 0 0 0-2.6-1.09c-.98 0-1.9.38-2.6 1.07l-8.37 8.32a5.4 5.4 0 0 0-1.59 3.81c0 1.44.55 2.79 1.57 3.81a5.387 5.387 0 0 0 7.62.02l5.93-5.9c.29-.29.77-.29 1.06 0s.29.77 0 1.06l-5.93 5.9c-1.34 1.33-3.1 2-4.86 2z"
}));
exports.default = Attachment;
Attachment.displayName = 'Attachment';
});

unwrapExports(Attachment_1);

var Attention_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Attention = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  d: "M12 14c-.41 0-.75-.34-.75-.75v-6c0-.41.34-.75.75-.75s.75.34.75.75v6c0 .41-.34.75-.75.75M12 18.04a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
}), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M1 12c0 6.07 4.93 11 11 11s11-4.93 11-11S18.07 1 12 1 1 5.93 1 12m1.5 0c0-5.24 4.26-9.5 9.5-9.5s9.5 4.26 9.5 9.5-4.26 9.5-9.5 9.5-9.5-4.26-9.5-9.5",
  clipRule: "evenodd"
}));
exports.default = Attention;
Attention.displayName = 'Attention';
});

unwrapExports(Attention_1);

var Bills_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Bills = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  d: "M11.47 15.257c-1.504-.12-3.011-1.118-3.03-2.877 0-.41.33-.75.74-.76.41 0 .75.33.75.74.01 1.03 1.11 1.41 1.84 1.41.79 0 1.57-.05 1.98-.45.33-.31.4-.84.18-1.22-.29-.48-.94-.73-1.59-.93l-.86-.24c-1-.28-2.11-.67-2.71-1.67-.59-.98-.41-2.28.43-3.08.648-.62 1.546-.793 2.27-.841V4.83c0-.41.34-.75.75-.75s.75.34.75.75v.565c1.341.266 2.563 1.232 2.58 2.815 0 .41-.33.75-.74.76-.41 0-.75-.33-.75-.74-.01-.948-.941-1.345-1.659-1.403a.74.74 0 0 1-.385-.006c-.718.01-1.401.083-1.776.449-.33.31-.4.84-.18 1.22.32.53 1.08.78 1.83 1l.87.24c.91.27 1.91.67 2.46 1.6.59.98.41 2.27-.43 3.08-.52.496-1.198.706-1.82.795v.585c0 .41-.34.75-.75.75s-.75-.34-.75-.75zM8.74 19.83h6.52c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H8.74c-.41 0-.75.34-.75.75s.34.75.75.75"
}), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M21.45 2.47h.8c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H1.75c-.41 0-.75.34-.75.75s.34.75.75.75h.8v17.77c0 1.54 1.25 2.79 2.79 2.79h13.32c1.54 0 2.79-1.25 2.79-2.79zm-1.5 0H4.05v17.77c0 .71.58 1.29 1.29 1.29h13.32c.71 0 1.29-.58 1.29-1.29z",
  clipRule: "evenodd"
}));
exports.default = Bills;
Bills.displayName = 'Bills';
});

unwrapExports(Bills_1);

var Bookmark_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Bookmark = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  d: "M5.41 22.71c-.21 0-.41-.05-.6-.17-.36-.21-.58-.59-.58-1.01V4.22c0-1.62 1.32-2.93 2.93-2.93h9.66c1.62 0 2.93 1.32 2.93 2.93V21.5c0 .42-.22.8-.58 1.01s-.8.22-1.17.02l-5.61-3.08a.83.83 0 0 0-.81 0l-5.61 3.11c-.18.1-.38.15-.57.15zM7.17 2.79c-.79 0-1.43.64-1.43 1.43v16.76l5.14-2.84c.71-.39 1.55-.39 2.26 0l5.13 2.82V4.22c0-.79-.64-1.43-1.43-1.43z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "white",
  d: "M0 0h24v24H0z"
}))));
exports.default = Bookmark;
Bookmark.displayName = 'Bookmark';
});

unwrapExports(Bookmark_1);

var BroadbandAddon_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const BroadbandAddon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  d: "M13.685 5.64h.005-.01zM14.25 5.38a.76.76 0 0 1-.565.26.76.76 0 0 1-.485-.18c-1.51-1.29-3.43-2-5.41-2s-3.86.7-5.35 1.96c-.32.27-.79.23-1.06-.09a.75.75 0 0 1 .09-1.06 9.82 9.82 0 0 1 6.32-2.31c2.31 0 4.61.84 6.38 2.36.31.27.35.74.08 1.06"
}), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  d: "M11.46 7.84c.14.13.33.2.51.2h.01c.2 0 .4-.08.55-.24.28-.3.26-.78-.04-1.06A6.92 6.92 0 0 0 7.8 4.89c-1.72 0-3.37.64-4.64 1.8-.31.28-.33.75-.05 1.06s.76.33 1.06.05c.99-.91 2.25-1.41 3.62-1.41s2.67.52 3.67 1.45"
}), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  d: "M10.22 10.44c-.21 0-.42-.09-.57-.26-.92-1.08-2.74-1.09-3.68-.04-.28.31-.75.34-1.06.06a.747.747 0 0 1-.06-1.06A3.95 3.95 0 0 1 7.8 7.82c1.13 0 2.25.5 3 1.38.27.32.23.79-.08 1.06-.14.12-.31.18-.49.18zM16.37 14.1h-1.31c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h1.31v-1.31c0-.41.34-.75.75-.75s.75.34.75.75v1.31h1.32c.41 0 .75.34.75.75s-.34.75-.75.75h-1.32v1.32c0 .41-.34.75-.75.75s-.75-.34-.75-.75z"
}), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M8.54 11.7v1.19h2.93a5.673 5.673 0 0 1 5.65-5.2 5.67 5.67 0 0 1 5.666 5.876l.004.074v7.66c0 .41-.34.75-.75.75H1.97c-.41 0-.75-.34-.75-.75v-7.66c0-.41.34-.75.75-.75h5.07V11.7c0-.41.34-.75.75-.75s.75.34.75.75m12.75 5.5a5.66 5.66 0 0 1-4.17 1.83 5.674 5.674 0 0 1-5.577-4.64H2.72v6.16h18.57zm-8.34-3.84c0-2.3 1.87-4.17 4.17-4.17s4.17 1.87 4.17 4.17-1.87 4.17-4.17 4.17-4.17-1.87-4.17-4.17",
  clipRule: "evenodd"
}));
exports.default = BroadbandAddon;
BroadbandAddon.displayName = 'BroadbandAddon';
});

unwrapExports(BroadbandAddon_1);

var Broadband_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Broadband = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  d: "M13.69 5.64h-.005a.76.76 0 0 0 .565-.26c.27-.32.23-.79-.08-1.06a9.87 9.87 0 0 0-6.38-2.36c-2.31 0-4.55.82-6.32 2.31-.32.27-.36.74-.09 1.06s.75.36 1.06.09a8.26 8.26 0 0 1 5.35-1.96c1.98 0 3.9.71 5.41 2a.76.76 0 0 0 .485.18h-.005z"
}), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  d: "M11.97 8.04c-.18 0-.37-.07-.51-.2-1-.93-2.3-1.45-3.67-1.45s-2.63.5-3.62 1.41c-.3.28-.78.26-1.06-.05a.746.746 0 0 1 .05-1.06 6.87 6.87 0 0 1 4.64-1.8c1.72 0 3.41.66 4.69 1.85.3.28.32.76.04 1.06-.15.16-.35.24-.55.24z"
}), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  d: "M9.65 10.18c.15.17.36.26.57.26h.01c.18 0 .35-.06.49-.18.31-.27.35-.74.08-1.06a3.97 3.97 0 0 0-3-1.38c-1.13 0-2.2.48-2.95 1.32-.28.31-.25.78.06 1.06s.78.25 1.06-.06c.94-1.05 2.76-1.04 3.68.04M14.52 18.49a1 1 0 1 0 0-2 1 1 0 0 0 0 2M19.11 17.49a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M8.54 12.89V11.7c0-.41-.34-.75-.75-.75s-.75.34-.75.75v1.19H2.97c-.96 0-1.75.79-1.75 1.75v5.66c0 .96.79 1.75 1.75 1.75h18.07c.96 0 1.75-.79 1.75-1.75v-5.66c0-.96-.79-1.75-1.75-1.75zm-5.82 1.74c0-.14.11-.25.25-.25h18.07c.14 0 .25.11.25.25v5.66c0 .14-.11.25-.25.25H2.97c-.14 0-.25-.11-.25-.25z",
  clipRule: "evenodd"
}));
exports.default = Broadband;
Broadband.displayName = 'Broadband';
});

unwrapExports(Broadband_1);

var Calendar_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Calendar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  d: "M6.65 14.39a1 1 0 1 0 0-2 1 1 0 0 0 0 2M13 13.39a1 1 0 1 1-2 0 1 1 0 0 1 2 0M17.35 14.39a1 1 0 1 0 0-2 1 1 0 0 0 0 2M7.65 18.18a1 1 0 1 1-2 0 1 1 0 0 1 2 0M12 19.18a1 1 0 1 0 0-2 1 1 0 0 0 0 2M18.35 18.18a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M15.25 3.01H8.7v-.89c0-.41-.34-.75-.75-.75s-.75.34-.75.75v.89H4.02c-1.52 0-2.75 1.23-2.75 2.75v14.12c0 1.52 1.23 2.75 2.75 2.75h15.92c1.52 0 2.75-1.23 2.75-2.75V5.76c0-1.52-1.23-2.75-2.75-2.75h-3.19v-.89c0-.41-.34-.75-.75-.75s-.75.34-.75.75zm-7.3 3.34c-.41 0-.75-.34-.75-.75V4.51H4.02c-.69 0-1.25.56-1.25 1.25v2.73h18.42V5.76c0-.69-.56-1.25-1.25-1.25h-3.19V5.6c0 .41-.34.75-.75.75s-.75-.34-.75-.75V4.51H8.7V5.6c0 .41-.34.75-.75.75M2.77 9.99h18.42v9.89c0 .69-.56 1.25-1.25 1.25H4.02c-.69 0-1.25-.56-1.25-1.25z",
  clipRule: "evenodd"
}));
exports.default = Calendar;
Calendar.displayName = 'Calendar';
});

unwrapExports(Calendar_1);

var CallBack_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const CallBack = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M16.47 14.79c-4 0-7.25-3.25-7.25-7.25S12.47.29 16.47.29s7.25 3.25 7.25 7.25-3.25 7.25-7.25 7.25m0-13c-3.17 0-5.75 2.58-5.75 5.75s2.58 5.75 5.75 5.75 5.75-2.58 5.75-5.75-2.58-5.75-5.75-5.75m-.46 21.92c-.06 0-.13 0-.19-.01-1.84-.21-3.57-.64-5.14-1.28h-.01l-.88-.37.02-.02c-4.13-1.96-6.46-5.16-7.75-7.82l-.02.02-.37-.88v-.01A18.6 18.6 0 0 1 .31 8.16c-.05-.47.1-.94.42-1.29.33-.36.8-.57 1.29-.57h1.19c.8 0 1.5.54 1.7 1.32l.65 2.61c.17.68-.08 1.39-.63 1.81L3.3 13.28c1.17 2.54 3.38 5.68 7.44 7.52l1.25-1.67c.42-.57 1.14-.82 1.83-.65l2.6.65c.78.2 1.33.89 1.33 1.7v1.15c0 .5-.21.97-.58 1.3-.31.28-.72.43-1.13.43zm-3.85-2.34c1.19.4 2.47.68 3.82.83.06 0 .11 0 .15-.05.03-.03.08-.08.08-.18v-1.15c0-.11-.08-.21-.19-.24l-2.6-.65c-.1-.02-.2.01-.26.09zM2 7.79c-.07 0-.13.03-.17.07-.044.044-.042.096-.04.121v.01c.1.92.34 2.279.9 3.849l1.3-1c.08-.06.11-.16.09-.26l-.65-2.61a.255.255 0 0 0-.24-.19H2zm13.97 1h3c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-2.25V5.04c0-.41-.34-.75-.75-.75s-.75.34-.75.75v3c0 .41.34.75.75.75",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "white",
  d: "M0 0h24v24H0z"
}))));
exports.default = CallBack;
CallBack.displayName = 'CallBack';
});

unwrapExports(CallBack_1);

var Camera_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Camera = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M6.91 12.95c0 2.81 2.28 5.09 5.09 5.09s5.09-2.28 5.09-5.09S14.81 7.86 12 7.86s-5.09 2.28-5.09 5.09m1.5 0c0-1.98 1.61-3.59 3.59-3.59s3.59 1.61 3.59 3.59-1.61 3.59-3.59 3.59-3.59-1.61-3.59-3.59",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M4.05 21.41h15.9l.01.01c1.5 0 2.72-1.22 2.72-2.72V8.58c0-1.44-1.17-2.61-2.61-2.61h-2.3l-1.62-2.44c-.38-.58-1.03-.93-1.72-.93H9.37c-.69 0-1.33.34-1.71.92L6.04 5.96h-2.1c-1.44 0-2.61 1.17-2.61 2.61v10.12c0 1.5 1.22 2.72 2.72 2.72M2.83 8.57c0-.61.5-1.11 1.11-1.11l-.01.01h2.21c.44 0 .84-.22 1.08-.58L8.9 4.35c.1-.16.27-.25.46-.25h5.06c.18 0 .36.09.46.25l1.68 2.52c.24.37.65.59 1.09.59h2.41c.61 0 1.11.5 1.11 1.11v10.12c0 .67-.55 1.22-1.22 1.22H4.05c-.67 0-1.22-.55-1.22-1.22z",
  clipRule: "evenodd"
}));
exports.default = Camera;
Camera.displayName = 'Camera';
});

unwrapExports(Camera_1);

var Cart_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Cart = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M9.41 17.95h11.54c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H9.41c-1.188 0-1.65-1.53-1.804-2.265l11.704-.335c3.31-.43 3.31-3.59 3.31-5.69V5.13c0-.41-.34-.75-.75-.75H5.775L5.49 2.86a.76.76 0 0 0-.74-.61H2.12c-.41 0-.75.34-.75.75s.34.75.75.75h2.01l.274 1.457q.006.06.022.117l1.535 8.167a.7.7 0 0 0 .036.195l.063.334c.16 1.46 1.06 3.93 3.35 3.93m-2.08-5.268 11.87-.332c1.79-.23 1.92-1.74 1.92-4.19V5.88H6.056z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  d: "M9.89 22.07a1.25 1.25 0 1 1 0-2.501 1.25 1.25 0 0 1 0 2.5M17.97 20.82a1.25 1.25 0 1 0 2.5-.001 1.25 1.25 0 0 0-2.5 0"
}));
exports.default = Cart;
Cart.displayName = 'Cart';
});

unwrapExports(Cart_1);

var CartActive_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const CartActive = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#E71336",
  d: "M20 6.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
}), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M13.778 5.88a6.5 6.5 0 0 1-.267-1.5H5.775L5.49 2.86a.76.76 0 0 0-.74-.61H2.12c-.41 0-.75.34-.75.75s.34.75.75.75h2.01l.274 1.457q.006.06.022.117l1.535 8.167a.7.7 0 0 0 .036.195l.063.334c.16 1.46 1.06 3.93 3.35 3.93h11.54c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H9.41c-1.188 0-1.65-1.53-1.804-2.265l11.704-.335c2.438-.317 3.08-2.114 3.25-3.878a6.4 6.4 0 0 1-1.562.451c-.186 1.108-.652 1.78-1.798 1.927l-11.87.332L6.057 5.88zM9.89 22.07a1.25 1.25 0 1 1 0-2.501 1.25 1.25 0 0 1 0 2.5m9.33 0a1.25 1.25 0 1 1 0-2.501 1.25 1.25 0 0 1 0 2.5",
  clipRule: "evenodd"
}));
exports.default = CartActive;
CartActive.displayName = 'CartActive';
});

unwrapExports(CartActive_1);

var Cash_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Cash = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M11.65 3.647V2.09c0-.41.34-.75.75-.75s.75.34.75.75v1.596c2.354.282 4.624 1.865 4.66 4.574 0 .41-.33.75-.74.76-.41 0-.74-.33-.75-.74-.03-2.04-2.04-3.14-3.92-3.14-1.54 0-3.08.12-3.97.97-.79.76-.98 2.03-.42 2.95.69 1.15 2.18 1.65 3.64 2.07l1.57.43c1.52.46 3.18 1.12 4.08 2.61.9 1.51.61 3.58-.67 4.81-.966.926-2.318 1.235-3.48 1.338v1.592c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-1.54h-.05c-2.6 0-5.38-1.62-5.42-4.62 0-.41.33-.75.74-.76.44-.02.75.33.76.74.03 2.04 2.04 3.14 3.92 3.14 1.54 0 3.08-.12 3.97-.97.79-.76.98-2.03.42-2.95-.63-1.05-1.91-1.55-3.2-1.94l-1.56-.43c-1.68-.48-3.55-1.12-4.52-2.74-.9-1.51-.61-3.58.67-4.81 1.196-1.147 2.984-1.347 4.27-1.383",
  clipRule: "evenodd"
}));
exports.default = Cash;
Cash.displayName = 'Cash';
});

unwrapExports(Cash_1);

var Category_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Category = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M4.26 7.24c-1.65 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3m0-4.49c-.82 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5m7.72 4.49c-1.65 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3m0-4.49c-.82 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5m4.73 1.49c0 1.66 1.35 3 3 3 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3m1.5.01c0-.83.68-1.5 1.5-1.5.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5M4.29 14.97c-1.65 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3m0-4.49c-.82 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5m4.73 1.49c0 1.66 1.35 3 3 3 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3m1.5.01c0-.83.68-1.5 1.5-1.5.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5m9.22 2.99c-1.65 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3m0-4.49c-.82 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5M1.26 19.76a3 3 0 0 0 3 2.99c1.66 0 3-1.33 3-2.99s-1.34-3-3-3-3 1.35-3 3m1.5 0c0-.83.68-1.5 1.5-1.5.83 0 1.5.68 1.5 1.5s-.67 1.49-1.5 1.49-1.5-.66-1.5-1.49m9.22 2.99a3 3 0 0 1-3-2.99c0-1.65 1.34-3 3-3s3 1.34 3 3-1.34 2.99-3 2.99m0-4.49c-.82 0-1.5.67-1.5 1.5s.67 1.49 1.5 1.49 1.5-.67 1.5-1.49-.67-1.5-1.5-1.5m4.73 1.5a3 3 0 0 0 3 2.99c1.65 0 2.99-1.33 2.99-2.99s-1.33-3-2.99-3-3 1.35-3 3m1.5 0c0-.83.68-1.5 1.5-1.5s1.49.68 1.49 1.5-.66 1.49-1.49 1.49-1.5-.66-1.5-1.49",
  clipRule: "evenodd"
}));
exports.default = Category;
Category.displayName = 'Category';
});

unwrapExports(Category_1);

var Chart_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Chart = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M2.05 22.02h19.89c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H2.8V2.72c0-.41-.34-.75-.75-.75s-.75.34-.75.75v18.55c0 .41.34.75.75.75M21.2 10.57c0 .41.34.75.75.75s.75-.34.75-.75V6.82a.755.755 0 0 0-.871-.74H18.2c-.41 0-.75.34-.75.75s.34.75.75.75h1.893l-5.383 5.27-3.12-3.17a.75.75 0 0 0-.53-.22.7.7 0 0 0-.53.22l-6.01 5.95c-.29.29-.29.77 0 1.06.14.15.34.22.53.22l-.02.01c.19 0 .38-.08.53-.22l5.48-5.42 3.12 3.17c.29.28.77.29 1.06 0l5.98-5.856z",
  clipRule: "evenodd"
}));
exports.default = Chart;
Chart.displayName = 'Chart';
});

unwrapExports(Chart_1);

var Checklist_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Checklist = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M1.24 4.91a3.08 3.08 0 0 0 3.08 3.07c1.7 0 3.08-1.37 3.08-3.07S6.02 1.83 4.32 1.83 1.24 3.22 1.24 4.91m1.5 0c0-.87.71-1.58 1.58-1.58s1.58.72 1.58 1.58a1.581 1.581 0 0 1-3.16 0",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  d: "M3.15 21.95c.14.14.35.19.53.22v-.01c.2 0 .39-.08.53-.22l2.71-2.69c.29-.29.29-.77 0-1.06a.754.754 0 0 0-1.06 0l-2.18 2.16-.92-.93a.754.754 0 0 0-1.06 0c-.29.29-.29.77 0 1.06z"
}), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M4.32 15.56c-1.7 0-3.08-1.38-3.08-3.08s1.38-3.07 3.08-3.07 3.08 1.38 3.08 3.07-1.38 3.08-3.08 3.08m0-4.64c-.87 0-1.58.71-1.58 1.57s.71 1.58 1.58 1.58 1.58-.71 1.58-1.58-.71-1.57-1.58-1.57",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  d: "M10.91 5.66h11.1c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-11.1c-.41 0-.75.34-.75.75s.34.75.75.75M22.01 13.24h-11.1c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h11.1c.41 0 .75.34.75.75s-.34.75-.75.75M10.91 20.82h11.1c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-11.1c-.41 0-.75.34-.75.75s.34.75.75.75"
}));
exports.default = Checklist;
Checklist.displayName = 'Checklist';
});

unwrapExports(Checklist_1);

var Community_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Community = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M8.05 6.58a3.93 3.93 0 1 0 7.861-.001 3.93 3.93 0 0 0-7.86.001m1.5-.01c0-1.34 1.09-2.43 2.43-2.43s2.43 1.09 2.43 2.43S13.32 9 11.98 9 9.55 7.91 9.55 6.57",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  d: "M16.91 20.61h1.5v-3.5c0-2.07-1.68-3.75-3.75-3.75H9.32c-2.07 0-3.75 1.68-3.75 3.75v3.5h1.5v-3.5c0-1.24 1.01-2.25 2.25-2.25h5.34c1.24 0 2.25 1.01 2.25 2.25z"
}), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M4.24 11.15c-1.54 0-2.8-1.26-2.8-2.8s1.26-2.8 2.8-2.8 2.8 1.26 2.8 2.8-1.26 2.8-2.8 2.8m0-4.09c-.72 0-1.3.58-1.3 1.3s.58 1.3 1.3 1.3 1.3-.58 1.3-1.3-.58-1.3-1.3-1.3M16.93 8.35c0 1.54 1.26 2.8 2.8 2.8 1.55 0 2.8-1.26 2.8-2.8s-1.26-2.8-2.8-2.8-2.8 1.26-2.8 2.8m1.5.01c0-.72.58-1.3 1.3-1.3s1.3.58 1.3 1.3-.58 1.3-1.3 1.3-1.3-.58-1.3-1.3",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  d: "M2.03 19.43c-.41 0-.75-.34-.75-.75v-3.13c0-1.52 1.23-2.75 2.75-2.75h1.05c.41 0 .75.34.75.75s-.34.75-.75.75H4.03c-.69 0-1.25.56-1.25 1.25v3.13c0 .41-.34.75-.75.75M21.22 18.68c0 .41.34.75.75.75s.75-.34.75-.75v-3.13c0-1.52-1.23-2.75-2.75-2.75h-1.05c-.41 0-.75.34-.75.75s.34.75.75.75h1.05c.69 0 1.25.56 1.25 1.25z"
}));
exports.default = Community;
Community.displayName = 'Community';
});

unwrapExports(Community_1);

var Contacts_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Contacts = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M10.49 8.26c0 1.64 1.34 2.98 2.98 2.98s2.98-1.34 2.98-2.98-1.34-2.98-2.98-2.98-2.98 1.34-2.98 2.98m1.5 0c0-.82.66-1.48 1.48-1.48s1.48.66 1.48 1.48-.66 1.48-1.48 1.48-1.48-.66-1.48-1.48M17.46 18.58H9.48c-.86 0-1.56-.72-1.56-1.62 0-1.76.78-3.07 2.31-3.87.9-.47 1.93-.71 3.06-.71h.26c1.13 0 2.17.24 3.09.73 1.6.84 2.38 2.1 2.38 3.86 0 .89-.7 1.62-1.56 1.62zm-4.17-4.7q-1.335 0-2.37.54c-1.04.55-1.51 1.33-1.51 2.54 0 .08.05.12.06.12h7.98s.06-.04.06-.12c0-1.2-.47-1.95-1.57-2.53-.71-.37-1.51-.56-2.4-.56h-.26z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M6.46 22.66h12.72c1.52 0 2.75-1.23 2.75-2.75V4.09c0-1.52-1.23-2.75-2.75-2.75H6.46c-1.52 0-2.75 1.23-2.75 2.75v1.63h-.9c-.41 0-.75.34-.75.75s.34.75.75.75h.9v4.14h-.9c-.41 0-.75.34-.75.75s.34.75.75.75h.9V17h-.9c-.41 0-.75.34-.75.75s.34.75.75.75h.9v1.41c0 1.52 1.23 2.75 2.75 2.75M5.21 18.5v1.41c0 .69.56 1.25 1.25 1.25h12.72c.69 0 1.25-.56 1.25-1.25V4.09c0-.69-.56-1.25-1.25-1.25H6.46c-.69 0-1.25.56-1.25 1.25v1.63h.41c.41 0 .75.34.75.75s-.34.75-.75.75h-.41v4.14h.41c.41 0 .75.34.75.75s-.34.75-.75.75h-.41V17h.41c.41 0 .75.34.75.75s-.34.75-.75.75z",
  clipRule: "evenodd"
}));
exports.default = Contacts;
Contacts.displayName = 'Contacts';
});

unwrapExports(Contacts_1);

var Contract_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Contract = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  d: "M12.66 6.36H5.57c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h7.09c.41 0 .75.34.75.75s-.34.75-.75.75M5.57 9.9h7.09c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H5.57c-.41 0-.75.34-.75.75s.34.75.75.75M13.63 19.59h.04l-.02-.02a.75.75 0 0 0 .04-1.5c-.64-.03-.75-.48-.75-.77-.02-.96-.33-1.55-.91-1.74-.87-.29-1.73.59-2.1 1.04-.43.39-.75.66-1 .85.08-.23.18-.47.29-.7a.3.3 0 0 0 .04-.1l.005-.017c.115-.396.444-1.531-.325-2.093-.79-.58-1.97.12-2.5.49l-2.37 2.01c-.32.27-.36.74-.09 1.06s.74.36 1.06.09l2.31-1.96c.17-.11.37-.22.55-.3-.01.07-.03.15-.06.25-1.078 2.314-.383 2.828-.152 2.999h.002c.79.57 1.85-.14 3.31-1.49.03-.02.06-.05.08-.08.11-.14.25-.28.38-.39v.12c-.01.86.56 2.17 2.17 2.25"
}), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M15.47 22.68H3.96c-1.52 0-2.76-1.24-2.76-2.76V4.08c0-1.52 1.24-2.76 2.76-2.76h11.51a2.767 2.767 0 0 1 2.745 2.468l.845-1.798c.08-.18.24-.32.42-.39.19-.07.39-.06.57.03l2.31 1.09c.37.18.54.62.36 1l-4.49 9.52v6.68c0 1.52-1.24 2.76-2.76 2.76m1.26-18.6v2.864l-2.9 6.166c-.05.1-.07.21-.07.32v3.02c0 .29.17.56.43.68.1.05.21.07.32.07l-.02-.01c.17 0 .34-.05.48-.17l1.76-1.47v4.37c0 .69-.56 1.26-1.26 1.26H3.96c-.69 0-1.26-.56-1.26-1.26V4.08c0-.69.56-1.26 1.26-1.26h11.51c.69 0 1.26.56 1.26 1.26m-1.47 10.77.95-.8 4.85-10.29-.96-.45-4.84 10.28z",
  clipRule: "evenodd"
}));
exports.default = Contract;
Contract.displayName = 'Contract';
});

unwrapExports(Contract_1);

var Coverage_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Coverage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M11.03 22.56c.07.04.47.25 1.02.25l-.02-.01c.26 0 .55-.05.86-.18 1.5-.66 3.06-1.61 4.91-2.99 1.45-1.09 2.99-2.47 3.36-4.5.4-2.17.67-4.45.81-6.8.03-.37.03-.71 0-1.03-.14-1.77-.96-2.58-2.33-3.38-1.32-.78-2.8-1.44-4.4-1.98l-.33-.11-.147-.05c-.704-.235-1.427-.477-2.203-.57-1.09-.13-2.05.15-2.9.4-1.92.57-3.72 1.34-5.32 2.28-1.37.8-2.19 1.61-2.33 3.38-.02.32-.02.66 0 1.03.14 2.34.42 4.63.81 6.8.37 2.03 1.91 3.42 3.36 4.5 1.42 1.06 3.09 2.25 4.85 2.96m-.913-19.505c.643-.188 1.248-.365 1.882-.365.127 0 .254 0 .381.02.651.077 1.284.29 1.96.52l.09.03.34.11c1.5.51 2.89 1.13 4.12 1.85 1.09.65 1.5 1.08 1.59 2.21.02.27.02.55 0 .82-.13 2.28-.4 4.51-.78 6.62-.28 1.52-1.56 2.65-2.78 3.56-1.76 1.31-3.22 2.21-4.62 2.82-.28.13-.54 0-.62-.04-1.68-.68-3.26-1.81-4.6-2.81-1.22-.91-2.5-2.04-2.78-3.56-.38-2.11-.64-4.34-.78-6.62a6 6 0 0 1 0-.82c.09-1.14.49-1.57 1.59-2.21 1.5-.88 3.18-1.59 4.99-2.13zm.373 11.415c.14.14.33.22.53.22l-.01-.01c.2 0 .39-.08.53-.22l4.32-4.28c.29-.29.29-.77 0-1.06a.754.754 0 0 0-1.06 0l-3.78 3.75-1.77-1.8a.754.754 0 0 0-1.06 0c-.29.29-.29.76 0 1.06z",
  clipRule: "evenodd"
}));
exports.default = Coverage;
Coverage.displayName = 'Coverage';
});

unwrapExports(Coverage_1);

var Creditcard_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Creditcard = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  d: "M5.01 17.43h2.7c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-2.7c-.41 0-.75.34-.75.75s.34.75.75.75M18.46 17.18a1 1 0 1 0 0-2 1 1 0 0 0 0 2M15.93 16.18a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M4.07 20.44h15.85c1.52 0 2.75-1.23 2.75-2.75V6.31c0-1.52-1.23-2.75-2.75-2.75H4.07c-1.52 0-2.75 1.23-2.75 2.75v11.38c0 1.52 1.23 2.75 2.75 2.75M2.82 6.31c0-.69.56-1.25 1.25-1.25h15.85c.69 0 1.25.56 1.25 1.25v.43H2.82zm0 1.93h18.35v2.06H2.82zm18.35 9.45V11.8H2.82v5.89c0 .69.56 1.25 1.25 1.25h15.85c.69 0 1.25-.56 1.25-1.25",
  clipRule: "evenodd"
}));
exports.default = Creditcard;
Creditcard.displayName = 'Creditcard';
});

unwrapExports(Creditcard_1);

var Data_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Data = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M18.15 22.75H5.85c-1.65 0-2.99-1.23-2.99-2.75V4c0-1.52 1.34-2.75 2.99-2.75h7.97c.75 0 1.46.28 1.99.79l4.47 4.23c.54.51.85 1.23.85 1.96v11.76c0 1.52-1.34 2.75-2.99 2.75zm-12.3-20c-.82 0-1.49.56-1.49 1.25v16c0 .69.67 1.25 1.49 1.25h12.31c.82 0 1.49-.56 1.49-1.25V8.24c0-.33-.14-.64-.39-.88l-4.47-4.24c-.25-.24-.6-.38-.96-.38H5.86zm3.92 12.31c.19 0 .35-.02.5-.05.14-.03.28-.07.41-.13V14h-.58c-.08 0-.15-.02-.2-.07a.22.22 0 0 1-.07-.17v-.74h2.07v2.46c-.15.11-.3.2-.47.28-.16.08-.33.14-.52.19s-.38.09-.58.11a7 7 0 0 1-.67.04c-.43 0-.82-.08-1.18-.23s-.68-.36-.94-.62a2.9 2.9 0 0 1-.62-.94c-.15-.36-.23-.76-.23-1.19s.07-.83.22-1.2c.14-.36.35-.68.62-.94s.59-.47.97-.62.8-.22 1.27-.22a3.7 3.7 0 0 1 1.27.22c.18.07.34.15.49.25s.28.2.4.31l-.39.6c-.04.06-.08.1-.13.13s-.11.05-.17.05c-.08 0-.16-.03-.25-.08q-.095-.053-.18-.102l-.12-.068c-.09-.05-.19-.08-.29-.11s-.2-.05-.31-.06a4 4 0 0 0-.37-.02c-.25 0-.48.04-.68.13s-.38.21-.52.38c-.14.16-.25.36-.33.59s-.12.48-.12.76c0 .31.04.58.13.82s.2.44.35.61.33.29.54.38.43.13.68.13m2.95-4.86v5.83h2.32c.35 0 .66-.04.93-.13.28-.09.5-.21.69-.37.18-.16.32-.35.42-.56.09-.21.14-.44.14-.69 0-.33-.1-.6-.28-.81s-.47-.36-.85-.45c.17-.07.32-.14.45-.23s.23-.19.31-.29.14-.22.18-.34.06-.25.06-.38c0-.24-.04-.45-.12-.65s-.21-.36-.39-.5a1.8 1.8 0 0 0-.69-.32 4.3 4.3 0 0 0-1.03-.11zm2.05 2.46h-.69v-1.44h.79c.15 0 .28.02.39.04q.165.03.27.12c.07.05.13.13.16.22.03.1.05.21.05.35s-.03.26-.07.35a.5.5 0 0 1-.19.22c-.09.05-.19.09-.31.11s-.25.03-.4.03m-.7 2.35v-1.45l.02-.02h.94c.17 0 .31.02.42.05.11.04.2.08.27.14.06.06.11.14.14.22.03.09.04.18.04.29 0 .1-.02.19-.04.28s-.07.17-.13.24c-.07.08-.16.13-.27.18-.12.05-.26.07-.44.07z",
  clipRule: "evenodd"
}));
exports.default = Data;
Data.displayName = 'Data';
});

unwrapExports(Data_1);

var Delivery_1$1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Delivery = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M9.61 19.15h5.34a2.78 2.78 0 0 0 2.68 2.04 2.79 2.79 0 0 0 2.68-2.04h1.63v.01c.41 0 .75-.34.75-.75v-6.17c0-.45-.11-.89-.32-1.29l-2.08-3.91a2.75 2.75 0 0 0-2.43-1.46h-3.78V4.56c0-.96-.79-1.75-1.75-1.75H3.06c-.96 0-1.75.79-1.75 1.75V17.4c0 .96.79 1.75 1.75 1.75h1.19a2.79 2.79 0 0 0 2.68 2.04 2.79 2.79 0 0 0 2.68-2.04m-.006-1.5h2.966v-4.54H2.81v4.29c0 .14.11.25.25.25h1.196a2.79 2.79 0 0 1 2.674-2.02 2.79 2.79 0 0 1 2.674 2.02m-3.954.762v-.024a1.28 1.28 0 0 1 1.28-1.268c.7 0 1.28.58 1.28 1.28s-.58 1.28-1.28 1.28a1.29 1.29 0 0 1-1.28-1.268m13.26-.018v.012a1.29 1.29 0 0 1-1.28 1.274c-.7 0-1.28-.58-1.28-1.28s.57-1.28 1.28-1.28a1.29 1.29 0 0 1 1.28 1.274m1.394-.744h.886v-5.42c0-.2-.05-.41-.15-.59l-2.08-3.91c-.22-.41-.64-.66-1.1-.66h-3.78v10.58h.876a2.79 2.79 0 0 1 2.674-2.02 2.79 2.79 0 0 1 2.674 2.02M12.57 6.33v5.28H2.81V4.56c0-.14.11-.25.25-.25h9.27c.14 0 .25.11.25.25V6.21a1 1 0 0 0-.01.121",
  clipRule: "evenodd"
}));
exports.default = Delivery;
Delivery.displayName = 'Delivery';
});

unwrapExports(Delivery_1$1);

var Discount_1$1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Discount = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M9.58 21.98c.51.51 1.18.77 1.85.77s1.34-.26 1.85-.77l8.7-8.7c.49-.49.77-1.16.77-1.85V3.87c0-1.44-1.18-2.62-2.62-2.62h-7.56c-.7 0-1.36.27-1.85.77l-8.7 8.69a2.63 2.63 0 0 0 0 3.71zm2.2-18.9c.21-.21.49-.33.79-.33h7.56c.62 0 1.12.5 1.12 1.12v7.56c0 .29-.12.58-.33.79l-8.7 8.7c-.43.44-1.14.44-1.58 0l-7.56-7.56a1.11 1.11 0 0 1 0-1.58zM9.32 9.29c.24.64.97.97 1.61.72.64-.24.96-.97.72-1.61s-.97-.96-1.61-.72-.96.97-.72 1.61m4.19 7.48c-.64.25-1.37-.08-1.61-.72s.08-1.37.72-1.61 1.37.08 1.61.72-.08 1.37-.72 1.61m4-11.52a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0M7.37 13.88a.753.753 0 0 0 .97.43l7.57-2.91c.39-.15.58-.58.43-.97a.746.746 0 0 0-.97-.43L7.8 12.91c-.39.15-.58.58-.43.97",
  clipRule: "evenodd"
}));
exports.default = Discount;
Discount.displayName = 'Discount';
});

unwrapExports(Discount_1$1);

var DocumentInfo_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const DocumentInfo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M17.87 22.75c1.59 0 2.88-1.23 2.88-2.75V8.24a2.76 2.76 0 0 0-.81-1.95l-4.27-4.24c-.4-.4-.9-.658-1.443-.756a.7.7 0 0 0-.155-.023 3 3 0 0 0-.342-.021h-7.6C4.54 1.25 3.25 2.48 3.25 4v16c0 1.52 1.29 2.75 2.88 2.75zm-4.58-20H6.13c-.76 0-1.38.56-1.38 1.25v16c0 .69.62 1.25 1.38 1.25h11.73c.76 0 1.38-.56 1.38-1.25V8.39h-3.2c-1.52 0-2.75-1.23-2.75-2.75zm1.5.549V5.64c0 .69.56 1.25 1.25 1.25h2.367zM12 18.5c-.41 0-.75-.34-.75-.75v-4.5c0-.41.34-.75.75-.75s.75.34.75.75v4.5c0 .41-.34.75-.75.75m1-8.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0",
  clipRule: "evenodd"
}));
exports.default = DocumentInfo;
DocumentInfo.displayName = 'DocumentInfo';
});

unwrapExports(DocumentInfo_1);

var DocumentWTick_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const DocumentWTick = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  d: "M10.99 16.9a.75.75 0 0 1-.53-.22l-2.3-2.34a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l1.77 1.8 3.78-3.75c.29-.29.77-.29 1.06 0s.29.77 0 1.06l-4.32 4.28a.75.75 0 0 1-.53.22z"
}), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M17.87 22.75H6.13c-1.59 0-2.88-1.23-2.88-2.75V4c0-1.52 1.29-2.75 2.88-2.75h7.6q.173 0 .341.02.081.004.156.024a2.7 2.7 0 0 1 1.443.756l4.27 4.24a2.7 2.7 0 0 1 .703 1.192q.106.372.107.758V20c0 1.52-1.29 2.75-2.88 2.75m1.37-14.36V20c0 .69-.62 1.25-1.38 1.25H6.13c-.76 0-1.38-.56-1.38-1.25V4c0-.69.62-1.25 1.38-1.25h7.16v2.89c0 1.52 1.23 2.75 2.75 2.75zm-.833-1.5L14.79 3.299V5.64c0 .69.56 1.25 1.25 1.25z",
  clipRule: "evenodd"
}));
exports.default = DocumentWTick;
DocumentWTick.displayName = 'DocumentWTick';
});

unwrapExports(DocumentWTick_1);

var Document_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Document = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M6.13 22.75h11.74c1.59 0 2.88-1.23 2.88-2.75V8.24a2.76 2.76 0 0 0-.81-1.95l-4.27-4.24c-.4-.4-.9-.658-1.443-.756a.7.7 0 0 0-.155-.023 3 3 0 0 0-.342-.021h-7.6C4.54 1.25 3.25 2.48 3.25 4v16c0 1.52 1.29 2.75 2.88 2.75m7.16-20H6.13c-.76 0-1.38.56-1.38 1.25v16c0 .69.62 1.25 1.38 1.25h11.73c.76 0 1.38-.56 1.38-1.25V8.39h-3.2c-1.52 0-2.75-1.23-2.75-2.75zm1.5.549V5.64c0 .69.56 1.25 1.25 1.25h2.367z",
  clipRule: "evenodd"
}));
exports.default = Document;
Document.displayName = 'Document';
});

unwrapExports(Document_1);

var Download_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Download = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M11.22 15.857V2c0-.41.34-.75.75-.75s.75.34.75.75v13.847l3.61-3.787c.29-.3.76-.31 1.06-.03.3.29.31.76.03 1.06l-4.81 5.045a.7.7 0 0 1-.12.145.75.75 0 0 1-.52.21v-.01c-.2 0-.4-.08-.54-.23L6.52 13.1c-.29-.3-.27-.78.03-1.06.3-.29.77-.27 1.06.03zM5.23 22.75h13.54c2.04 0 3.7-1.66 3.7-3.7v-2c0-.41-.34-.75-.75-.75s-.75.34-.75.75v2c0 1.21-.99 2.2-2.2 2.2H5.23c-1.21 0-2.2-.99-2.2-2.2v-2c0-.41-.34-.75-.75-.75s-.75.34-.75.75v2c0 2.04 1.66 3.7 3.7 3.7",
  clipRule: "evenodd"
}));
exports.default = Download;
Download.displayName = 'Download';
});

unwrapExports(Download_1);

var Edit_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Edit = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M1.5 22.5c.14.14.33.22.53.22v-.02h.09l5.79-.71a.73.73 0 0 0 .44-.21l10.83-10.83a.8.8 0 0 0 .148-.148L21.91 8.22a2.76 2.76 0 0 0 0-3.89L20.8 3.22l-.02-.02-1.11-1.11a2.76 2.76 0 0 0-3.89 0L2.21 15.65a.8.8 0 0 0-.21.44l-.71 5.79c-.03.23.05.46.21.62M18.73 9.29l2.12-2.12c.49-.49.49-1.28 0-1.77l-1.11-1.11-.02-.02-1.11-1.11a1.25 1.25 0 0 0-1.77 0l-2.116 2.115zm-5.067-2.956L3.46 16.53l-.57 4.58 4.58-.56 10.2-10.2z",
  clipRule: "evenodd"
}));
exports.default = Edit;
Edit.displayName = 'Edit';
});

unwrapExports(Edit_1);

var Entertainment_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Entertainment = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M4.22 11.75C3 11.75 2 10.75 2 9.53c0-.85.48-1.6 1.19-1.97A2.712 2.712 0 0 1 5.73 3.9c.19 0 .37.02.55.06a3.684 3.684 0 0 1 3.56-2.72c1.2 0 2.29.58 2.97 1.52.53-.36 1.16-.57 1.81-.57a3.205 3.205 0 0 1 3.156 2.671l.074-.001c.99 0 1.82.7 2.02 1.64.99.33 1.69 1.27 1.69 2.36a2.5 2.5 0 0 1-2.27 2.49l-1.76 10.77c-.06.36-.37.63-.74.63h-3.378a1 1 0 0 1-.122.01v-.01H7.12c-.37 0-.68-.27-.74-.63L4.672 11.673q-.21.046-.462.047zm14.674-1.902.006.002h.15c.55 0 1-.45 1-1s-.42-.97-.95-.99c-.21 0-.41-.11-.54-.27a.76.76 0 0 1-.16-.58c.01-.4-.24-.65-.55-.65a.56.56 0 0 0-.56.56c0 .41-.34.75-.75.75s-.75-.34-.75-.75c0-.537.207-1.025.543-1.392a1 1 0 0 1-.013-.138c0-.93-.76-1.7-1.7-1.7-.56 0-1.08.28-1.4.74-.16.23-.44.36-.72.32a.76.76 0 0 1-.61-.51c-.3-.9-1.13-1.5-2.06-1.5-1.21 0-2.19.98-2.19 2.18l.004.034q.005.03.006.066c.02.29-.14.57-.4.7-.26.14-.57.11-.81-.07-.15-.12-.4-.26-.73-.26-.67 0-1.21.54-1.21 1.21 0 .35.15.67.42.9.25.22.33.58.19.88s-.46.47-.8.42a.724.724 0 0 0-.83.7c0 .4.32.72.72.72.21 0 .3-.06.56-.26a.76.76 0 0 1 .656-.15h4.143a.7.7 0 0 1 .17 0h8.93q.122 0 .235.038M8.939 11.31l.852 9.94H7.75l-1.62-9.94zm5.171 9.94h2.04l1.62-9.94h-2.808zm-.65-9.94-.85 9.94h-1.318l-.852-9.94z",
  clipRule: "evenodd"
}));
exports.default = Entertainment;
Entertainment.displayName = 'Entertainment';
});

unwrapExports(Entertainment_1);

var Expand_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Expand = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  d: "M20.75 9.03c0 .41.34.75.75.75s.75-.34.75-.75V2.5a.7.7 0 0 0-.071-.316.74.74 0 0 0-.367-.365.7.7 0 0 0-.312-.069h-6.53c-.41 0-.75.34-.75.75s.34.75.75.75h4.72l-6.72 6.72c-.29.29-.29.77 0 1.06.15.15.34.22.53.22s.38-.07.53-.22l6.72-6.72zM1.75 21.5v-6.53c0-.41.34-.75.75-.75s.75.34.75.75v4.72l6.72-6.72c.29-.29.77-.29 1.06 0s.29.77 0 1.06l-6.72 6.72h4.72c.41 0 .75.34.75.75s-.34.75-.75.75H2.5a.75.75 0 0 1-.72-.544.7.7 0 0 1-.03-.206"
}));
exports.default = Expand;
Expand.displayName = 'Expand';
});

unwrapExports(Expand_1);

var Express_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Express = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  d: "M16.5 3H13c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3.5c.41 0 .75.34.75.75s-.34.75-.75.75M3.86 14.13H1.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2.11c.41 0 .75.34.75.75s-.34.75-.75.75M14 13.38q0 .039.004.076a.756.756 0 0 0 .746.674h2.93c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H15.5V8.67c0-.41-.34-.75-.75-.75s-.75.34-.75.75z"
}), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M6.5 13.38c0 4.55 3.7 8.25 8.25 8.25S23 17.93 23 13.38s-3.7-8.25-8.25-8.25-8.25 3.7-8.25 8.25m1.5 0c0-3.72 3.03-6.75 6.75-6.75s6.75 3.03 6.75 6.75-3.03 6.75-6.75 6.75S8 17.1 8 13.38",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  d: "M5.22 9.88H3.25c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h1.97c.41 0 .75.34.75.75s-.34.75-.75.75M3.25 18.38h1.97c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H3.25c-.41 0-.75.34-.75.75s.34.75.75.75"
}));
exports.default = Express;
Express.displayName = 'Express';
});

unwrapExports(Express_1);

var ExternalLink_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const ExternalLink = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  d: "M12.11 12.66h-.005a.74.74 0 0 0 .525-.22l8.61-8.549V9.27c0 .41.34.75.75.75v.01c.41 0 .75-.34.75-.75V2.1a.7.7 0 0 0-.015-.15.74.74 0 0 0-.841-.6H14.82c-.41 0-.75.34-.75.75s.34.75.75.75h5.342l-8.582 8.53c-.29.29-.29.77 0 1.06a.73.73 0 0 0 .525.22H12.1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  d: "M1.26 21.1c0 .86.7 1.55 1.55 1.55h16.4c.86 0 1.55-.7 1.55-1.55v-8.2c0-.41-.34-.75-.75-.75s-.75.34-.75.75l-.05 8.25-16.45-.05.05-16.45h8.2c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-8.2c-.86 0-1.55.7-1.55 1.55z"
}));
exports.default = ExternalLink;
ExternalLink.displayName = 'ExternalLink';
});

unwrapExports(ExternalLink_1);

var FAQ_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const FAQ = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M2 23.11a.757.757 0 0 1-.75-.75V1.64c0-.41.34-.75.75-.75h20c.41 0 .75.34.75.75v15.25c0 .41-.34.75-.75.75H7.14l-4.58 5.22c-.14.17-.35.26-.56.26zm.75-20.72v17.98l3.49-3.97a.76.76 0 0 1 .56-.26h14.45V2.39zm9.14 12.36a1.01 1.01 0 1 0 0-2.02 1.01 1.01 0 0 0 0 2.02m-.75-4.07c0 .41.34.75.75.75v.01c.41 0 .75-.34.75-.75 0-.55.06-.81.26-1.01.14-.16.33-.32.52-.48.35-.3.72-.62.98-.97.63-.83.79-1.89.45-2.82-.34-.92-1.12-1.58-2.14-1.81-1.59-.35-3.28.59-3.71 2.07-.12.4.11.82.51.93.4.12.82-.11.93-.51.21-.73 1.12-1.21 1.94-1.02.52.11.9.42 1.06.86.17.46.08.98-.24 1.4-.17.22-.47.48-.76.73-.22.19-.44.39-.62.57-.6.62-.68 1.35-.68 2.05",
  clipRule: "evenodd"
}));
exports.default = FAQ;
FAQ.displayName = 'FAQ';
});

unwrapExports(FAQ_1);

var Filter_1$1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Filter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M4.678 5A2.904 2.904 0 0 0 7.48 7.15c1.34 0 2.47-.913 2.802-2.15H22c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H10.282A2.904 2.904 0 0 0 7.48 1.35c-1.34 0-2.47.913-2.802 2.15H2c-.41 0-.75.34-.75.75S1.59 5 2 5zm4.202-.764a1.404 1.404 0 0 0-1.4-1.386c-.77 0-1.4.63-1.4 1.4s.63 1.4 1.4 1.4c.765 0 1.393-.623 1.4-1.386v-.028M22 20.5H10.282a2.904 2.904 0 0 1-2.802 2.15c-1.34 0-2.47-.913-2.802-2.15H2c-.41 0-.75-.34-.75-.75S1.59 19 2 19h2.678a2.904 2.904 0 0 1 2.802-2.15c1.34 0 2.47.913 2.802 2.15H22c.41 0 .75.34.75.75s-.34.75-.75.75m-13.12-.75v-.014a1.404 1.404 0 0 0-1.4-1.386c-.77 0-1.4.63-1.4 1.4s.63 1.4 1.4 1.4c.765 0 1.393-.622 1.4-1.386zM13.718 11.25A2.904 2.904 0 0 1 16.52 9.1c1.34 0 2.47.913 2.802 2.15H22c.41 0 .75.34.75.75s-.34.75-.75.75h-2.678a2.904 2.904 0 0 1-2.802 2.15c-1.34 0-2.47-.913-2.802-2.15H2c-.41 0-.75-.34-.75-.75s.34-.75.75-.75zm4.202.764a1.404 1.404 0 0 1-1.4 1.386c-.77 0-1.4-.63-1.4-1.4s.63-1.4 1.4-1.4c.765 0 1.393.623 1.4 1.386v.028",
  clipRule: "evenodd"
}));
exports.default = Filter;
Filter.displayName = 'Filter';
});

unwrapExports(Filter_1$1);

var FlightLeft_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const FlightLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  d: "M15.16 23h-2.82c-.27 0-.52-.15-.65-.38l-4.33-7.71H4.28c-2.22 0-2.96-1.75-3.03-2.68v-.41c.08-.99.81-2.74 3.03-2.74h3.08l4.33-7.7c.13-.24.38-.38.65-.38h2.82c.24 0 .47.12.61.31s.18.45.1.68L13.5 9.1h4.48l1.55-1.55a.75.75 0 0 1 .53-.22h1.95c.23 0 .45.11.59.29s.19.42.13.65L21.78 12l.95 3.74c.06.22 0 .46-.13.65-.14.18-.36.29-.59.29h-1.95a.75.75 0 0 1-.53-.22l-1.55-1.55H13.5l2.37 7.11c.08.23.04.48-.1.68a.74.74 0 0 1-.61.31zm-2.38-1.5h1.34l-2.37-7.11a.75.75 0 0 1 .1-.68c.14-.2.37-.31.61-.31h5.84c.2 0 .39.08.53.22l1.55 1.55h.67l-.72-2.81c-.02-.09-.08-.39 0-.72l.72-2.81h-.67l-1.55 1.55a.75.75 0 0 1-.53.22h-5.84c-.24 0-.47-.12-.61-.31a.75.75 0 0 1-.1-.68l2.37-7.11h-1.34l-4.33 7.71c-.13.24-.38.38-.65.38H4.28c-1.34 0-1.52 1.09-1.54 1.31v.28c.02.15.2 1.24 1.54 1.24H7.8c.27 0 .52.15.65.38l4.33 7.71z"
}));
exports.default = FlightLeft;
FlightLeft.displayName = 'FlightLeft';
});

unwrapExports(FlightLeft_1);

var FlightRight_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const FlightRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  d: "M11.66 23H8.84c-.24 0-.47-.12-.61-.31a.75.75 0 0 1-.1-.68l2.37-7.11H6.02l-1.55 1.55a.75.75 0 0 1-.53.22H1.99c-.23 0-.45-.11-.59-.29a.75.75 0 0 1-.13-.65L2.22 12l-.95-3.74c-.06-.22 0-.46.13-.65.14-.18.36-.29.59-.29h1.95c.2 0 .39.08.53.22l1.55 1.55h4.48L8.13 1.98a.75.75 0 0 1 .1-.68c.14-.2.37-.31.61-.31h2.82c.27 0 .52.15.65.38l4.33 7.71h3.08c2.22 0 2.96 1.75 3.03 2.68v.41c-.08.99-.81 2.74-3.03 2.74h-3.08l-4.33 7.71c-.13.24-.38.38-.65.38m-1.78-1.5h1.34l4.33-7.71c.13-.24.38-.38.65-.38h3.52c1.34 0 1.52-1.09 1.54-1.31v-.28c-.02-.15-.2-1.24-1.54-1.24H16.2c-.27 0-.52-.15-.65-.38l-4.33-7.71H9.88l2.37 7.11c.08.23.04.48-.1.68a.74.74 0 0 1-.61.31H5.7a.75.75 0 0 1-.53-.22L3.62 8.82h-.67l.72 2.81c.02.08.08.38 0 .72l-.72 2.81h.67l1.55-1.55a.75.75 0 0 1 .53-.22h5.84c.24 0 .47.12.61.31s.18.45.1.68l-2.37 7.11z"
}));
exports.default = FlightRight;
FlightRight.displayName = 'FlightRight';
});

unwrapExports(FlightRight_1);

var Flight_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Flight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  d: "M15.92 22.76c-.06 0-.12 0-.19-.02L12 21.79l-3.74.95c-.22.06-.46 0-.65-.13a.75.75 0 0 1-.29-.59v-1.95c0-.2.08-.39.22-.53l1.55-1.55v-4.48l-7.11 2.37c-.23.07-.48.04-.68-.1a.74.74 0 0 1-.31-.61v-2.82c0-.27.15-.52.38-.65l7.71-4.33V4.29c0-2.22 1.75-2.96 2.68-3.03h.41c.99.08 2.74.81 2.74 3.03v3.08l7.71 4.33c.24.13.38.38.38.65v2.82c0 .24-.12.47-.31.61s-.45.18-.68.1l-7.11-2.37v4.48l1.55 1.55c.14.14.22.33.22.53v1.95a.754.754 0 0 1-.75.75zm-3.56-2.44 2.81.72v-.67l-1.55-1.55a.75.75 0 0 1-.22-.53v-5.83c0-.24.12-.47.31-.61s.45-.18.68-.1l7.11 2.37v-1.34l-7.71-4.33a.73.73 0 0 1-.38-.65V4.28c0-1.34-1.09-1.52-1.31-1.54h-.28c-.15.02-1.24.2-1.24 1.54V7.8c0 .27-.15.52-.38.65l-7.71 4.33v1.34l7.11-2.37a.75.75 0 0 1 .68.1c.2.14.31.37.31.61v5.83c0 .2-.08.39-.22.53l-1.55 1.55v.67l2.81-.72c.09-.02.39-.09.72 0z"
}));
exports.default = Flight;
Flight.displayName = 'Flight';
});

unwrapExports(Flight_1);

var Food_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Food = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  d: "M9.12 1.75c0-.41.34-.75.75-.75s.75.34.75.75v7.14c0 1.61-1.31 2.91-2.91 2.91h-.59v10.45c0 .41-.34.75-.75.75s-.75-.34-.75-.75V11.8h-.59c-1.61 0-2.91-1.31-2.91-2.91V1.75c0-.41.34-.75.75-.75s.75.34.75.75v7.14c0 .78.63 1.41 1.41 1.41h.59V1.75c0-.41.34-.75.75-.75s.75.34.75.75v8.55h.59c.78 0 1.41-.63 1.41-1.41z"
}), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M20.24 2.87c.54.74.96 1.64 1.32 2.83l.01.01c.55 1.83.37 3.58-.51 4.81-.63.87-1.61 1.44-2.71 1.6v10.14c0 .41-.34.75-.75.75s-.75-.34-.75-.75V12.12c-1.08-.16-2.08-.73-2.71-1.61-.89-1.23-1.07-2.98-.51-4.81.37-1.18.79-2.08 1.32-2.83 1.61-2.25 3.68-2.25 5.29 0m-2.66 7.79c.96.02 1.78-.36 2.26-1.03h-.01c.86-1.2.49-2.84.29-3.49-.31-1.03-.66-1.79-1.1-2.4-1.01-1.42-1.83-1.42-2.85 0-.43.61-.78 1.37-1.1 2.4-.2.65-.57 2.29.29 3.49.48.67 1.32 1.05 2.22 1.03",
  clipRule: "evenodd"
}));
exports.default = Food;
Food.displayName = 'Food';
});

unwrapExports(Food_1);

var GlobalSMS_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const GlobalSMS = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: props.color || "#222222",
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16 16.37c-2.23 0-2.83-4.88-2.83-7.76S13.77.85 16 .85s2.83 4.88 2.83 7.76-.6 7.76-2.83 7.76m-.03-14.02c-.33.15-1.3 2.24-1.3 6.26s.92 6.01 1.33 6.25c.41-.24 1.33-2.33 1.33-6.25s-.97-6.11-1.36-6.26"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M16 16.37c-4.28 0-7.76-3.48-7.76-7.76S11.72.85 16 .85s7.76 3.48 7.76 7.76-3.48 7.76-7.76 7.76m0-14.02a6.27 6.27 0 0 0-5.617 3.5h11.234A6.27 6.27 0 0 0 16 2.35M9.74 8.61q.001-.648.128-1.26h12.264a6.3 6.3 0 0 1 .005 2.5H9.864a6.3 6.3 0 0 1-.124-1.24M16 14.87a6.27 6.27 0 0 1-5.627-3.52h11.254A6.27 6.27 0 0 1 16 14.87M1.27 22.99c.24.11.48.16.73.16v.01c.42 0 .82-.15 1.15-.44l2.06-1.8c.04-.04.1-.06.16-.06h10.62c.96 0 1.75-.79 1.75-1.75v-.5c0-.41-.34-.75-.75-.75s-.75.34-.75.75v.5c0 .14-.11.25-.25.25H5.37c-.42 0-.83.15-1.15.43l-2.06 1.8c-.11.09-.22.06-.27.04-.06-.03-.15-.09-.15-.23V8.6c0-.14.11-.25.25-.25h4c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-4c-.96 0-1.75.79-1.75 1.75v12.8c0 .69.4 1.3 1.03 1.59",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "white",
  d: "M0 0h24v24H0z"
}))));
exports.default = GlobalSMS;
GlobalSMS.displayName = 'GlobalSMS';
});

unwrapExports(GlobalSMS_1);

var Heart_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Heart = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  d: "M12 21.25c-.18 0-.36-.06-.5-.19l-7.79-7.03c-2.5-2.6-2.34-5.15-2.33-5.25 0-1.89.55-3.42 1.64-4.49 1.56-1.54 3.65-1.54 3.73-1.52 2.71 0 4.41 1.33 5.26 2.24.85-.91 2.55-2.24 5.27-2.24.08 0 2.16-.01 3.72 1.52 1.09 1.07 1.64 2.6 1.64 4.54 0 .05.16 2.6-2.29 5.16l-7.83 7.07c-.14.13-.32.19-.5.19zm-5.27-17s-1.58.01-2.68 1.1c-.78.78-1.18 1.95-1.18 3.46 0 .13-.09 2.07 1.88 4.12L12 19.47l7.29-6.58c1.93-2.02 1.85-3.96 1.84-4.04 0-1.57-.4-2.73-1.18-3.51-1.12-1.11-2.68-1.1-2.67-1.1-3.17 0-4.57 2.24-4.63 2.33-.14.22-.41.38-.64.36-.26 0-.51-.14-.64-.36-.06-.09-1.47-2.33-4.62-2.33z"
}));
exports.default = Heart;
Heart.displayName = 'Heart';
});

unwrapExports(Heart_1);

var Help_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Help = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  d: "M12.02 14.68c-.41 0-.75-.34-.75-.75 0-.76.09-1.56.74-2.23.2-.2.44-.42.69-.64.33-.28.67-.58.86-.83.37-.5.48-1.11.28-1.65-.19-.52-.64-.89-1.25-1.02-.97-.21-2.03.35-2.28 1.21-.12.4-.53.62-.93.51a.746.746 0 0 1-.51-.93c.46-1.61 2.32-2.64 4.05-2.25 1.11.25 1.96.97 2.33 1.97.37 1.02.19 2.16-.49 3.07-.274.368-.645.691-1.014 1.012l-.066.058-.026.022a8 8 0 0 0-.564.518c-.24.25-.32.55-.32 1.19 0 .41-.34.75-.75.75zM12.02 17.93a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
}), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M1 12c0 6.07 4.93 11 11 11s11-4.93 11-11S18.07 1 12 1 1 5.93 1 12m1.5 0c0-5.24 4.26-9.5 9.5-9.5s9.5 4.26 9.5 9.5-4.26 9.5-9.5 9.5-9.5-4.26-9.5-9.5",
  clipRule: "evenodd"
}));
exports.default = Help;
Help.displayName = 'Help';
});

unwrapExports(Help_1);

var HiAppPrepaid_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const HiAppPrepaid = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  d: "M18.15 22.75H5.85c-1.65 0-2.99-1.23-2.99-2.75V4c0-1.52 1.34-2.75 2.99-2.75h7.97c.75 0 1.46.28 1.99.79l4.47 4.24c.54.51.85 1.23.85 1.96V20c0 1.52-1.34 2.75-2.99 2.75zm-12.3-20c-.82 0-1.49.56-1.49 1.25v16c0 .69.67 1.25 1.49 1.25h12.31c.82 0 1.49-.56 1.49-1.25V8.24c0-.33-.14-.64-.39-.88l-4.47-4.24c-.25-.24-.6-.38-.96-.38H5.86z"
}), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  d: "M6.26 16.03V8.54h1.55v2.76c.19-.16.39-.29.61-.39q.33-.15.78-.15.42 0 .75.15c.22.1.4.24.55.41.15.18.26.38.34.62s.11.5.11.79v3.3H9.4v-3.3c0-.25-.06-.45-.17-.59-.12-.14-.29-.21-.52-.21-.17 0-.33.04-.48.11s-.29.17-.43.3v3.7H6.25zM14.14 9.43c0 .12-.02.24-.07.35s-.12.2-.21.29c-.09.08-.19.15-.3.19-.11.05-.24.07-.37.07s-.24-.02-.35-.07a1 1 0 0 1-.29-.19 1 1 0 0 1-.2-.29.8.8 0 0 1-.07-.35c0-.13.02-.25.07-.36s.11-.21.2-.29c.08-.08.18-.15.29-.19s.23-.07.35-.07a.97.97 0 0 1 .67.26c.09.08.15.18.21.29.05.11.07.23.07.36m-.18 2.17v4.43h-1.55V11.6zM15.61 15.25c0-.12.02-.23.07-.33.04-.1.11-.19.18-.27a.75.75 0 0 1 .28-.18c.11-.04.22-.07.35-.07s.24.02.35.07.2.11.28.18c.08.08.14.17.19.27s.07.21.07.33-.02.23-.07.34-.11.2-.19.27-.17.14-.28.18-.22.07-.35.07-.24-.02-.35-.07a.8.8 0 0 1-.46-.45.8.8 0 0 1-.07-.34m1.62-6.5v2.11c0 .31-.02.61-.06.91s-.08.61-.15.92h-1.05c-.06-.31-.11-.62-.15-.92s-.05-.61-.05-.91V8.75h1.46"
}));
exports.default = HiAppPrepaid;
HiAppPrepaid.displayName = 'HiAppPrepaid';
});

unwrapExports(HiAppPrepaid_1);

var Hide_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Hide = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M10.02 15.07 20.46 4.63c.29-.29.29-.77 0-1.06a.754.754 0 0 0-1.06 0l-1.576 1.576c-1.79-1.162-3.78-1.787-5.844-1.796-3.57.02-7.06 1.99-9.33 5.26-.4.57-.78 1.2-1.12 1.87-.35.67-.75 1.44-.15 2.54l.09.17c.35.66.72 1.34 1.17 1.99a13 13 0 0 0 2.469 2.681L3.6 19.37c-.29.29-.29.77 0 1.06.15.15.34.22.53.22s.38-.07.53-.22l5.325-5.325zm-6.14-.75c.658.944 1.43 1.775 2.302 2.468l2.263-2.263A4.45 4.45 0 0 1 7.58 11.9a4.421 4.421 0 0 1 7.046-3.556L16.74 6.23c-1.475-.897-3.088-1.371-4.7-1.38-3.13.02-6.16 1.74-8.15 4.62-.36.52-.71 1.09-1.02 1.7-.34.66-.36.78-.16 1.14l.09.17c.35.65.68 1.26 1.08 1.84m9.67-4.899A2.9 2.9 0 0 0 12 8.97a2.923 2.923 0 0 0-2.475 4.475z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  d: "M9.28 20.07c.89.25 1.81.38 2.72.38v.01c3.58-.01 7.08-1.97 9.36-5.26.45-.65.82-1.33 1.17-1.99l.09-.17c.59-1.1.2-1.87-.15-2.54-.34-.67-.72-1.3-1.12-1.87-.1-.14-.2-.28-.3-.41A.76.76 0 0 0 20 8.08c-.33.25-.39.72-.14 1.05a14.7 14.7 0 0 1 1.28 2.06c.34.66.36.77.16 1.14l-.09.17c-.35.65-.68 1.26-1.08 1.84-2.01 2.89-5.05 4.62-8.13 4.62-.78 0-1.55-.12-2.32-.33-.4-.12-.81.12-.92.52-.11.39.12.81.52.92"
}));
exports.default = Hide;
Hide.displayName = 'Hide';
});

unwrapExports(Hide_1);

var Home_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Home = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  d: "M20.64 22.69h-4.85c-.68 0-1.24-.55-1.25-1.23l-.02-3.89H9.48l-.03 3.89c0 .68-.57 1.23-1.25 1.23H3.36c-1.17 0-2.13-.95-2.13-2.11v-7.86c0-1.72.73-3.38 2-4.55l6.44-5.95c1.28-1.19 3.3-1.19 4.59 0l6.5 5.95a6.24 6.24 0 0 1 2.02 4.57v7.85c0 1.17-.96 2.11-2.13 2.11zm-4.6-1.5h4.6c.35 0 .63-.28.63-.61v-7.85c0-1.31-.56-2.57-1.53-3.46l-6.5-5.95c-.72-.66-1.84-.66-2.56 0L4.24 9.27c-.96.89-1.52 2.15-1.52 3.45v7.86c0 .34.28.61.63.61h4.59l.03-3.95c0-.65.54-1.17 1.19-1.17h5.66c.65 0 1.19.53 1.19 1.18l.02 3.94z"
}));
exports.default = Home;
Home.displayName = 'Home';
});

unwrapExports(Home_1);

var IDD_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const IDD = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: props.color || "#222222",
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.96 15.81c-2.23 0-2.83-4.88-2.83-7.76s.6-7.76 2.83-7.76 2.83 4.88 2.83 7.76-.6 7.76-2.83 7.76m-.03-14.02c-.33.15-1.3 2.24-1.3 6.26s.92 6 1.33 6.25c.41-.24 1.33-2.32 1.33-6.25s-.97-6.11-1.36-6.26"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M8.21 8.05c0 4.28 3.48 7.76 7.76 7.76s7.76-3.48 7.76-7.76S20.25.29 15.97.29 8.21 3.77 8.21 8.05m2.142-2.76a6.27 6.27 0 0 1 5.618-3.5 6.27 6.27 0 0 1 5.617 3.5zm-.514 1.5h12.264a6.3 6.3 0 0 1 .005 2.5H9.833a6.3 6.3 0 0 1 .005-2.5m6.132 7.52a6.27 6.27 0 0 0 5.627-3.52H10.343a6.27 6.27 0 0 0 5.627 3.52m.03 9.4h.02c.41 0 .82-.15 1.13-.43.37-.33.58-.8.58-1.3v-1.15c0-.81-.55-1.5-1.33-1.7l-2.6-.65c-.69-.17-1.41.08-1.83.65l-1.25 1.67c-4.07-1.84-6.27-4.98-7.44-7.52l1.63-1.24c.55-.42.8-1.13.63-1.81l-.65-2.61c-.2-.78-.9-1.32-1.7-1.32H2c-.5 0-.96.21-1.29.57-.32.35-.47.82-.42 1.29.13 1.2.47 3.07 1.36 5.18l.37.89.02-.02c1.29 2.66 3.62 5.85 7.75 7.82l-.02.02.9.37c1.57.64 3.3 1.07 5.14 1.28.07.01.13.01.19.01m-.03-1.51a18.4 18.4 0 0 1-3.82-.83l1-1.35c.06-.08.16-.11.26-.09l2.6.65c.11.03.19.12.19.24v1.15c0 .1-.05.15-.08.18-.04.05-.09.05-.15.05M1.82 7.86c.04-.04.1-.07.17-.07v-.02h1.19c.11 0 .21.08.24.19l.65 2.61c.02.1-.01.2-.09.26l-1.3 1a17 17 0 0 1-.9-3.854c-.001-.018-.005-.071.04-.116",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "white",
  d: "M0 0h24v24H0z"
}))));
exports.default = IDD;
IDD.displayName = 'IDD';
});

unwrapExports(IDD_1);

var Itinerary_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Itinerary = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  d: "M22.01 19.51a.72.72 0 0 0-.2-.5s-.01-.02-.02-.03l-2.48-2.48a.754.754 0 0 0-1.06 0c-.29.29-.29.77 0 1.06l1.21 1.21H9.55c-.06 0-.11.02-.16.03a2.75 2.75 0 0 0-2.65-2.04c-.94 0-1.78.48-2.27 1.2a2.98 2.98 0 0 1-.97-2.2c0-1.66 1.35-3 3-3h2.87c.33 1.15 1.38 2 2.63 2s2.3-.85 2.63-2h2.87c2.48 0 4.5-2.02 4.5-4.5 0-1.54-.79-2.95-2.07-3.77 0-.08.02-.15.02-.23 0-1.52-1.23-2.75-2.75-2.75-1.26 0-2.31.85-2.64 2.01H7.37c-.33-1.15-1.38-2-2.63-2-1.52 0-2.75 1.23-2.75 2.75s1.23 2.75 2.75 2.75c1.26 0 2.31-.85 2.63-2h7.19a2.75 2.75 0 0 0 2.64 2.01c.89 0 1.67-.43 2.17-1.08.7.56 1.12 1.41 1.12 2.33 0 1.66-1.35 3-3 3h-2.86c-.33-1.15-1.38-2-2.63-2s-2.3.85-2.63 2H6.5c-2.48 0-4.5 2.02-4.5 4.5 0 1.51.76 2.9 1.99 3.73v.02c0 1.52 1.23 2.75 2.75 2.75 1.26 0 2.32-.86 2.64-2.02.05.01.11.03.17.03h9.91l-1.21 1.21c-.29.29-.29.77 0 1.06.15.15.34.22.53.22s.38-.07.53-.22l2.48-2.48s.01-.02.02-.03a.717.717 0 0 0 .2-.5zM17.21 5.5a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5M12 10.75a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m-5.26 10a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5"
}));
exports.default = Itinerary;
Itinerary.displayName = 'Itinerary';
});

unwrapExports(Itinerary_1);

var Laptop_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Laptop = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  d: "M10.48 18.54h3.04c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-3.04c-.41 0-.75.34-.75.75s.34.75.75.75"
}), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M19.99 12.44c0 .22-.042.432-.118.627q.062.106.088.233l1.22 5.88c.11.55-.02 1.13-.37 1.55-.3.37-.74.58-1.2.58H4.37c-.46 0-.89-.21-1.2-.58-.34-.42-.48-1-.37-1.55l1.22-5.88a.7.7 0 0 1 .1-.251 1.7 1.7 0 0 1-.11-.61v-8c0-.96.79-1.75 1.75-1.75h12.48c.96 0 1.75.79 1.75 1.75zm-1.75 1.75H5.76q-.095 0-.186-.01H5.37v.01l-1.1 5.29c-.04.18.06.32.1.33h15.26s.13-.15.1-.34l-1.1-5.29h-.204a2 2 0 0 1-.186.01m-12.48-10c-.14 0-.25.11-.25.25v8c0 .14.11.25.25.25h12.48c.14 0 .25-.11.25-.25v-8c0-.14-.11-.25-.25-.25z",
  clipRule: "evenodd"
}));
exports.default = Laptop;
Laptop.displayName = 'Laptop';
});

unwrapExports(Laptop_1);

var Leisure_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Leisure = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "m13.83 2 .11.382c4.459-.443 6.737 1.321 7.72 2.448.86.99 1.35 2.2 1.15 2.88a.755.755 0 0 1-1.04.48c-2.52-1.18-3.82.55-3.96.75-.2.29-.59.4-.92.26-.669-.289-1.27-.416-1.802-.437L17.63 21.85c.08.41-.19.8-.59.88q-.04.001-.078.005-.033.005-.062.005v.01c-.35 0-.67-.25-.74-.61L13.607 8.995a3.6 3.6 0 0 0-1.517 1.065c-.23.31-.67.39-1 .19-2.26-1.4-3.95.44-4.13.65-.15.17-.36.26-.57.26l.01-.01c-.09 0-.18-.01-.26-.05a.76.76 0 0 1-.49-.7c0-.672.194-6.352 6.789-7.785l-.059-.205a.76.76 0 0 1 .52-.93c.39-.12.81.12.93.52M5.783 20.3c-1.314-.465-2.236-1.408-2.873-2.9-.79-1.843-1.434-3.633-1.586-4.056l-.034-.094c-.14-.39.07-.82.46-.96s.82.07.96.46c0 .02.7 2 1.58 4.05.73 1.71 1.77 2.35 3.81 2.35 1.89 0 3.39-1.3 3.4-1.31.31-.27.78-.24 1.06.07.27.31.24.78-.07 1.06a7.5 7.5 0 0 1-1.737 1.082L12.55 21.4a.75.75 0 0 1-.9 1.2l-2.48-1.86-5.83 1.97c-.08.03-.16.04-.24.04-.31 0-.6-.2-.71-.51-.13-.39.08-.82.47-.95zM10.85 4.71c-2.188 1.026-3.083 2.704-3.45 4 .865-.428 1.96-.667 3.158-.34-.114-1.144-.084-2.519.292-3.66m2.45-.737.21-.033-.01.01.226-.03c1.387.056 2.205 2.389 2.508 3.48-1.761-.397-3.197.064-4.177.698-.113-1.445-.017-3.744 1.244-4.125m4.39 3.041c-.274-1.04-.751-2.246-1.458-3.16 1.89.166 3.094.843 3.828 1.486.39.34.68.7.88 1.01a4.4 4.4 0 0 0-3.25.664",
  clipRule: "evenodd"
}));
exports.default = Leisure;
Leisure.displayName = 'Leisure';
});

unwrapExports(Leisure_1);

var Lightning_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Lightning = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  d: "M9.62 22.75c-.24 0-.49-.05-.73-.17-.73-.34-1.1-1.1-.92-1.88l1.47-6.63a.15.15 0 0 0-.04-.15c-.02-.03-.06-.04-.14-.07l-2.33.04H6.9c-.63 0-1.21-.35-1.49-.92a1.67 1.67 0 0 1 .16-1.77l6.99-9.28c.48-.63 1.29-.85 2.01-.53.73.32 1.12 1.06.98 1.84L14.38 9.6c-.01.07.01.12.04.15.02.03.04.08.14.06h2.54a1.673 1.673 0 0 1 1.32 2.71l-7.5 9.58c-.33.42-.81.65-1.31.65zm-.36-10.39c.51 0 .98.22 1.3.62.33.4.45.92.34 1.42l-1.47 6.63s-.03.14.1.2c.12.06.19-.02.22-.05l7.5-9.58c.06-.07.04-.14.02-.19a.18.18 0 0 0-.16-.1h-2.54c-.5 0-.97-.22-1.29-.6s-.45-.89-.36-1.38l1.17-6.37s.03-.14-.1-.2-.19.03-.21.06l-7 9.29c-.06.07-.04.14-.02.19.02.04.08.07.16.1l2.33-.04h.03z"
}));
exports.default = Lightning;
Lightning.displayName = 'Lightning';
});

unwrapExports(Lightning_1);

var Listen_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Listen = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  d: "M19.15 22.68c-.91 0-1.65-.22-2.21-.65-.76-.58-.74-1.33-.73-1.87v-3.55c0-1.52 1.24-2.75 2.75-2.75h2.19c0-.59-.01-1.18-.01-1.77 0-.63-.07-1.28-.21-1.93-.38-1.81-1.2-3.43-2.35-4.68-1.14-1.23-2.64-2.09-4.33-2.48 0 0-.97-.17-2.26-.18-1.3 0-2.28.18-2.29.19a8.4 8.4 0 0 0-4.29 2.47c-1.15 1.25-1.97 2.87-2.35 4.68-.14.65-.21 1.3-.21 1.93 0 .59 0 1.18-.01 1.77h2.19c1.52 0 2.75 1.23 2.75 2.75v3.55c.01.54.03 1.29-.73 1.87-.56.43-1.3.65-2.21.65-.99 0-1.8-.32-2.41-.95-1.13-1.17-1.08-2.97-1.08-3.05-.05-1.43-.03-2.94-.02-4.39 0-.73.02-1.46.02-2.2s.08-1.49.24-2.24c.44-2.08 1.38-3.94 2.72-5.39C5.65 3 7.42 1.99 9.4 1.54c.08-.02 1.14-.21 2.59-.22 1.46 0 2.53.2 2.57.21 2.02.46 3.78 1.47 5.12 2.93 1.34 1.45 2.28 3.31 2.72 5.39.16.75.24 1.5.24 2.24s0 1.46.02 2.2c.02 1.45.03 2.96-.02 4.44 0 .03.05 1.84-1.08 3-.61.63-1.42.95-2.41.95m-.19-7.32c-.69 0-1.25.56-1.25 1.25v3.58c-.01.5 0 .55.15.66.36.28.9.34 1.29.34.57 0 1.01-.16 1.33-.49.69-.7.66-1.95.66-1.97.03-1.13.03-2.26.02-3.37h-2.21zm-16.13 0c0 1.1 0 2.22.02 3.32 0 .06-.02 1.31.66 2.01.32.33.76.49 1.33.49.39 0 .93-.06 1.29-.34.14-.11.16-.15.15-.65v-3.58c0-.69-.56-1.25-1.25-1.25H2.82z"
}));
exports.default = Listen;
Listen.displayName = 'Listen';
});

unwrapExports(Listen_1);

var Loading_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Loading = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  d: "M21.56 15.55c.07.03.14.03.21.03.33 0 .63-.21.72-.54.29-.99.43-2.01.43-3.04 0-6.02-4.9-10.92-10.92-10.92-.41 0-.75.34-.75.75s.34.75.75.75c5.19 0 9.42 4.22 9.42 9.42 0 .89-.12 1.77-.37 2.62-.12.4.11.81.51.93M7.01 2.98c.09.33.39.54.72.54v.01a.76.76 0 0 0 .39-.11c.36-.21.48-.67.27-1.03a.746.746 0 0 0-.97-.3c-.33.15-.51.53-.41.89M2.8 7.6c.12.07.24.1.37.1.26 0 .51-.14.65-.38.37-.64.81-1.23 1.31-1.77.28-.3.26-.78-.04-1.06a.755.755 0 0 0-1.06.04c-.58.62-1.09 1.31-1.51 2.05-.2.36-.08.81.28 1.02M2.13 15.23c-.34 0-.64-.23-.73-.57-.22-.86-.33-1.76-.33-2.66 0-.47.03-.94.09-1.4.05-.41.43-.7.84-.65s.7.43.65.84c-.05.4-.08.8-.08 1.21 0 .78.09 1.55.28 2.29.1.4-.14.81-.55.91-.06.02-.12.02-.18.02zM7.945 22.08h.005-.01zM8.63 21.63a.75.75 0 0 1-.98.39c-1.65-.71-3.11-1.84-4.22-3.26-.26-.33-.2-.8.12-1.05.33-.26.8-.2 1.05.12a9.54 9.54 0 0 0 3.64 2.81c.38.17.55.61.39.99M11.997 22.92a.756.756 0 0 1-.747-.75c0-.41.34-.75.75-.75 2.56 0 4.96-1.01 6.75-2.85.29-.29.76-.3 1.06-.01s.3.76.01 1.06a10.83 10.83 0 0 1-7.823 3.3M11.997 22.92H12h-.01z"
}));
exports.default = Loading;
Loading.displayName = 'Loading';
});

unwrapExports(Loading_1);

var MailUnread_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const MailUnread = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#E71336",
  d: "M20 6.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
}), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M19.919 10.5a6.5 6.5 0 0 1-2.065-.365L13.46 13.31c-.85.67-2.04.67-2.91-.03L2.79 7.658V7.55c0-.69.56-1.25 1.25-1.25h9.881a6.4 6.4 0 0 1-.372-1.5H4.04c-1.52 0-2.75 1.23-2.75 2.75v10.63c0 1.52 1.23 2.75 2.75 2.75h15.84c1.52 0 2.75-1.23 2.75-2.75V9.94a6.4 6.4 0 0 1-1.5.461v7.779c0 .69-.56 1.25-1.25 1.25H4.04c-.69 0-1.25-.56-1.25-1.25V9.503l6.86 4.957c.7.57 1.55.85 2.39.85v.01c.83 0 1.65-.27 2.33-.81z",
  clipRule: "evenodd"
}));
exports.default = MailUnread;
MailUnread.displayName = 'MailUnread';
});

unwrapExports(MailUnread_1);

var Mail_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Mail = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M4.04 20.93h15.84c1.52 0 2.75-1.23 2.75-2.75V7.55c0-1.52-1.23-2.75-2.75-2.75H4.04c-1.52 0-2.75 1.23-2.75 2.75v10.63c0 1.52 1.23 2.75 2.75 2.75M2.79 7.55c0-.69.56-1.25 1.25-1.25h15.84c.69 0 1.25.56 1.25 1.25v.218l-7.67 5.542c-.85.68-2.03.67-2.91-.03L2.79 7.658zm0 1.953 6.86 4.957c.7.57 1.55.85 2.39.85l-.01.01c.83 0 1.65-.27 2.33-.81l6.77-4.887v8.557c0 .69-.56 1.25-1.25 1.25H4.04c-.69 0-1.25-.56-1.25-1.25z",
  clipRule: "evenodd"
}));
exports.default = Mail;
Mail.displayName = 'Mail';
});

unwrapExports(Mail_1);

var _Map = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Map = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M7.56 14.88c-1.504-1.903-2.8-4.214-2.8-6.28 0-3.99 3.25-7.24 7.24-7.24s7.24 3.25 7.24 7.24c0 2.066-1.295 4.377-2.8 6.28h2.17c.78 0 1.5.45 1.83 1.15l1.06 3.02c.35.72.3 1.64-.17 2.39s-1.28 1.2-2.17 1.2H4.83c-.88 0-1.69-.45-2.17-1.2-.46-.73-.52-1.62-.17-2.41l.86-3c.33-.7 1.05-1.15 1.83-1.15zm1.302 1.5H5.18c-.19 0-.36.1-.45.26l-.86 2.98c-.16.33-.14.71.06 1.02s.52.5.9.5h14.33c.37 0 .7-.18.9-.5.2-.31.22-.69.06-1.02l-1.06-3.02c-.06-.1-.24-.22-.45-.22h-3.472c-1.4 1.476-2.719 2.46-3.138 2.46s-1.739-.984-3.138-2.46M12 2.86c-3.16 0-5.74 2.57-5.74 5.74 0 3.37 4.44 7.6 5.73 8.6 1.31-1.02 5.75-5.25 5.75-8.6 0-3.16-2.57-5.74-5.74-5.74m0 9.1a3.26 3.26 0 1 1 .001-6.521 3.26 3.26 0 0 1-.001 6.52m0-5.02c-.97 0-1.76.79-1.76 1.76s.79 1.76 1.76 1.76 1.76-.79 1.76-1.76-.79-1.76-1.76-1.76",
  clipRule: "evenodd"
}));
exports.default = Map;
Map.displayName = 'Map';
});

unwrapExports(_Map);

var Menu_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Menu = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M4.5 5.25h15c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-15c-.41 0-.75.34-.75.75s.34.75.75.75m15 7.5h-15c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h15c.41 0 .75.34.75.75s-.34.75-.75.75m0 7.5h-15c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h15c.41 0 .75.34.75.75s-.34.75-.75.75",
  clipRule: "evenodd"
}));
exports.default = Menu;
Menu.displayName = 'Menu';
});

unwrapExports(Menu_1);

var Message_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Message = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M2 23.11a.757.757 0 0 1-.75-.75V1.64c0-.41.34-.75.75-.75h20c.41 0 .75.34.75.75v15.25c0 .41-.34.75-.75.75H7.14l-4.58 5.22c-.14.17-.35.25-.56.25m.75-20.72v17.98l3.49-3.97a.75.75 0 0 1 .56-.25h14.45V2.39zm13.64 5.8H7.61c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h8.78c.41 0 .75.34.75.75s-.34.75-.75.75m-8.78 4.27h8.78c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H7.61c-.41 0-.75.34-.75.75s.34.75.75.75",
  clipRule: "evenodd"
}));
exports.default = Message;
Message.displayName = 'Message';
});

unwrapExports(Message_1);

var Mic_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Mic = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M8 12.04c0 2.21 1.79 4 4 4s4-1.79 4-4V5.31c0-2.21-1.79-4-4-4s-4 1.79-4 4zm1.5-6.73a2.5 2.5 0 0 1 5 0v6.73a2.5 2.5 0 0 1-5 0z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  d: "M4.5 12.04a7.504 7.504 0 0 0 6.75 7.463v1.687H7.12c-.41 0-.75.34-.75.75s.34.75.75.75h9.76c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-4.13v-1.687a7.504 7.504 0 0 0 6.75-7.463v-2.02c0-.41-.34-.75-.75-.75s-.75.34-.75.75v2.02c0 3.31-2.69 6-6 6s-6-2.69-6-6v-2.02c0-.41-.34-.75-.75-.75s-.75.34-.75.75z"
}));
exports.default = Mic;
Mic.displayName = 'Mic';
});

unwrapExports(Mic_1);

var Minimise_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Minimise = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M14.56 11.45c.15.15.34.22.53.22h6.48c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H16.9l6.65-6.65c.29-.29.29-.77 0-1.06a.754.754 0 0 0-1.06 0l-6.65 6.65V4.45c0-.41-.34-.75-.75-.75s-.75.34-.75.75v6.47q.001.165.067.306a.7.7 0 0 0 .153.224M2.45 23.53c.15.15.34.22.53.22s.38-.07.53-.22l6.65-6.65v4.67c0 .41.34.75.75.75s.75-.34.75-.75v-6.47a.7.7 0 0 0-.015-.15.74.74 0 0 0-.842-.6H4.43c-.41 0-.75.34-.75.75s.34.75.75.75h4.66l-6.64 6.64c-.29.29-.29.77 0 1.06",
  clipRule: "evenodd"
}));
exports.default = Minimise;
Minimise.displayName = 'Minimise';
});

unwrapExports(Minimise_1);

var MobileAddon_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const MobileAddon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M1.75 21.5c0 .96.79 1.75 1.75 1.75h12c.96 0 1.75-.79 1.75-1.75V20c0-.41-.34-.75-.75-.75s-.75.34-.75.75v1.5c0 .14-.11.25-.25.25h-12c-.14 0-.25-.11-.25-.25v-19c0-.14.11-.25.25-.25h12c.14 0 .25.11.25.25V4c0 .41.34.75.75.75s.75-.34.75-.75V2.5c0-.96-.79-1.75-1.75-1.75h-12c-.96 0-1.75.79-1.75 1.75zm9-16.25h-2.5c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2.5c.41 0 .75.34.75.75s-.34.75-.75.75m0 6.75c0 3.17 2.58 5.75 5.75 5.75s5.75-2.58 5.75-5.75-2.58-5.75-5.75-5.75-5.75 2.58-5.75 5.75m1.5 0a4.26 4.26 0 0 1 4.25-4.25A4.26 4.26 0 0 1 20.75 12a4.26 4.26 0 0 1-4.25 4.25A4.26 4.26 0 0 1 12.25 12m2.31.74h1.19v1.19c0 .41.34.75.75.75s.75-.34.75-.75v-1.19h1.2c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-1.2v-1.2c0-.41-.34-.75-.75-.75s-.75.34-.75.75v1.2h-1.19c-.41 0-.75.34-.75.75s.34.75.75.75M8.5 19.5c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1",
  clipRule: "evenodd"
}));
exports.default = MobileAddon;
MobileAddon.displayName = 'MobileAddon';
});

unwrapExports(MobileAddon_1);

var MobileBroadband_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const MobileBroadband = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M13.76 5.13V3.06c0-.16-.11-.29-.25-.29H10.5c-.14 0-.25.13-.25.29v2.07zm-5.01.05V3.06c0-.99.79-1.79 1.75-1.79h3.01c.96 0 1.75.8 1.75 1.79v2.122c.76.19 1.33.883 1.33 1.698v11.38c0 2.46-2.06 4.46-4.59 4.46s-4.59-2-4.59-4.46V6.88a1.76 1.76 0 0 1 1.34-1.7M12 21.22c-1.7 0-3.09-1.33-3.09-2.96V6.88c0-.14.11-.25.25-.25h5.68c.14 0 .25.11.25.25v11.38c0 1.63-1.39 2.96-3.09 2.96m-9.06-4.55c-.22 0-.45-.1-.59-.29A7.08 7.08 0 0 1 .85 12c0-1.6.59-3.3 1.66-4.58.27-.32.74-.36 1.06-.1.32.27.36.74.1 1.06A5.63 5.63 0 0 0 2.36 12c0 1.32.41 2.46 1.18 3.46.25.33.19.8-.13 1.05-.14.11-.3.16-.46.16zm1.97-1.89c.15.17.35.25.56.25.18 0 .36-.06.5-.19.31-.28.34-.75.06-1.06-.44-.49-.68-1.12-.68-1.78s.24-1.29.68-1.78c.27-.31.25-.78-.06-1.06a.756.756 0 0 0-1.06.06A4.2 4.2 0 0 0 3.85 12c0 1.03.37 2.02 1.06 2.78m16.15 1.89c-.16 0-.32-.05-.46-.16a.74.74 0 0 1-.13-1.05c.77-1 1.18-2.2 1.18-3.46s-.47-2.6-1.31-3.62a.75.75 0 0 1 .1-1.06.75.75 0 0 1 1.06.1A7.16 7.16 0 0 1 23.16 12c0 1.67-.52 3.11-1.5 4.38-.15.19-.37.29-.59.29zm-3.03-1.83c.14.13.32.19.5.19.21 0 .41-.08.56-.25A4.2 4.2 0 0 0 20.15 12c0-1.03-.37-2.02-1.06-2.78a.747.747 0 0 0-1.06-.06c-.31.28-.34.75-.06 1.06.44.49.68 1.12.68 1.78s-.24 1.29-.68 1.78c-.27.31-.25.78.06 1.06",
  clipRule: "evenodd"
}));
exports.default = MobileBroadband;
MobileBroadband.displayName = 'MobileBroadband';
});

unwrapExports(MobileBroadband_1);

var MobileSignal_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const MobileSignal = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M5.28 9.119 1.43 3.46a.74.74 0 0 1-.04-.77c.13-.25.39-.4.66-.4h7.96c.28 0 .53.15.66.4s.11.54-.04.77L6.78 9.12v11.85c0 .41-.34.75-.75.75s-.75-.34-.75-.75zm.74-1.569L3.46 3.78h5.12zm15.93 14.17c-.41 0-.75-.34-.75-.75v-16c0-.41.34-.75.75-.75s.75.34.75.75v16c0 .41-.34.75-.75.75m-12.69-.75c0 .41.34.75.75.75s.75-.34.75-.75v-4c0-.41-.34-.75-.75-.75s-.75.34-.75.75zm4.73.75c-.41 0-.75-.34-.75-.75v-7.5c0-.41.34-.75.75-.75s.75.34.75.75v7.5c0 .41-.34.75-.75.75m3.23-.75c0 .41.34.75.75.75s.75-.34.75-.75v-11c0-.41-.34-.75-.75-.75s-.75.34-.75.75z",
  clipRule: "evenodd"
}));
exports.default = MobileSignal;
MobileSignal.displayName = 'MobileSignal';
});

unwrapExports(MobileSignal_1);

var MobilephoneBill_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const MobilephoneBill = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: props.color || "#222222",
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 18.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1M11.85 15.33c-1.19 0-2.05-.74-2.45-1.44a.75.75 0 0 1 .27-1.03c.36-.21.82-.08 1.02.27.07.12.44.69 1.15.69.31 0 .96 0 1.22-.25.15-.14.19-.4.09-.57-.16-.27-.58-.43-.98-.55l-.59-.16c-.74-.21-1.56-.5-2.02-1.27a1.99 1.99 0 0 1 .34-2.43c.69-.67 1.71-.67 2.25-.67 1.07 0 1.95.52 2.46 1.45.2.36.07.82-.3 1.02-.36.2-.82.07-1.02-.3-.25-.46-.62-.67-1.14-.67-.31 0-.96 0-1.22.25-.15.14-.19.4-.09.57.18.3.66.46 1.14.59l.6.16c.68.21 1.42.51 1.85 1.22.46.78.32 1.79-.34 2.43-.69.67-1.71.67-2.25.67z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.15 16.38c-.41 0-.75-.34-.75-.75v-1.06c0-.41.34-.75.75-.75s.75.34.75.75v1.06c0 .41-.34.75-.75.75M12.15 9.45c-.41 0-.75-.34-.75-.75V7.64c0-.41.34-.75.75-.75s.75.34.75.75V8.7c0 .41-.34.75-.75.75M13.25 5.25h-2.5c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2.5c.41 0 .75.34.75.75s-.34.75-.75.75"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18 23.25H6c-.96 0-1.75-.79-1.75-1.75v-19c0-.96.79-1.75 1.75-1.75h12c.96 0 1.75.79 1.75 1.75v19c0 .96-.79 1.75-1.75 1.75m-12-21c-.14 0-.25.11-.25.25v19c0 .14.11.25.25.25h12c.14 0 .25-.11.25-.25v-19c0-.14-.11-.25-.25-.25z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "white",
  d: "M0 0h24v24H0z"
}))));
exports.default = MobilephoneBill;
MobilephoneBill.displayName = 'MobilephoneBill';
});

unwrapExports(MobilephoneBill_1);

var Mobilephone_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Mobilephone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M4.25 21.5c0 .96.79 1.75 1.75 1.75h12c.96 0 1.75-.79 1.75-1.75v-19c0-.96-.79-1.75-1.75-1.75H6c-.96 0-1.75.79-1.75 1.75zm1.5-19c0-.14.11-.25.25-.25h12c.14 0 .25.11.25.25v19c0 .14-.11.25-.25.25H6c-.14 0-.25-.11-.25-.25zm7.25 17a1 1 0 1 1-2 0 1 1 0 0 1 2 0m.25-14.25h-2.5c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2.5c.41 0 .75.34.75.75s-.34.75-.75.75",
  clipRule: "evenodd"
}));
exports.default = Mobilephone;
Mobilephone.displayName = 'Mobilephone';
});

unwrapExports(Mobilephone_1);

var Monitor_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Monitor = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M13.598 18.1h-3.206l-.308 3.04h3.822zm1.505 0h4.967c1.52 0 2.75-1.23 2.75-2.75V4.11c0-1.52-1.23-2.75-2.75-2.75H3.92c-1.52 0-2.75 1.23-2.75 2.75v11.24c0 1.52 1.23 2.75 2.75 2.75h4.967l-.308 3.04h-2.17c-.41 0-.75.34-.75.75s.34.75.75.75H17.59c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H15.41zm6.217-4.17v1.42c0 .69-.56 1.25-1.25 1.25H3.92c-.69 0-1.25-.56-1.25-1.25v-1.42zm0-1.5H2.67V4.11c0-.69.56-1.25 1.25-1.25h16.15c.69 0 1.25.56 1.25 1.25z",
  clipRule: "evenodd"
}));
exports.default = Monitor;
Monitor.displayName = 'Monitor';
});

unwrapExports(Monitor_1);

var More_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const More = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M4.26 15.06a3.06 3.06 0 1 1 0-6.12 3.06 3.06 0 0 1 0 6.12m0-4.62c-.86 0-1.56.7-1.56 1.56s.7 1.56 1.56 1.56 1.56-.7 1.56-1.56-.7-1.56-1.56-1.56m15.48 4.62a3.06 3.06 0 1 1 0-6.12 3.06 3.06 0 0 1 0 6.12m0-4.62c-.86 0-1.56.7-1.56 1.56s.7 1.56 1.56 1.56 1.56-.7 1.56-1.56-.7-1.56-1.56-1.56M8.94 12a3.06 3.06 0 1 0 6.12 0 3.06 3.06 0 0 0-6.12 0m1.5 0c0-.86.7-1.56 1.56-1.56s1.56.7 1.56 1.56-.7 1.56-1.56 1.56-1.56-.7-1.56-1.56",
  clipRule: "evenodd"
}));
exports.default = More;
More.displayName = 'More';
});

unwrapExports(More_1);

var Movie_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Movie = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M8.54 9.168q.213.277.471.512h-.868q.223-.236.396-.512M8.084 5.1a3.28 3.28 0 0 0-2.335-.97c-1.82 0-3.29 1.47-3.29 3.29 0 .876.343 1.671.9 2.26h-.34c-.96 0-1.75.79-1.75 1.75v8c0 .96.79 1.75 1.75 1.75h14c.96 0 1.75-.79 1.75-1.75v-.748l2.98.948c.08.03.15.04.23.04v.01c.15 0 .31-.05.44-.14.2-.15.31-.37.31-.61v-6.98c0-.24-.12-.47-.31-.61a.76.76 0 0 0-.67-.11l-2.98.948v-.748c0-.96-.79-1.75-1.75-1.75h-2.691a3.94 3.94 0 0 0 1.291-2.92c0-2.18-1.77-3.95-3.95-3.95A3.95 3.95 0 0 0 8.085 5.1m3.585-.78c-1.35 0-2.45 1.1-2.45 2.45s1.1 2.45 2.45 2.45 2.45-1.1 2.45-2.45-1.1-2.45-2.45-2.45m7.1 9.43v3.36l2.46.78v-4.92zm-1.5-.55v-1.77c0-.14-.11-.25-.25-.25h-14c-.14 0-.25.11-.25.25v8c0 .14.11.25.25.25h14c.14 0 .25-.11.25-.25V13.2M3.96 7.43c0-.99.8-1.79 1.79-1.79s1.79.8 1.79 1.79-.8 1.79-1.79 1.79-1.79-.8-1.79-1.79",
  clipRule: "evenodd"
}));
exports.default = Movie;
Movie.displayName = 'Movie';
});

unwrapExports(Movie_1);

var Music_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Music = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M8.29 16.013V7.08c0-1.08.68-2.05 1.69-2.42l8.34-3.08c.67-.24 1.41-.15 1.99.25.58.41.93 1.07.93 1.78v13.27c0 1.97-1.6 3.57-3.57 3.57s-3.57-1.6-3.57-3.57a3.572 3.572 0 0 1 5.64-2.908V7.97l-9.95 3.475v6.704a3.572 3.572 0 0 1-3.47 4.411c-1.97 0-3.57-1.6-3.57-3.57a3.572 3.572 0 0 1 5.54-2.977m1.5-6.163 9.95-3.475V3.61c0-.22-.1-.42-.29-.55a.64.64 0 0 0-.61-.08L10.5 6.06c-.42.16-.71.57-.71 1.02zm7.88 4.96c-1.14 0-2.07.93-2.07 2.07s.93 2.07 2.07 2.07 2.07-.93 2.07-2.07-.93-2.07-2.07-2.07M6.32 16.93c-1.14 0-2.07.93-2.07 2.07s.93 2.07 2.07 2.07 2.07-.93 2.07-2.07-.93-2.07-2.07-2.07",
  clipRule: "evenodd"
}));
exports.default = Music;
Music.displayName = 'Music';
});

unwrapExports(Music_1);

var Notice_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Notice = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "black",
  fillRule: "evenodd",
  d: "M19.76 22.75H4.24c-.41 0-.75-.34-.75-.75V2c0-.41.34-.75.75-.75h15.53c.41 0 .75.34.75.75v20c0 .41-.34.75-.75.75zm-14.77-1.5h14.03V2.75H4.99zm7.22-14.1a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5m-4.24 3.81h8.05c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H7.97c-.41 0-.75.34-.75.75s.34.75.75.75m8.05 4.08H7.97c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h8.05c.41 0 .75.34.75.75s-.34.75-.75.75m-8.04 4.08h3.63c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H7.98c-.41 0-.75.34-.75.75s.34.75.75.75",
  clipRule: "evenodd"
}));
exports.default = Notice;
Notice.displayName = 'Notice';
});

unwrapExports(Notice_1);

var NotificationActive_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const NotificationActive = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#E71336",
  d: "M20 6.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
}), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M14.02 1.46a7 7 0 0 0-.89-.15c-.74-.08-1.52-.08-2.26 0-.67.07-1.34.24-1.98.49-2.13.84-3.64 2.78-4.14 5.3-.18.88-.16 1.76-.14 2.61.01.25.01.5.01.74v2.89c0 .99-.19 1.44-.73 1.79-.96.62-1.77 1.83-1.4 3.11.16.68.61 1.41 1.38 1.41h16.27c.76 0 1.21-.73 1.37-1.38.38-1.3-.43-2.52-1.39-3.14-.55-.35-.73-.8-.73-1.79v-2.868a6.4 6.4 0 0 1-1.51-.328v3.196c0 1.05.17 2.25 1.41 3.05.48.31.93.9.76 1.49-.02.09-.06.2-.1.27H4.05a2 2 0 0 1-.11-.29c-.16-.56.29-1.16.77-1.47 1.24-.8 1.41-1.99 1.41-3.05v-2.89q-.001-.186-.005-.377-.005-.196-.005-.393c-.02-.8-.03-1.57.11-2.28.4-2.04 1.55-3.53 3.22-4.19.52-.21 1.05-.34 1.59-.4.63-.07 1.31-.07 1.94 0q.313.034.622.102.13-.762.428-1.452m-.15 21.29h-3.73c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3.73c.41 0 .75.34.75.75s-.34.75-.75.75",
  clipRule: "evenodd"
}));
exports.default = NotificationActive;
NotificationActive.displayName = 'NotificationActive';
});

unwrapExports(NotificationActive_1);

var NotificationDisabled_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const NotificationDisabled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M3.44 19.557c-.521-.2-.842-.776-.98-1.327-.37-1.28.44-2.49 1.4-3.11.54-.35.72-.8.72-1.79v-2.88c0-.24 0-.49-.01-.74-.02-.85-.04-1.73.14-2.6.5-2.52 2-4.44 4.13-5.28.64-.25 1.31-.42 1.98-.49.74-.08 1.51-.08 2.25 0 .67.07 1.34.24 1.98.49 1.354.536 2.453 1.497 3.208 2.795L21.27 1.59c.29-.29.77-.3 1.06 0 .29.29.3.77 0 1.06L2.73 22.4c-.15.15-.34.22-.53.22s-.38-.07-.53-.22a.745.745 0 0 1 0-1.06zM17.152 5.74c-.583-1.19-1.507-2.06-2.652-2.52-.52-.2-1.05-.34-1.59-.39-.63-.07-1.3-.07-1.94 0-.54.06-1.07.19-1.58.39-1.67.66-2.81 2.14-3.21 4.18-.131.666-.122 1.375-.112 2.128l.002.152q.001.195.005.385.005.191.005.385v2.88c0 1.06-.17 2.24-1.41 3.05-.48.31-.92.9-.76 1.46.03.1.07.21.11.29h.64q.09 0 .175.021zM10.08 19.63h9.96c.76 0 1.21-.73 1.37-1.38.37-1.3-.43-2.51-1.39-3.13-.54-.35-.72-.8-.72-1.79v-2.88c0-.41-.34-.75-.75-.75s-.75.34-.75.75v2.88c0 1.06.17 2.25 1.41 3.05.48.31.92.9.75 1.49-.02.07-.06.18-.1.26h-9.78c-.41 0-.75.34-.75.75s.34.75.75.75m3.72 3.09h-3.72c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3.72c.41 0 .75.34.75.75s-.34.75-.75.75",
  clipRule: "evenodd"
}));
exports.default = NotificationDisabled;
NotificationDisabled.displayName = 'NotificationDisabled';
});

unwrapExports(NotificationDisabled_1);

var Notification_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Notification = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M3.9 19.63h16.21c.76 0 1.21-.73 1.37-1.38.37-1.3-.43-2.51-1.39-3.13-.54-.35-.72-.8-.72-1.79v-2.88q0-.187.005-.37a18 18 0 0 0 .006-.493c.01-.812.02-1.649-.141-2.477-.5-2.51-2-4.44-4.13-5.28-.64-.25-1.31-.42-1.98-.49-.73-.08-1.51-.08-2.25 0-.67.07-1.34.24-1.98.49-2.13.84-3.63 2.76-4.13 5.28-.18.87-.16 1.75-.14 2.6.01.25.01.5.01.74v2.88c0 .99-.18 1.44-.72 1.79-.96.62-1.77 1.83-1.4 3.11.17.68.62 1.4 1.38 1.4m16.03-1.5H4.08a2 2 0 0 1-.11-.29c-.16-.56.28-1.15.76-1.46 1.24-.81 1.41-1.99 1.41-3.05v-2.88q-.001-.194-.005-.385L6.13 9.68l-.002-.152c-.01-.753-.02-1.462.112-2.128.4-2.04 1.54-3.52 3.21-4.18.51-.2 1.04-.33 1.58-.39.64-.07 1.31-.07 1.94 0 .53.05 1.06.19 1.58.39 1.67.66 2.81 2.14 3.21 4.18.14.71.13 1.47.11 2.28-.01.26-.01.52-.01.77v2.88c0 1.06.17 2.25 1.41 3.05.48.31.93.9.76 1.49-.02.08-.06.19-.1.26m-9.79 4.59h3.72c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-3.72c-.41 0-.75.34-.75.75s.34.75.75.75",
  clipRule: "evenodd"
}));
exports.default = Notification;
Notification.displayName = 'Notification';
});

unwrapExports(Notification_1);

var Options_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Options = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M12 7.32a3.06 3.06 0 1 1 0-6.12 3.06 3.06 0 0 1 0 6.12m0-4.63c-.86 0-1.56.7-1.56 1.56s.7 1.56 1.56 1.56 1.56-.7 1.56-1.56-.7-1.56-1.56-1.56m0 20.12a3.06 3.06 0 1 1 0-6.12 3.06 3.06 0 0 1 0 6.12m0-4.63c-.86 0-1.56.7-1.56 1.56s.7 1.56 1.56 1.56 1.56-.7 1.56-1.56-.7-1.56-1.56-1.56M8.94 12a3.06 3.06 0 1 0 6.12 0 3.06 3.06 0 0 0-6.12 0m1.5 0c0-.86.7-1.56 1.56-1.56s1.56.7 1.56 1.56-.7 1.56-1.56 1.56-1.56-.7-1.56-1.56",
  clipRule: "evenodd"
}));
exports.default = Options;
Options.displayName = 'Options';
});

unwrapExports(Options_1);

var Pause_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Pause = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M6.46 20.71h.58c1.39 0 2.52-1.13 2.52-2.52V5.64c0-1.3-1.05-2.35-2.35-2.35h-.75c-1.39 0-2.52 1.13-2.52 2.52v12.38c0 1.39 1.13 2.52 2.52 2.52M5.44 5.81c0-.56.46-1.02 1.02-1.02h.76c.47 0 .85.38.85.85v12.55c0 .56-.46 1.02-1.02 1.02h-.59c-.56 0-1.02-.46-1.02-1.02zm11.51 14.9h.58c1.39 0 2.52-1.13 2.52-2.52V5.81c0-1.39-1.13-2.52-2.52-2.52h-.75c-1.3 0-2.35 1.05-2.35 2.35v12.55c0 1.39 1.13 2.52 2.52 2.52M15.93 5.64c0-.47.38-.85.85-.85h.76c.56 0 1.02.46 1.02 1.02v12.38c0 .56-.46 1.02-1.02 1.02h-.59c-.56 0-1.02-.46-1.02-1.02z",
  clipRule: "evenodd"
}));
exports.default = Pause;
Pause.displayName = 'Pause';
});

unwrapExports(Pause_1);

var PeaceOfMind_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const PeaceOfMind = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M1 12c0 6.07 4.93 11 11 11s11-4.93 11-11S18.07 1 12 1 1 5.93 1 12m1.5 0c0-5.24 4.26-9.5 9.5-9.5s9.5 4.26 9.5 9.5-4.26 9.5-9.5 9.5-9.5-4.26-9.5-9.5m3.32-2.13c.45.34 1.297.749 2.325.75H8.14h.01-.005c.709 0 1.487-.191 2.275-.72.34-.23.43-.7.2-1.04a.753.753 0 0 0-1.04-.2c-1.47 1-2.7.13-2.84.03a.748.748 0 0 0-.92 1.18m7.39 0c.44.34 1.297.749 2.325.75h-.005.01-.005c.709 0 1.487-.191 2.275-.72.34-.23.43-.7.2-1.04a.753.753 0 0 0-1.04-.2c-1.47 1-2.7.13-2.84.03a.756.756 0 0 0-1.05.13c-.25.32-.2.8.13 1.05M12 17.53c-2.34 0-4.408-1.187-4.624-1.311l-.016-.009a.76.76 0 0 1-.26-1.03c.21-.36.67-.47 1.03-.26l.008.005c.138.078 1.94 1.105 3.862 1.105s3.724-1.027 3.862-1.105l.008-.005a.74.74 0 0 1 1.03.26c.21.36.1.82-.26 1.03l-.015.008c-.212.122-2.292 1.312-4.625 1.312",
  clipRule: "evenodd"
}));
exports.default = PeaceOfMind;
PeaceOfMind.displayName = 'PeaceOfMind';
});

unwrapExports(PeaceOfMind_1);

var Personal_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Personal = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M7.18 6.09c0 2.66 2.16 4.82 4.82 4.82v-.01c2.66 0 4.82-2.16 4.82-4.82S14.66 1.26 12 1.26 7.18 3.43 7.18 6.09m1.5-.01c0-1.83 1.49-3.32 3.32-3.32s3.32 1.49 3.32 3.32S13.83 9.4 12 9.4 8.68 7.91 8.68 6.08M3.72 22.74h16.57c1.35 0 2.44-1.04 2.44-2.33 0-2.97-1.48-5.1-4.53-6.5-1.8-.82-3.82-1.24-6.02-1.24h-.55c-2.2 0-4.2.41-5.95 1.21-2.96 1.36-4.4 3.5-4.4 6.53 0 1.28 1.09 2.33 2.44 2.33m2.59-7.51c1.55-.71 3.34-1.07 5.32-1.07h.54c1.98 0 3.8.37 5.39 1.1 2.53 1.16 3.66 2.75 3.66 5.14 0 .46-.42.83-.94.83H3.72c-.52 0-.94-.37-.94-.83 0-2.45 1.09-4.04 3.53-5.17",
  clipRule: "evenodd"
}));
exports.default = Personal;
Personal.displayName = 'Personal';
});

unwrapExports(Personal_1);

var PhoneContact_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const PhoneContact = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  d: "M20 21.71h-.18c-2.12-.23-4.1-.71-5.89-1.44h-.02l-.88-.36v-.02c-4.73-2.22-7.37-5.88-8.81-8.9H4.2l-.38-.88C2.8 7.68 2.42 5.54 2.28 4.17c-.05-.47.11-.94.42-1.29.33-.36.79-.57 1.29-.57h1.56c.8 0 1.5.54 1.7 1.33l.78 3.11c.17.68-.08 1.39-.63 1.81l-1.95 1.49c1.32 2.9 3.84 6.52 8.52 8.61l1.5-2.01c.42-.57 1.14-.82 1.83-.65l3.1.77c.78.2 1.33.89 1.33 1.7V20c0 .49-.21.97-.57 1.29-.31.28-.72.44-1.14.44zm-4.59-2.5c1.42.49 2.95.82 4.57 1 .08.01.12-.02.15-.05s.08-.08.08-.18v-1.53c0-.12-.08-.21-.19-.24l-3.1-.77c-.1-.02-.2.01-.26.09l-1.26 1.68zM4 3.79c-.07 0-.13.03-.17.07-.05.06-.04.11-.04.13.11 1.09.39 2.72 1.07 4.6l1.63-1.25c.08-.06.12-.16.09-.26L5.8 3.97a.255.255 0 0 0-.24-.19H4z"
}));
exports.default = PhoneContact;
PhoneContact.displayName = 'PhoneContact';
});

unwrapExports(PhoneContact_1);

var Pin_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Pin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M3.27 10.15c0 5.21 7.42 12.42 8.73 12.42v.01c1.03 0 8.73-6.96 8.73-12.42 0-4.81-3.92-8.73-8.73-8.73s-8.73 3.91-8.73 8.72m1.5.01c0-3.988 3.247-7.227 7.225-7.23 3.988.003 7.225 3.252 7.225 7.23 0 4.27-5.73 9.67-7.23 10.79-1.48-1.09-7.22-6.49-7.22-10.79m3.39.11a3.841 3.841 0 0 0 7.68 0 3.841 3.841 0 0 0-7.68 0m1.5.01c0-1.29 1.05-2.34 2.34-2.34s2.34 1.05 2.34 2.34-1.05 2.34-2.34 2.34-2.34-1.05-2.34-2.34",
  clipRule: "evenodd"
}));
exports.default = Pin;
Pin.displayName = 'Pin';
});

unwrapExports(Pin_1);

var Play_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Play = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "black",
  d: "M6.28 20.61c-.34 0-.69-.09-1-.27-.63-.36-1-1.01-1-1.73V5.39c0-.72.37-1.37 1-1.73s1.37-.36 2 0l11.44 6.61c.63.36 1 1.01 1 1.73s-.37 1.37-1 1.73L7.28 20.34c-.31.18-.66.27-1 .27m0-15.72c-.12 0-.21.04-.25.07-.08.04-.25.17-.25.43V18.6c0 .26.17.39.25.43s.28.13.5 0l11.44-6.61c.23-.13.25-.35.25-.43 0-.09-.02-.3-.25-.43L6.53 4.96a.5.5 0 0 0-.25-.07"
}));
exports.default = Play;
Play.displayName = 'Play';
});

unwrapExports(Play_1);

var Pointer_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Pointer = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  d: "M11.49 22.74c-.48 0-1-.03-1.52-.22-.86-.31-1.69-.91-2.45-1.79l-4.35-5.55-.06-.09c-.46-.81-.92-2.62.68-3.71.98-.67 2.09-.74 3.04-.19.05.03.09.06.13.1l.68.61V4.21c0-.4.09-.82.27-1.22.37-.84 1.12-1.44 2.05-1.63.56-.12 1.39-.22 2.12.25.62.4.97 1.07.97 1.85v4.43l5.18 1.75c1.97.67 3.1 1.95 3.1 3.51v4.7q0 .945-.54 2.07c-.42.87-.98 1.6-1.61 2.12-.85.69-1.62.69-2.45.69h-5.25zM4.38 14.3l4.29 5.47c.57.65 1.18 1.11 1.8 1.33.41.15.87.14 1.39.13h4.77c.85 0 1.18-.02 1.6-.36.47-.38.88-.93 1.21-1.6.26-.54.39-1.03.39-1.42v-4.7c0-1.21-1.3-1.83-2.08-2.09l-5.69-1.92c-.3-.1-.51-.39-.51-.71V3.46c0-.15-.04-.43-.28-.58-.21-.13-.52-.15-1.01-.05-.46.09-.81.37-.98.76-.09.21-.14.43-.14.62v9.38c0 .3-.17.57-.45.69-.27.12-.59.07-.81-.13l-1.86-1.68c-.55-.27-1.06-.07-1.39.17-.77.52-.38 1.42-.25 1.68z"
}));
exports.default = Pointer;
Pointer.displayName = 'Pointer';
});

unwrapExports(Pointer_1);

var PowerSwitch_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const PowerSwitch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M11.25 12.08c0 .41.34.75.75.75s.75-.34.75-.75V2.07c0-.41-.34-.75-.75-.75s-.75.34-.75.75zm-9.44.41c0 5.62 4.57 10.19 10.2 10.19 5.62 0 10.19-4.57 10.19-10.19 0-4.15-2.48-7.85-6.32-9.43a.754.754 0 0 0-.98.41c-.16.38.03.82.41.98a8.66 8.66 0 0 1 5.39 8.04c0 4.79-3.91 8.69-8.7 8.69s-8.69-3.9-8.69-8.69c0-3.54 2.12-6.69 5.39-8.04.38-.16.57-.6.41-.98a.754.754 0 0 0-.98-.41 10.16 10.16 0 0 0-6.32 9.43",
  clipRule: "evenodd"
}));
exports.default = PowerSwitch;
PowerSwitch.displayName = 'PowerSwitch';
});

unwrapExports(PowerSwitch_1);

var Processing_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Processing = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M15.15 22.75h-11c-1.52 0-2.75-1.23-2.75-2.75V4c0-1.52 1.23-2.75 2.75-2.75h11c1.52 0 2.75 1.23 2.75 2.75v4.357c2.694.662 4.7 3.1 4.7 5.993 0 2.902-2.017 5.344-4.722 5.998a2.75 2.75 0 0 1-2.728 2.402M16.4 4v4.18a6.18 6.18 0 0 0-6.14 6.17 6.18 6.18 0 0 0 6.028 6.168 1.25 1.25 0 0 1-1.138.732h-11c-.69 0-1.25-.56-1.25-1.25V4c0-.69.56-1.25 1.25-1.25h11c.69 0 1.25.56 1.25 1.25m-2.61 2.38H5.63c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h8.16c.41 0 .75.34.75.75s-.34.75-.75.75M5.63 10.1h3.08c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H5.63c-.41 0-.75.34-.75.75s.34.75.75.75m10.8-.42a4.669 4.669 0 1 0 0 9.34 4.669 4.669 0 1 0 0-9.34m1.41 6.97c.14.12.3.17.47.17l.01-.01c.22 0 .43-.1.58-.28.26-.32.21-.79-.11-1.05l-1.67-1.35v-2.71c0-.41-.34-.75-.75-.75s-.75.34-.75.75v3.07c0 .22.1.44.28.58z",
  clipRule: "evenodd"
}));
exports.default = Processing;
Processing.displayName = 'Processing';
});

unwrapExports(Processing_1);

var Recommended_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Recommended = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  d: "M11.95 21c-4.04 0-7.29-.99-7.43-1.03a.75.75 0 0 1-.52-.6L2.04 6.81a.755.755 0 0 1 1.22-.7L8 9.95l3.32-6.55a.76.76 0 0 1 .67-.41c.28 0 .54.16.67.41l3.32 6.55 4.79-3.84c.24-.19.58-.22.85-.06s.41.46.36.77l-2.01 12.56c-.05.28-.25.51-.52.6-.14.04-3.44 1.03-7.48 1.03zm-6.54-2.34c1 .26 3.57.84 6.54.84s5.59-.59 6.6-.85l1.63-10.16-3.99 3.2a.751.751 0 0 1-1.14-.24L11.98 5.4l-3.07 6.06c-.1.2-.29.35-.51.39-.22.05-.45 0-.63-.15L3.83 8.5l1.59 10.15z"
}));
exports.default = Recommended;
Recommended.displayName = 'Recommended';
});

unwrapExports(Recommended_1);

var RedMembership_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const RedMembership = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  d: "M11.79 1.76C6.14 1.76 1.55 6.35 1.55 12s4.59 10.24 10.24 10.24S22.03 17.65 22.03 12 17.43 1.76 11.79 1.76m5.74 16.81c-.37.32-.76.61-1.17.86l-3.35-5.46a2.84 2.84 0 0 0 2.6-2.82c0-1.56-1.27-2.83-2.83-2.83h-2.35V6.99h2.58c2.37 0 4.09 1.72 4.09 4.09 0 1.59-.46 2.63-1.44 3.27l-.63.41 2.51 3.81zm-4.76-8.74c.73 0 1.33.6 1.33 1.33s-.6 1.33-1.33 1.33h-2.35V9.84h2.35zM8.92 20.25a8 8 0 0 1-1.56-.73V9.83h1.56zm1.5.37v-7.98l4.59 7.48c-1 .4-2.09.63-3.23.63-.47 0-.92-.05-1.36-.12zm8.18-3.16-1.53-2.32c1.02-.93 1.52-2.27 1.52-4.07 0-3.19-2.4-5.59-5.59-5.59H8.92v2.83H5.86v10.07c-1.72-1.6-2.81-3.87-2.81-6.4 0-4.8 3.92-8.72 8.74-8.72s8.74 3.92 8.74 8.74c0 2.07-.73 3.97-1.93 5.46"
}));
exports.default = RedMembership;
RedMembership.displayName = 'RedMembership';
});

unwrapExports(RedMembership_1);

var RefreshPhone_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const RefreshPhone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M16.27 23.25c.96 0 1.75-.79 1.75-1.75v-2.04c0-.41-.34-.75-.75-.75s-.75.34-.75.75v2.04c0 .14-.11.25-.25.25h-12c-.14 0-.25-.11-.25-.25v-19c0-.14.11-.25.25-.25h12c.14 0 .25.11.25.25v1.42c0 .41.34.75.75.75s.75-.34.75-.75V2.5c0-.96-.79-1.75-1.75-1.75h-12c-.96 0-1.75.79-1.75 1.75v19c0 .96.79 1.75 1.75 1.75zm-7.25-18h2.5c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-2.5c-.41 0-.75.34-.75.75s.34.75.75.75m1.25 15.26a1 1 0 1 0 0-2 1 1 0 0 0 0 2m8.84-10.04h2.78a.743.743 0 0 0 .3-.06.75.75 0 0 0 .45-.804V6.85c0-.41-.34-.75-.75-.75s-.75.34-.75.75v.542a5.761 5.761 0 0 0-9.62 4.278c0 3.18 2.58 5.76 5.76 5.76v.01a5.73 5.73 0 0 0 5.5-4.05c.13-.4-.09-.82-.49-.94-.4-.13-.82.1-.94.49a4.24 4.24 0 0 1-4.07 2.99c-2.35 0-4.26-1.91-4.26-4.26a4.263 4.263 0 0 1 7.562-2.7H19.11c-.41 0-.75.34-.75.75s.34.75.75.75",
  clipRule: "evenodd"
}));
exports.default = RefreshPhone;
RefreshPhone.displayName = 'RefreshPhone';
});

unwrapExports(RefreshPhone_1);

var Refresh_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Refresh = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M1.47 12c0 5.928 4.817 10.747 10.745 10.75h-.005.01-.005A10.7 10.7 0 0 0 22.48 15.2c.13-.4-.09-.82-.49-.94-.4-.13-.82.1-.94.49a9.205 9.205 0 0 1-8.83 6.5c-5.1 0-9.25-4.15-9.25-9.25s4.15-9.25 9.25-9.25a9.24 9.24 0 0 1 8.002 4.61H15.89c-.41 0-.75.34-.75.75s.34.75.75.75h5.55a.755.755 0 0 0 .745-.835 1 1 0 0 0 .005-.085V2.38c0-.41-.34-.75-.75-.75s-.75.34-.75.75v3a10.73 10.73 0 0 0-8.47-4.13C6.3 1.25 1.47 6.07 1.47 12",
  clipRule: "evenodd"
}));
exports.default = Refresh;
Refresh.displayName = 'Refresh';
});

unwrapExports(Refresh_1);

var Remote_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Remote = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M14.71 2.12c.04.39.37.68.75.68h.06l.091-.003c.079-.004.185-.009.316-.004q.06.014.123.017c.75.03 2.2.3 3.52 1.62s1.6 2.75 1.65 3.48c.03.4.36.7.75.7h.04a.75.75 0 0 0 .7-.8c-.06-.95-.4-2.77-2.08-4.44-1.614-1.604-3.394-1.981-4.383-2.053a1 1 0 0 0-.127-.017c-.35-.03-.61-.01-.73 0-.41.04-.72.41-.68.82m-6.33 20.6c-.74 0-1.43-.29-1.94-.81l-4.35-4.35c-.52-.52-.81-1.21-.81-1.94s.29-1.42.81-1.94l7.73-7.73c1.04-1.04 2.85-1.04 3.89 0l1.343 1.343a1.17 1.17 0 0 1 1.654 1.654L18.06 10.3a2.73 2.73 0 0 1 0 3.88l-7.73 7.73c-.52.52-1.21.81-1.94.81zm3.37-16.08c-.32 0-.64.12-.88.37l-7.73 7.73a1.234 1.234 0 0 0 0 1.76l4.35 4.35c.47.47 1.29.47 1.77 0l7.73-7.73a1.234 1.234 0 0 0 0-1.76l-4.35-4.35c-.24-.24-.56-.37-.88-.37zm-.09 4.78c-.19 0-.38-.07-.53-.22l-.94-.94a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l.94.94c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22m2.07 2.39c.15.15.34.22.53.22s.38-.07.53-.22c.29-.29.29-.77 0-1.06l-.94-.94a.754.754 0 0 0-1.06 0c-.29.29-.29.77 0 1.06zm-3.3 4.05c-.19 0-.38-.07-.53-.22l-1.245-1.245L7.41 17.64c-.15.15-.34.22-.53.22s-.38-.07-.53-.22a.754.754 0 0 1 0-1.06l1.245-1.245L6.35 14.09a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l1.245 1.245L9.9 13.03c.29-.29.77-.29 1.06 0s.29.77 0 1.06l-1.245 1.245 1.245 1.245c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22m8.54-8.85h-.07a.756.756 0 0 1-.68-.81v-.005c0-.087.01-.875-.75-1.635-.82-.82-1.64-.79-1.67-.78a.743.743 0 0 1-.8-.69c-.03-.41.26-.77.67-.8h.018c.183-.009 1.561-.07 2.812 1.19 1.34 1.34 1.22 2.79 1.21 2.86a.75.75 0 0 1-.75.68z",
  clipRule: "evenodd"
}));
exports.default = Remote;
Remote.displayName = 'Remote';
});

unwrapExports(Remote_1);

var Return_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Return = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M1.41 5.02q0 .036.003.07c.004.175.07.349.197.49l2.61 2.87c.14.17.35.25.55.25h.01c.18 0 .36-.07.5-.2.31-.28.33-.75.05-1.06L3.811 5.77H19.84c.69 0 1.25.56 1.25 1.25v3.99c0 .41.34.75.75.75s.75-.34.75-.75V7.02c0-1.52-1.23-2.75-2.75-2.75H3.857L5.33 2.65c.28-.31.26-.78-.05-1.06a.746.746 0 0 0-1.06.05L1.61 4.51a.77.77 0 0 0-.2.51M18.73 22.4c.14.14.32.2.5.2h.01c.2 0 .4-.09.55-.25l2.61-2.87a.75.75 0 0 0 .196-.535.75.75 0 0 0-.196-.535l-2.61-2.87a.746.746 0 0 0-1.06-.05c-.31.28-.33.75-.05 1.06l1.528 1.68H4.16c-.69 0-1.25-.56-1.25-1.25v-3.99c0-.41-.34-.75-.75-.75s-.75.34-.75.75v3.99c0 1.52 1.23 2.75 2.75 2.75h15.984l-1.464 1.61c-.28.31-.26.78.05 1.06",
  clipRule: "evenodd"
}));
exports.default = Return;
Return.displayName = 'Return';
});

unwrapExports(Return_1);

var Rewards_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Rewards = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M12 22.94H3.5c-.41 0-.75-.34-.75-.75v-15c0-.41.34-.75.75-.75h3.486c-.522-.662-.662-1.304-.656-1.81 0-.92.37-1.78.96-2.31 1.16-1.05 2.96-1.06 4.17-.02q.227.201.435.441c.245-.342.498-.619.765-.851 1.31-1.13 3.26-1.12 4.52.02.64.58 1.03 1.52 1.04 2.51 0 .562-.156 1.28-.76 2.02h3.04c.41 0 .75.34.75.75v15c0 .41-.34.75-.75.75zm-.75-18.56a.7.7 0 0 1-.14-.17q-.285-.48-.63-.78c-.63-.54-1.59-.54-2.18 0-.28.25-.46.73-.46 1.22 0 .78.798 1.398 1.496 1.79h1.914zm8.5 17.06h-7.02V7.94h2.51a1 1 0 0 0 .154 0h4.356zm-4.625-15H12.73V4.16c.03-.04.09-.13.09-.13l.09-.13c.22-.36.46-.66.72-.88.73-.62 1.85-.62 2.54 0 .33.3.54.84.54 1.42.01.864-.818 1.547-1.585 2m-3.875 1.5v13.5h-7V7.94z",
  clipRule: "evenodd"
}));
exports.default = Rewards;
Rewards.displayName = 'Rewards';
});

unwrapExports(Rewards_1);

var Roaming_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Roaming = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M2.55 23.25c-.96 0-1.75-.79-1.75-1.75v-19c0-.96.79-1.75 1.75-1.75h12c.96 0 1.75.79 1.75 1.75v1.42c0 .41-.34.75-.75.75s-.75-.34-.75-.75V2.5c0-.14-.11-.25-.25-.25h-12c-.14 0-.25.11-.25.25v19c0 .14.11.25.25.25h12c.14 0 .25-.11.25-.25v-2.54c0-.41.34-.75.75-.75s.75.34.75.75v2.54c0 .96-.79 1.75-1.75 1.75zm19.16-10.8a.746.746 0 0 0 .98-.4c.36-.88.86-2.68.11-4.9-.75-2.25-2.26-3.38-3.1-3.85a.74.74 0 0 0-1.02.28.74.74 0 0 0 .28 1.02c.65.36 1.83 1.25 2.42 3.02s.2 3.17-.08 3.85c-.15.38.03.82.41.98M9.55 19.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0m9.28-7.98a.747.747 0 0 1-.64-1.13c.03-.05.41-.75.06-1.81-.37-1.1-1.12-1.43-1.15-1.44a.755.755 0 0 1-.41-.97c.15-.38.58-.57.96-.42.06.02 1.42.57 2.01 2.33.575 1.714-.098 2.933-.182 3.086l-.008.014c-.14.23-.39.35-.64.35zm-7.44 5.1v-3.66h.75c.17 0 .3.02.39.07.08.05.17.13.24.24l1.98 3.01c.07.11.16.2.27.26q.165.09.39.09h1.57l-2.35-3.47q-.24-.345-.57-.54c.33-.11.62-.25.88-.42s.47-.37.65-.6c.17-.23.31-.49.4-.77s.14-.58.14-.9c0-.39-.07-.76-.21-1.09-.13-.33-.35-.61-.64-.85s-.66-.43-1.12-.56-1.01-.2-1.65-.2H9.64v9.39zm1.09-4.92h-1.1V8.58h1.12c.65 0 1.13.12 1.44.38s.47.62.47 1.1c0 .24-.05.46-.12.66s-.19.37-.35.52c-.15.14-.36.26-.6.34s-.53.12-.86.12M7.3 5.25h2.5c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H7.3c-.41 0-.75.34-.75.75s.34.75.75.75",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "white",
  d: "M0 0h24v24H0z"
}))));
exports.default = Roaming;
Roaming.displayName = 'Roaming';
});

unwrapExports(Roaming_1);

var Search_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Search = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M11.1 20.08c-5.07 0-9.2-4.13-9.2-9.2s4.13-9.19 9.2-9.19 9.2 4.13 9.2 9.2c0 2.373-.905 4.54-2.387 6.173l3.967 3.967c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22s-.38-.07-.53-.22l-4-4a9.15 9.15 0 0 1-5.72 2zm0-16.89c-4.25 0-7.7 3.45-7.7 7.7s3.45 7.7 7.7 7.7 7.7-3.45 7.7-7.7-3.45-7.7-7.7-7.7",
  clipRule: "evenodd"
}));
exports.default = Search;
Search.displayName = 'Search';
});

unwrapExports(Search_1);

var Secure_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Secure = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M15.61 7.95V6.06c0-1.79-1.46-3.25-3.25-3.25h-.53c-1.79 0-3.25 1.46-3.25 3.25v1.89zm-8.53 0V6.06c0-2.62 2.13-4.75 4.75-4.75h.53c2.62 0 4.75 2.13 4.75 4.75v1.89h.74c1.52 0 2.75 1.23 2.75 2.75v9.23c0 1.52-1.23 2.75-2.75 2.75H6.14c-1.52 0-2.75-1.23-2.75-2.75V10.7c0-1.52 1.23-2.75 2.75-2.75zM4.89 10.7c0-.69.56-1.25 1.25-1.25h11.71c.69 0 1.25.56 1.25 1.25v9.23c0 .69-.56 1.25-1.25 1.25H6.14c-.69 0-1.25-.56-1.25-1.25zM12 18.55c-.41 0-.75-.34-.75-.75v-2.165a2 2 0 1 1 1.5 0V17.8c0 .41-.34.75-.75.75",
  clipRule: "evenodd"
}));
exports.default = Secure;
Secure.displayName = 'Secure';
});

unwrapExports(Secure_1);

var Send_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Send = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M13.7 22.37a.748.748 0 0 0 1.4.01l7.71-20.22c.11-.28.04-.59-.17-.8a.74.74 0 0 0-.8-.17L1.62 8.89c-.29.12-.48.4-.48.71s.2.59.49.7l8.82 3.25zm-2.846-10.284L4.03 9.58l16.78-6.39-6.39 16.78-2.506-6.824L15.25 9.81c.29-.29.29-.77 0-1.06a.754.754 0 0 0-1.06 0z",
  clipRule: "evenodd"
}));
exports.default = Send;
Send.displayName = 'Send';
});

unwrapExports(Send_1);

var Services_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Services = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M15.54 10.46c-.41 0-.75-.34-.75-.75V6.68h-3.03c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3.03V2.16c0-.41.34-.75.75-.75s.75.34.75.75v3.02h3.02c.41 0 .75.34.75.75s-.34.75-.75.75h-3.02v3.03c0 .41-.34.75-.75.75M3.03 22.57h2.26a1.76 1.76 0 0 0 1.643-1.151c.996-.032 1.284.002 1.357.011.27.04.78.18 1.36.34 1.04.29 2.33.64 3.53.8.1.02.21.02.34.02v-.01c1.28 0 3.92-.64 5.43-1.63.03-.02 3.51-2.59 3.73-4.02.17-1.09-.15-1.99-.9-2.53-.864-.616-1.502-.492-2.314-.333l-.016.003c-.47.096-1.078.514-2.229 1.377-.067-.517-.316-1.04-.871-1.477-1.06-.83-5.62-1.61-6.97-1.19-.488.148-1.553.708-2.367 1.156A1.76 1.76 0 0 0 5.29 12.49H3.03c-.96 0-1.75.79-1.75 1.75v6.58c0 .96.79 1.75 1.75 1.75m4.01-6.927v4.276c1.094-.02 1.373.014 1.47.041.35.05.87.19 1.53.37l.146.04c.972.262 2.137.577 3.184.72.63.08 3.31-.43 4.76-1.38.77-.5 2.91-2.45 3.07-3.01.05-.34.04-.83-.3-1.08-.31-.23-.39-.23-1.16-.08-.26.08-1.21.79-1.77 1.22-.63.48-1.18.89-1.55 1.08q-1.095.57-1.98.57l-2.19-.21a.75.75 0 0 1-.67-.82c.04-.41.4-.72.82-.67l2.11.21c.213 0 .577-.108.989-.3l-.029-.02c.1-.15.58-.96-.04-1.45-.63-.49-4.64-1.23-5.6-.94-.42.137-1.838.898-2.79 1.433M2.78 14.24c0-.14.11-.25.25-.25h2.26c.14 0 .25.11.25.25v6.58c0 .14-.11.25-.25.25H3.03c-.14 0-.25-.11-.25-.25z",
  clipRule: "evenodd"
}));
exports.default = Services;
Services.displayName = 'Services';
});

unwrapExports(Services_1);

var Settings_1$1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Settings = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M10.54 23h2.92l.01.02c1.02 0 1.85-.8 1.85-1.79v-1.49c.74-.28 1.43-.66 2.06-1.13l1.41.77c.87.48 2 .19 2.5-.64l1.48-2.41c.25-.42.31-.9.19-1.36a1.78 1.78 0 0 0-.88-1.11l-1.37-.75c.05-.37.08-.72.08-1.09s-.03-.74-.08-1.1l1.36-.75c.43-.23.75-.63.88-1.1.13-.46.06-.96-.19-1.37l-1.47-2.4c-.5-.83-1.62-1.13-2.5-.66l-1.42.77c-.63-.47-1.32-.85-2.05-1.13V2.79c0-.99-.83-1.79-1.85-1.79h-2.92C9.53 1 8.7 1.8 8.7 2.79v1.49c-.73.28-1.42.66-2.05 1.13l-1.43-.78c-.88-.47-2-.18-2.49.65l-1.48 2.4c-.25.41-.31.9-.19 1.36.13.47.44.87.88 1.11l1.37.75c-.05.36-.08.74-.08 1.1s.03.73.08 1.09l-1.37.75c-.44.25-.75.64-.88 1.11-.13.46-.06.95.19 1.37l1.47 2.4c.51.83 1.63 1.12 2.5.64l1.41-.77c.63.46 1.32.84 2.06 1.13v1.49c0 .99.83 1.79 1.85 1.79m-3.35-5.88a.74.74 0 0 0-.48-.18v.01c-.12 0-.25.03-.36.09L4.5 18.05c-.17.09-.4.04-.49-.11l-1.47-2.4a.25.25 0 0 1-.03-.2c.02-.07.07-.14.15-.18l1.83-1.01c.29-.16.44-.49.37-.81-.09-.45-.14-.89-.14-1.34s.05-.9.15-1.33a.76.76 0 0 0-.37-.82L2.66 8.84a.3.3 0 0 1-.15-.18.22.22 0 0 1 .02-.19l1.48-2.4c.09-.15.32-.2.49-.11l1.86 1.01c.27.14.6.11.84-.09a7 7 0 0 1 2.46-1.34c.32-.1.53-.39.53-.72V2.8c0-.16.16-.29.35-.29h2.92c.19 0 .35.13.35.29v2.02c0 .33.22.62.53.72.9.27 1.73.73 2.46 1.34.24.21.57.24.84.09l1.85-1.01c.17-.1.4-.05.5.11l1.47 2.4c.05.07.04.14.03.19s-.04.12-.15.18l-1.85 1.01c-.29.16-.44.49-.37.82.1.43.15.89.15 1.33s-.05.89-.14 1.34c-.07.32.08.65.37.81l1.83 1.01c.07.05.13.11.15.19.02.05.02.12-.02.19l-1.47 2.41c-.09.14-.32.19-.49.1l-1.85-1.01a.74.74 0 0 0-.84.08 7.2 7.2 0 0 1-2.48 1.36c-.31.09-.52.38-.52.71v2.02c0 .16-.16.29-.35.29h-2.92c-.19 0-.35-.13-.35-.29v-2.02a.75.75 0 0 0-.52-.71c-.92-.29-1.76-.75-2.48-1.36m.9-5.12a3.91 3.91 0 1 0 7.82 0 3.91 3.91 0 1 0-7.82 0m1.5 0c0-1.33 1.08-2.41 2.41-2.41s2.41 1.08 2.41 2.41-1.08 2.41-2.41 2.41S9.59 13.33 9.59 12",
  clipRule: "evenodd"
}));
exports.default = Settings;
Settings.displayName = 'Settings';
});

unwrapExports(Settings_1$1);

var Share_1$1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Share = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("g", {
  fill: props.color || "#222222",
  clipPath: "url(#b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.29 16.03c-2.22 0-4.03-1.81-4.03-4.03s1.81-4.03 4.03-4.03S9.32 9.78 9.32 12s-1.81 4.03-4.03 4.03m0-6.56C3.9 9.47 2.76 10.6 2.76 12s1.13 2.53 2.53 2.53S7.82 13.4 7.82 12 6.69 9.47 5.29 9.47M18.63 9.38c-2.22 0-4.03-1.81-4.03-4.03s1.81-4.03 4.03-4.03 4.03 1.81 4.03 4.03-1.81 4.03-4.03 4.03m0-6.56c-1.39 0-2.53 1.13-2.53 2.53s1.13 2.53 2.53 2.53 2.53-1.13 2.53-2.53-1.13-2.53-2.53-2.53M18.71 22.68c-2.22 0-4.03-1.81-4.03-4.03s1.81-4.03 4.03-4.03 4.03 1.81 4.03 4.03-1.81 4.03-4.03 4.03m0-6.56c-1.39 0-2.53 1.13-2.53 2.53s1.13 2.53 2.53 2.53 2.53-1.13 2.53-2.53-1.13-2.53-2.53-2.53"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.2 6.07 7.826 9.986l.703 1.325 7.375-3.917zM8.528 12.681l-.704 1.325 7.376 3.915.703-1.325z"
}))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "white",
  d: "M0 0h24v24H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "white",
  d: "M0 0h24v24H0z"
}))));
exports.default = Share;
Share.displayName = 'Share';
});

unwrapExports(Share_1$1);

var Shop_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Shop = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  d: "M21.62 9.44c-.11-1.41-1.33-2.51-2.78-2.51h-1.2c-.12-3.06-2.65-5.52-5.74-5.52S6.28 3.87 6.16 6.93h-.99c-1.45 0-2.67 1.1-2.78 2.51l-.9 11.44c0 .95.79 1.73 1.76 1.73h17.53c.97 0 1.76-.77 1.76-1.79l-.9-11.38zM11.9 2.9c2.27 0 4.11 1.79 4.23 4.02H7.66a4.245 4.245 0 0 1 4.23-4.02zm8.86 18.2H3.24c-.14 0-.26-.1-.26-.17l.9-11.38c.05-.63.61-1.13 1.29-1.13h13.68c.67 0 1.24.5 1.29 1.13l.9 11.32c0 .12-.12.23-.26.23z"
}));
exports.default = Shop;
Shop.displayName = 'Shop';
});

unwrapExports(Shop_1);

var Show_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Show = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M1.43 13.23C2.55 15.42 5.83 20.5 12 20.5s9.45-5.09 10.57-7.27c.4-.78.4-1.7 0-2.48-1.12-2.19-4.4-7.27-10.57-7.27S2.55 8.56 1.43 10.75c-.4.78-.4 1.7 0 2.48m1.33-1.79c1-1.94 3.89-6.45 9.24-6.45s8.24 4.51 9.24 6.45c.18.35.18.76 0 1.11-1 1.94-3.89 6.45-9.24 6.45s-8.24-4.51-9.24-6.45c-.18-.35-.18-.76 0-1.11m4.79.56c0 2.45 2 4.45 4.45 4.45s4.45-2 4.45-4.45-2-4.45-4.45-4.45-4.45 2-4.45 4.45m1.5 0A2.949 2.949 0 1 1 12 14.95c-1.63 0-2.95-1.32-2.95-2.95",
  clipRule: "evenodd"
}));
exports.default = Show;
Show.displayName = 'Show';
});

unwrapExports(Show_1);

var Simcard_1$1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Simcard = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M18.15 22.75H5.85c-1.65 0-2.99-1.23-2.99-2.75V4c0-1.52 1.34-2.75 2.99-2.75h7.97c.75 0 1.46.28 1.99.79l4.47 4.23c.54.51.85 1.23.85 1.96v11.76c0 1.52-1.34 2.75-2.99 2.75zm-12.3-20c-.82 0-1.49.56-1.49 1.25v16c0 .69.67 1.25 1.49 1.25h12.31c.82 0 1.49-.56 1.49-1.25V8.24c0-.33-.14-.64-.39-.88l-4.47-4.24c-.25-.24-.6-.38-.96-.38H5.86zm7.76 16.94H8.05c-.96 0-1.75-.79-1.75-1.75v-5.95c0-.96.79-1.75 1.75-1.75h7.89c.96 0 1.75.79 1.75 1.75v5.95c0 .96-.79 1.75-1.75 1.75h-2.21a1 1 0 0 1-.12.01zm-.75-1.5h-4.8c-.14 0-.25-.11-.25-.25v-1.62h5.05zm1.5 0v-2.62c0-.41-.34-.75-.75-.75h-5.8v-2.83c0-.14.11-.25.25-.25h1.55v.8c0 .41.34.75.75.75s.75-.34.75-.75v-.8h1.78v.8c0 .41.34.75.75.75s.75-.34.75-.75v-.8h1.56c.14 0 .25.11.25.25v5.95c0 .14-.11.25-.25.25z",
  clipRule: "evenodd"
}));
exports.default = Simcard;
Simcard.displayName = 'Simcard';
});

unwrapExports(Simcard_1$1);

var SpeedMeter_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SpeedMeter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M1 12c0 6.07 4.93 11 11 11s11-4.93 11-11S18.07 1 12 1 1 5.93 1 12m1.5 0c0-5.24 4.26-9.5 9.5-9.5s9.5 4.26 9.5 9.5a9.46 9.46 0 0 1-2.067 5.912 10.84 10.84 0 0 0-6.247-2.907l2.164-4.335c.18-.37.03-.82-.34-1a.763.763 0 0 0-1.01.34l-2.466 4.94a10.78 10.78 0 0 0-6.96 2.97A9.46 9.46 0 0 1 2.5 12m9.49 4.44a9.13 9.13 0 0 0-6.39 2.575A9.46 9.46 0 0 0 12 21.5a9.46 9.46 0 0 0 6.405-2.488 9.16 9.16 0 0 0-6.385-2.572h-.03m-6.96-4.28h-.06a.743.743 0 0 1-.68-.81c.33-3.98 3.73-7.1 7.72-7.1s7.39 3.12 7.72 7.09a.75.75 0 0 1-.68.81.75.75 0 0 1-.81-.68c-.27-3.21-3.01-5.72-6.23-5.72s-5.96 2.51-6.23 5.72c-.03.39-.36.69-.75.69m8.22 6.74a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0",
  clipRule: "evenodd"
}));
exports.default = SpeedMeter;
SpeedMeter.displayName = 'SpeedMeter';
});

unwrapExports(SpeedMeter_1);

var Star_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Star = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  d: "M17.49 22.75c-.3 0-.6-.08-.88-.23l-4.45-2.44a.31.31 0 0 0-.32 0l-4.45 2.44c-.62.34-1.36.3-1.94-.11-.61-.43-.91-1.16-.78-1.9l.85-5.17a.46.46 0 0 0-.12-.39l-3.6-3.67c-.51-.52-.69-1.28-.45-1.99.23-.68.8-1.17 1.49-1.28l4.97-.75c.12-.02.22-.1.28-.22l2.22-4.71c.31-.67.96-1.08 1.68-1.08s1.37.41 1.68 1.08l2.22 4.71c.06.12.16.2.28.22l4.97.75c.69.11 1.27.59 1.49 1.28.23.7.06 1.46-.45 1.99l-3.6 3.67c-.1.1-.14.25-.12.39l.85 5.17c.12.74-.18 1.47-.78 1.9-.32.23-.69.34-1.06.34zM12 18.53c.3 0 .61.08.88.23l4.44 2.44c.15.08.27.03.35-.02.05-.04.21-.17.17-.43l-.85-5.17c-.1-.62.1-1.25.53-1.68l3.6-3.66c.18-.18.12-.4.1-.46a.38.38 0 0 0-.3-.27l-4.97-.75c-.61-.09-1.14-.49-1.41-1.06l-2.22-4.71a.35.35 0 0 0-.33-.22c-.09 0-.23.03-.33.22L9.44 7.7c-.27.57-.8.97-1.41 1.06l-4.97.75c-.2.03-.27.2-.3.27-.02.06-.08.28.1.46l3.6 3.67c.43.44.63 1.07.53 1.68l-.85 5.17c-.04.26.12.4.17.43.08.06.2.1.35.02l4.44-2.44c.28-.15.58-.23.88-.23z"
}));
exports.default = Star;
Star.displayName = 'Star';
});

unwrapExports(Star_1);

var Store_1$1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Store = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M9.31 10.49H10v-.01c.45 0 .875-.108 1.25-.3v10.95H4.61V10.489l.09.001v-.01c.44 0 .88-.08 1.3-.23a4.5 4.5 0 0 0 1.236-.704 2.74 2.74 0 0 0 2.074.944M2 21.13h1.11V10.15c-.714-.31-1.26-.804-1.53-1.41-.45-1.01-.04-1.93.24-2.55.26-.58.56-1.13.86-1.66l.16-.29c.183-.338.372-.67.563-1.005l.207-.365.06-.11c.5-.86 1.42-1.4 2.42-1.4h11.35v.01h.47c1 0 1.93.54 2.42 1.4l.06.11c.26.45.52.91.77 1.37l.16.29.105.19c.258.472.526.96.755 1.47l.007.017c.27.61.679 1.532.233 2.533-.264.591-.79 1.076-1.48 1.387V21.13H22c.41 0 .75.34.75.75s-.34.75-.75.75H2c-.41 0-.75-.34-.75-.75s.34-.75.75-.75m17.44 0V10.497l-.14.003v-.01c-.44 0-.88-.08-1.3-.23a4.5 4.5 0 0 1-1.246-.712 2.74 2.74 0 0 1-2.064.932v.01H14a2.74 2.74 0 0 1-1.25-.3v10.94zM11.25 7.742A1.25 1.25 0 0 1 10 8.98h-.69c-.69 0-1.25-.56-1.25-1.25V2.86h3.19v4.882m7.27 1.108c-.378-.137-.749-.383-1.108-.723q.027-.195.028-.397V2.87h.47c.46 0 .89.25 1.12.65l.06.11c.26.44.51.89.76 1.34l.16.29.083.151c.26.475.509.929.717 1.399.29.64.39.99.24 1.33-.21.46-.86.73-1.36.82-.39.07-.79.03-1.17-.11m-5.77-1.11V2.86h3.19v4.87c0 .69-.56 1.25-1.25 1.25H14a1.25 1.25 0 0 1-1.25-1.24M6.09 2.86h.47v4.88q0 .195.026.382-.54.514-1.106.718c-.38.14-.78.18-1.17.11-.5-.09-1.15-.36-1.36-.82-.15-.34-.05-.69.24-1.33.208-.47.457-.924.717-1.399l.083-.151.16-.29c.25-.45.5-.89.76-1.34l.06-.11c.23-.4.66-.65 1.12-.65M9.1 16.21c-.41 0-.75-.34-.75-.75v-1.5c0-.41.34-.75.75-.75s.75.34.75.75v1.5c0 .41-.34.75-.75.75m5.08-.75c0 .41.34.75.75.75s.75-.34.75-.75v-1.5c0-.41-.34-.75-.75-.75s-.75.34-.75.75z",
  clipRule: "evenodd"
}));
exports.default = Store;
Store.displayName = 'Store';
});

unwrapExports(Store_1$1);

var Support_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Support = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M2.75 5c0-.69.56-1.25 1.25-1.25h16c.69 0 1.25.56 1.25 1.25v14.92a.25.25 0 0 1-.406.195l-2.828-2.262a2.75 2.75 0 0 0-1.718-.603H4c-.69 0-1.25-.56-1.25-1.25zM4 2.25A2.75 2.75 0 0 0 1.25 5v11A2.75 2.75 0 0 0 4 18.75h12.298c.284 0 .56.097.781.274l2.828 2.262c1.146.917 2.843.1 2.843-1.367V5A2.75 2.75 0 0 0 20 2.25zm4.604 9.306a.75.75 0 1 0-1.208.889c.895 1.215 2.654 1.89 4.353 1.966 1.723.078 3.638-.445 4.837-1.942a.75.75 0 0 0-1.172-.937c-.801 1.002-2.174 1.445-3.597 1.38-1.444-.064-2.685-.64-3.213-1.357M8.25 9.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M17 8.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0",
  clipRule: "evenodd"
}));
exports.default = Support;
Support.displayName = 'Support';
});

unwrapExports(Support_1);

var Tablet_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Tablet = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M19.28 23.25H4.71c-1.08 0-1.96-.79-1.96-1.75v-19c0-.96.88-1.75 1.96-1.75h14.57c1.08 0 1.96.79 1.96 1.75v19c0 .96-.88 1.75-1.96 1.75m-14.57-21c-.29 0-.46.16-.46.25v19c0 .09.18.25.46.25h14.57c.29 0 .46-.16.46-.25v-19c0-.09-.18-.25-.46-.25zM12 20.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2M10.5 5.25h3c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-3c-.41 0-.75.34-.75.75s.34.75.75.75",
  clipRule: "evenodd"
}));
exports.default = Tablet;
Tablet.displayName = 'Tablet';
});

unwrapExports(Tablet_1);

var Thumbsup_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Thumbsup = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M10.45 21.54h7.84l.01.01c1.52 0 2.37-1.39 2.64-2.25l1.75-6.81c.02-.03.02-.07.02-.1.12-1-.26-1.92-1.03-2.55-.78-.64-1.53-.69-2.28-.69h-3.29V4.82c0-.77-.36-1.43-1-1.87-.74-.5-1.77-.61-2.61-.28-.54.21-1.03.55-1.41 1L6.65 8.88a1.74 1.74 0 0 0-1.12-.41h-2.5c-.96 0-1.75.79-1.75 1.75v9.5c0 .96.79 1.75 1.75 1.75h2.5a1.76 1.76 0 0 0 1.747-1.652c.836.87 1.854 1.722 3.173 1.722m-3.17-3.904a1 1 0 0 1 .06.054c.17.17.34.35.51.55.77.84 1.65 1.8 2.6 1.8h7.84c.81 0 1.2-1.16 1.2-1.17l1.72-6.71c.04-.46-.13-.87-.49-1.16-.37-.3-.7-.35-1.33-.35h-4.04c-.41 0-.75-.34-.75-.75V4.82c0-.27-.11-.48-.34-.63-.33-.22-.83-.27-1.21-.12-.31.12-.6.33-.81.58l-4.96 5.808zm-4.5-7.416c0-.14.11-.25.25-.25h2.5c.14 0 .25.11.25.25v9.5c0 .14-.11.25-.25.25h-2.5c-.14 0-.25-.11-.25-.25z",
  clipRule: "evenodd"
}));
exports.default = Thumbsup;
Thumbsup.displayName = 'Thumbsup';
});

unwrapExports(Thumbsup_1);

var Time_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Time = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M1 12c0 6.07 4.93 11 11 11s11-4.93 11-11S18.07 1 12 1 1 5.93 1 12m1.5 0c0-5.24 4.26-9.5 9.5-9.5s9.5 4.26 9.5 9.5-4.26 9.5-9.5 9.5-9.5-4.26-9.5-9.5m9.5.75c-.41 0-.75-.34-.75-.75V5.56c0-.41.34-.75.75-.75s.75.34.75.75v5.69H16c.41 0 .75.34.75.75s-.34.75-.75.75h-4",
  clipRule: "evenodd"
}));
exports.default = Time;
Time.displayName = 'Time';
});

unwrapExports(Time_1);

var Timeline_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Timeline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M4.96 7.326a3.06 3.06 0 0 1-2.3-2.956c0-1.68 1.37-3.05 3.05-3.05s3.05 1.37 3.05 3.05c0 1.421-.98 2.62-2.3 2.956v1.728a3.06 3.06 0 0 1 2.3 2.956c0 1.421-.98 2.62-2.3 2.956v1.708a3.06 3.06 0 0 1 2.3 2.956c0 1.68-1.37 3.05-3.05 3.05s-3.05-1.37-3.05-3.05c0-1.421.98-2.62 2.3-2.956v-1.708a3.06 3.06 0 0 1-2.3-2.956c0-1.421.98-2.62 2.3-2.957zm-.8-2.956c0-.85.7-1.55 1.55-1.55s1.55.7 1.55 1.55-.7 1.55-1.55 1.55-1.55-.7-1.55-1.55m0 7.64c0-.85.7-1.55 1.55-1.55s1.55.7 1.55 1.55-.7 1.55-1.55 1.55-1.55-.7-1.55-1.55m1.55 6.07c-.85 0-1.55.7-1.55 1.55s.7 1.55 1.55 1.55 1.55-.7 1.55-1.55-.7-1.55-1.55-1.55m5.78-12.96h9.1c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-9.1c-.41 0-.75.34-.75.75s.34.75.75.75m7.59 7.64h-7.59c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h7.59c.41 0 .75.34.75.75s-.34.75-.75.75m-7.59 7.64h9.1c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-9.1c-.41 0-.75.34-.75.75s.34.75.75.75",
  clipRule: "evenodd"
}));
exports.default = Timeline;
Timeline.displayName = 'Timeline';
});

unwrapExports(Timeline_1);

var Transport_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Transport = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "m17.83 6.52.417 2.77H5.743l.417-2.77c.2-1.32 1.31-2.28 2.65-2.28h6.37c1.33 0 2.45.96 2.65 2.28M3.169 9.785l-1.51-.735a.74.74 0 0 1-.34-1 .74.74 0 0 1 1-.34l1.978.963L4.66 6.3A4.15 4.15 0 0 1 8.8 2.75h6.37c2.08 0 3.82 1.5 4.14 3.56l.364 2.377 2.006-.977c.37-.18.82-.03 1 .34s.03.82-.34 1l-1.503.732a3.79 3.79 0 0 1 1.923 3.298v6.38c0 .96-.78 1.75-1.75 1.75l-3.37.03h-.02v.01a1.588 1.588 0 0 1-1.59-1.59v-1.12l-8.15-.04v1.12c0 .88-.71 1.59-1.59 1.59H3c-.96 0-1.75-.79-1.75-1.75v-6.38c0-1.41.774-2.642 1.919-3.295M2.74 13.09c0-1.188.916-2.171 2.076-2.28h14.358a2.297 2.297 0 0 1 2.076 2.28v6.38c0 .14-.11.25-.25.25l-3.38.03-.09-.09v-1.61c0-.55-.45-1-1-1l-9.15-.04h-.01c-.55 0-1 .45-1 1v1.62c0 .05-.04.09-.09.09H2.99c-.14 0-.25-.11-.25-.25zm3.22 1.57h2c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-2c-.41 0-.75.34-.75.75s.34.75.75.75m10.08 0h2c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-2c-.41 0-.75.34-.75.75s.34.75.75.75",
  clipRule: "evenodd"
}));
exports.default = Transport;
Transport.displayName = 'Transport';
});

unwrapExports(Transport_1);

var Trash_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Trash = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M20.02 19.65V6.5h.43c.41 0 .75-.34.75-.75S20.86 5 20.45 5h-2.735l-.755-2.25c-.3-.88-1.08-1.47-1.96-1.47H9c-.89 0-1.68.59-1.97 1.48L6.29 5H3.56c-.41 0-.75.34-.75.75s.34.75.75.75h.35v13.15a3.06 3.06 0 0 0 3.06 3.06h9.99a3.06 3.06 0 0 0 3.06-3.06M5.41 6.5v13.15c0 .86.7 1.56 1.56 1.56h9.99c.86 0 1.56-.7 1.56-1.56V6.5zM7.866 5h8.258l-.594-1.77c-.09-.27-.31-.45-.54-.45h-6c-.23 0-.45.18-.54.45zm4.054 13.76c-.41 0-.75-.34-.75-.75v-9c0-.41.34-.75.75-.75s.75.34.75.75v9c0 .41-.34.75-.75.75m-4.25-1.9c0 .41.34.75.75.75s.75-.34.75-.75v-6.5c0-.41-.34-.75-.75-.75s-.75.34-.75.75zm6.97 0c0 .41.34.75.75.75s.75-.34.75-.75v-6.5c0-.41-.34-.75-.75-.75s-.75.34-.75.75z",
  clipRule: "evenodd"
}));
exports.default = Trash;
Trash.displayName = 'Trash';
});

unwrapExports(Trash_1);

var TVAddon_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const TVAddon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M2.92 17.22h8.29v1.84H9.29c-.41 0-.75.34-.75.75s.34.75.75.75h5.34a.75.75 0 0 0 .58-.278 5.757 5.757 0 0 0 7.432-6.472h.028V5.09c0-.91-.74-1.65-1.65-1.65H2.92c-.91 0-1.65.74-1.65 1.65v10.48c0 .91.74 1.65 1.65 1.65m18.25-6.343V5.09c0-.08-.07-.15-.15-.15H2.92c-.08 0-.15.07-.15.15v10.48c0 .08.07.15.15.15h8.382a5.757 5.757 0 0 1 5.678-6.66c1.65 0 3.14.7 4.19 1.817m-8.46 7.78v.403h.401a6 6 0 0 1-.401-.403m.02-3.847a4.26 4.26 0 0 1 4.25-4.25 4.26 4.26 0 0 1 4.25 4.25 4.26 4.26 0 0 1-4.25 4.25 4.26 4.26 0 0 1-4.25-4.25m2.25.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h1.25v-1.25c0-.41.34-.75.75-.75s.75.34.75.75v1.25h1.25c.41 0 .75.34.75.75s-.34.75-.75.75h-1.25v1.25c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-1.25z",
  clipRule: "evenodd"
}));
exports.default = TVAddon;
TVAddon.displayName = 'TVAddon';
});

unwrapExports(TVAddon_1);

var TV_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const TV = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M11.25 17.22h-8.3c-.91 0-1.65-.74-1.65-1.65V5.09c0-.91.74-1.65 1.65-1.65h18.1c.91 0 1.65.74 1.65 1.65v10.48c0 .91-.74 1.65-1.65 1.65h-8.3v1.84h1.92c.41 0 .75.34.75.75s-.34.75-.75.75H9.33c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h1.92zM2.95 4.94c-.08 0-.15.07-.15.15v10.48c0 .08.07.15.15.15h18.1c.08 0 .15-.07.15-.15V5.09c0-.08-.07-.15-.15-.15z",
  clipRule: "evenodd"
}));
exports.default = TV;
TV.displayName = 'TV';
});

unwrapExports(TV_1);

var Upload_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Upload = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M7.48 8.31a.755.755 0 0 1-.55-1.27l4.49-4.72a.755.755 0 0 1 1.1.01l4.49 4.72c.29.3.27.78-.03 1.06a.75.75 0 0 1-.52.21v-.01c-.2 0-.4-.08-.54-.23l-3.2-3.364V17.25c0 .41-.34.75-.75.75s-.75-.34-.75-.75V4.706L8.02 8.07c-.15.15-.35.23-.54.23zM5.8 21.9h12.39c1.9 0 3.45-1.55 3.45-3.45v-1.83c0-.41-.34-.75-.75-.75s-.75.34-.75.75v1.83c0 1.07-.87 1.95-1.95 1.95H5.8c-1.08 0-1.95-.87-1.95-1.95v-1.83c0-.41-.34-.75-.75-.75s-.75.34-.75.75v1.83c0 1.9 1.55 3.45 3.45 3.45",
  clipRule: "evenodd"
}));
exports.default = Upload;
Upload.displayName = 'Upload';
});

unwrapExports(Upload_1);

var Viewlist_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Viewlist = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M18.27 22.71H5.73c-1.52 0-2.75-1.23-2.75-2.75V4.04c0-1.52 1.23-2.75 2.75-2.75h12.54c1.52 0 2.75 1.23 2.75 2.75v15.93c0 1.52-1.23 2.75-2.75 2.75zM5.73 2.79c-.69 0-1.25.56-1.25 1.25v15.93c0 .69.56 1.25 1.25 1.25h12.54c.69 0 1.25-.56 1.25-1.25V4.04c0-.69-.56-1.25-1.25-1.25zm1.86 4.26h-.15a1 1 0 1 0 0 2h.15a1 1 0 1 0 0-2m-.15 3.92h.15a1 1 0 1 1 0 2h-.15a1 1 0 1 1 0-2m.15 4h-.15a1 1 0 1 0 0 2h.15a1 1 0 1 0 0-2m3.08-6.17h6c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-6c-.41 0-.75.34-.75.75s.34.75.75.75m6 3.95h-6c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h6c.41 0 .75.34.75.75s-.34.75-.75.75m-6 3.95h6c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-6c-.41 0-.75.34-.75.75s.34.75.75.75",
  clipRule: "evenodd"
}));
exports.default = Viewlist;
Viewlist.displayName = 'Viewlist';
});

unwrapExports(Viewlist_1);

var Voucher_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Voucher = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("g", {
  fill: props.color || "#222222",
  clipPath: "url(#b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.75 5c.28 0 .5.22.5.5v3.7a2.804 2.804 0 0 0-2.31 2.76c0 1.38 1 2.52 2.31 2.76v3.79c0 .28-.22.5-.5.5H2.25c-.28 0-.5-.22-.5-.5v-3.79a2.81 2.81 0 0 0 2.3-2.75c0-1.37-.99-2.52-2.3-2.75v-3.7c0-.28.22-.5.5-.5h19.5m0-1.52H2.25c-1.1 0-2 .9-2 2v5.16h1c.72 0 1.3.58 1.3 1.3s-.58 1.3-1.3 1.3h-1v5.24c0 1.1.9 2 2 2h19.5c1.1 0 2-.9 2-2v-5.24h-1.01c-.72 0-1.3-.58-1.3-1.3s.58-1.3 1.3-1.3h1.01V5.5c0-1.1-.9-2-2-2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.68 8.44c-.41 0-.75-.34-.75-.75v-2c0-.41.34-.75.75-.75s.75.34.75.75v2c0 .41-.34.75-.75.75M8.68 13.72c-.41 0-.75-.34-.75-.75v-2.01c0-.41.34-.75.75-.75s.75.34.75.75v2.01c0 .41-.34.75-.75.75M8.68 18.99c-.41 0-.75-.34-.75-.75v-2c0-.41.34-.75.75-.75s.75.34.75.75v2c0 .41-.34.75-.75.75"
}))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "white",
  d: "M0 0h24v24H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "white",
  d: "M0 0h24v24H0z"
}))));
exports.default = Voucher;
Voucher.displayName = 'Voucher';
});

unwrapExports(Voucher_1);

var Wallet_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Wallet = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M19.17 21.25H4.83a2.58 2.58 0 0 1-2.58-2.58V5.56c0-1.55 1.26-2.81 2.81-2.81h11.11a2.58 2.58 0 0 1 2.58 2.58v1.53h.42a2.58 2.58 0 0 1 2.58 2.58v9.21a2.58 2.58 0 0 1-2.58 2.58zM17.869 8.37q.06.01.121.01h1.17c.59 0 1.08.48 1.08 1.08v1.79h-3.92c-.41 0-.75.34-.75.75v3.74c0 .41.34.75.75.75h3.92v2.18c0 .59-.48 1.08-1.08 1.08H4.83c-.59 0-1.08-.48-1.08-1.08V8.046c.391.207.837.324 1.31.324zM5.06 4.26v-.01c-.72 0-1.31.59-1.31 1.31s.59 1.31 1.31 1.31h12.18V5.35c0-.6-.49-1.08-1.08-1.08H5.06zm12.01 8.49h3.17v2.24h-3.17z",
  clipRule: "evenodd"
}));
exports.default = Wallet;
Wallet.displayName = 'Wallet';
});

unwrapExports(Wallet_1);

var Wifi_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Wifi = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M1.71 10.08c.14.12.3.17.47.17v.01c.22 0 .43-.1.58-.28 2.29-2.81 5.7-4.42 9.27-4.42s6.93 1.58 9.21 4.35c.27.32.74.36 1.06.1.32-.27.36-.74.1-1.06-2.57-3.11-6.31-4.9-10.37-4.9S4.17 5.86 1.6 9.02c-.26.33-.21.8.11 1.06m2.88 2.87c.13.1.29.15.44.15v-.01c.23 0 .45-.1.6-.3a7.99 7.99 0 0 1 6.4-3.24c2.51 0 4.9 1.21 6.4 3.24a.752.752 0 0 0 1.21-.89 9.46 9.46 0 0 0-7.6-3.85c-2.99 0-5.83 1.44-7.61 3.85-.24.34-.17.8.16 1.05m3.31 3.06q-.18 0-.36-.09c-.36-.2-.5-.65-.3-1.02a5.452 5.452 0 0 1 9.56-.04c.2.36.07.82-.29 1.02s-.82.07-1.02-.29a3.946 3.946 0 0 0-6.93.03c-.14.25-.39.39-.66.39m5.38 1.49a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0",
  clipRule: "evenodd"
}));
exports.default = Wifi;
Wifi.displayName = 'Wifi';
});

unwrapExports(Wifi_1);

var Work_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Work = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M8.25 6.75H4c-.69 0-1.25.56-1.25 1.25v3.5c0 .69.56 1.25 1.25 1.25h16c.69 0 1.25-.56 1.25-1.25V8c0-.69-.56-1.25-1.25-1.25H8.25m7.5-1.5H20c1.52 0 2.75 1.23 2.75 2.75v11c0 1.52-1.23 2.75-2.75 2.75H4c-1.52 0-2.75-1.23-2.75-2.75V8c0-1.52 1.23-2.75 2.75-2.75h4.25V4c0-.96.79-1.75 1.75-1.75h4c.96 0 1.75.79 1.75 1.75zm-1.5 0V4c0-.14-.11-.25-.25-.25h-4c-.14 0-.25.11-.25.25v1.25zm-11.5 8.7V19c0 .69.56 1.25 1.25 1.25h16c.69 0 1.25-.56 1.25-1.25v-5.05c-.375.192-.8.3-1.25.3h-5.5v1.26c0 .96-.79 1.75-1.75 1.75h-1.5c-.96 0-1.75-.79-1.75-1.75v-1.26H4c-.45 0-.875-.108-1.25-.3m8.25.31v1.25c0 .14.11.25.25.25h1.5c.14 0 .25-.11.25-.25v-1.25z",
  clipRule: "evenodd"
}));
exports.default = Work;
Work.displayName = 'Work';
});

unwrapExports(Work_1);

var AddonProductFilled_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const AddonProductFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  clipPath: "url(#a)",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  d: "M21.11 1H7.39C6.35 1 5.5 1.85 5.5 2.89V5.5H2.89C1.85 5.5 1 6.35 1 7.39v13.73c0 1.04.85 1.89 1.89 1.89h13.73c1.04 0 1.89-.85 1.89-1.89v-2.61h2.61c1.04 0 1.89-.85 1.89-1.89V2.89c0-1.04-.85-1.89-1.89-1.89zM17 21.11c0 .21-.17.39-.39.39H2.89a.39.39 0 0 1-.39-.39V7.39c0-.21.17-.39.39-.39H5.5v9.61c0 1.04.85 1.89 1.89 1.89H17zm1.25-10.61H15v3.25c0 .41-.34.75-.75.75s-.75-.34-.75-.75V10.5h-3.25c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3.25V5.75c0-.41.34-.75.75-.75s.75.34.75.75V9h3.25c.41 0 .75.34.75.75s-.34.75-.75.75"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "white",
  d: "M0 0h24v24H0z"
}))));
exports.default = AddonProductFilled;
AddonProductFilled.displayName = 'AddonProductFilled';
});

unwrapExports(AddonProductFilled_1);

var BillsFilled_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const BillsFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  stroke: "none",
  d: "M22.25.97H1.75c-.41 0-.75.34-.75.75s.34.75.75.75h.8v17.77c0 1.54 1.25 2.79 2.79 2.79h13.32c1.54 0 2.79-1.25 2.79-2.79V2.47h.8c.41 0 .75-.34.75-.75s-.34-.75-.75-.75M9.21 6.2c.65-.62 1.54-.79 2.26-.84v-.54c0-.41.34-.75.75-.75s.75.34.75.75v.6c1.35.26 2.57 1.22 2.59 2.81 0 .41-.33.75-.74.76-.45-.02-.75-.33-.76-.74-.01-.9-.94-1.39-1.82-1.4h-.06c-.77 0-1.54.06-1.95.45-.33.31-.4.84-.18 1.22.32.53 1.08.78 1.83 1l.87.24c.91.27 1.91.67 2.46 1.6.59.98.41 2.27-.43 3.08-.52.5-1.2.7-1.82.79v.58c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-.54c-1.51-.12-3.01-1.11-3.04-2.86 0-.41.33-.75.74-.76.41 0 .74.33.75.74.01.91.96 1.41 1.84 1.41.78 0 1.57-.05 1.98-.45.32-.31.4-.84.18-1.22-.29-.48-.94-.73-1.59-.93l-.86-.23c-1-.28-2.11-.67-2.71-1.67-.59-.98-.41-2.28.43-3.08zm6.05 13.63H8.74c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h6.52c.41 0 .75.34.75.75s-.34.75-.75.75",
  strokeWidth: 1
}));
exports.default = BillsFilled;
BillsFilled.displayName = 'BillsFilled';
});

unwrapExports(BillsFilled_1);

var HeartFilled_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const HeartFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  stroke: "none",
  d: "M12 21.25c-.18 0-.36-.06-.5-.19l-7.79-7.03c-2.5-2.6-2.34-5.15-2.33-5.26 0-1.89.55-3.41 1.64-4.49 1.56-1.54 3.65-1.52 3.73-1.52 2.71 0 4.41 1.33 5.26 2.24.85-.91 2.55-2.24 5.27-2.24.08 0 2.16-.01 3.72 1.52 1.09 1.07 1.64 2.6 1.64 4.54 0 .05.16 2.6-2.29 5.16l-7.83 7.07c-.14.13-.32.19-.5.19z",
  strokeWidth: 1
}));
exports.default = HeartFilled;
HeartFilled.displayName = 'HeartFilled';
});

unwrapExports(HeartFilled_1);

var HomeFilled_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const HomeFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  stroke: "none",
  d: "M20.64 22.69h-4.85c-.68 0-1.24-.55-1.25-1.23l-.02-3.89H9.48l-.03 3.89c0 .68-.56 1.23-1.25 1.23H3.36c-1.17 0-2.13-.95-2.13-2.11v-7.86c0-1.72.73-3.38 2-4.55l6.44-5.95c1.28-1.19 3.3-1.19 4.59 0l6.5 5.95a6.22 6.22 0 0 1 2.02 4.57v7.85c0 1.17-.96 2.11-2.13 2.11z",
  strokeWidth: 1
}));
exports.default = HomeFilled;
HomeFilled.displayName = 'HomeFilled';
});

unwrapExports(HomeFilled_1);

var MoreFilled_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const MoreFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  stroke: "none",
  d: "M4.26 15.06a3.06 3.06 0 1 1 0-6.12 3.06 3.06 0 0 1 0 6.12m15.48 0a3.06 3.06 0 1 1 0-6.12 3.06 3.06 0 0 1 0 6.12M8.94 12a3.06 3.06 0 1 0 6.12 0 3.06 3.06 0 0 0-6.12 0",
  clipRule: "evenodd",
  strokeWidth: 1
}));
exports.default = MoreFilled;
MoreFilled.displayName = 'MoreFilled';
});

unwrapExports(MoreFilled_1);

var PersonalFilled_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const PersonalFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  stroke: "none",
  d: "M7.18 6.09c0 2.66 2.16 4.82 4.82 4.82v-.01c2.66 0 4.82-2.16 4.82-4.82S14.66 1.26 12 1.26 7.18 3.43 7.18 6.09M3.72 22.74h16.57c1.35 0 2.44-1.04 2.44-2.33 0-2.97-1.48-5.1-4.53-6.5-1.79-.82-3.82-1.24-6.02-1.24h-.55c-2.2 0-4.2.41-5.95 1.21-2.96 1.36-4.4 3.5-4.4 6.53 0 1.28 1.09 2.33 2.44 2.33",
  clipRule: "evenodd",
  strokeWidth: 1
}));
exports.default = PersonalFilled;
PersonalFilled.displayName = 'PersonalFilled';
});

unwrapExports(PersonalFilled_1);

var PriceDown_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const PriceDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#0CAA8F",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: 1,
  d: "M10.892 18.114a1.57 1.57 0 0 0 2.215 0l9.428-9.427A1.571 1.571 0 0 0 21.435 6H2.58a1.57 1.57 0 0 0-1.115 2.687z"
}));
exports.default = PriceDown;
PriceDown.displayName = 'PriceDown';
});

unwrapExports(PriceDown_1);

var PriceUp_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const PriceUp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#CA112F",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: 1,
  d: "M13.108 6.457a1.57 1.57 0 0 0-2.215 0l-9.428 9.427a1.571 1.571 0 0 0 1.1 2.687H21.42a1.57 1.57 0 0 0 1.115-2.687z"
}));
exports.default = PriceUp;
PriceUp.displayName = 'PriceUp';
});

unwrapExports(PriceUp_1);

var RewardsFilled_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const RewardsFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  stroke: "none",
  d: "M20.5 6.44h-3.05c.61-.74.77-1.46.77-2.02 0-1-.4-1.94-1.04-2.51-1.26-1.14-3.21-1.15-4.52-.02-.27.23-.51.53-.76.87-.14-.17-.29-.33-.45-.47-1.21-1.04-3-1.04-4.17.02-.59.53-.95 1.4-.96 2.32 0 .51.14 1.15.67 1.82h-3.5c-.41 0-.75.34-.75.75v15c0 .41.34.75.75.75h7.75V6.44H9.33c-.7-.39-1.52-1.02-1.51-1.81 0-.49.19-.97.46-1.22.6-.54 1.55-.53 2.18 0q.345.3.63.78c.04.07.09.11.15.16v2.07h1.5v16.5h7.75c.41 0 .75-.34.75-.75V7.19c0-.41-.34-.75-.75-.75zm-7.75-2.26s.06-.09.09-.13l.08-.13c.21-.36.46-.66.72-.88.73-.63 1.84-.63 2.54 0 .33.3.53.84.54 1.41 0 .87-.83 1.56-1.6 2.01h-2.36V4.19z",
  strokeWidth: 1
}));
exports.default = RewardsFilled;
RewardsFilled.displayName = 'RewardsFilled';
});

unwrapExports(RewardsFilled_1);

var SecureFilled_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SecureFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  stroke: "none",
  d: "M17.86 7.95h-.74V6.06c0-2.62-2.13-4.75-4.75-4.75h-.53c-2.62 0-4.75 2.13-4.75 4.75v1.89h-.94c-1.52 0-2.75 1.23-2.75 2.75v9.23c0 1.52 1.23 2.75 2.75 2.75h11.71c1.52 0 2.75-1.23 2.75-2.75V10.7c0-1.52-1.23-2.75-2.75-2.75m-5.11 7.68v2.17c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-2.17c-.73-.3-1.25-1.01-1.25-1.85 0-1.1.9-2 2-2s2 .9 2 2c0 .84-.52 1.55-1.25 1.85m2.86-7.68H8.58V6.06c0-1.79 1.46-3.25 3.25-3.25h.53c1.79 0 3.25 1.46 3.25 3.25z",
  strokeWidth: 1
}));
exports.default = SecureFilled;
SecureFilled.displayName = 'SecureFilled';
});

unwrapExports(SecureFilled_1);

var ShopFilled_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const ShopFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  stroke: "none",
  d: "M16.143 6.92A4.264 4.264 0 0 0 11.89 2.9a4.264 4.264 0 0 0-4.253 4.02zm-10.008 0A5.77 5.77 0 0 1 11.89 1.4c3.1 0 5.63 2.451 5.755 5.52h1.195c1.45 0 2.67 1.1 2.78 2.51l.9 11.38c0 1.01-.79 1.78-1.76 1.78v.01H3.24c-.97 0-1.76-.77-1.76-1.73l.9-11.44c.11-1.41 1.33-2.51 2.78-2.51z",
  clipRule: "evenodd",
  strokeWidth: 1
}));
exports.default = ShopFilled;
ShopFilled.displayName = 'ShopFilled';
});

unwrapExports(ShopFilled_1);

var StarFull_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const StarFull = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  stroke: "none",
  d: "M17.67 22.47c-.302 0-.585-.075-.868-.228L12.2 19.754a.38.38 0 0 0-.358.001l-4.6 2.487c-.523.314-1.303.305-1.91-.101a1.81 1.81 0 0 1-.745-1.742l.917-5.4a.37.37 0 0 0-.104-.328l-3.898-3.897a1.77 1.77 0 0 1-.412-1.797c.205-.615.767-1.078 1.43-1.181l5.302-.789a.38.38 0 0 0 .283-.209l2.305-4.776A1.79 1.79 0 0 1 12.045 1c.682 0 1.322.399 1.632 1.019l2.307 4.801c.054.113.16.191.283.209l5.299.79c.664.102 1.225.564 1.43 1.176.226.605.07 1.292-.406 1.796l-3.923 3.881a.38.38 0 0 0-.106.329l.896 5.395c.102.694-.183 1.362-.744 1.743a1.75 1.75 0 0 1-1.043.331",
  clipRule: "evenodd",
  strokeWidth: 1
}));
exports.default = StarFull;
StarFull.displayName = 'StarFull';
});

unwrapExports(StarFull_1);

var StarHalf_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const StarHalf = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  stroke: "none",
  clipRule: "evenodd",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#E1E1E1",
  d: "M17.67 22.47c-.302 0-.585-.075-.868-.228L12.2 19.754a.38.38 0 0 0-.358.001l-4.6 2.487c-.523.314-1.303.305-1.91-.101a1.81 1.81 0 0 1-.745-1.742l.917-5.4a.37.37 0 0 0-.104-.328l-3.898-3.897a1.77 1.77 0 0 1-.412-1.797c.205-.615.767-1.078 1.43-1.181l5.302-.789a.38.38 0 0 0 .283-.209l2.305-4.776A1.79 1.79 0 0 1 12.045 1c.682 0 1.322.399 1.632 1.019l2.307 4.801c.054.113.16.191.283.209l5.299.79c.664.102 1.225.564 1.43 1.176.226.605.07 1.292-.406 1.796l-3.923 3.881a.38.38 0 0 0-.106.329l.896 5.395c.102.694-.183 1.362-.744 1.743a1.75 1.75 0 0 1-1.043.331"
}), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  d: "M11.996 1H12v18.717a.4.4 0 0 0-.205.044l-4.58 2.488c-.52.314-1.297.305-1.9-.101a1.82 1.82 0 0 1-.743-1.743l.913-5.401a.38.38 0 0 0-.104-.329l-3.88-3.898a1.78 1.78 0 0 1-.41-1.797c.203-.616.763-1.079 1.424-1.182l5.277-.79a.37.37 0 0 0 .282-.208l2.295-4.778c.3-.63.925-1.022 1.627-1.022"
})));
exports.default = StarHalf;
StarHalf.displayName = 'StarHalf';
});

unwrapExports(StarHalf_1);

var FavouriteActive_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const FavouriteActive = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 32 32",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  stroke: "none",
  d: "M16 0a16 16 0 1 0-.015 32A16 16 0 0 0 16 0m.31 22.44-.41.33-.4-.33c-5.28-4.29-6.78-5.87-6.83-8.36a4 4 0 0 1 1-2.77 3.9 3.9 0 0 1 2.6-1.31 4.36 4.36 0 0 1 3.63 1.55 4.3 4.3 0 0 1 1.63-1.21 4.4 4.4 0 0 1 2-.34 3.94 3.94 0 0 1 3.61 4.07c-.06 2.5-1.56 4.08-6.83 8.37",
  strokeWidth: 1
}));
exports.default = FavouriteActive;
FavouriteActive.displayName = 'FavouriteActive';
});

unwrapExports(FavouriteActive_1);

var Favourite_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Favourite = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 32 32",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#A8A8A8",
  stroke: "none",
  d: "M16 0a16 16 0 1 0-.015 32A16 16 0 0 0 16 0m.31 22.44-.41.33-.4-.33c-5.28-4.29-6.78-5.87-6.83-8.36a4 4 0 0 1 1-2.77 3.9 3.9 0 0 1 2.6-1.31 4.36 4.36 0 0 1 3.63 1.55 4.3 4.3 0 0 1 1.63-1.21 4.4 4.4 0 0 1 2-.34 3.94 3.94 0 0 1 3.61 4.07c-.06 2.5-1.56 4.08-6.83 8.37",
  strokeWidth: 1
}));
exports.default = Favourite;
Favourite.displayName = 'Favourite';
});

unwrapExports(Favourite_1);

var Alert_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Alert = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  clipPath: "url(#a)",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#BC1430",
  d: "M12 1C5.92 1 1 5.92 1 12s4.92 11 11 11 11-4.92 11-11S18.08 1 12 1m-.75 6.25c0-.41.34-.75.75-.75s.75.34.75.75v6c0 .41-.34.75-.75.75s-.75-.34-.75-.75zM12 18.04c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "white",
  d: "M0 0h24v24H0z"
}))));
exports.default = Alert;
Alert.displayName = 'Alert';
});

unwrapExports(Alert_1);

var CannotBeTracked_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const CannotBeTracked = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#0CAA8F",
  stroke: "none",
  d: "M12 1C5.92 1 1 5.92 1 12s4.92 11 11 11 11-4.92 11-11S18.08 1 12 1m.75 15.75c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-6c0-.41.34-.75.75-.75s.75.34.75.75zm-.04-9.08a1 1 0 0 1-.71.29.99.99 0 0 1-.92-1.38c.05-.12.12-.23.21-.32.28-.28.73-.37 1.09-.22.12.05.23.12.33.22.09.09.17.2.22.32s.07.25.07.38c0 .27-.1.52-.29.71",
  strokeWidth: 1
}));
exports.default = CannotBeTracked;
CannotBeTracked.displayName = 'CannotBeTracked';
});

unwrapExports(CannotBeTracked_1);

var Completed_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Completed = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  clipPath: "url(#a)",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#0CAA8F",
  d: "M12 1C5.92 1 1 5.92 1 12s4.92 11 11 11 11-4.92 11-11S18.08 1 12 1m5.36 8.01-6.44 7a.73.73 0 0 1-.53.24h-.02c-.19 0-.38-.08-.52-.21l-3.18-3.06a.746.746 0 0 1-.02-1.06c.29-.3.76-.31 1.06-.02l2.63 2.53 5.92-6.44c.28-.3.76-.32 1.06-.04s.32.75.04 1.06"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "white",
  d: "M0 0h24v24H0z"
}))));
exports.default = Completed;
Completed.displayName = 'Completed';
});

unwrapExports(Completed_1);

var Default_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Default = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#E1E1E1",
  fillRule: "evenodd",
  stroke: "none",
  d: "M12 21.5a9.5 9.5 0 1 0 0-19 9.5 9.5 0 0 0 0 19m0 1.5c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11",
  clipRule: "evenodd",
  strokeWidth: 1
}));
exports.default = Default;
Default.displayName = 'Default';
});

unwrapExports(Default_1);

var InProgress_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const InProgress = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  clipPath: "url(#a)",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#FFB824",
  d: "M12 1C5.92 1 1 5.92 1 12s4.92 11 11 11 11-4.92 11-11S18.08 1 12 1m4 11.75h-4c-.41 0-.75-.34-.75-.75V5.56c0-.41.34-.75.75-.75s.75.34.75.75v5.69H16c.41 0 .75.34.75.75s-.34.75-.75.75"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "white",
  d: "M0 0h24v24H0z"
}))));
exports.default = InProgress;
InProgress.displayName = 'InProgress';
});

unwrapExports(InProgress_1);

var ArrowDown_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const ArrowDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  d: "M11.95 17.25a.75.75 0 0 1-.53-.22l-8.95-9a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l8.42 8.47 8.52-8.47c.29-.29.77-.29 1.06 0s.29.77 0 1.06l-9.05 9a.75.75 0 0 1-.53.22"
}));
exports.default = ArrowDown;
ArrowDown.displayName = 'ArrowDown';
});

unwrapExports(ArrowDown_1);

var ArrowLeft_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const ArrowLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  d: "M15.9 21.75c-.19 0-.38-.07-.53-.22l-9-8.95a.75.75 0 0 1 0-1.06l9-9.05c.29-.29.77-.29 1.06 0s.29.77 0 1.06l-8.47 8.52 8.47 8.42c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22"
}));
exports.default = ArrowLeft;
ArrowLeft.displayName = 'ArrowLeft';
});

unwrapExports(ArrowLeft_1);

var ArrowRight_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const ArrowRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  d: "M8.1 21.75c-.19 0-.39-.07-.53-.22a.754.754 0 0 1 0-1.06l8.47-8.42-8.47-8.52a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l9 9.05a.75.75 0 0 1 0 1.06l-9 8.95c-.15.15-.34.22-.53.22"
}));
exports.default = ArrowRight;
ArrowRight.displayName = 'ArrowRight';
});

unwrapExports(ArrowRight_1);

var ArrowUp_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const ArrowUp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  d: "M21 17.25c-.19 0-.39-.07-.53-.22l-8.42-8.47-8.52 8.47c-.29.29-.77.29-1.06 0a.754.754 0 0 1 0-1.06l9.05-9c.14-.14.38-.23.53-.22.2 0 .39.08.53.22l8.95 9c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22"
}));
exports.default = ArrowUp;
ArrowUp.displayName = 'ArrowUp';
});

unwrapExports(ArrowUp_1);

var BackArrow_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const BackArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M12.39 21.53c.15.15.34.22.53.22s.38-.07.53-.22c.29-.29.29-.77 0-1.06l-7.766-7.72H20.08c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H5.775l7.675-7.72c.29-.29.29-.77 0-1.06a.754.754 0 0 0-1.06 0L3.4 11.52a.75.75 0 0 0 0 1.06z",
  clipRule: "evenodd"
}));
exports.default = BackArrow;
BackArrow.displayName = 'BackArrow';
});

unwrapExports(BackArrow_1);

var Clear_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Clear = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M1 12c0 6.07 4.93 11 11 11s11-4.93 11-11S18.07 1 12 1 1 5.93 1 12m1.5 0c0-5.24 4.26-9.5 9.5-9.5s9.5 4.26 9.5 9.5-4.26 9.5-9.5 9.5-9.5-4.26-9.5-9.5M15 15.75c-.19 0-.38-.07-.53-.22L12 13.06l-2.47 2.47c-.15.15-.34.22-.53.22s-.38-.07-.53-.22a.754.754 0 0 1 0-1.06L10.94 12 8.47 9.53a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0L12 10.94l2.47-2.47c.29-.29.77-.29 1.06 0s.29.77 0 1.06L13.06 12l2.47 2.47c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22",
  clipRule: "evenodd"
}));
exports.default = Clear;
Clear.displayName = 'Clear';
});

unwrapExports(Clear_1);

var Close_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Close = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M18.97 20.03c.15.15.34.22.53.22s.38-.07.53-.22c.29-.29.29-.77 0-1.06L13.06 12l6.97-6.97c.29-.29.29-.77 0-1.06a.754.754 0 0 0-1.06 0L12 10.94 5.03 3.97a.754.754 0 0 0-1.06 0c-.29.29-.29.77 0 1.06L10.94 12l-6.97 6.97c-.29.29-.29.77 0 1.06.15.15.34.22.53.22s.38-.07.53-.22L12 13.06z",
  clipRule: "evenodd"
}));
exports.default = Close;
Close.displayName = 'Close';
});

unwrapExports(Close_1);

var Info_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Info = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M1 12c0 6.07 4.93 11 11 11s11-4.93 11-11S18.07 1 12 1 1 5.93 1 12m1.5 0c0-5.24 4.26-9.5 9.5-9.5s9.5 4.26 9.5 9.5-4.26 9.5-9.5 9.5-9.5-4.26-9.5-9.5M12 7.96c-.06 0-.13-.01-.2-.02-.06 0-.12-.03-.18-.06a.8.8 0 0 1-.28-.168l-.05-.042-.12-.15a.8.8 0 0 1-.09-.18.6.6 0 0 1-.06-.18 1 1 0 0 0-.01-.1q-.009-.048-.01-.1c0-.26.11-.52.29-.71.28-.28.72-.37 1.09-.21q.18.075.33.21c.18.19.29.45.29.71s-.11.52-.29.71q-.15.135-.33.21c-.12.06-.25.08-.38.08m0 9.54c-.41 0-.75-.34-.75-.75v-6c0-.41.34-.75.75-.75s.75.34.75.75v6c0 .41-.34.75-.75.75",
  clipRule: "evenodd"
}));
exports.default = Info;
Info.displayName = 'Info';
});

unwrapExports(Info_1);

var Minus_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Minus = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  d: "M20 12.75H4c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h16c.41 0 .75.34.75.75s-.34.75-.75.75"
}));
exports.default = Minus;
Minus.displayName = 'Minus';
});

unwrapExports(Minus_1);

var Plus_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Plus = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M11.25 20c0 .41.34.75.75.75s.75-.34.75-.75v-7.25H20c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-7.25V4c0-.41-.34-.75-.75-.75s-.75.34-.75.75v7.25H4c-.41 0-.75.34-.75.75s.34.75.75.75h7.25z",
  clipRule: "evenodd"
}));
exports.default = Plus;
Plus.displayName = 'Plus';
});

unwrapExports(Plus_1);

var SortingDown_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SortingDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M11.25 4v14.432L6.47 14.56a.747.747 0 1 0-.94 1.16l5.945 4.815a.7.7 0 0 0 .329.19.8.8 0 0 0 .19.025H12c.193 0 .37-.075.503-.197l5.967-4.833a.747.747 0 1 0-.94-1.16l-4.78 3.872V4c0-.41-.34-.75-.75-.75s-.75.34-.75.75",
  clipRule: "evenodd"
}));
exports.default = SortingDown;
SortingDown.displayName = 'SortingDown';
});

unwrapExports(SortingDown_1);

var SortingNeutral_1$1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SortingNeutral = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M12.9 6.15a.7.7 0 0 1-.47-.17L9.45 3.568V13c0 .41-.34.75-.75.75s-.75-.34-.75-.75V3.578L4.97 5.99c-.14.11-.31.17-.47.17v-.01a.71.71 0 0 1-.58-.28.747.747 0 0 1 .11-1.05l4.122-3.337A.746.746 0 0 1 9.17 1.41l4.2 3.4a.754.754 0 0 1-.47 1.34m1.65 14.272V11c0-.41.34-.75.75-.75s.75.34.75.75v9.422l2.98-2.412a.747.747 0 1 1 .94 1.16l-4.115 3.331a.75.75 0 0 1-.538.249H15.3a.8.8 0 0 1-.205-.027.7.7 0 0 1-.32-.187L10.63 19.18a.76.76 0 0 1-.11-1.06c.26-.32.73-.37 1.05-.11z",
  clipRule: "evenodd"
}));
exports.default = SortingNeutral;
SortingNeutral.displayName = 'SortingNeutral';
});

unwrapExports(SortingNeutral_1$1);

var SortingUp_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SortingUp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  fillRule: "evenodd",
  d: "M12 20.75c-.41 0-.75-.34-.75-.75V5.568L6.47 9.44c-.14.11-.31.17-.47.17a.71.71 0 0 1-.58-.28.747.747 0 0 1 .11-1.05l5.966-4.833A.75.75 0 0 1 12 3.25c.192 0 .37.075.503.197L18.47 8.28c.32.26.37.73.11 1.05-.15.18-.36.28-.58.28a.7.7 0 0 1-.47-.17l-4.78-3.872V20c0 .41-.34.75-.75.75",
  clipRule: "evenodd"
}));
exports.default = SortingUp;
SortingUp.displayName = 'SortingUp';
});

unwrapExports(SortingUp_1);

var Tick_1$1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(React__default["default"]);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Tick = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: props.size || 16,
  height: props.size || 16,
  fill: "none",
  viewBox: "0 0 24 24",
  strokeWidth: props.size <= 16 ? 0.8 : 0,
  stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: props.color || "#222222",
  d: "M8.95 19.3c-.19 0-.38-.08-.52-.21l-5.95-5.73a.746.746 0 0 1-.02-1.06c.29-.3.76-.31 1.06-.02l5.4 5.19L20.45 4.94c.28-.31.76-.32 1.06-.04s.32.75.04 1.06L9.5 19.05a.73.73 0 0 1-.53.24h-.02z"
}));
exports.default = Tick;
Tick.displayName = 'Tick';
});

unwrapExports(Tick_1$1);

const AddGeneric = AddGeneric_1$1.default;
          var AddGeneric_1 = AddGeneric;
        

          AddonProduct_1.default;
        

          Announcement_1.default;
        

          Attachment_1.default;
        

          Attention_1.default;
        

          Bills_1.default;
        

          Bookmark_1.default;
        

          BroadbandAddon_1.default;
        

          Broadband_1.default;
        

          Calendar_1.default;
        

          CallBack_1.default;
        

          Camera_1.default;
        

          Cart_1.default;
        

          CartActive_1.default;
        

          Cash_1.default;
        

          Category_1.default;
        

          Chart_1.default;
        

          Checklist_1.default;
        

          Community_1.default;
        

          Contacts_1.default;
        

          Contract_1.default;
        

          Coverage_1.default;
        

          Creditcard_1.default;
        

          Data_1.default;
        

          const Delivery = Delivery_1$1.default;
          var Delivery_1 = Delivery;
        

          const Discount = Discount_1$1.default;
          var Discount_1 = Discount;
        

          DocumentInfo_1.default;
        

          DocumentWTick_1.default;
        

          Document_1.default;
        

          Download_1.default;
        

          Edit_1.default;
        

          Entertainment_1.default;
        

          Expand_1.default;
        

          Express_1.default;
        

          ExternalLink_1.default;
        

          FAQ_1.default;
        

          const Filter = Filter_1$1.default;
          var Filter_1 = Filter;
        

          FlightLeft_1.default;
        

          FlightRight_1.default;
        

          Flight_1.default;
        

          Food_1.default;
        

          GlobalSMS_1.default;
        

          Heart_1.default;
        

          Help_1.default;
        

          HiAppPrepaid_1.default;
        

          Hide_1.default;
        

          Home_1.default;
        

          IDD_1.default;
        

          Itinerary_1.default;
        

          Laptop_1.default;
        

          Leisure_1.default;
        

          Lightning_1.default;
        

          Listen_1.default;
        

          Loading_1.default;
        

          MailUnread_1.default;
        

          Mail_1.default;
        

          _Map.default;
        

          Menu_1.default;
        

          Message_1.default;
        

          Mic_1.default;
        

          Minimise_1.default;
        

          MobileAddon_1.default;
        

          MobileBroadband_1.default;
        

          MobileSignal_1.default;
        

          MobilephoneBill_1.default;
        

          Mobilephone_1.default;
        

          Monitor_1.default;
        

          More_1.default;
        

          Movie_1.default;
        

          Music_1.default;
        

          Notice_1.default;
        

          NotificationActive_1.default;
        

          NotificationDisabled_1.default;
        

          Notification_1.default;
        

          Options_1.default;
        

          Pause_1.default;
        

          PeaceOfMind_1.default;
        

          Personal_1.default;
        

          PhoneContact_1.default;
        

          Pin_1.default;
        

          Play_1.default;
        

          Pointer_1.default;
        

          PowerSwitch_1.default;
        

          Processing_1.default;
        

          Recommended_1.default;
        

          RedMembership_1.default;
        

          RefreshPhone_1.default;
        

          Refresh_1.default;
        

          Remote_1.default;
        

          Return_1.default;
        

          Rewards_1.default;
        

          Roaming_1.default;
        

          Search_1.default;
        

          Secure_1.default;
        

          Send_1.default;
        

          Services_1.default;
        

          const Settings = Settings_1$1.default;
          var Settings_1 = Settings;
        

          const Share = Share_1$1.default;
          var Share_1 = Share;
        

          Shop_1.default;
        

          Show_1.default;
        

          const Simcard = Simcard_1$1.default;
          var Simcard_1 = Simcard;
        

          SpeedMeter_1.default;
        

          Star_1.default;
        

          const Store = Store_1$1.default;
          var Store_1 = Store;
        

          Support_1.default;
        

          Tablet_1.default;
        

          Thumbsup_1.default;
        

          Time_1.default;
        

          Timeline_1.default;
        

          Transport_1.default;
        

          Trash_1.default;
        

          TVAddon_1.default;
        

          TV_1.default;
        

          Upload_1.default;
        

          Viewlist_1.default;
        

          Voucher_1.default;
        

          Wallet_1.default;
        

          Wifi_1.default;
        

          Work_1.default;
        

          AddonProductFilled_1.default;
        

          BillsFilled_1.default;
        

          HeartFilled_1.default;
        

          HomeFilled_1.default;
        

          MoreFilled_1.default;
        

          PersonalFilled_1.default;
        

          PriceDown_1.default;
        

          PriceUp_1.default;
        

          RewardsFilled_1.default;
        

          SecureFilled_1.default;
        

          ShopFilled_1.default;
        

          StarFull_1.default;
        

          StarHalf_1.default;
        

          FavouriteActive_1.default;
        

          Favourite_1.default;
        

          Alert_1.default;
        

          CannotBeTracked_1.default;
        

          Completed_1.default;
        

          Default_1.default;
        

          InProgress_1.default;
        

          ArrowDown_1.default;
        

          ArrowLeft_1.default;
        

          ArrowRight_1.default;
        

          ArrowUp_1.default;
        

          BackArrow_1.default;
        

          Clear_1.default;
        

          Close_1.default;
        

          Info_1.default;
        

          Minus_1.default;
        

          Plus_1.default;
        

          SortingDown_1.default;
        

          const SortingNeutral = SortingNeutral_1$1.default;
          var SortingNeutral_1 = SortingNeutral;
        

          SortingUp_1.default;
        

          const Tick = Tick_1$1.default;
          var Tick_1 = Tick;

/**
 * replace text with map
 *
 * @param {String} str //original string,
 * str eg."Once you make the following changes on Step ${changeStep}. The information for step ${clearedStep} will be cleared. "
 * @param {Object} replaceMap //replaceMap
 * replaceMap eg.{changeStep: 1,clearedStep: 2}
 * @return {String} output eg. "Once you make the following changes on Step 1. The information for step 2 will be cleared. "
 */
var replaceText = (function (str, replaceMap) {
    var wrappedMap = {};
    Object.keys(replaceMap).forEach(function (item) {
        wrappedMap['${' + item + '}'] = replaceMap[item];
    });
    var reStr = '(' +
        Object.keys(replaceMap)
            .map(function (it) { return '\\${' + it + '}'; })
            .join('|') +
        ')';
    var re = new RegExp(reStr, 'g');
    return str.replace(re, function (it) { return wrappedMap[it]; });
});

var ACTION_BUTTON_SAVE = "Save";
var ACTION_BUTTON_VIEW_MORE = "View More";
var ACTION_BUTTON_NEXT = "Next";
var ACTION_BUTTON_SHOW_MORE_BRANDS = "Show more brands";
var ACTION_BUTTON_CLEAR = "Clear";
var ACTION_BUTTON_APPLY = "Apply";
var ACTION_BUTTON_BACK = "Back";
var ACTION_BUTTON_SHOWMORE = "Show More";
var ACTION_BUTTON_SHOW_LESS = "Show less";
var ACTION_BUTTON_ADD = "Add";
var ACTION_BUTTON_REMOVE = "Remove";
var EQUIPMENT_CARD_PRICE_FROM = "From $";
var EQUIPMENT_SELECTED_TEXT_TITLE = "You have selected:";
var EQUIPMENT_SELECTED_TEXT_HIDE = "Hide Details";
var EQUIPMENT_SELECTED_TEXT_SEE_MORE = "See More";
var EQUIPMENT_MOBILE_DEVICE_TITLE = "Mobile Devices";
var EQUIPMENT_TITLE_BTN = "I do not need Mobile Devices";
var EQUIPMENT_ACCESSORY_TITLE = "Accessories";
var EQUIPMENT_FILTER_SEARCH = "Search ${type}";
var EQUIPMENT_FILTER_BRANDS_TITLE = "Brands";
var EQUIPMENT_FILTER_SORT_BY = "Sort By";
var EQUIPMENT_FILTER_TITLE = "Filter";
var EQUIPMENT_INSTALMENT_PLAN_TITLE = "Instalment Plan";
var EQUIPMENT_ERROR_NOT_FOUND = "There are no available ${type} that fall in this category.";
var EQUIPMENT_VALIDATION_ERROR_NO_DEVICE_SELECTED_TITLE = "Mobile device not selected";
var EQUIPMENT_VALIDATION_ERROR_NO_DEVICE_SELECTED_MSG = "Please select a mobile device or click the \"I do not need mobile device\" button to proceed";
var EQUIPMENT_DETAILS_QUANTITY_TITLE = "Quantity";
var EQUIPMENT_DETAILS_CHOOSE_QUANTITY = "Choose Quantity";
var EQUIPMENT_DETAILS_QUANTITY_DESCRIPTION = "This quantity is based on the number of new lines that you are purchasing in this order";
var EQUIPMENT_DETAILS_QUANTITY_ERROR = "You have reached maximum amount";
var EQUIPMENT_DETAILS_STORAGE_TITLE = "Choose your storage";
var EQUIPMENT_DETAILS_PAYMENT_TERMS = "Choose your payment terms";
var EQUIPMENT_DETAILS_STOCK_TITLE = "Current stocks";
var EQUIPMENT_DETAILS_STOCK_NOT_AVAILABLE = "Not Available";
var EQUIPMENT_DETAILS_COLOR_TITLE = "Choose your colour";
var EQUIPMENT_DETAILS_UNIT_PRICE = "Unit Price";
var EQUIPMENT_DETAILS_PRICE = "Price";
var EQUIPMENT_DETAILS_TOTAL_PRICE = "Total price for all units";
var EQUIPMENT_DETAILS_TECH_SPECS = "Tech Specs";
var EQUIPMENT_DETAILS_BOX_TITLE = "What's in the Box";
var EQUIPMENT_DETAILS_CHOOSE_MODEL = "Choose your model";
var MTH_CONTRACT_TEXT = "mth contract";
var NO_CONTRACT_TEXT = "No Contract";
var ACTION_BUTTON_UPGRADE = "Upgrade";
var SETUP_FEE = "Setup fee";
var UPSIZE_SMS = "Upsize SMS";
var UPSIZE_DATA = "Upsize Data";
var UPSIZE_TALKTIME = "Upsize Talktime";
var PROMOTE_TITLE = "Enjoy up to {0} OFF this device!";
var PROMOTE_LINK_TEXT = "Find out more";
var OUT_OF_STOCK = "Out of stock";
var MONTHS = "Months";
var PLAN = "Plan";
var PRODUCT = "Product";
var VARIANT_INSTALLMENT_PRICE = "${price}/mth";
var DISPLAYED_MONTHLY_CHARGES = "${price}/mth";
var DISPLAYED_DISCOUNTED_MONTHLY_CHARGES = "${price}/mth";
var PRODUCT_COST = "${price}";
var CHOOSE_YOUR_PLAN = "Choose your plan";
var EQUIPMENT_DETAILS_OR = "OR";
var EQUIPMENT_DETAILS_DELIVERY = "Delivery";
var EQUIPMENT_DETAILS_FREE_GIFTS = "Free gifts";
var PRE_ODER_TEXT = "Available as pre-order";
var TODAY = "Today";
var MONTHLY = "Monthly";
var DISCOUNT_DISCLAIMER = "Discounts will be calculated at checkout";
var ACCESSORY_HEADER_TEXT = "Because you are interested in {deviceTitle}";
var VIEW_MORE_OPTIONS = "View more";
var SELECT = "Select";
var ADD = "Add";
var ACCESSORY_SIZE_HEADER_TEXT = "Choose your size";
var SHOW_MORE = "Show more";
var SHOW_LESS = "Show less";
var SIM_ONLY_BUTTON = "OK, Show plans";
var OUT_OF_STOCK_MESSAGE = "We are sorry, this item is out of stock.";
var OUT_OF_STOCK_MESSAGE_LINK = "This item is out of stock. ";
var OUT_OF_STOCK_MESSAGE_HERE = " Continue browsing";
var OUT_OF_STOCK_MESSAGE_CHOOSE = "  other items instead.";
var OUT_OF_STOCK_COLOUR_MESSAGE = "We are sorry, the colour you have selected is out of stock, please select another colour.";
var SIM_ONLY_PLUS_PLAN = "SIM Only Plan";
var DEVICE_INSTALLMENT_PLAN = "Product with Singtel PayLater";
var SINGTEL_PAY_LATER_ZERO_INSTEREST_INSTALMENT_PLAN = "Singtel PayLater - 0% interest instalment payment plan";
var SIM_ONLY_PLUS_UPSELL_DESCRIPTION = "Available for Singtel customers who are Singaporean Citizens (SC), Permanent Residents (PR) and Foreigner Employment Pass (EP) holders aged 21 years and above. For more details, kindly refer to ";
var TERMS_CONDITIONS = "Terms & Conditions";
var GROUP_PLANS_FOOTER_LINER_TNC = "Terms & Conditions";
var DOOR_STEP_DELIVERY = "Doorstep delivery";
var POP_STATION = "POPStation";
var COLLECT_AT_STORE = "Collect at store";
var FREE = "FREE";
var EXCLUSIVE_FOR_SENIOR_CITIZEN = "Exclusive for senior citizens aged 60 and above: Enjoy 20% OFF XO Plus 50 + extra 100 mins, or 20% OFF XO Plus 68/88/118/168 with 10,000 mins monthly. Discounts will be applied upon checkout.";
var MOBILE_TERMS_CONDITIONS = "View Mobile Terms & Conditions";
var ORDER_SUMMARY_TITLE = "You've selected";
var TEXT_APPLY_FILTER = "Apply";
var TEXT_CLEAR_ALL = "Clear all";
var TEXT_FILTER = "Filter";
var SEARCH_MODAL_TITLE = "Filter";
var TEXT_TO = "to";
var TEXT_FULL_PRICE = "Full price";
var TEXT_BUY_NOW = "Buy now";
var TEXT_CHECK_ELIGIBILITY = "Check eligibility";
var TEXT_SHOW_FILTER = "Show filter";
var TEXT_HIDE_FILTER = "Hide filter";
var TEXT_RESULTS = "Results";
var CART_BOX_DESCRIPTION = "Some discounts will be calculated at checkout";
var CART_BOX_IPP_DESCRIPTION = "Some discounts will be calculated at checkout";
var CART_BOX_PRIMARY_BUTTON_TEXT = "Buy now";
var CART_BOX_IPP_PRIMARY_BUTTON_TEXT = "Check eligibility";
var CART_BOX_SECONDARY_BUTTON_TEXT = "Add to cart";
var COMES_WITH = "Comes with";
var enUS = {
	ACTION_BUTTON_SAVE: ACTION_BUTTON_SAVE,
	ACTION_BUTTON_VIEW_MORE: ACTION_BUTTON_VIEW_MORE,
	ACTION_BUTTON_NEXT: ACTION_BUTTON_NEXT,
	ACTION_BUTTON_SHOW_MORE_BRANDS: ACTION_BUTTON_SHOW_MORE_BRANDS,
	ACTION_BUTTON_CLEAR: ACTION_BUTTON_CLEAR,
	ACTION_BUTTON_APPLY: ACTION_BUTTON_APPLY,
	ACTION_BUTTON_BACK: ACTION_BUTTON_BACK,
	ACTION_BUTTON_SHOWMORE: ACTION_BUTTON_SHOWMORE,
	ACTION_BUTTON_SHOW_LESS: ACTION_BUTTON_SHOW_LESS,
	ACTION_BUTTON_ADD: ACTION_BUTTON_ADD,
	ACTION_BUTTON_REMOVE: ACTION_BUTTON_REMOVE,
	EQUIPMENT_CARD_PRICE_FROM: EQUIPMENT_CARD_PRICE_FROM,
	EQUIPMENT_SELECTED_TEXT_TITLE: EQUIPMENT_SELECTED_TEXT_TITLE,
	EQUIPMENT_SELECTED_TEXT_HIDE: EQUIPMENT_SELECTED_TEXT_HIDE,
	EQUIPMENT_SELECTED_TEXT_SEE_MORE: EQUIPMENT_SELECTED_TEXT_SEE_MORE,
	EQUIPMENT_MOBILE_DEVICE_TITLE: EQUIPMENT_MOBILE_DEVICE_TITLE,
	EQUIPMENT_TITLE_BTN: EQUIPMENT_TITLE_BTN,
	EQUIPMENT_ACCESSORY_TITLE: EQUIPMENT_ACCESSORY_TITLE,
	EQUIPMENT_FILTER_SEARCH: EQUIPMENT_FILTER_SEARCH,
	EQUIPMENT_FILTER_BRANDS_TITLE: EQUIPMENT_FILTER_BRANDS_TITLE,
	EQUIPMENT_FILTER_SORT_BY: EQUIPMENT_FILTER_SORT_BY,
	EQUIPMENT_FILTER_TITLE: EQUIPMENT_FILTER_TITLE,
	EQUIPMENT_INSTALMENT_PLAN_TITLE: EQUIPMENT_INSTALMENT_PLAN_TITLE,
	EQUIPMENT_ERROR_NOT_FOUND: EQUIPMENT_ERROR_NOT_FOUND,
	EQUIPMENT_VALIDATION_ERROR_NO_DEVICE_SELECTED_TITLE: EQUIPMENT_VALIDATION_ERROR_NO_DEVICE_SELECTED_TITLE,
	EQUIPMENT_VALIDATION_ERROR_NO_DEVICE_SELECTED_MSG: EQUIPMENT_VALIDATION_ERROR_NO_DEVICE_SELECTED_MSG,
	EQUIPMENT_DETAILS_QUANTITY_TITLE: EQUIPMENT_DETAILS_QUANTITY_TITLE,
	EQUIPMENT_DETAILS_CHOOSE_QUANTITY: EQUIPMENT_DETAILS_CHOOSE_QUANTITY,
	EQUIPMENT_DETAILS_QUANTITY_DESCRIPTION: EQUIPMENT_DETAILS_QUANTITY_DESCRIPTION,
	EQUIPMENT_DETAILS_QUANTITY_ERROR: EQUIPMENT_DETAILS_QUANTITY_ERROR,
	EQUIPMENT_DETAILS_STORAGE_TITLE: EQUIPMENT_DETAILS_STORAGE_TITLE,
	EQUIPMENT_DETAILS_PAYMENT_TERMS: EQUIPMENT_DETAILS_PAYMENT_TERMS,
	EQUIPMENT_DETAILS_STOCK_TITLE: EQUIPMENT_DETAILS_STOCK_TITLE,
	EQUIPMENT_DETAILS_STOCK_NOT_AVAILABLE: EQUIPMENT_DETAILS_STOCK_NOT_AVAILABLE,
	EQUIPMENT_DETAILS_COLOR_TITLE: EQUIPMENT_DETAILS_COLOR_TITLE,
	EQUIPMENT_DETAILS_UNIT_PRICE: EQUIPMENT_DETAILS_UNIT_PRICE,
	EQUIPMENT_DETAILS_PRICE: EQUIPMENT_DETAILS_PRICE,
	EQUIPMENT_DETAILS_TOTAL_PRICE: EQUIPMENT_DETAILS_TOTAL_PRICE,
	EQUIPMENT_DETAILS_TECH_SPECS: EQUIPMENT_DETAILS_TECH_SPECS,
	EQUIPMENT_DETAILS_BOX_TITLE: EQUIPMENT_DETAILS_BOX_TITLE,
	EQUIPMENT_DETAILS_CHOOSE_MODEL: EQUIPMENT_DETAILS_CHOOSE_MODEL,
	MTH_CONTRACT_TEXT: MTH_CONTRACT_TEXT,
	NO_CONTRACT_TEXT: NO_CONTRACT_TEXT,
	ACTION_BUTTON_UPGRADE: ACTION_BUTTON_UPGRADE,
	SETUP_FEE: SETUP_FEE,
	UPSIZE_SMS: UPSIZE_SMS,
	UPSIZE_DATA: UPSIZE_DATA,
	UPSIZE_TALKTIME: UPSIZE_TALKTIME,
	PROMOTE_TITLE: PROMOTE_TITLE,
	PROMOTE_LINK_TEXT: PROMOTE_LINK_TEXT,
	OUT_OF_STOCK: OUT_OF_STOCK,
	MONTHS: MONTHS,
	PLAN: PLAN,
	PRODUCT: PRODUCT,
	VARIANT_INSTALLMENT_PRICE: VARIANT_INSTALLMENT_PRICE,
	DISPLAYED_MONTHLY_CHARGES: DISPLAYED_MONTHLY_CHARGES,
	DISPLAYED_DISCOUNTED_MONTHLY_CHARGES: DISPLAYED_DISCOUNTED_MONTHLY_CHARGES,
	PRODUCT_COST: PRODUCT_COST,
	CHOOSE_YOUR_PLAN: CHOOSE_YOUR_PLAN,
	EQUIPMENT_DETAILS_OR: EQUIPMENT_DETAILS_OR,
	EQUIPMENT_DETAILS_DELIVERY: EQUIPMENT_DETAILS_DELIVERY,
	EQUIPMENT_DETAILS_FREE_GIFTS: EQUIPMENT_DETAILS_FREE_GIFTS,
	PRE_ODER_TEXT: PRE_ODER_TEXT,
	TODAY: TODAY,
	MONTHLY: MONTHLY,
	DISCOUNT_DISCLAIMER: DISCOUNT_DISCLAIMER,
	ACCESSORY_HEADER_TEXT: ACCESSORY_HEADER_TEXT,
	VIEW_MORE_OPTIONS: VIEW_MORE_OPTIONS,
	SELECT: SELECT,
	ADD: ADD,
	ACCESSORY_SIZE_HEADER_TEXT: ACCESSORY_SIZE_HEADER_TEXT,
	SHOW_MORE: SHOW_MORE,
	SHOW_LESS: SHOW_LESS,
	SIM_ONLY_BUTTON: SIM_ONLY_BUTTON,
	OUT_OF_STOCK_MESSAGE: OUT_OF_STOCK_MESSAGE,
	OUT_OF_STOCK_MESSAGE_LINK: OUT_OF_STOCK_MESSAGE_LINK,
	OUT_OF_STOCK_MESSAGE_HERE: OUT_OF_STOCK_MESSAGE_HERE,
	OUT_OF_STOCK_MESSAGE_CHOOSE: OUT_OF_STOCK_MESSAGE_CHOOSE,
	OUT_OF_STOCK_COLOUR_MESSAGE: OUT_OF_STOCK_COLOUR_MESSAGE,
	SIM_ONLY_PLUS_PLAN: SIM_ONLY_PLUS_PLAN,
	DEVICE_INSTALLMENT_PLAN: DEVICE_INSTALLMENT_PLAN,
	SINGTEL_PAY_LATER_ZERO_INSTEREST_INSTALMENT_PLAN: SINGTEL_PAY_LATER_ZERO_INSTEREST_INSTALMENT_PLAN,
	SIM_ONLY_PLUS_UPSELL_DESCRIPTION: SIM_ONLY_PLUS_UPSELL_DESCRIPTION,
	TERMS_CONDITIONS: TERMS_CONDITIONS,
	GROUP_PLANS_FOOTER_LINER_TNC: GROUP_PLANS_FOOTER_LINER_TNC,
	DOOR_STEP_DELIVERY: DOOR_STEP_DELIVERY,
	POP_STATION: POP_STATION,
	COLLECT_AT_STORE: COLLECT_AT_STORE,
	FREE: FREE,
	EXCLUSIVE_FOR_SENIOR_CITIZEN: EXCLUSIVE_FOR_SENIOR_CITIZEN,
	MOBILE_TERMS_CONDITIONS: MOBILE_TERMS_CONDITIONS,
	ORDER_SUMMARY_TITLE: ORDER_SUMMARY_TITLE,
	TEXT_APPLY_FILTER: TEXT_APPLY_FILTER,
	TEXT_CLEAR_ALL: TEXT_CLEAR_ALL,
	TEXT_FILTER: TEXT_FILTER,
	SEARCH_MODAL_TITLE: SEARCH_MODAL_TITLE,
	TEXT_TO: TEXT_TO,
	TEXT_FULL_PRICE: TEXT_FULL_PRICE,
	TEXT_BUY_NOW: TEXT_BUY_NOW,
	TEXT_CHECK_ELIGIBILITY: TEXT_CHECK_ELIGIBILITY,
	TEXT_SHOW_FILTER: TEXT_SHOW_FILTER,
	TEXT_HIDE_FILTER: TEXT_HIDE_FILTER,
	TEXT_RESULTS: TEXT_RESULTS,
	CART_BOX_DESCRIPTION: CART_BOX_DESCRIPTION,
	CART_BOX_IPP_DESCRIPTION: CART_BOX_IPP_DESCRIPTION,
	CART_BOX_PRIMARY_BUTTON_TEXT: CART_BOX_PRIMARY_BUTTON_TEXT,
	CART_BOX_IPP_PRIMARY_BUTTON_TEXT: CART_BOX_IPP_PRIMARY_BUTTON_TEXT,
	CART_BOX_SECONDARY_BUTTON_TEXT: CART_BOX_SECONDARY_BUTTON_TEXT,
	COMES_WITH: COMES_WITH
};

var useTranslation = (function (customLang) {
    var translate = function (key, replaceMap) {
        var _a;
        var str = (customLang === null || customLang === void 0 ? void 0 : customLang[key]) || ((_a = enUS) === null || _a === void 0 ? void 0 : _a[key]) || key;
        if (replaceMap) {
            if (Array.isArray(replaceMap)) {
                return replaceString(str, replaceMap);
            }
            return replaceText(str, replaceMap);
        }
        else {
            return str;
        }
    };
    return { t: translate, translate: translate };
});
var replaceString = function (text, injectStrings) {
    if (injectStrings === void 0) { injectStrings = []; }
    if (!text || !injectStrings || !injectStrings.length)
        return text;
    return injectStrings.reduce(function (result, injectString, index) {
        result = result.replace("{" + index + "}", injectString);
        return result;
    }, text);
};

var FilterContentWrapper = styled__default["default"](web.Spacing)(templateObject_1$r || (templateObject_1$r = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
styled__default["default"].div(templateObject_2$o || (templateObject_2$o = __makeTemplateObject(["\n  display: flex;\n  justify-content: right;\n"], ["\n  display: flex;\n  justify-content: right;\n"])));
var DisabledOverlay = styled__default["default"].div(templateObject_3$f || (templateObject_3$f = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background-color: rgba(255, 255, 255, ", ");\n  z-index: 10;\n"], ["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background-color: rgba(255, 255, 255, ", ");\n  z-index: 10;\n"])), function (props) { return props.opacity || 0.7; });
var ClearFilterWrapper = styled__default["default"](web.Spacing)(templateObject_4$e || (templateObject_4$e = __makeTemplateObject(["\n  text-align: ", ";\n"], ["\n  text-align: ", ";\n"])), function (props) { return (props.isMobile ? 'center' : 'left'); });
styled__default["default"](web.Spacing)(templateObject_5$9 || (templateObject_5$9 = __makeTemplateObject(["\n  margin-right: -20px;\n"], ["\n  margin-right: -20px;\n"])));
var CenterContent = styled__default["default"].div(templateObject_6$7 || (templateObject_6$7 = __makeTemplateObject(["\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  height: 100%;\n"], ["\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  height: 100%;\n"])));
var templateObject_1$r, templateObject_2$o, templateObject_3$f, templateObject_4$e, templateObject_5$9, templateObject_6$7;

var fullscreenStyles = styled.css(templateObject_1$q || (templateObject_1$q = __makeTemplateObject(["\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n"], ["\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n"])));
web.withTheme(styled__default["default"](web.Grid)(templateObject_3$e || (templateObject_3$e = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var coreTheme = _a.coreTheme;
    return styled.css(templateObject_2$n || (templateObject_2$n = __makeTemplateObject(["\n    position: fixed;\n    background: ", ";\n    ", "\n  "], ["\n    position: fixed;\n    background: ", ";\n    ", "\n  "])), coreTheme.cl_white, fullscreenStyles);
}));
var SkeletonOverlay = styled__default["default"].div(templateObject_4$d || (templateObject_4$d = __makeTemplateObject(["\n  position: fixed;\n  ", ";\n  opacity: 0;\n  z-index: 999;\n"], ["\n  position: fixed;\n  ", ";\n  opacity: 0;\n  z-index: 999;\n"])), fullscreenStyles);
var GridWrapper = styled__default["default"](web.Spacing)(templateObject_5$8 || (templateObject_5$8 = __makeTemplateObject(["\n  display: flex;\n  position: relative;\n"], ["\n  display: flex;\n  position: relative;\n"])));
var templateObject_1$q, templateObject_2$n, templateObject_3$e, templateObject_4$d, templateObject_5$8;

var getItemType = function (itemType, index, listLength, secondaryItem) {
    if (!secondaryItem)
        return itemType;
    if (index !== listLength - 2) {
        return itemType;
    }
    return secondaryItem;
};
var ListSkeletonLoader = function (_a) {
    var _b = _a.numberOfItem, numberOfItem = _b === void 0 ? 3 : _b, _c = _a.itemType, itemType = _c === void 0 ? 'ListItem' : _c, children = _a.children, _d = _a.isLoading, isLoading = _d === void 0 ? true : _d, _e = _a.responsive, responsive = _e === void 0 ? true : _e, secondaryItem = _a.secondaryItem, column = _a.column;
    var skeletonLoader = (React__default["default"].createElement(React__default["default"].Fragment, null, isLoading &&
        Array(numberOfItem)
            .fill(null)
            .map(function (_, index) {
            return (React__default["default"].createElement(web.Spacing, { key: "skeleton-" + index, topBottom: 1, responsive: responsive, "data-testid": "skeleton-item" },
                React__default["default"].createElement(web.SkeletonLoader, { preset: getItemType(itemType, index, numberOfItem, secondaryItem), loading: true })));
        })));
    if (!isLoading)
        return children;
    if (column) {
        return (React__default["default"].createElement(web.Grid, null,
            React__default["default"].createElement(web.Column, __assign({}, column), skeletonLoader)));
    }
    return skeletonLoader;
};
var SkeletonGrid = function (_a) {
    var _b = _a.numberOfColumn, numberOfColumn = _b === void 0 ? 3 : _b, _c = _a.itemType, itemType = _c === void 0 ? 'ListItem' : _c, _d = _a.numberOfRow, numberOfRow = _d === void 0 ? 3 : _d, _e = _a.withOverlay, withOverlay = _e === void 0 ? false : _e, children = _a.children, _f = _a.isLoading, isLoading = _f === void 0 ? true : _f, _g = _a.position, position = _g === void 0 ? {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
    } : _g;
    if (!isLoading) {
        return children;
    }
    return (React__default["default"].createElement(GridWrapper, { top: position.top, left: position.left, right: position.right, bottom: position.bottom, responsive: false },
        Array(numberOfColumn)
            .fill(null)
            .map(function (_, index) {
            return (React__default["default"].createElement(web.Column, { noGutter: true, xs: numberOfColumn > 1 ? 6 : 12, sm: 12 / numberOfColumn },
                React__default["default"].createElement(web.Spacing, { left: 1, right: 1, responsive: false },
                    React__default["default"].createElement(ListSkeletonLoader, { responsive: false, itemType: itemType, numberOfItem: numberOfRow }))));
        }),
        withOverlay && React__default["default"].createElement(SkeletonOverlay, null)));
};

var PRODUCT_CATALOG = {
    FILTER_TYPES: {
        PLAN: 'ipp',
        CATEGORY: 'category',
        BRAND: 'brand',
        PRICE: 'price',
        PRICE_RANGE: 'price_range',
        DEAL: 'deal',
        PAYMENT_OPTION: 'payment_option'
    }
};

function _extends$2() {
  _extends$2 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$2.apply(this, arguments);
}

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$1(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject$6, _templateObject2$5, _templateObject3$4, _templateObject4$2, _templateObject5$2, _templateObject6$2, _templateObject7$2;
styled__default["default"](web.Row)(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteral(["\n  width: 100%;\n  flex-direction: column;\n\n  & > div:first-child {\n    height: 24px;\n  }\n"])));
styled__default["default"](web.Row)(_templateObject2$5 || (_templateObject2$5 = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
styled__default["default"](web.Text)(_templateObject3$4 || (_templateObject3$4 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 4rem;\n  overflow-y: hidden;\n"])));
styled__default["default"](web.Layout.Inline)(_templateObject4$2 || (_templateObject4$2 = _taggedTemplateLiteral(["\n  height: calc(100% - 100px);\n"])));
var HeaderWrapper = styled__default["default"](web.Spacing)(_templateObject5$2 || (_templateObject5$2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 1;\n  justify-content: ", ";\n  align-items: center;\n"])), function (props) {
  return props.isMobile ? 'flex-start' : 'flex-end';
});
var InlineWrapper$1 = styled__default["default"](web.Spacing)(_templateObject6$2 || (_templateObject6$2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: ", ";\n"])), function (props) {
  return props.spaceBetween ? 'space-between' : '';
});
styled__default["default"].div(_templateObject7$2 || (_templateObject7$2 = _taggedTemplateLiteral(["\n  border: 1px solid ", ";\n  padding: 7px 12px 5px;\n  border-radius: 16px;\n  p {\n    line-height: 20px;\n  }\n"])), web.theme.main.colours.tertiary.l4);

var FilterBar = React.memo(function (props) {
    var _a;
    var _b = web.useDevice(), isMobile = _b.isMobile, isTablet = _b.isTablet;
    var isMobileView = isMobile || isTablet;
    var t = useTranslation().t;
    var equipmentListContext = React__default["default"].useContext(EquipmentListContext);
    var _c = React.useState(0), selectedGroup = _c[0], setSelectedGroup = _c[1];
    var filterData = props.filterData, showFilterModal = props.showFilterModal, setShowFilterModal = props.setShowFilterModal;
    var _d = React.useState({}), desktopCollapse = _d[0], setDesktopCollapse = _d[1];
    var defaultPrice = getPrice(filterData);
    var _e = React.useState({
        minPrice: defaultPrice.minPrice,
        maxPrice: defaultPrice.maxPrice
    }), price = _e[0], setPrice = _e[1];
    var callbacks = (equipmentListContext || {}).callbacks;
    var refApplyFilter = React.useRef(null);
    React.useEffect(function () {
        refApplyFilter.current = __spreadArray([], filterData, true);
    }, [filterData]);
    var getFilterContent = function (filterGroup, groupIndex) {
        switch (filterGroup.type) {
            case PRODUCT_CATALOG.FILTER_TYPES.PRICE: {
                return renderPriceRange(filterGroup, groupIndex);
            }
            default: {
                return renderCheckBoxGroup(filterGroup, groupIndex);
            }
        }
    };
    function getPrice(filterData) {
        var _a, _b, _c;
        var price = (_a = filterData.find(function (filterGroup) {
            return filterGroup.type === PRODUCT_CATALOG.FILTER_TYPES.PRICE;
        })) === null || _a === void 0 ? void 0 : _a.items;
        return {
            minPrice: ((_b = price === null || price === void 0 ? void 0 : price.minPrice) === null || _b === void 0 ? void 0 : _b.value) || '',
            maxPrice: ((_c = price === null || price === void 0 ? void 0 : price.maxPrice) === null || _c === void 0 ? void 0 : _c.value) || ''
        };
    }
    React.useEffect(function () {
        if (filterData === null || filterData === void 0 ? void 0 : filterData.length) {
            setPrice(getPrice(filterData));
        }
    }, [filterData]);
    var renderPriceRange = function (filterGroup, groupIndex) {
        var _a, _b;
        var item = filterGroup.items;
        var applyFilter = function () {
            applyOrSelectFilter({
                filterItem: filterGroup.items,
                groupIndex: groupIndex,
                filterGroup: filterGroup
            });
        };
        return (React__default["default"].createElement(web.Spacing, { bottom: 1 },
            React__default["default"].createElement(web.Row, null,
                React__default["default"].createElement(web.Column, { xs: 5, sm: 5, md: 5, noGutter: true },
                    React__default["default"].createElement(web.TextInput, { onChange: function (e) {
                            setPrice(__assign(__assign({}, price), { minPrice: e.target.value }));
                        }, value: price.minPrice, type: "number", placeholder: "", label: (_a = item.minPrice) === null || _a === void 0 ? void 0 : _a.text, bgColor: "haze" })),
                React__default["default"].createElement(web.Column, { xs: 2, sm: 2, md: 2 },
                    React__default["default"].createElement(CenterContent, null,
                        React__default["default"].createElement(web.Text, { type: "body" }, t('TEXT_TO')))),
                React__default["default"].createElement(web.Column, { xs: 5, sm: 5, md: 5, noGutter: true },
                    React__default["default"].createElement(web.TextInput, { onChange: function (e) {
                            setPrice(__assign(__assign({}, price), { maxPrice: e.target.value }));
                        }, type: "number", placeholder: "", value: price.maxPrice, label: (_b = item.maxPrice) === null || _b === void 0 ? void 0 : _b.text, bgColor: "haze" }))),
            !isMobileView && (React__default["default"].createElement(web.Spacing, { top: 1 },
                React__default["default"].createElement(web.TextLink, { onClick: applyFilter }, t('TEXT_APPLY_FILTER'))))));
    };
    var renderCheckBoxGroup = function (filterGroup, groupIndex) {
        return (React__default["default"].createElement(web.Checkbox.InputGroup, null, filterGroup.items.map(function (filterItem, index) {
            var _a;
            if (((_a = equipmentListContext.configs) === null || _a === void 0 ? void 0 : _a.hideDisabledFilter) &&
                filterItem.disabled) {
                return null;
            }
            return (React__default["default"].createElement(FilterContentWrapper, { top: 1 },
                filterItem.disabled && React__default["default"].createElement(DisabledOverlay, { opacity: 0.5 }),
                React__default["default"].createElement(web.Checkbox.Input, { checked: filterItem.selected, onChange: function () {
                        applyOrSelectFilter({
                            filterGroup: filterGroup,
                            filterItemIndex: index,
                            groupIndex: groupIndex,
                            filterItem: filterItem
                        });
                    }, label: "" + filterItem.name + (filterItem.numberOfItem !== undefined
                        ? " (" + filterItem.numberOfItem + ")"
                        : '') })));
        })));
    };
    var onFilterGroupClick = function (index) {
        setSelectedGroup(index);
    };
    var applyOrSelectFilter = function (_a) {
        var filterItem = _a.filterItem, filterGroup = _a.filterGroup, groupIndex = _a.groupIndex, filterItemIndex = _a.filterItemIndex;
        var selectedGroup;
        if (Array.isArray(filterGroup.items)) {
            var selectedItem = __assign(__assign({}, filterItem), { selected: !filterItem.selected });
            selectedGroup = __assign(__assign({}, filterGroup), { items: __spreadArray(__spreadArray(__spreadArray([], filterGroup.items.slice(0, filterItemIndex), true), [
                    selectedItem
                ], false), filterGroup.items.slice(filterItemIndex + 1), true) });
        }
        else {
            selectedGroup = __assign(__assign({}, filterGroup), { items: {
                    minPrice: {
                        text: filterGroup.items.minPrice.text,
                        value: price.minPrice
                    },
                    maxPrice: {
                        text: filterGroup.items.maxPrice.text,
                        value: price.maxPrice
                    }
                } });
        }
        var newFilterData = __spreadArray(__spreadArray(__spreadArray([], filterData.slice(0, groupIndex), true), [
            selectedGroup
        ], false), filterData.slice(groupIndex + 1), true);
        if (isMobileView) {
            callbacks.onSelectFilter && callbacks.onSelectFilter(newFilterData);
            refApplyFilter.current = newFilterData;
        }
        else {
            callbacks.applyFilter(newFilterData);
        }
    };
    var onCloseFilterModal = function () {
        setShowFilterModal(false);
        callbacks.onCloseFilterModal && callbacks.onCloseFilterModal();
    };
    var renderMobileFilter = function () {
        return (React__default["default"].createElement(web.Modal, { visible: showFilterModal, title: t('SEARCH_MODAL_TITLE'), onClose: onCloseFilterModal, bgColor: web.theme.main.colours.white, wide: true, scrollable: true },
            React__default["default"].createElement(web.Modal.Content, null,
                React__default["default"].createElement(web.Spacing, { bottom: 4 }, renderFilter())),
            React__default["default"].createElement(web.Modal.Footer, null,
                React__default["default"].createElement(InlineWrapper$1, { spaceBetween: true, top: 1 },
                    renderClearAll(),
                    React__default["default"].createElement(web.Button, { "data-testid": 'btn-apply-filter', text: t('TEXT_APPLY_FILTER'), fullWidth: false, onClick: function () {
                            refApplyFilter.current &&
                                callbacks.applyFilter(refApplyFilter.current);
                            setShowFilterModal(false);
                        } })))));
    };
    var renderFilter = function () {
        return filterData.map(function (filterGroup, index) {
            var _a, _b;
            var filterContent = getFilterContent(filterGroup, index);
            var id = filterGroup.id;
            var isDesktopCollapsed = (_b = (_a = desktopCollapse[id]) !== null && _a !== void 0 ? _a : filterGroup.collapsed) !== null && _b !== void 0 ? _b : true;
            return (React__default["default"].createElement(web.Accordion, { key: id, title: filterGroup.name, desc: filterContent, selected: selectedGroup === index, value: id, onClick: function () {
                    var _a;
                    setDesktopCollapse(__assign(__assign({}, desktopCollapse), (_a = {}, _a[id] = !isDesktopCollapsed, _a)));
                    onFilterGroupClick(index);
                } }));
        });
    };
    var renderClearAll = function () {
        return (React__default["default"].createElement(ClearFilterWrapper, { isMobile: isMobileView },
            React__default["default"].createElement(web.TextLink, { onClick: callbacks === null || callbacks === void 0 ? void 0 : callbacks.clearFilter }, t('TEXT_CLEAR_ALL'))));
    };
    var renderDesktopFilter = function () {
        return (React__default["default"].createElement(React__default["default"].Fragment, null,
            React__default["default"].createElement(InlineWrapper$1, { bottom: 1, spaceBetween: true },
                React__default["default"].createElement(web.Text, { tag: "p", type: "header" }, t('TEXT_FILTER')),
                renderClearAll()),
            React__default["default"].createElement(web.Divider, null),
            renderFilter()));
    };
    if ((_a = equipmentListContext === null || equipmentListContext === void 0 ? void 0 : equipmentListContext.configs) === null || _a === void 0 ? void 0 : _a.isLoading) {
        return React__default["default"].createElement(ListSkeletonLoader, { isLoading: true, numberOfItem: 4 });
    }
    return isMobileView ? renderMobileFilter() : renderDesktopFilter();
});

var StyledBanner = web.withTheme(styled__default["default"].div(templateObject_1$p || (templateObject_1$p = __makeTemplateObject(["\n  padding: 10px 0 10px 0;\n  height: 230px;\n  background-color: ", ";\n"], ["\n  padding: 10px 0 10px 0;\n  height: 230px;\n  background-color: ", ";\n"])), function (_a) {
    var coreTheme = _a.coreTheme;
    return coreTheme.cl_ter_d1;
}));
var StyledButton$1 = web.withTheme(styled__default["default"](web.Button)(templateObject_2$m || (templateObject_2$m = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
    var coreTheme = _a.coreTheme;
    return coreTheme.cl_white;
}));
var Banner$1 = function (_a) {
    var banner = _a.banner;
    var enablePromoBanner = banner.enablePromoBanner, title = banner.title, description = banner.description; banner.desktopImg; banner.mobileImg; banner.enableCTA; var ctaText = banner.ctaText; banner.sectionTitle; banner.sectionDescription;
    var theme = web.useTheme().theme;
    var whiteText = theme.cl_white;
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement(StyledBanner, { enablePromoBanner: enablePromoBanner },
            React__default["default"].createElement(web.Row, null,
                React__default["default"].createElement(web.Column, null,
                    React__default["default"].createElement(web.Spacing, { left: "100px", top: "35px" },
                        React__default["default"].createElement(web.Text, { type: "header", color: whiteText }, title),
                        React__default["default"].createElement(web.Text, { type: "smallBody", color: whiteText }, description),
                        React__default["default"].createElement(web.Spacing, { top: "25px" },
                            React__default["default"].createElement(StyledButton$1, null, ctaText))))))));
};
var templateObject_1$p, templateObject_2$m;

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}var AsyncMode=l;var ConcurrentMode=m;var ContextConsumer=k;var ContextProvider=h;var Element$1=c;var ForwardRef=n;var Fragment=e;var Lazy=t;var Memo=r;var Portal=d;
var Profiler=g;var StrictMode=f;var Suspense=p;var isAsyncMode=function(a){return A(a)||z(a)===l};var isConcurrentMode=A;var isContextConsumer=function(a){return z(a)===k};var isContextProvider=function(a){return z(a)===h};var isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};var isForwardRef=function(a){return z(a)===n};var isFragment=function(a){return z(a)===e};var isLazy=function(a){return z(a)===t};
var isMemo=function(a){return z(a)===r};var isPortal=function(a){return z(a)===d};var isProfiler=function(a){return z(a)===g};var isStrictMode=function(a){return z(a)===f};var isSuspense=function(a){return z(a)===p};
var isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};var typeOf=z;

var reactIs_production_min = {
	AsyncMode: AsyncMode,
	ConcurrentMode: ConcurrentMode,
	ContextConsumer: ContextConsumer,
	ContextProvider: ContextProvider,
	Element: Element$1,
	ForwardRef: ForwardRef,
	Fragment: Fragment,
	Lazy: Lazy,
	Memo: Memo,
	Portal: Portal,
	Profiler: Profiler,
	StrictMode: StrictMode,
	Suspense: Suspense,
	isAsyncMode: isAsyncMode,
	isConcurrentMode: isConcurrentMode,
	isContextConsumer: isContextConsumer,
	isContextProvider: isContextProvider,
	isElement: isElement,
	isForwardRef: isForwardRef,
	isFragment: isFragment,
	isLazy: isLazy,
	isMemo: isMemo,
	isPortal: isPortal,
	isProfiler: isProfiler,
	isStrictMode: isStrictMode,
	isSuspense: isSuspense,
	isValidElementType: isValidElementType,
	typeOf: typeOf
};

var reactIs_development = createCommonjsModule(function (module, exports) {



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.AsyncMode = AsyncMode;
exports.ConcurrentMode = ConcurrentMode;
exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
exports.isValidElementType = isValidElementType;
exports.typeOf = typeOf;
  })();
}
});
reactIs_development.AsyncMode;
reactIs_development.ConcurrentMode;
reactIs_development.ContextConsumer;
reactIs_development.ContextProvider;
reactIs_development.Element;
reactIs_development.ForwardRef;
reactIs_development.Fragment;
reactIs_development.Lazy;
reactIs_development.Memo;
reactIs_development.Portal;
reactIs_development.Profiler;
reactIs_development.StrictMode;
reactIs_development.Suspense;
reactIs_development.isAsyncMode;
reactIs_development.isConcurrentMode;
reactIs_development.isContextConsumer;
reactIs_development.isContextProvider;
reactIs_development.isElement;
reactIs_development.isForwardRef;
reactIs_development.isFragment;
reactIs_development.isLazy;
reactIs_development.isMemo;
reactIs_development.isPortal;
reactIs_development.isProfiler;
reactIs_development.isStrictMode;
reactIs_development.isSuspense;
reactIs_development.isValidElementType;
reactIs_development.typeOf;

var reactIs = createCommonjsModule(function (module) {

if (process.env.NODE_ENV === 'production') {
  module.exports = reactIs_production_min;
} else {
  module.exports = reactIs_development;
}
});

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$1 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret$1;

var printWarning$1 = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has$1 = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning$1 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$1(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning$1(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning$1(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes;

var has = Function.call.bind(Object.prototype.hasOwnProperty);
var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret_1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = objectAssign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes_1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

var propTypes = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = factoryWithThrowingShims();
}
});

var config = {
  disabled: false
};

var timeoutsShape = process.env.NODE_ENV !== 'production' ? propTypes.oneOfType([propTypes.number, propTypes.shape({
  enter: propTypes.number,
  exit: propTypes.number,
  appear: propTypes.number
}).isRequired]) : null;
process.env.NODE_ENV !== 'production' ? propTypes.oneOfType([propTypes.string, propTypes.shape({
  enter: propTypes.string,
  exit: propTypes.string,
  active: propTypes.string
}), propTypes.shape({
  enter: propTypes.string,
  enterDone: propTypes.string,
  enterActive: propTypes.string,
  exit: propTypes.string,
  exitDone: propTypes.string,
  exitActive: propTypes.string
})]) : null;

var TransitionGroupContext = React__default["default"].createContext(null);

var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [ReactDOM__default["default"].findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : ReactDOM__default["default"].findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default["default"].findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children;
        _this$props.in;
        _this$props.mountOnEnter;
        _this$props.unmountOnExit;
        _this$props.appear;
        _this$props.enter;
        _this$props.exit;
        _this$props.timeout;
        _this$props.addEndListener;
        _this$props.onEnter;
        _this$props.onEntering;
        _this$props.onEntered;
        _this$props.onExit;
        _this$props.onExiting;
        _this$props.onExited;
        _this$props.nodeRef;
        var childProps = _objectWithoutPropertiesLoose(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      React__default["default"].createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : React__default["default"].cloneElement(React__default["default"].Children.only(children), childProps))
    );
  };

  return Transition;
}(React__default["default"].Component);

Transition.contextType = TransitionGroupContext;
Transition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: propTypes.shape({
    current: typeof Element === 'undefined' ? propTypes.any : function (propValue, key, componentName, location, propFullName, secret) {
      var value = propValue[key];
      return propTypes.instanceOf(value && 'ownerDocument' in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
    }
  }),

  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: propTypes.oneOfType([propTypes.func.isRequired, propTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: propTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: propTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: propTypes.bool,

  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: propTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: propTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: propTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: propTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: propTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: propTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: propTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: propTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: propTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: propTypes.func
} : {}; // Name the function so it is clearer in the documentation

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
var Transition$1 = Transition;

var _templateObject$5, _templateObject2$4, _templateObject3$3;
var COLLAPSE_DURATION = 300;
var CollapseAnimationContainer = styled__default["default"].div(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteral(["\n  transform: scaleY(0);\n  transform-origin: top;\n  overflow: hidden;\n  height: 0;\n  transition: transform ", "ms ease-in-out;\n  ", ";\n"])), COLLAPSE_DURATION, function (_ref) {
  var state = _ref.state;

  switch (state) {
    case 'entered':
      return styled.css(_templateObject2$4 || (_templateObject2$4 = _taggedTemplateLiteral(["\n          transform: scaleY(1);\n          overflow: visible;\n          height: auto;\n        "])));

    case 'exiting':
      return styled.css(_templateObject3$3 || (_templateObject3$3 = _taggedTemplateLiteral(["\n          height: auto;\n        "])));

    default:
      return "";
  }
});

var _excluded = ["visible", "children"];

var Collapse = function Collapse(_ref) {
  var _ref$visible = _ref.visible,
      visible = _ref$visible === void 0 ? false : _ref$visible,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React__default["default"].createElement(Transition$1, _extends$2({
    appear: true,
    timeout: COLLAPSE_DURATION,
    "in": visible,
    mountOnEnter: true,
    unmountOnExit: true
  }, rest), function (state) {
    return /*#__PURE__*/React__default["default"].createElement(CollapseAnimationContainer, {
      state: state
    }, children);
  });
};

var EFilterTypes;
(function (EFilterTypes) {
    EFilterTypes["IPP"] = "IPP";
})(EFilterTypes || (EFilterTypes = {}));
var EFilterKey;
(function (EFilterKey) {
    EFilterKey["BRAND_ID"] = "brandId";
    EFilterKey["TAGS"] = "tags";
})(EFilterKey || (EFilterKey = {}));
var constants = {
    DEFAULT_BRAND_SIZE: 5,
    DEFAULT_SEGMENT_SIZE: 9
};
var PromoType;
(function (PromoType) {
    PromoType["TYPE_ONE"] = "1";
    PromoType["TYPE_TWO"] = "2";
})(PromoType || (PromoType = {}));

function useScrollToLoadMore(enableViewMore, result) {
    var _a = React.useState([]), items = _a[0], setItems = _a[1];
    var paginationRef = React.useRef(0);
    var fetchSegmentedData = React.useCallback(function () {
        if (enableViewMore) {
            var DEFAULT_SEGMENT_SIZE = constants.DEFAULT_SEGMENT_SIZE;
            var nextPage = paginationRef.current + 1;
            paginationRef.current = nextPage;
            setItems(result.slice(0, nextPage * DEFAULT_SEGMENT_SIZE));
        }
        else {
            setItems(result);
        }
    }, [enableViewMore, result]);
    React.useEffect(function () {
        fetchSegmentedData();
        if (enableViewMore) {
            window.addEventListener('scroll', handleScroll);
            return function () { return window.removeEventListener('scroll', handleScroll); };
        }
    }, [enableViewMore, fetchSegmentedData]);
    var handleScroll = React.useCallback(function () {
        if (window.innerHeight + document.documentElement.scrollTop + 200 >
            document.documentElement.offsetHeight) {
            fetchSegmentedData();
        }
    }, [fetchSegmentedData]);
    return { items: items };
}

var EquipmentWrapper = styled__default["default"].div(templateObject_1$o || (templateObject_1$o = __makeTemplateObject(["\n  margin-left: ", ";\n  margin-right: ", ";\n"], ["\n  margin-left: ", ";\n  margin-right: ", ";\n"])), function (props) { return (props.isMobile ? '-8px' : 0); }, function (props) { return (props.isMobile ? '-8px' : 0); });
var CentralizedText = styled__default["default"](web.Layout.Inline)(templateObject_2$l || (templateObject_2$l = __makeTemplateObject(["\n  height: calc(100% - 100px);\n"], ["\n  height: calc(100% - 100px);\n"])));
var templateObject_1$o, templateObject_2$l;

var interopRequireDefault = createCommonjsModule(function (module) {
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

unwrapExports(interopRequireDefault);

var assertThisInitialized = createCommonjsModule(function (module) {
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

unwrapExports(assertThisInitialized);

var setPrototypeOf = createCommonjsModule(function (module) {
function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  module.exports["default"] = module.exports, module.exports.__esModule = true;
  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

unwrapExports(setPrototypeOf);

var inheritsLoose = createCommonjsModule(function (module) {
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  setPrototypeOf(subClass, superClass);
}

module.exports = _inheritsLoose;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

unwrapExports(inheritsLoose);

var objectWithoutPropertiesLoose = createCommonjsModule(function (module) {
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

unwrapExports(objectWithoutPropertiesLoose);

var _extends_1 = createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  module.exports["default"] = module.exports, module.exports.__esModule = true;
  return _extends.apply(this, arguments);
}

module.exports = _extends;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

unwrapExports(_extends_1);

var gatsbyImage = createCommonjsModule(function (module, exports) {



exports.__esModule = true;
exports.default = void 0;

var _assertThisInitialized2 = interopRequireDefault(assertThisInitialized);

var _inheritsLoose2 = interopRequireDefault(inheritsLoose);

var _objectWithoutPropertiesLoose2 = interopRequireDefault(objectWithoutPropertiesLoose);

var _extends2 = interopRequireDefault(_extends_1);

var _react = interopRequireDefault(React__default["default"]);

var _propTypes = interopRequireDefault(propTypes);

var _excluded = ["sizes", "srcSet", "src", "style", "onLoad", "onError", "loading", "draggable", "ariaHidden"];

var logDeprecationNotice = function logDeprecationNotice(prop, replacement) {
  if (process.env.NODE_ENV === "production") {
    return;
  }

  console.log("\n    The \"" + prop + "\" prop is now deprecated and will be removed in the next major version\n    of \"gatsby-image\".\n    ");

  if (replacement) {
    console.log("Please use " + replacement + " instead of \"" + prop + "\".");
  }
}; // Handle legacy props during their deprecation phase


var convertProps = function convertProps(props) {
  var convertedProps = (0, _extends2.default)({}, props);
  var resolutions = convertedProps.resolutions,
      sizes = convertedProps.sizes,
      critical = convertedProps.critical;

  if (resolutions) {
    convertedProps.fixed = resolutions;
    logDeprecationNotice("resolutions", "the gatsby-image v2 prop \"fixed\"");
    delete convertedProps.resolutions;
  }

  if (sizes) {
    convertedProps.fluid = sizes;
    logDeprecationNotice("sizes", "the gatsby-image v2 prop \"fluid\"");
    delete convertedProps.sizes;
  }

  if (critical) {
    logDeprecationNotice("critical", "the native \"loading\" attribute");
    convertedProps.loading = "eager";
  } // convert fluid & fixed to arrays so we only have to work with arrays


  if (convertedProps.fluid) {
    convertedProps.fluid = groupByMedia([].concat(convertedProps.fluid));
  }

  if (convertedProps.fixed) {
    convertedProps.fixed = groupByMedia([].concat(convertedProps.fixed));
  }

  return convertedProps;
};
/**
 * Checks if fluid or fixed are art-direction arrays.
 *
 * @param currentData  {{media?: string}[]}   The props to check for images.
 * @return {boolean}
 */


var hasArtDirectionSupport = function hasArtDirectionSupport(currentData) {
  return !!currentData && Array.isArray(currentData) && currentData.some(function (image) {
    return typeof image.media !== "undefined";
  });
};
/**
 * Tries to detect if a media query matches the current viewport.
 * @property media   {{media?: string}}  A media query string.
 * @return {boolean}
 */


var matchesMedia = function matchesMedia(_ref) {
  var media = _ref.media;
  return media ? isBrowser && !!window.matchMedia(media).matches : false;
};
/**
 * Find the source of an image to use as a key in the image cache.
 * Use `the first image in either `fixed` or `fluid`
 * @param {{fluid: {src: string, media?: string}[], fixed: {src: string, media?: string}[]}} args
 * @return {string?} Returns image src or undefined it not given.
 */


var getImageCacheKey = function getImageCacheKey(_ref2) {
  var fluid = _ref2.fluid,
      fixed = _ref2.fixed;
  var srcData = getCurrentSrcData(fluid || fixed || []);
  return srcData && srcData.src;
};
/**
 * Returns the current src - Preferably with art-direction support.
 * @param currentData  {{media?: string}[], maxWidth?: Number, maxHeight?: Number}   The fluid or fixed image array.
 * @return {{src: string, media?: string, maxWidth?: Number, maxHeight?: Number}}
 */


var getCurrentSrcData = function getCurrentSrcData(currentData) {
  if (isBrowser && hasArtDirectionSupport(currentData)) {
    // Do we have an image for the current Viewport?
    var foundMedia = currentData.findIndex(matchesMedia);

    if (foundMedia !== -1) {
      return currentData[foundMedia];
    } // No media matches, select first element without a media condition


    var noMedia = currentData.findIndex(function (image) {
      return typeof image.media === "undefined";
    });

    if (noMedia !== -1) {
      return currentData[noMedia];
    }
  } // Else return the first image.


  return currentData[0];
}; // Cache if we've seen an image before so we don't bother with
// lazy-loading & fading in on subsequent mounts.


var imageCache = Object.create({});

var inImageCache = function inImageCache(props) {
  var convertedProps = convertProps(props);
  var cacheKey = getImageCacheKey(convertedProps);
  return imageCache[cacheKey] || false;
};

var activateCacheForImage = function activateCacheForImage(props) {
  var convertedProps = convertProps(props);
  var cacheKey = getImageCacheKey(convertedProps);

  if (cacheKey) {
    imageCache[cacheKey] = true;
  }
}; // Native lazy-loading support: https://addyosmani.com/blog/lazy-loading/


var hasNativeLazyLoadSupport = typeof HTMLImageElement !== "undefined" && "loading" in HTMLImageElement.prototype;
var isBrowser = typeof window !== "undefined";
var hasIOSupport = isBrowser && window.IntersectionObserver;
var io;
var listeners = new WeakMap();

function getIO() {
  if (typeof io === "undefined" && typeof window !== "undefined" && window.IntersectionObserver) {
    io = new window.IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (listeners.has(entry.target)) {
          var cb = listeners.get(entry.target); // Edge doesn't currently support isIntersecting, so also test for an intersectionRatio > 0

          if (entry.isIntersecting || entry.intersectionRatio > 0) {
            io.unobserve(entry.target);
            listeners.delete(entry.target);
            cb();
          }
        }
      });
    }, {
      rootMargin: "200px"
    });
  }

  return io;
}

function generateImageSources(imageVariants) {
  return imageVariants.map(function (_ref3) {
    var src = _ref3.src,
        srcSet = _ref3.srcSet,
        srcSetWebp = _ref3.srcSetWebp,
        media = _ref3.media,
        sizes = _ref3.sizes;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: src
    }, srcSetWebp && /*#__PURE__*/_react.default.createElement("source", {
      type: "image/webp",
      media: media,
      srcSet: srcSetWebp,
      sizes: sizes
    }), srcSet && /*#__PURE__*/_react.default.createElement("source", {
      media: media,
      srcSet: srcSet,
      sizes: sizes
    }));
  });
} // Return an array ordered by elements having a media prop, does not use
// native sort, as a stable sort is not guaranteed by all browsers/versions


function groupByMedia(imageVariants) {
  var withMedia = [];
  var without = [];
  imageVariants.forEach(function (variant) {
    return (variant.media ? withMedia : without).push(variant);
  });

  if (without.length > 1 && process.env.NODE_ENV !== "production") {
    console.warn("We've found " + without.length + " sources without a media property. They might be ignored by the browser, see: https://www.gatsbyjs.org/packages/gatsby-image/#art-directing-multiple-images");
  }

  return [].concat(withMedia, without);
}

function generateTracedSVGSources(imageVariants) {
  return imageVariants.map(function (_ref4) {
    var src = _ref4.src,
        media = _ref4.media,
        tracedSVG = _ref4.tracedSVG;
    return /*#__PURE__*/_react.default.createElement("source", {
      key: src,
      media: media,
      srcSet: tracedSVG
    });
  });
}

function generateBase64Sources(imageVariants) {
  return imageVariants.map(function (_ref5) {
    var src = _ref5.src,
        media = _ref5.media,
        base64 = _ref5.base64;
    return /*#__PURE__*/_react.default.createElement("source", {
      key: src,
      media: media,
      srcSet: base64
    });
  });
}

function generateNoscriptSource(_ref6, isWebp) {
  var srcSet = _ref6.srcSet,
      srcSetWebp = _ref6.srcSetWebp,
      media = _ref6.media,
      sizes = _ref6.sizes;
  var src = isWebp ? srcSetWebp : srcSet;
  var mediaAttr = media ? "media=\"" + media + "\" " : "";
  var typeAttr = isWebp ? "type='image/webp' " : "";
  var sizesAttr = sizes ? "sizes=\"" + sizes + "\" " : "";
  return "<source " + typeAttr + mediaAttr + "srcset=\"" + src + "\" " + sizesAttr + "/>";
}

function generateNoscriptSources(imageVariants) {
  return imageVariants.map(function (variant) {
    return (variant.srcSetWebp ? generateNoscriptSource(variant, true) : "") + generateNoscriptSource(variant);
  }).join("");
}

var listenToIntersections = function listenToIntersections(el, cb) {
  var observer = getIO();

  if (observer) {
    observer.observe(el);
    listeners.set(el, cb);
  }

  return function () {
    observer.unobserve(el);
    listeners.delete(el);
  };
};

var noscriptImg = function noscriptImg(props) {
  // Check if prop exists before adding each attribute to the string output below to prevent
  // HTML validation issues caused by empty values like width="" and height=""
  var src = props.src ? "src=\"" + props.src + "\" " : "src=\"\" "; // required attribute

  var sizes = props.sizes ? "sizes=\"" + props.sizes + "\" " : "";
  var srcSet = props.srcSet ? "srcset=\"" + props.srcSet + "\" " : "";
  var title = props.title ? "title=\"" + props.title + "\" " : "";
  var alt = props.alt ? "alt=\"" + props.alt + "\" " : "alt=\"\" "; // required attribute

  var width = props.width ? "width=\"" + props.width + "\" " : "";
  var height = props.height ? "height=\"" + props.height + "\" " : "";
  var crossOrigin = props.crossOrigin ? "crossorigin=\"" + props.crossOrigin + "\" " : "";
  var loading = props.loading ? "loading=\"" + props.loading + "\" " : "";
  var draggable = props.draggable ? "draggable=\"" + props.draggable + "\" " : "";
  var sources = generateNoscriptSources(props.imageVariants);
  return "<picture>" + sources + "<img " + loading + width + height + sizes + srcSet + src + alt + title + crossOrigin + draggable + "style=\"position:absolute;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center\"/></picture>";
}; // Earlier versions of gatsby-image during the 2.x cycle did not wrap
// the `Img` component in a `picture` element. This maintains compatibility
// until a breaking change can be introduced in the next major release


var Placeholder = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var src = props.src,
      imageVariants = props.imageVariants,
      generateSources = props.generateSources,
      spreadProps = props.spreadProps,
      ariaHidden = props.ariaHidden;

  var baseImage = /*#__PURE__*/_react.default.createElement(Img, (0, _extends2.default)({
    ref: ref,
    src: src
  }, spreadProps, {
    ariaHidden: ariaHidden
  }));

  return imageVariants.length > 1 ? /*#__PURE__*/_react.default.createElement("picture", null, generateSources(imageVariants), baseImage) : baseImage;
});

var Img = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var sizes = props.sizes,
      srcSet = props.srcSet,
      src = props.src,
      style = props.style,
      onLoad = props.onLoad,
      onError = props.onError,
      loading = props.loading,
      draggable = props.draggable,
      ariaHidden = props.ariaHidden,
      otherProps = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
  return /*#__PURE__*/_react.default.createElement("img", (0, _extends2.default)({
    "aria-hidden": ariaHidden,
    sizes: sizes,
    srcSet: srcSet,
    src: src
  }, otherProps, {
    onLoad: onLoad,
    onError: onError,
    ref: ref,
    loading: loading,
    draggable: draggable,
    style: (0, _extends2.default)({
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      objectFit: "cover",
      objectPosition: "center"
    }, style)
  }));
});

Img.propTypes = {
  style: _propTypes.default.object,
  onError: _propTypes.default.func,
  onLoad: _propTypes.default.func
};

var Image = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2.default)(Image, _React$Component);

  function Image(props) {
    var _this;

    _this = _React$Component.call(this, props) || this; // If this image has already been loaded before then we can assume it's
    // already in the browser cache so it's cheap to just show directly.

    _this.seenBefore = isBrowser && inImageCache(props);
    _this.isCritical = props.loading === "eager" || props.critical;
    _this.addNoScript = !(_this.isCritical && !props.fadeIn);
    _this.useIOSupport = !hasNativeLazyLoadSupport && hasIOSupport && !_this.isCritical && !_this.seenBefore;
    var isVisible = _this.isCritical || isBrowser && (hasNativeLazyLoadSupport || !_this.useIOSupport);
    _this.state = {
      isVisible: isVisible,
      imgLoaded: false,
      imgCached: false,
      fadeIn: !_this.seenBefore && props.fadeIn,
      isHydrated: false
    };
    _this.imageRef = /*#__PURE__*/_react.default.createRef();
    _this.placeholderRef = props.placeholderRef || /*#__PURE__*/_react.default.createRef();
    _this.handleImageLoaded = _this.handleImageLoaded.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleRef = _this.handleRef.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  var _proto = Image.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.setState({
      isHydrated: isBrowser
    });

    if (this.state.isVisible && typeof this.props.onStartLoad === "function") {
      this.props.onStartLoad({
        wasCached: inImageCache(this.props)
      });
    }

    if (this.isCritical) {
      var img = this.imageRef.current;

      if (img && img.complete) {
        this.handleImageLoaded();
      }
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.cleanUpListeners) {
      this.cleanUpListeners();
    }
  } // Specific to IntersectionObserver based lazy-load support
  ;

  _proto.handleRef = function handleRef(ref) {
    var _this2 = this;

    if (this.useIOSupport && ref) {
      this.cleanUpListeners = listenToIntersections(ref, function () {
        var imageInCache = inImageCache(_this2.props);

        if (!_this2.state.isVisible && typeof _this2.props.onStartLoad === "function") {
          _this2.props.onStartLoad({
            wasCached: imageInCache
          });
        } // imgCached and imgLoaded must update after isVisible,
        // Once isVisible is true, imageRef becomes accessible, which imgCached needs access to.
        // imgLoaded and imgCached are in a 2nd setState call to be changed together,
        // avoiding initiating unnecessary animation frames from style changes.


        _this2.setState({
          isVisible: true
        }, function () {
          _this2.setState({
            imgLoaded: imageInCache,
            // `currentSrc` should be a string, but can be `undefined` in IE,
            // !! operator validates the value is not undefined/null/""
            // for lazyloaded components this might be null
            // TODO fix imgCached behaviour as it's now false when it's lazyloaded
            imgCached: !!(_this2.imageRef.current && _this2.imageRef.current.currentSrc)
          });
        });
      });
    }
  };

  _proto.handleImageLoaded = function handleImageLoaded() {
    activateCacheForImage(this.props);
    this.setState({
      imgLoaded: true
    });

    if (this.props.onLoad) {
      this.props.onLoad();
    }
  };

  _proto.render = function render() {
    var _convertProps = convertProps(this.props),
        title = _convertProps.title,
        alt = _convertProps.alt,
        className = _convertProps.className,
        _convertProps$style = _convertProps.style,
        style = _convertProps$style === void 0 ? {} : _convertProps$style,
        _convertProps$imgStyl = _convertProps.imgStyle,
        imgStyle = _convertProps$imgStyl === void 0 ? {} : _convertProps$imgStyl,
        _convertProps$placeho = _convertProps.placeholderStyle,
        placeholderStyle = _convertProps$placeho === void 0 ? {} : _convertProps$placeho,
        placeholderClassName = _convertProps.placeholderClassName,
        fluid = _convertProps.fluid,
        fixed = _convertProps.fixed,
        backgroundColor = _convertProps.backgroundColor,
        durationFadeIn = _convertProps.durationFadeIn,
        Tag = _convertProps.Tag,
        itemProp = _convertProps.itemProp,
        loading = _convertProps.loading,
        draggable = _convertProps.draggable;

    var imageVariants = fluid || fixed; // Abort early if missing image data (#25371)

    if (!imageVariants) {
      return null;
    }

    var shouldReveal = this.state.fadeIn === false || this.state.imgLoaded;
    var shouldFadeIn = this.state.fadeIn === true && !this.state.imgCached;
    var imageStyle = (0, _extends2.default)({
      opacity: shouldReveal ? 1 : 0,
      transition: shouldFadeIn ? "opacity " + durationFadeIn + "ms" : "none"
    }, imgStyle);
    var bgColor = typeof backgroundColor === "boolean" ? "lightgray" : backgroundColor;
    var delayHideStyle = {
      transitionDelay: durationFadeIn + "ms"
    };
    var imagePlaceholderStyle = (0, _extends2.default)({
      opacity: this.state.imgLoaded ? 0 : 1
    }, shouldFadeIn && delayHideStyle, imgStyle, placeholderStyle);
    var placeholderImageProps = {
      title: title,
      alt: !this.state.isVisible ? alt : "",
      style: imagePlaceholderStyle,
      className: placeholderClassName,
      itemProp: itemProp
    }; // Initial client render state needs to match SSR until hydration finishes.
    // Once hydration completes, render again to update to the correct image.
    // `imageVariants` is always an Array type at this point due to `convertProps()`

    var image = !this.state.isHydrated ? imageVariants[0] : getCurrentSrcData(imageVariants);

    if (fluid) {
      return /*#__PURE__*/_react.default.createElement(Tag, {
        className: (className ? className : "") + " gatsby-image-wrapper",
        style: (0, _extends2.default)({
          position: "relative",
          overflow: "hidden",
          maxWidth: image.maxWidth ? image.maxWidth + "px" : null,
          maxHeight: image.maxHeight ? image.maxHeight + "px" : null
        }, style),
        ref: this.handleRef,
        key: "fluid-" + JSON.stringify(image.srcSet)
      }, /*#__PURE__*/_react.default.createElement(Tag, {
        "aria-hidden": true,
        style: {
          width: "100%",
          paddingBottom: 100 / image.aspectRatio + "%"
        }
      }), bgColor && /*#__PURE__*/_react.default.createElement(Tag, {
        "aria-hidden": true,
        title: title,
        style: (0, _extends2.default)({
          backgroundColor: bgColor,
          position: "absolute",
          top: 0,
          bottom: 0,
          opacity: !this.state.imgLoaded ? 1 : 0,
          right: 0,
          left: 0
        }, shouldFadeIn && delayHideStyle)
      }), image.base64 && /*#__PURE__*/_react.default.createElement(Placeholder, {
        ariaHidden: true,
        ref: this.placeholderRef,
        src: image.base64,
        spreadProps: placeholderImageProps,
        imageVariants: imageVariants,
        generateSources: generateBase64Sources
      }), image.tracedSVG && /*#__PURE__*/_react.default.createElement(Placeholder, {
        ariaHidden: true,
        ref: this.placeholderRef,
        src: image.tracedSVG,
        spreadProps: placeholderImageProps,
        imageVariants: imageVariants,
        generateSources: generateTracedSVGSources
      }), this.state.isVisible && /*#__PURE__*/_react.default.createElement("picture", null, generateImageSources(imageVariants), /*#__PURE__*/_react.default.createElement(Img, {
        alt: alt,
        title: title,
        sizes: image.sizes,
        src: image.src,
        crossOrigin: this.props.crossOrigin,
        srcSet: image.srcSet,
        style: imageStyle,
        ref: this.imageRef,
        onLoad: this.handleImageLoaded,
        onError: this.props.onError,
        itemProp: itemProp,
        loading: loading,
        draggable: draggable
      })), this.addNoScript && /*#__PURE__*/_react.default.createElement("noscript", {
        dangerouslySetInnerHTML: {
          __html: noscriptImg((0, _extends2.default)({
            alt: alt,
            title: title,
            loading: loading
          }, image, {
            imageVariants: imageVariants
          }))
        }
      }));
    }

    if (fixed) {
      var divStyle = (0, _extends2.default)({
        position: "relative",
        overflow: "hidden",
        display: "inline-block",
        width: image.width,
        height: image.height
      }, style);

      if (style.display === "inherit") {
        delete divStyle.display;
      }

      return /*#__PURE__*/_react.default.createElement(Tag, {
        className: (className ? className : "") + " gatsby-image-wrapper",
        style: divStyle,
        ref: this.handleRef,
        key: "fixed-" + JSON.stringify(image.srcSet)
      }, bgColor && /*#__PURE__*/_react.default.createElement(Tag, {
        "aria-hidden": true,
        title: title,
        style: (0, _extends2.default)({
          backgroundColor: bgColor,
          width: image.width,
          opacity: !this.state.imgLoaded ? 1 : 0,
          height: image.height
        }, shouldFadeIn && delayHideStyle)
      }), image.base64 && /*#__PURE__*/_react.default.createElement(Placeholder, {
        ariaHidden: true,
        ref: this.placeholderRef,
        src: image.base64,
        spreadProps: placeholderImageProps,
        imageVariants: imageVariants,
        generateSources: generateBase64Sources
      }), image.tracedSVG && /*#__PURE__*/_react.default.createElement(Placeholder, {
        ariaHidden: true,
        ref: this.placeholderRef,
        src: image.tracedSVG,
        spreadProps: placeholderImageProps,
        imageVariants: imageVariants,
        generateSources: generateTracedSVGSources
      }), this.state.isVisible && /*#__PURE__*/_react.default.createElement("picture", null, generateImageSources(imageVariants), /*#__PURE__*/_react.default.createElement(Img, {
        alt: alt,
        title: title,
        width: image.width,
        height: image.height,
        sizes: image.sizes,
        src: image.src,
        crossOrigin: this.props.crossOrigin,
        srcSet: image.srcSet,
        style: imageStyle,
        ref: this.imageRef,
        onLoad: this.handleImageLoaded,
        onError: this.props.onError,
        itemProp: itemProp,
        loading: loading,
        draggable: draggable
      })), this.addNoScript && /*#__PURE__*/_react.default.createElement("noscript", {
        dangerouslySetInnerHTML: {
          __html: noscriptImg((0, _extends2.default)({
            alt: alt,
            title: title,
            loading: loading
          }, image, {
            imageVariants: imageVariants
          }))
        }
      }));
    }

    return null;
  };

  return Image;
}(_react.default.Component);

Image.defaultProps = {
  fadeIn: true,
  durationFadeIn: 500,
  alt: "",
  Tag: "div",
  // We set it to `lazy` by default because it's best to default to a performant
  // setting and let the user "opt out" to `eager`
  loading: "lazy"
};

var fixedObject = _propTypes.default.shape({
  width: _propTypes.default.number.isRequired,
  height: _propTypes.default.number.isRequired,
  src: _propTypes.default.string.isRequired,
  srcSet: _propTypes.default.string.isRequired,
  base64: _propTypes.default.string,
  tracedSVG: _propTypes.default.string,
  srcWebp: _propTypes.default.string,
  srcSetWebp: _propTypes.default.string,
  media: _propTypes.default.string
});

var fluidObject = _propTypes.default.shape({
  aspectRatio: _propTypes.default.number.isRequired,
  src: _propTypes.default.string.isRequired,
  srcSet: _propTypes.default.string.isRequired,
  sizes: _propTypes.default.string.isRequired,
  base64: _propTypes.default.string,
  tracedSVG: _propTypes.default.string,
  srcWebp: _propTypes.default.string,
  srcSetWebp: _propTypes.default.string,
  media: _propTypes.default.string,
  maxWidth: _propTypes.default.number,
  maxHeight: _propTypes.default.number
});

function requireFixedOrFluid(originalPropTypes) {
  return function (props, propName, componentName) {
    var _PropTypes$checkPropT;

    if (!props.fixed && !props.fluid) {
      throw new Error("The prop `fluid` or `fixed` is marked as required in `" + componentName + "`, but their values are both `undefined`.");
    }

    _propTypes.default.checkPropTypes((_PropTypes$checkPropT = {}, _PropTypes$checkPropT[propName] = originalPropTypes, _PropTypes$checkPropT), props, "prop", componentName);
  };
} // If you modify these propTypes, please don't forget to update following files as well:
// https://github.com/gatsbyjs/gatsby/blob/master/packages/gatsby-image/index.d.ts
// https://github.com/gatsbyjs/gatsby/blob/master/packages/gatsby-image/README.md#gatsby-image-props
// https://github.com/gatsbyjs/gatsby/blob/master/docs/docs/gatsby-image.md#gatsby-image-props


Image.propTypes = {
  resolutions: fixedObject,
  sizes: fluidObject,
  fixed: requireFixedOrFluid(_propTypes.default.oneOfType([fixedObject, _propTypes.default.arrayOf(fixedObject)])),
  fluid: requireFixedOrFluid(_propTypes.default.oneOfType([fluidObject, _propTypes.default.arrayOf(fluidObject)])),
  fadeIn: _propTypes.default.bool,
  durationFadeIn: _propTypes.default.number,
  title: _propTypes.default.string,
  alt: _propTypes.default.string,
  className: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  // Support Glamor's css prop.
  critical: _propTypes.default.bool,
  crossOrigin: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.bool]),
  style: _propTypes.default.object,
  imgStyle: _propTypes.default.object,
  placeholderStyle: _propTypes.default.object,
  placeholderClassName: _propTypes.default.string,
  backgroundColor: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.bool]),
  onLoad: _propTypes.default.func,
  onError: _propTypes.default.func,
  onStartLoad: _propTypes.default.func,
  Tag: _propTypes.default.string,
  itemProp: _propTypes.default.string,
  loading: _propTypes.default.oneOf(["auto", "lazy", "eager"]),
  draggable: _propTypes.default.bool
};
var _default = Image;
exports.default = _default;
});

var Img = unwrapExports(gatsbyImage);

var StrikeThroughText = web.withTheme(styled__default["default"](web.Text)(templateObject_1$n || (templateObject_1$n = __makeTemplateObject(["\n  text-decoration: line-through;\n  display: inline;\n  margin-left: 8px;\n  ", "\n  color: ", ";\n"], ["\n  text-decoration: line-through;\n  display: inline;\n  margin-left: 8px;\n  ", "\n  color: ", ";\n"])), function (props) {
    return (props.isMobile || props.fullWidth) &&
        "\n    display: block;\n    margin-left: 0px;\n  ";
}, function (_a) {
    var coreTheme = _a.coreTheme;
    return coreTheme.cl_ter_l4;
}));
var XSSpacing = web.withTheme(styled__default["default"](web.Spacing)(templateObject_3$d || (templateObject_3$d = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var coreTheme = _a.coreTheme;
    return styled.css(templateObject_2$k || (templateObject_2$k = __makeTemplateObject(["\n    @media (max-width: ", ") {\n      padding: 0;\n    }\n  "], ["\n    @media (max-width: ", ") {\n      padding: 0;\n    }\n  "])), coreTheme.brk_xs);
}));
var LogoWrapper = web.withTheme(styled__default["default"].div(templateObject_5$7 || (templateObject_5$7 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var coreTheme = _a.coreTheme, props = __rest(_a, ["coreTheme"]);
    return styled.css(templateObject_4$c || (templateObject_4$c = __makeTemplateObject(["\n      height: 56px;\n      width: 56px;\n      flex-shrink: 0;\n      @media (max-width: ", ") {\n        height: 42px;\n        width: 42px;\n      }\n      ", "\n    "], ["\n      height: 56px;\n      width: 56px;\n      flex-shrink: 0;\n      @media (max-width: ", ") {\n        height: 42px;\n        width: 42px;\n      }\n      ", "\n    "])), coreTheme.brk_xs, (props === null || props === void 0 ? void 0 : props.inline) && 'padding-right: 1rem;');
}));
var templateObject_1$n, templateObject_2$k, templateObject_3$d, templateObject_4$c, templateObject_5$7;

var PRODUCT_DETAILS = {
    TAGS: {
        FIVE_G: 'network-speed/5g-speed',
        FOUR_G: ['xo-plus-plan', 'simonly-ipp-plan']
    },
    ELEMENT_IDS: {
        FULFILMENT_SECTION: 'fulfilment-section',
        PLAN_SECTION: 'plan-section',
        ACCESSORIES_SESSION: 'accessories-section',
        TECH_SPECS: 'tech-specs',
        DEVICE_STORAGE_SECTION: 'device-storage-section',
        DEVICE_COLOR_SECTION: 'device-color-section',
        MODEL_SECTION: 'model-section'
    },
    MAX_NUMBER_OF_ACCESSORIES: 12,
    SUMMARY_BAR_HEIGHT: 95,
    ACCESSORY: {
        DESC_SHOW_MORE_MOBILE_THRESHOLD: 70,
        DESC_SHOW_MORE_THRESHOLD: 100
    },
    FULFILMENT_TYPES: {
        DOOR_STEP_DELIVERY: 'courier',
        COLLECT_AT_STORE: 'singtel-store',
        POP_STATION: 'pop-station'
    },
    INVALID_SIZE: ['NA', 'NIL', '0GB'],
    MONTHLY_TERMS: [12, 24, 36],
    PAYMENT_TERM_TYPE: {
        FULL_PRICE: 'fullPrice'
    }
};

var localisation = {
    en: enUS
};
var messages = {};
var updateMessages = function (values) {
    messages = __assign(__assign({}, messages), values);
};
var localStorageKey = 'lang';
var trans = function (id, replaceMap) {
    var localeData = helpers.getLocaleData(localisation, helpers.getLocale(localStorageKey));
    var toBeTranslated = __assign(__assign({}, localeData), messages)[id] || '';
    return helpers.translate(toBeTranslated || id, replaceMap);
};

var getStoragesAndGroupsByGroupName = function (variants, groupName) {
    return variants.reduce(function (result, variant) {
        if (variant.planGroup === groupName &&
            !result.storages[variant.memorySize]) {
            result.storages[variant.memorySize] = true;
        }
        if (!result.planGroup[variant.planGroup]) {
            result.planGroup[variant.planGroup] = true;
        }
        return result;
    }, { storages: {}, planGroup: {} });
};
var filterStorageAndPlanGroup = function (_a) {
    var storages = _a.storages, variants = _a.variants, currenPlanGroup = _a.currenPlanGroup, currentStorage = _a.currentStorage, planGroups = _a.planGroups;
    if (!currenPlanGroup) {
        return {
            storages: storages,
            selectedStorage: currentStorage,
            filterPlanGroups: planGroups
        };
    }
    var storageAndPlanGroups = getStoragesAndGroupsByGroupName(variants, currenPlanGroup === null || currenPlanGroup === void 0 ? void 0 : currenPlanGroup.groupName);
    var storageList = storages.reduce(function (result, storage) {
        if (storageAndPlanGroups.storages[storage.value]) {
            result.push(storage);
        }
        return result;
    }, []);
    var isNewListHasCurrentStorage = storageList.find(function (storage) {
        return storage.value === (currentStorage === null || currentStorage === void 0 ? void 0 : currentStorage.value) && storage.stockCount > 0;
    });
    var selectedStorage = isNewListHasCurrentStorage
        ? currentStorage
        : storageList.find(function (storage) { return storage.stockCount > 0; });
    var filterPlanGroups = planGroups.filter(function (planGroup) { return storageAndPlanGroups.planGroup[planGroup.groupName]; });
    return {
        storages: storageList,
        selectedStorage: selectedStorage,
        filterPlanGroups: filterPlanGroups
    };
};
var isValidStorage = function (variant) {
    // Storage can be text now, doesn't need to be number but need to validate invalid value.
    return (variant.memorySize &&
        !PRODUCT_DETAILS.INVALID_SIZE.includes(variant.memorySize));
};
var filterDuplicateColors = function (variants) {
    return variants.reduce(function (result, variant) {
        var existedColorAndSizeIndex = result.findIndex(function (variantInResult) {
            return (variantInResult.colorCode === variant.colorCode &&
                variantInResult.memorySize === variant.memorySize);
        });
        if (existedColorAndSizeIndex < 0) {
            result.push(variant);
        }
        else if ((!result[existedColorAndSizeIndex].stockCount && variant.stockCount) ||
            result[existedColorAndSizeIndex].stockCount < variant.stockCount) {
            result[existedColorAndSizeIndex] = variant;
        }
        return result;
    }, []);
};
var getColorList = function (variants) {
    return filterDuplicateColors(variants)
        .reduce(function (colorList, variant) {
        var existedColor = colorList.find(function (color) { return color.colorCode === variant.colorCode; });
        var validStorage = isValidStorage(variant);
        if (!existedColor) {
            colorList.push({
                colorCode: variant.colorCode,
                colorDescription: variant.colorDescription,
                colorHexCode: variant.colorHexCode,
                variantInfo: variant,
                storages: validStorage
                    ? [
                        {
                            value: variant.memorySize,
                            stockCount: variant.stockCount,
                            variantInfo: variant
                        }
                    ]
                    : []
            });
        }
        else {
            var isStorageExisted = existedColor.storages.find(function (storage) { return storage.value === variant.memorySize; });
            if (validStorage && !isStorageExisted) {
                existedColor.storages.push({
                    value: variant.memorySize,
                    stockCount: variant.stockCount,
                    variantInfo: variant
                });
            }
        }
        return colorList;
    }, [])
        .map(function (color) {
        var _a;
        var sortedStorage = color.storages.sort(function (storage, nextStorage) {
            return parseInt(storage.value) - parseInt(nextStorage.value);
        });
        var totalStockFromStorage = color.storages.reduce(function (acc, storage) { return acc + (storage.stockCount || 0); }, 0);
        return __assign(__assign({}, color), { totalStockFromStorage: totalStockFromStorage, storages: sortedStorage, hasStock: ((_a = color.storages) === null || _a === void 0 ? void 0 : _a.length)
                ? totalStockFromStorage > 0
                : color.variantInfo.stockCount > 0 });
    });
};
var getSelectedVariantAndStorageToDisplay = function (_a) {
    var _b, _c;
    var variants = _a.variants, selectedColor = _a.selectedColor, preSelectStorageValue = _a.preSelectStorageValue, currentStorage = _a.currentStorage;
    var filteredVariantsByColor = variants.filter(function (variant) { return variant.colorCode === (selectedColor === null || selectedColor === void 0 ? void 0 : selectedColor.colorCode); });
    var defaultVariant = filteredVariantsByColor[0];
    var filteredVariant = filteredVariantsByColor.reduce(function (result, variant) {
        if (preSelectStorageValue &&
            !result.preSelectVariant &&
            variant.stockCount > 0 &&
            slugify(variant.memorySize) === slugify(preSelectStorageValue)) {
            result.preSelectVariant = variant;
        }
        if (!result.inStockVariant && variant.stockCount > 0) {
            result.inStockVariant = variant;
        }
        return result;
    }, { preSelectVariant: null, inStockVariant: null });
    var selectedVariant = filteredVariant.preSelectVariant ||
        filteredVariant.inStockVariant ||
        defaultVariant;
    var currentStorageInNewColor = currentStorage &&
        currentStorage.stockCount > 0 &&
        ((_b = selectedColor === null || selectedColor === void 0 ? void 0 : selectedColor.storages) === null || _b === void 0 ? void 0 : _b.find(function (storage) {
            return storage.value === currentStorage.value && storage.stockCount > 0;
        }));
    var selectedStorage = currentStorageInNewColor ||
        ((_c = selectedColor === null || selectedColor === void 0 ? void 0 : selectedColor.storages) === null || _c === void 0 ? void 0 : _c.find(function (storage) { return storage.value === (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.memorySize); }));
    return {
        selectedVariant: selectedVariant,
        selectedStorage: selectedStorage
    };
};
var isValidPrice = function (price) {
    return parseFloat(price === null || price === void 0 ? void 0 : price.toString()) >= 0;
};
var getPlansForCurrentVariant = function (_a) {
    var variants = _a.variants, plans = _a.plans, selectedColor = _a.selectedColor, selectedStorage = _a.selectedStorage, monthlyTerm = _a.monthlyTerm;
    var t = useTranslation().t;
    var addedPlans = {};
    var hasSelected = false;
    var filteredPlans = plans.reduce(function (result, plan) {
        for (var i = 0; i < variants.length; i++) {
            var variant = variants[i];
            var monthlyTermCondition = monthlyTerm
                ? (variant === null || variant === void 0 ? void 0 : variant.monthlyTerm) === monthlyTerm
                : true;
            var storageCondition = selectedStorage && isValidStorage(variant)
                ? variant.memorySize === (selectedStorage === null || selectedStorage === void 0 ? void 0 : selectedStorage.value)
                : true;
            if (storageCondition &&
                variant.colorCode === selectedColor.colorCode &&
                monthlyTermCondition &&
                plan.mecId === variant.planId &&
                !addedPlans[plan.mecId]) {
                var isProductHasStock_1 = variant.stockCount > 0;
                addedPlans[plan.mecId] = true;
                if (!hasSelected) {
                    hasSelected = plan.selected;
                }
                var hasDiscountPrice = isValidPrice(variant.usualPrice);
                var hasDiscountMonthlyPrice = isValidPrice(plan.discountedPrice);
                var hasDiscount = hasDiscountPrice &&
                    (variant.installmentPrice
                        ? Number(variant.installmentPrice) < Number(variant.usualPrice)
                        : Number(variant.price) < Number(variant.usualPrice));
                var hasDiscountMonthlyCharges = !!(hasDiscountMonthlyPrice &&
                    Number(plan.discountedPrice) < Number(plan.monthlyCharges));
                var formattedPlan = __assign(__assign({}, plan), { variantInfo: variant, originalMonthlyCharges: hasDiscountMonthlyCharges
                        ? t('DISPLAYED_MONTHLY_CHARGES', {
                            price: formatPrice(plan.monthlyCharges)
                        })
                        : null, sellingMonthlyCharges: hasDiscountMonthlyCharges
                        ? t('DISPLAYED_DISCOUNTED_MONTHLY_CHARGES', {
                            price: formatPrice(plan.discountedPrice)
                        })
                        : t('DISPLAYED_MONTHLY_CHARGES', {
                            price: Number(plan.discountedPrice) > Number(plan.monthlyCharges)
                                ? formatPrice(plan.discountedPrice)
                                : formatPrice(plan.monthlyCharges)
                        }), hasDiscountMonthlyCharges: hasDiscountMonthlyCharges, originalPrice: hasDiscount
                        ? t('PRODUCT_COST', {
                            price: formatPrice(variant.usualPrice)
                        })
                        : null, sellingPrice: variant.installmentPrice
                        ? t('VARIANT_INSTALLMENT_PRICE', {
                            price: formatPrice(variant.installmentPrice)
                        })
                        : t('PRODUCT_COST', {
                            price: formatPrice(variant.price)
                        }), hasDiscount: hasDiscount, disabled: !isProductHasStock_1 });
                result.push(formattedPlan);
                break;
            }
        }
        return result;
    }, []);
    if (!hasSelected && filteredPlans.length) {
        filteredPlans[0].selected = true;
    }
    return filteredPlans;
};
var sortPlans = function (plans) {
    if (plans === void 0) { plans = []; }
    var selectedPlanIndex = plans.findIndex(function (plan) { return plan.defaultSelected; });
    if (selectedPlanIndex >= 0) {
        return __spreadArray(__spreadArray([
            plans[selectedPlanIndex]
        ], plans.slice(0, selectedPlanIndex), true), plans.slice(selectedPlanIndex + 1), true);
    }
    return plans;
};
var isColorHasStock = function (color) {
    var _a, _b;
    if (!((_a = color.storages) === null || _a === void 0 ? void 0 : _a.length)) {
        return ((_b = color.variantInfo) === null || _b === void 0 ? void 0 : _b.stockCount) > 0;
    }
    return color.storages.reduce(function (result, storage) {
        if (!result && storage.stockCount > 0) {
            return true;
        }
        return result;
    }, false);
};
var formatPrice = function (price, decimal) {
    if (decimal === void 0) { decimal = 2; }
    if (typeof price === 'string' && price.includes('$'))
        return price;
    price = Number(price) || 0;
    var formatted = Math.abs(price).toFixed(decimal);
    return price < 0 ? "-$" + formatted : "$" + formatted;
};
var findTag = function (tags, targetTag) {
    if (Array.isArray(targetTag)) {
        return !!tags.find(function (tag) {
            return targetTag.some(function (target) { return tag.includes(target); });
        });
    }
    return !!tags.find(function (tag) { return tag.includes(targetTag); });
};
var filterPlansByGroup = function (plans, planGroup) {
    if (plans === void 0) { plans = []; }
    if (!planGroup)
        return [];
    return plans.filter(function (plan) { return plan.groupName === planGroup.groupName; });
};
var filterPlans = function (_a) {
    var selectedColor = _a.selectedColor, selectedStorage = _a.selectedStorage, selectedPlanGroup = _a.selectedPlanGroup, _b = _a.plans, plans = _b === void 0 ? [] : _b, _c = _a.variants, variants = _c === void 0 ? [] : _c, monthlyTerm = _a.monthlyTerm, preSelectedPlan = _a.preSelectedPlan, currentPlan = _a.currentPlan;
    var plansByGroup = filterPlansByGroup(plans, selectedPlanGroup);
    var plansForCurrentVariant = getPlansForCurrentVariant({
        variants: variants,
        plans: plansByGroup,
        selectedColor: selectedColor,
        selectedStorage: selectedStorage,
        monthlyTerm: monthlyTerm
    });
    var sortedPlans = sortPlans(plansForCurrentVariant);
    var isNewPlansHasCurrentPlan = !!(currentPlan &&
        plansForCurrentVariant.find(function (plan) { return plan.planId === currentPlan.planId; }));
    var formattedPreselectedPlan = sortedPlans.find(function (plan) {
        var _a;
        return plan.planId === (preSelectedPlan === null || preSelectedPlan === void 0 ? void 0 : preSelectedPlan.planId) &&
            ((_a = plan.variantInfo) === null || _a === void 0 ? void 0 : _a.stockCount) > 0;
    });
    var selectedPlan = formattedPreselectedPlan ||
        sortedPlans.find(function (plan) {
            var _a;
            return (isNewPlansHasCurrentPlan
                ? plan.planId === currentPlan.planId
                : true) &&
                !plan.disabled &&
                ((_a = plan.variantInfo) === null || _a === void 0 ? void 0 : _a.stockCount) > 0;
        });
    return {
        plansForCurrentVariant: sortedPlans,
        selectedPlan: selectedPlan
    };
};
var getMonthlyTerms = function (variants, selectedPlanGroup) {
    return variants
        .reduce(function (result, variant) {
        if (variant.planGroup === (selectedPlanGroup === null || selectedPlanGroup === void 0 ? void 0 : selectedPlanGroup.groupName) &&
            variant.monthlyTerm &&
            !result.includes(variant.monthlyTerm)) {
            result.push(variant.monthlyTerm);
        }
        return result;
    }, [])
        .sort(function (a, b) { return b - a; });
};
var getDescriptions = function (description) {
    var _a;
    if (!description.includes('<li>')) {
        return [description];
    }
    return (((_a = description.match(/<li>(.*?)<\/li>/g)) === null || _a === void 0 ? void 0 : _a.map(function (str) {
        return str.replace(/<\/?li>/g, '');
    })) || []);
};
var getDefaultColor = function (colorList, colorCode, needStockCheck) {
    if (needStockCheck === void 0) { needStockCheck = true; }
    var colorFilterFunc = function (color, needStockCheck) {
        if (needStockCheck === void 0) { needStockCheck = true; }
        return slugify(color.colorCode) === slugify(colorCode) &&
            (needStockCheck ? color.hasStock : true);
    };
    var defaultColor = colorList.find(function (color) { return color.hasStock === needStockCheck; });
    if (colorCode) {
        var preselectedColor = colorList.find(function (color) {
            return colorFilterFunc(color, needStockCheck);
        });
        if (preselectedColor) {
            return preselectedColor;
        }
        defaultColor =
            defaultColor || colorList.find(function (color) { return colorFilterFunc(color, false); });
    }
    return defaultColor || colorList[0];
};
var slugify = function (str) {
    if (!str) {
        return '';
    }
    return str
        .trim()
        .toLowerCase()
        .replace(/\s?\+/g, '-plus')
        .replace(/[^A-Za-z0-9]/g, '-');
};
var getPreselectPlanAndGroup = function (planGroups, plans, selectedPlanValue) {
    var defaultPlanGroup = planGroups[0];
    if (!selectedPlanValue)
        return { preselectedPlanGroup: defaultPlanGroup };
    var preSelectedPlan = plans.find(function (plan) { return slugify(plan.planName) === slugify(selectedPlanValue); });
    var preselectedGroup = planGroups.find(function (planGroup) { return planGroup.groupName === (preSelectedPlan === null || preSelectedPlan === void 0 ? void 0 : preSelectedPlan.groupName); }) || defaultPlanGroup;
    return {
        preSelectedPlan: preSelectedPlan,
        preselectedPlanGroup: preselectedGroup
    };
};
var isValidYoutubeLink = function (videoUrl) {
    if (videoUrl === void 0) { videoUrl = ''; }
    var youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.?be)\/.+$/;
    return youtubeRegex.test(videoUrl);
};
var getFreeGiftsList = function (freeGiftsByDevice, freeGiftStockAvail) {
    if (!freeGiftsByDevice || !freeGiftStockAvail) {
        return null;
    }
    return freeGiftsByDevice
        .filter(function (freeGift) { return freeGift.title; })
        .map(function (freeGift) {
        var matched = freeGiftStockAvail.find(function (stock) { return stock.itemCode === freeGift.sku; });
        var available = matched ? matched.availableQty > 0 : false;
        return {
            text: freeGift.title,
            value: freeGift.text,
            available: available
        };
    });
};
var calculateAccessoryPrice = function (accessories) {
    return accessories.reduce(function (result, accessory) {
        var _a, _b;
        if (accessory.selected) {
            result += (_b = (_a = accessory.selectedVariant) === null || _a === void 0 ? void 0 : _a.price) !== null && _b !== void 0 ? _b : 0;
        }
        return result;
    }, 0);
};
var getSummaryPrice = function (plan, accessoryPrice, selectedProduct, quantity) {
    if (accessoryPrice === void 0) { accessoryPrice = 0; }
    if (quantity === void 0) { quantity = 1; }
    var variant = (plan === null || plan === void 0 ? void 0 : plan.variantInfo) || selectedProduct;
    var hasInstallmentPrice = (variant === null || variant === void 0 ? void 0 : variant.monthlyTerm) && (variant === null || variant === void 0 ? void 0 : variant.installmentPrice);
    var monthlyAmount = Number(hasInstallmentPrice ? variant === null || variant === void 0 ? void 0 : variant.installmentPrice : 0) +
        Number((plan === null || plan === void 0 ? void 0 : plan.discountedPrice) || (plan === null || plan === void 0 ? void 0 : plan.monthlyCharges) || 0);
    var upfrontAmount = (hasInstallmentPrice ? 0 : Number(variant === null || variant === void 0 ? void 0 : variant.price) * (quantity || 1)) +
        accessoryPrice;
    return {
        upfrontAmount: upfrontAmount,
        monthlyAmount: monthlyAmount
    };
};
var sortAndFilterItems = function (items, limit) {
    return (items || [])
        .sort(function (current, next) { return current.order - next.order; })
        .slice(0, limit);
};
var setPreselectAccessories = function (preselectIds, accessories) {
    return accessories.map(function (accessory) {
        var selected = !!accessory.variants.find(function (variant) {
            return preselectIds.includes(variant.id);
        });
        return __assign(__assign({}, accessory), { selected: selected });
    });
};
var isProductHasStock = function (variants) {
    return !!variants.find(function (variant) { return variant.stockCount > 0; });
};
var getSelectedAccessories = function (accessories) {
    return accessories.reduce(function (result, accessory) {
        if (accessory.selected) {
            result.push(accessory.selectedVariant);
        }
        return result;
    }, []);
};
var getDefaultQuantity = function (_a) {
    var paymentTermType = _a.paymentTermType, maxLimit = _a.maxLimit;
    if (paymentTermType !== PRODUCT_DETAILS.PAYMENT_TERM_TYPE.FULL_PRICE)
        return 1;
    return maxLimit > 0 ? 1 : 0;
};
var getPaymentTerms = function (_a) {
    var variants = _a.variants, selectedColor = _a.selectedColor, selectedStorage = _a.selectedStorage, selectedPaymentTerm = _a.selectedPaymentTerm, preselectPaymentTerm = _a.preselectPaymentTerm, hasStock = _a.hasStock;
    var filterVariants = variants.filter(function (variant) {
        return (variant.colorCode === selectedColor.colorCode &&
            ((selectedStorage === null || selectedStorage === void 0 ? void 0 : selectedStorage.value)
                ? variant.memorySize === selectedStorage.value
                : true));
    });
    var fullPriceVariant = filterVariants.find(function (variant) { return variant.monthlyTerm === null; });
    var hasSelectedItem = false;
    var paymentTerms = filterVariants.map(function (variant, index) {
        var isMonthly = !!variant.monthlyTerm;
        var description = isMonthly
            ? variant.monthlyTerm + "-months"
            : trans('TEXT_FULL_PRICE');
        var id = variant.monthlyTerm ||
            PRODUCT_DETAILS.PAYMENT_TERM_TYPE.FULL_PRICE;
        var selected = variant.stockCount > 0 &&
            (selectedPaymentTerm
                ? id === (selectedPaymentTerm === null || selectedPaymentTerm === void 0 ? void 0 : selectedPaymentTerm.id)
                : preselectPaymentTerm
                    ? id.toLowerCase() === preselectPaymentTerm
                    : fullPriceVariant
                        ? !isMonthly
                        : index === 0);
        if (selected && !hasSelectedItem) {
            hasSelectedItem = true;
        }
        return {
            id: id,
            value: variant.monthlyTerm || PRODUCT_DETAILS.PAYMENT_TERM_TYPE.FULL_PRICE,
            selected: selected,
            price: isMonthly ? variant.installmentPrice : variant.price,
            usualPrice: variant.usualPrice,
            description: description,
            priceSuffix: isMonthly ? '/mth' : '',
            variant: variant,
            disabled: !hasStock
        };
    });
    if (!hasSelectedItem) {
        var itemHasStock = paymentTerms.find(function (paymentTerm) { return paymentTerm.variant.stockCount > 0; });
        if (itemHasStock) {
            itemHasStock.selected = true;
        }
    }
    selectedPaymentTerm = paymentTerms.find(function (paymentTerm) { return paymentTerm.selected; });
    return {
        paymentTerms: paymentTerms,
        selectedPaymentTerm: selectedPaymentTerm
    };
};

var EquipmentCardWithoutColumn = function (_a) {
    var option = _a.option, onClick = _a.onClick, hasPriceSlash = _a.hasPriceSlash;
    var t = useTranslation().t;
    var _b = option || {}, ribbon = _b.ribbon, heroImage = _b.heroImage, deviceTitle = _b.deviceTitle, priceFrom = _b.priceFrom, customPrice = _b.customPrice, usualPrice = _b.usualPrice;
    var renderPrice = function () {
        return (React__default["default"].createElement(React__default["default"].Fragment, null,
            customPrice || t('EQUIPMENT_CARD_PRICE_FROM') + (priceFrom || 0),
            React__default["default"].createElement("div", null, usualPrice && hasPriceSlash && (React__default["default"].createElement(StrikeThroughText, { fullWidth: true, type: "smallBody" }, usualPrice)))));
    };
    return (React__default["default"].createElement(web.Card, { shadow: "sm", radius: "md", padding: "sm", onClick: onClick, "data-testid": "equipment-item" },
        React__default["default"].createElement(web.Card.Content, null,
            React__default["default"].createElement(CardImage, { heroImage: heroImage, title: deviceTitle }),
            React__default["default"].createElement(CardSummary, { ribbon: ribbon, deviceTitle: deviceTitle }),
            React__default["default"].createElement(web.Card.Footer, null, renderPrice()))));
};
var CardSummary = React.memo(function (_a) {
    var ribbon = _a.ribbon, deviceTitle = _a.deviceTitle;
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement(web.Ribbon.Variant1, null, ribbon),
        React__default["default"].createElement(web.Text, { type: "boldBody", tag: "h2" }, deviceTitle)));
});
var CardImage = React.memo(function (_a) {
    var _b;
    var heroImage = _a.heroImage, title = _a.title;
    var alt = (heroImage === null || heroImage === void 0 ? void 0 : heroImage.alt) || title;
    return (React__default["default"].createElement(React__default["default"].Fragment, null, ((_b = heroImage === null || heroImage === void 0 ? void 0 : heroImage.childImageSharp) === null || _b === void 0 ? void 0 : _b.fluid) ? (React__default["default"].createElement(Img, { fluid: heroImage.childImageSharp.fluid, alt: alt })) : (React__default["default"].createElement("img", { width: "100%", src: heroImage === null || heroImage === void 0 ? void 0 : heroImage.src, alt: alt }))));
});
var EquipmentCard = function (props) {
    var equipmentListContext = React__default["default"].useContext(EquipmentListContext);
    var _a = props.itemPerRow, itemPerRow = _a === void 0 ? 3 : _a, option = props.option;
    var renderCard = function () {
        var _a;
        var anchorTagPath = (_a = equipmentListContext === null || equipmentListContext === void 0 ? void 0 : equipmentListContext.configs) === null || _a === void 0 ? void 0 : _a.anchorTagPath;
        var card = React__default["default"].createElement(EquipmentCardWithoutColumn, __assign({}, props));
        if (anchorTagPath) {
            return (React__default["default"].createElement("a", { href: anchorTagPath + "/" + slugify(option.deviceTitle) }, card));
        }
        return card;
    };
    return (React__default["default"].createElement(web.Column, { xs: 6, sm: 12 / itemPerRow, md: 12 / itemPerRow }, renderCard()));
};

var EquipmentCardList = React.memo(function (_a) {
    var _b = _a.data, data = _b === void 0 ? [] : _b, isMobile = _a.isMobile, productListTitle = _a.productListTitle, itemPerRow = _a.itemPerRow;
    var t = useTranslation().t;
    var equipmentListContext = React__default["default"].useContext(EquipmentListContext);
    var renderProductList = function () {
        var _a;
        if ((_a = equipmentListContext === null || equipmentListContext === void 0 ? void 0 : equipmentListContext.configs) === null || _a === void 0 ? void 0 : _a.isLoading) {
            return React__default["default"].createElement(ListSkeletonLoader, { isLoading: true, numberOfItem: 4 });
        }
        return (React__default["default"].createElement(React__default["default"].Fragment, null, data.length ? (React__default["default"].createElement(EquipmentWrapper, { isMobile: isMobile },
            React__default["default"].createElement(web.Row, null, data.map(function (product) {
                var _a;
                return (React__default["default"].createElement(EquipmentCard, { hasPriceSlash: (_a = equipmentListContext === null || equipmentListContext === void 0 ? void 0 : equipmentListContext.configs) === null || _a === void 0 ? void 0 : _a.hasPriceSlash, itemPerRow: itemPerRow, key: product === null || product === void 0 ? void 0 : product.brandId, option: product, onClick: function () {
                        var _a;
                        (_a = equipmentListContext === null || equipmentListContext === void 0 ? void 0 : equipmentListContext.callbacks) === null || _a === void 0 ? void 0 : _a.onProductClick(product);
                    } }));
            })))) : (React__default["default"].createElement(CentralizedText, { align: "center", alignY: "center" },
            React__default["default"].createElement(web.Text, null, t('EQUIPMENT_ERROR_NOT_FOUND', { type: productListTitle }))))));
    };
    return renderProductList();
});

var FilterChipsContainer = styled__default["default"](web.Spacing)(templateObject_1$m || (templateObject_1$m = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n"])));
var FilterChips = function (props) {
    var numberOfChips = props.numberOfChips, onRemoved = props.onRemoved, onShowMoreClicked = props.onShowMoreClicked, chips = props.chips, chipTitleLength = props.chipTitleLength;
    if (!chips.length)
        return null;
    var isShowMoreVisible = chips.length > numberOfChips;
    var getChipName = function (fullName) {
        if (fullName.length > chipTitleLength) {
            return fullName.substring(0, chipTitleLength) + "...";
        }
        return fullName;
    };
    return (React__default["default"].createElement(FilterChipsContainer, { bottom: 1 },
        chips.slice(0, numberOfChips).map(function (item) {
            return (React__default["default"].createElement(web.Spacing, { right: 1, bottom: 2 },
                React__default["default"].createElement(web.Chip, { selected: item.selected, removable: true, onRemove: function () {
                        onRemoved(item.name);
                    } }, getChipName(item.name))));
        }),
        isShowMoreVisible && (React__default["default"].createElement(web.Spacing, { bottom: 2 },
            React__default["default"].createElement(web.Chip.MoreOrLessLink, { showAll: false, onClick: onShowMoreClicked })))));
};
var templateObject_1$m;

var EquipmentSelector = function (props) {
    var equipmentListContext = React__default["default"].useContext(EquipmentListContext);
    var _a = (equipmentListContext === null || equipmentListContext === void 0 ? void 0 : equipmentListContext.callbacks) || {}; _a.onProductClick; var applyFilter = _a.applyFilter, sortProduct = _a.sortProduct;
    var _b = (equipmentListContext === null || equipmentListContext === void 0 ? void 0 : equipmentListContext.configs) || {}, enableSorter = _b.enableSorter, enableBanner = _b.enableBanner, enableFilter = _b.enableFilter, _c = _b.numberOfChips, numberOfChips = _c === void 0 ? 2 : _c, _d = _b.chipTitleLength, chipTitleLength = _d === void 0 ? 40 : _d, enableViewMore = _b.enableViewMore, enableFilterChips = _b.enableFilterChips, hasProductCount = _b.hasProductCount;
    var banner = props.banner, _e = props.dataSrc, dataSrc = _e === void 0 ? [] : _e, _f = props.title, title = _f === void 0 ? '' : _f, _g = props.open, open = _g === void 0 ? true : _g, filterData = props.filterData, sorterData = props.sorterData; props.onSorterIconClick;
    var _h = web.useDevice(), isMobile = _h.isMobile, isTablet = _h.isTablet;
    var isMobileView = isMobile || isTablet;
    var theme = web.useTheme().theme;
    var _j = React.useState(false), showFilterModal = _j[0], setShowFilterModal = _j[1];
    var _k = React.useState(false), showSortModal = _k[0], setShowSortModal = _k[1];
    var _l = React.useState(enableFilter), showFilter = _l[0], setShowFilter = _l[1];
    var items = useScrollToLoadMore(enableViewMore, dataSrc).items;
    var handleFilterChipsClose = function (itemName) {
        var filterItemsAfterChipsClose = filterData === null || filterData === void 0 ? void 0 : filterData.map(function (group) {
            var _a;
            var updatedGroup = __assign({}, group);
            updatedGroup.items =
                Array.isArray(group === null || group === void 0 ? void 0 : group.items) &&
                    ((_a = group === null || group === void 0 ? void 0 : group.items) === null || _a === void 0 ? void 0 : _a.map(function (item) {
                        if (item.name === itemName) {
                            item.selected = false;
                        }
                        return item;
                    }));
            return updatedGroup;
        });
        applyFilter(filterItemsAfterChipsClose);
    };
    var onFilterIconClick = function () {
        if (isMobile || isTablet) {
            setShowFilterModal(true);
        }
        else {
            setShowFilter(!showFilter);
        }
    };
    var renderFilterIcon = function () {
        if (isMobileView) {
            return null;
        }
        return (React__default["default"].createElement(React__default["default"].Fragment, null, enableFilter && (React__default["default"].createElement(InlineWrapper$1, { top: 2, right: isMobile ? 0 : 1, responsive: false },
            React__default["default"].createElement(web.Spacing, { left: '4px' },
                React__default["default"].createElement(web.TextLink, { inline: true, onClick: onFilterIconClick },
                    React__default["default"].createElement(InlineWrapper$1, null,
                        React__default["default"].createElement(web.TextLink.Icon, { icon: Filter_1 }),
                        React__default["default"].createElement(web.TextLink.Text, null, showFilter
                            ? trans('TEXT_HIDE_FILTER')
                            : trans('TEXT_SHOW_FILTER')))))))));
    };
    var getSortOptions = React.useMemo(function () {
        var _a;
        if ((_a = sorterData === null || sorterData === void 0 ? void 0 : sorterData.items) === null || _a === void 0 ? void 0 : _a.length) {
            return sorterData.items.map(function (item) {
                return {
                    id: item.value,
                    label: item.text,
                    value: item.value
                };
            });
        }
        return [];
    }, [sorterData === null || sorterData === void 0 ? void 0 : sorterData.items]);
    var renderMobileSort = function () {
        if (!enableSorter)
            return null;
        return (React__default["default"].createElement(web.Modal, { visible: isMobileView && showSortModal, title: sorterData === null || sorterData === void 0 ? void 0 : sorterData.label, onClose: function () {
                setShowSortModal(false);
            }, bgColor: theme.cl_white, wide: true, scrollable: true },
            React__default["default"].createElement(web.Modal.Content, null,
                React__default["default"].createElement(web.Spacing, { bottom: 1 },
                    React__default["default"].createElement(web.Radio.InputGroup, { name: "", onChange: function (e, result) {
                            setShowSortModal(false);
                            sortProduct && sortProduct(result.value);
                        }, options: getSortOptions, value: sorterData === null || sorterData === void 0 ? void 0 : sorterData.defaultValue })))));
    };
    var renderSort = function () {
        if (!enableSorter || isMobileView)
            return null;
        return (React__default["default"].createElement(web.Spacing, { leftRight: 1, responsive: false },
            React__default["default"].createElement(web.DropdownInput, { bgColor: "haze", label: sorterData === null || sorterData === void 0 ? void 0 : sorterData.label, onChange: function (item) {
                    sortProduct(item.value);
                }, value: sorterData === null || sorterData === void 0 ? void 0 : sorterData.defaultValue, items: sorterData === null || sorterData === void 0 ? void 0 : sorterData.items, hintMessage: sorterData === null || sorterData === void 0 ? void 0 : sorterData.hintMessage, error: sorterData === null || sorterData === void 0 ? void 0 : sorterData.error })));
    };
    var renderFilterChips = function () {
        if (!isMobile)
            return null;
        var chips = filterData.reduce(function (result, group) {
            if (Array.isArray(group.items)) {
                var selectedItems = group.items.filter(function (item) { return item.selected; });
                result = __spreadArray(__spreadArray([], result, true), selectedItems, true);
            }
            return result;
        }, []);
        return (React__default["default"].createElement(FilterChips, { chipTitleLength: chipTitleLength, numberOfChips: numberOfChips, onRemoved: handleFilterChipsClose, onShowMoreClicked: function () {
                setShowFilterModal(true);
            }, chips: chips }));
    };
    var renderMobileSortFilterIcon = function () {
        var _a, _b;
        if (!isMobileView)
            return null;
        return (React__default["default"].createElement(InlineWrapper$1, null,
            enableSorter && (React__default["default"].createElement(web.Spacing, { right: '4px', responsive: false, onClick: function () {
                    setShowSortModal(true);
                } },
                React__default["default"].createElement(SortingNeutral_1, { color: (_a = theme.link) === null || _a === void 0 ? void 0 : _a.color, size: 24 }))),
            React__default["default"].createElement(web.Spacing, { top: '2px', onClick: onFilterIconClick },
                React__default["default"].createElement(Filter_1, { size: 24, color: (_b = theme.link) === null || _b === void 0 ? void 0 : _b.color }))));
    };
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        enableBanner && React__default["default"].createElement(Banner$1, { banner: banner }),
        React__default["default"].createElement(web.Row, null,
            React__default["default"].createElement(web.Column, { xs: 12, sm: 7, md: isMobileView ? 6 : 7, noGutter: true },
                React__default["default"].createElement(web.Spacing, { topBottom: 1 },
                    React__default["default"].createElement(web.Text, { type: "pageTitle", tag: "h1" }, title))),
            React__default["default"].createElement(web.Column, { xs: 12, sm: 5, md: isMobileView ? 6 : 5, noGutter: true },
                React__default["default"].createElement(HeaderWrapper, { isMobile: isMobileView, bottom: 3 },
                    renderFilterIcon(),
                    renderSort()))),
        React__default["default"].createElement(Collapse, { visible: open },
            React__default["default"].createElement(React__default["default"].Fragment, null,
                React__default["default"].createElement(web.Row, null,
                    enableFilter && showFilter ? (React__default["default"].createElement(web.Column, { xs: 12, md: 3, noGutter: true },
                        React__default["default"].createElement(web.Spacing, { right: 6 },
                            React__default["default"].createElement(FilterBar, { filterData: filterData, showFilterModal: showFilterModal, setShowFilterModal: setShowFilterModal })))) : null,
                    React__default["default"].createElement(web.Column, { xs: 12, md: enableFilter && showFilter ? 9 : 12, noGutter: true },
                        enableFilterChips ? renderFilterChips() : null,
                        React__default["default"].createElement(InlineWrapper$1, { spaceBetween: true },
                            hasProductCount && (React__default["default"].createElement(web.Spacing, { bottom: 1 },
                                React__default["default"].createElement(web.Text, { type: "body" }, (dataSrc === null || dataSrc === void 0 ? void 0 : dataSrc.length) + " " + trans('TEXT_RESULTS')))),
                            React__default["default"].createElement("div", null),
                            renderMobileSortFilterIcon()),
                        React__default["default"].createElement(EquipmentCardList, { itemPerRow: showFilter ? 3 : 4, data: items, isMobile: isMobileView, productListTitle: title }))))),
        renderMobileSort()));
};

var attributeList$1 = [
    'deviceId',
    'deviceTitle',
    'brandId',
    'brandDescription',
    'ribbon',
    'priceFrom',
    'discountPrice',
    'updateTime',
    'heroImage',
    'colorCode',
    'planGroups',
    'productCost'
];
var getMappedData$1 = function (dataSrc, dataMapping, validMapping) {
    if (!validMapping.length)
        return dataSrc;
    var getNewObj = function (obj) {
        validMapping.forEach(function (attr) {
            var attrInSrc = dataMapping[attr];
            var value = obj[attrInSrc];
            if (!value)
                return;
            //assign new attribute value to newObj
            obj[attr] = value;
        });
        return obj;
    };
    if (Array.isArray(dataSrc)) {
        return dataSrc.map(function (item) {
            var newObj = __assign({}, item);
            return getNewObj(newObj);
        });
    }
    else if (typeof dataSrc === 'object') {
        return getNewObj(__assign({}, dataSrc));
    }
    else {
        return dataSrc;
    }
};
/**
 *
 *
 * @export
 * @param {*} [dataSets=[]]
 * @param {object} [dataMapping={}]
 * @returns
 */
function useDataMapping$1(dataSets, dataMapping) {
    var validMappingList = React.useMemo(function () {
        return Object.keys(dataMapping || {}).filter(function (attr) {
            return attributeList$1.indexOf(attr) > -1;
        });
    }, [dataMapping]);
    var mappedDataSets = React.useMemo(function () {
        return dataSets.map(function (item) {
            return getMappedData$1(item, dataMapping, validMappingList);
        });
    }, [dataSets, dataMapping]);
    var getMappedReturnVal = React.useCallback(function (values) {
        return values.map(function (item) {
            var newObj = __assign({}, item);
            validMappingList.forEach(function (attr) {
                var newKey = dataMapping[attr];
                var value = item[attr];
                if (!value)
                    return;
                //assign new attribute value to newObj
                newObj[newKey] = value;
                delete newObj[attr];
            });
            return newObj;
        });
    }, [dataMapping, validMappingList]);
    return { mappedDataSets: mappedDataSets, getMappedReturnVal: getMappedReturnVal };
}

var EquipmentListContext = React__default["default"].createContext(null);
var ProductCatalogue = function (_a) {
    var data = _a.data, configs = _a.configs, localisation = _a.localisation, error = _a.error, callbacks = _a.callbacks;
    var promoStrip = data.promoStrip, banner = data.banner, productList = data.productList, productDetails = data.productDetails, value = data.value, filterData = data.filterData, productCatalogTitle = data.productCatalogTitle, sorterData = data.sorterData, searchModalData = data.searchModalData;
    var _b = configs || {}, open = _b.open, dataMapping = _b.dataMapping, showSorterModal = _b.showSorterModal, setShowSorterModal = _b.setShowSorterModal;
    var SEARCH_MODAL_TITLE = localisation.SEARCH_MODAL_TITLE;
    var _c = useDataMapping$1([productList, productDetails === null || productDetails === void 0 ? void 0 : productDetails.variants, value], dataMapping).mappedDataSets, mappedProducts = _c[0]; _c[1]; var mappedValue = _c[2];
    return (React__default["default"].createElement(EquipmentListContext.Provider, { value: { configs: configs, callbacks: callbacks } },
        React__default["default"].createElement(EquipmentSelector, { promoStrip: promoStrip, banner: banner, dataSrc: mappedProducts, localisation: localisation, value: mappedValue, open: open, error: error, title: productCatalogTitle, filterData: filterData, sorterData: sorterData, searchModalTitle: SEARCH_MODAL_TITLE, showSorterModal: showSorterModal, setShowSorterModal: setShowSorterModal, searchModalData: searchModalData })));
};

var ProductList = function (_a) {
    var data = _a.data, configs = _a.configs, localisation = _a.localisation, error = _a.error, callbacks = _a.callbacks;
    var promoStrip = data.promoStrip, banner = data.banner, productList = data.productList, productDetails = data.productDetails, value = data.value, filterData = data.filterData, productCatalogTitle = data.productCatalogTitle, sorterData = data.sorterData, searchModalData = data.searchModalData;
    var _b = configs || {}, enableViewMoreBtn = _b.enableViewMoreBtn, enableMoreBrandsBtn = _b.enableMoreBrandsBtn, enableFilter = _b.enableFilter, enableSorter = _b.enableSorter, open = _b.open, isSelectedDeviceTextRequired = _b.isSelectedDeviceTextRequired, _c = _b.dataMapping, dataMapping = _c === void 0 ? {} : _c, filterSelectedIndex = _b.filterSelectedIndex, showFilterModal = _b.showFilterModal, setShowFilterModal = _b.setShowFilterModal, showSorterModal = _b.showSorterModal, setShowSorterModal = _b.setShowSorterModal;
    var _d = callbacks || {}, onProductClick = _d.onProductClick, onFilterClick = _d.onFilterClick, onFilterIconClick = _d.onFilterIconClick, onSorterIconClick = _d.onSorterIconClick;
    var SEARCH_MODAL_TITLE = localisation.SEARCH_MODAL_TITLE;
    var _e = React.useState(false); _e[0]; var setVisible = _e[1];
    var _f = React.useState({}); _f[0]; var setCurrentItem = _f[1];
    var _g = useDataMapping$1([productList, productDetails.variants, value], dataMapping), _h = _g.mappedDataSets, mappedProducts = _h[0]; _h[1]; var mappedValue = _h[2];
    return (React__default["default"].createElement(EquipmentSelector, { promoStrip: promoStrip, banner: banner, dataSrc: mappedProducts, localisation: localisation, value: mappedValue, open: open, isSelectedDeviceTextRequired: isSelectedDeviceTextRequired, enableViewMoreBtn: enableViewMoreBtn, enableMoreBrandsBtn: enableMoreBrandsBtn, enableFilter: enableFilter, enableSorter: enableSorter, onProductClick: function (option) {
            setCurrentItem(option);
            setVisible(true);
            onProductClick && onProductClick(option);
        }, error: error, title: productCatalogTitle, filterData: filterData, filterSelectedIndex: filterSelectedIndex, onFilterClick: onFilterClick, sorterData: sorterData, onFilterIconClick: onFilterIconClick, onSorterIconClick: onSorterIconClick, showFilterModal: showFilterModal, setShowFilterModal: setShowFilterModal, searchModalTitle: SEARCH_MODAL_TITLE, showSorterModal: showSorterModal, setShowSorterModal: setShowSorterModal, searchModalData: searchModalData }));
};

var events = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.listen = listen;
exports.unlisten = unlisten;
////////////////////////////////////////////////////////////////////////////////////////
// Small helpers that provide an easy and efficient way to add/remove event listeners //
////////////////////////////////////////////////////////////////////////////////////////
var elementsWithListeners = [];
var registeredListeners = [];

function createListener(el) {
  return {
    el: el,
    callbacks: {},
    realCallbacks: {},
    realListenersCnt: 0
  };
}

function addCallback(listener, event, cb) {
  if (listener.callbacks[event]) {
    if (listener.callbacks[event].indexOf(cb) === -1) {
      listener.callbacks[event].push(cb);
    }

    return;
  }

  listener.callbacks[event] = [cb];

  listener.realCallbacks[event] = function (e) {
    for (var i = 0, l = listener.callbacks[event].length; i < l; i += 1) {
      listener.callbacks[event][i](e);
    }
  };

  listener.el.addEventListener(event, listener.realCallbacks[event]);
  listener.realListenersCnt += 1;
}

function removeCallback(listener, event, cb) {
  if (!listener.callbacks[event]) {
    return;
  }

  var idx = listener.callbacks[event].indexOf(cb);

  if (idx === -1) {
    return;
  }

  listener.callbacks[event].splice(idx, 1);

  if (listener.callbacks[event].length > 0) {
    return;
  } // no more listeners, lets clean up


  listener.el.removeEventListener(event, listener.realCallbacks[event]);
  delete listener.callbacks[event];
  delete listener.realCallbacks[event];
  listener.realListenersCnt -= 1;
}

function addListener(el, event, cb) {
  var idx = elementsWithListeners.indexOf(el);

  if (idx === -1) {
    idx = elementsWithListeners.length;
    elementsWithListeners.push(el);
    registeredListeners.push(createListener(el));
  }

  var listener = registeredListeners[idx];
  addCallback(listener, event, cb);
}

function removeListener(el, event, cb) {
  var idx = elementsWithListeners.indexOf(el);

  if (idx === -1) {
    return;
  }

  var listener = registeredListeners[idx];
  removeCallback(listener, event, cb);

  if (listener.realListenersCnt > 0) {
    return;
  } // no more listeners lets clean up


  elementsWithListeners.splice(idx, 1);
  registeredListeners.splice(idx, 1);
}
/**
 * Subscribe cb to events list
 * @param  {HTMLElement}   el       target element
 * @param  {Array}         events   array of event names
 * @param  {Function} cb   callback that should be called
 */


function listen(el, events, cb) {
  for (var i = 0, l = events.length; i < l; i += 1) {
    addListener(el, events[i], cb);
  }
}
/**
 * Unsubscribe cb from events list
 * @param  {HTMLElement}   el       target element
 * @param  {Array}         events   array of event names
 * @param  {Function} cb   callback that should be unsubscribed
 */


function unlisten(el, events, cb) {
  for (var i = 0, l = events.length; i < l; i += 1) {
    removeListener(el, events[i], cb);
  }
}
});

unwrapExports(events);
events.listen;
events.unlisten;

var find_1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = find;
var basicSelectors = {};

if (typeof document !== 'undefined') {
  basicSelectors.body = document.body;
  basicSelectors.window = window;
  basicSelectors.document = document;
}

var matchesMethodName = function () {
  if (typeof document !== 'undefined' && document.body) {
    var body = document.body;
    return typeof body.matches === 'function' ? 'matches' : // $FlowFixMe - flow doesn't like vendors, so do I, but we have to support such case
    typeof body.webkitMatchesSelector === 'function' ? 'webkitMatchesSelector' : //webkit
    // $FlowFixMe - see above
    typeof body.mozMatchesSelector === 'function' ? 'mozMatchesSelector' : //mozilla
    // $FlowFixMe - see above
    typeof body.msMatchesSelector === 'function' ? 'msMatchesSelector' : //ie
    // $FlowFixMe - see above
    typeof body.oMatchesSelector === 'function' ? 'oMatchesSelector' : //old opera
    null;
  }

  return null;
}();

function find(selector, el) {
  if (!selector) {
    return null;
  }

  if (basicSelectors.hasOwnProperty(selector)) {
    return basicSelectors[selector];
  } // select by id


  if (selector[0] === '#') {
    return document.getElementById(selector.slice(1));
  }

  if (matchesMethodName === null) {
    return null;
  }

  var temp = el; // eslint-disable-next-line no-cond-assign

  while (temp = temp.parentElement) {
    // $FlowFixMe - flow does not approve it, but it works fine :)
    if (temp[matchesMethodName](selector)) {
      return temp || null;
    }
  } // nothing has been found :(


  return null;
}

module.exports = exports.default;
});

unwrapExports(find_1);

var getClosestTransformedParent_1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = getClosestTransformedParent;

function getClosestTransformedParent(el) {
  do {
    var style = window.getComputedStyle(el);
    if (style.transform !== 'none' || style.webkitTransform !== 'none') return el; // $FlowFixMe - it's fine

    el = el.parentElement || el.parentNode;
  } while (el !== null && el.nodeType === 1);

  return null;
}

module.exports = exports.default;
});

unwrapExports(getClosestTransformedParent_1);

var rect = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.getRect = getRect;
exports.isIntersecting = isIntersecting;
exports.infiniteRect = void 0;
var infiniteRect = {
  top: -Infinity,
  bottom: Infinity,
  height: Infinity,
  left: -Infinity,
  right: Infinity,
  width: Infinity
};
exports.infiniteRect = infiniteRect;

function getRect(el) {
  if (el && typeof el.getBoundingClientRect === 'function') {
    return el.getBoundingClientRect();
  }

  if (el === window || el === document) {
    return {
      top: 0,
      left: 0,
      bottom: window.innerHeight,
      height: window.innerHeight,
      width: window.innerWidth,
      right: window.innerWidth
    };
  }

  return {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: 0,
    height: 0
  };
}

function isIntersecting(r1, r2, topOffset, bottomOffset) {
  var r1Top = r1.top + topOffset,
      r1Bottom = r1.bottom + bottomOffset;
  return r1Top >= r2.top && r1Top <= r2.bottom || r1Bottom >= r2.top && r1Bottom <= r2.bottom || r1Bottom >= r2.bottom && r1Top <= r2.top;
}
});

unwrapExports(rect);
rect.getRect;
rect.isIntersecting;
rect.infiniteRect;

var renderPropsVersion = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = void 0;





var _find = _interopRequireDefault(find_1);

var _getClosestTransformedParent = _interopRequireDefault(getClosestTransformedParent_1);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var buildTopStyles = function buildTopStyles(container, props) {
  var bottomOffset = props.bottomOffset,
      hideOnBoundaryHit = props.hideOnBoundaryHit;
  var top = container.top,
      height = container.height,
      width = container.width,
      boundaryBottom = container.boundaryBottom; // above boundary

  if (hideOnBoundaryHit || top + height + bottomOffset < boundaryBottom) {
    return {
      top: top + "px",
      width: width + "px",
      position: 'fixed'
    };
  } // reaching boundary


  if (!hideOnBoundaryHit && boundaryBottom > 0) {
    return {
      top: boundaryBottom - height - bottomOffset + "px",
      width: width + "px",
      position: 'fixed'
    };
  } // below boundary


  return {
    width: width + "px",
    bottom: bottomOffset + "px",
    position: 'absolute'
  };
};

var buildBottomStyles = function buildBottomStyles(container, props) {
  var bottomOffset = props.bottomOffset,
      hideOnBoundaryHit = props.hideOnBoundaryHit;
  var bottom = container.bottom,
      height = container.height,
      width = container.width,
      boundaryTop = container.boundaryTop;

  if (hideOnBoundaryHit || bottom - height - bottomOffset > boundaryTop) {
    return {
      width: width + "px",
      top: bottom - height + "px",
      position: 'fixed'
    };
  }

  return {
    width: width + "px",
    top: bottomOffset + "px",
    position: 'absolute'
  };
};

var buildStickyStyle = function buildStickyStyle(mode, props, container) {
  return (mode === 'top' ? buildTopStyles : buildBottomStyles)(container, props);
};

var isEqual = function isEqual(obj1, obj2) {
  var styles1 = obj1.wrapperStyles;
  var styles2 = obj2.wrapperStyles;

  if (obj1.isFixed !== obj2.isFixed || obj1.height !== obj2.height || !styles1 && styles2 || styles1 && !styles2) {
    return false;
  }

  if (!styles2) {
    // we need this condition to make Flow happy
    return true;
  }

  for (var field in styles1) {
    if (styles1.hasOwnProperty(field) && styles1[field] !== styles2[field]) {
      return false;
    }
  }

  return true;
};

var Sticky = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Sticky, _Component);

  function Sticky() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.holderEl = null;
    _this.wrapperEl = null;
    _this.el = null;
    _this.scrollEl = null;
    _this.boundaryEl = null;
    _this.disabled = false;
    _this.checkPositionIntervalId = void 0;
    _this.lastMinHeight = void 0;
    _this.state = {
      isFixed: false,
      wrapperStyles: null,
      holderStyles: null,
      height: 0
    };

    _this.holderRef = function (holderEl) {
      if (holderEl === _this.holderEl) {
        return;
      }

      _this.holderEl = holderEl;
    };

    _this.wrapperRef = function (wrapperEl) {
      if (wrapperEl === _this.wrapperEl) {
        return;
      }

      _this.wrapperEl = wrapperEl;

      _this.updateScrollEl();

      _this.updateBoundaryEl();
    };

    _this.checkPosition = function () {
      var _assertThisInitialize = _assertThisInitialized(_this),
          holderEl = _assertThisInitialize.holderEl,
          wrapperEl = _assertThisInitialize.wrapperEl,
          boundaryEl = _assertThisInitialize.boundaryEl,
          scrollEl = _assertThisInitialize.scrollEl,
          disabled = _assertThisInitialize.disabled;

      if (!scrollEl || !holderEl || !wrapperEl) {
        console.error("Missing required elements:", {
          scrollEl: scrollEl,
          holderEl: holderEl,
          wrapperEl: wrapperEl
        });
        return;
      }

      var _this$props = _this.props,
          mode = _this$props.mode,
          onFixedToggle = _this$props.onFixedToggle,
          offsetTransforms = _this$props.offsetTransforms,
          isIOSFixEnabled = _this$props.isIOSFixEnabled,
          dontUpdateHolderHeightWhenSticky = _this$props.dontUpdateHolderHeightWhenSticky;

      if (disabled) {
        if (_this.state.isFixed) {
          _this.setState({
            isFixed: false,
            wrapperStyles: {}
          });
        }

        return;
      }

      if (!holderEl.getBoundingClientRect || !wrapperEl.getBoundingClientRect) {
        return;
      }

      var holderRect = holderEl.getBoundingClientRect();
      var wrapperRect = wrapperEl.getBoundingClientRect();
      var boundaryRect = boundaryEl ? (0, rect.getRect)(boundaryEl) : rect.infiniteRect;
      var scrollRect = (0, rect.getRect)(scrollEl);

      var isFixed = _this.isFixed(holderRect, wrapperRect, boundaryRect, scrollRect);

      var offsets = null;

      if (offsetTransforms && isFixed) {
        var closestTransformedParent = (0, _getClosestTransformedParent.default)(scrollEl);

        if (closestTransformedParent) {
          offsets = (0, rect.getRect)(closestTransformedParent);
        }
      }

      var minHeight = _this.state.isFixed && dontUpdateHolderHeightWhenSticky && _this.lastMinHeight ? _this.lastMinHeight : wrapperRect.height;
      _this.lastMinHeight = minHeight; // To ensure that this component becomes sticky immediately on mobile devices instead
      // of disappearing until the scroll event completes, we add `transform: translateZ(0)`
      // to 'kick' rendering of this element to the GPU
      // @see http://stackoverflow.com/questions/32875046

      var iosRenderingFixStyles = isIOSFixEnabled ? {
        transform: 'translateZ(0)',
        WebkitTransform: 'translateZ(0)'
      } : null;
      var newState = {
        isFixed: isFixed,
        height: wrapperRect.height,
        holderStyles: {
          minHeight: minHeight + "px"
        },
        wrapperStyles: isFixed ? _extends({}, iosRenderingFixStyles, buildStickyStyle(mode, _this.props, {
          boundaryTop: mode === 'bottom' ? boundaryRect.top : 0,
          boundaryBottom: mode === 'top' ? boundaryRect.bottom : 0,
          top: mode === 'top' ? scrollRect.top - (offsets ? offsets.top : 0) : 0,
          bottom: mode === 'bottom' ? scrollRect.bottom - (offsets ? offsets.bottom : 0) : 0,
          width: holderRect.width,
          height: wrapperRect.height
        })) : iosRenderingFixStyles
      };

      if (isFixed !== _this.state.isFixed && onFixedToggle && typeof onFixedToggle === 'function') {
        onFixedToggle(isFixed);
      }

      if (!isEqual(_this.state, newState)) {
        _this.setState(newState);
      }
    };

    return _this;
  }

  var _proto = Sticky.prototype;

  _proto.isFixed = function isFixed(holderRect, wrapperRect, boundaryRect, scrollRect) {
    var _this$props2 = this.props,
        hideOnBoundaryHit = _this$props2.hideOnBoundaryHit,
        bottomOffset = _this$props2.bottomOffset,
        topOffset = _this$props2.topOffset,
        mode = _this$props2.mode;

    if (this.disabled) {
      return false;
    }

    if (hideOnBoundaryHit && boundaryRect && !(0, rect.isIntersecting)(boundaryRect, scrollRect, topOffset, bottomOffset)) {
      return false;
    }

    var hideOffset = hideOnBoundaryHit ? wrapperRect.height + bottomOffset : 0;

    if (mode === 'top') {
      return holderRect.top + topOffset < scrollRect.top && scrollRect.top + hideOffset <= boundaryRect.bottom;
    }

    return holderRect.bottom - topOffset > scrollRect.bottom && scrollRect.bottom - hideOffset >= boundaryRect.top;
  };

  _proto.updateScrollEl = function updateScrollEl() {
    if (!this.wrapperEl) {
      return;
    }

    if (this.scrollEl) {
      (0, events.unlisten)(this.scrollEl, ['scroll'], this.checkPosition);
      this.scrollEl = null;
    }

    var scrollElement = this.props.scrollElement;

    if (typeof scrollElement === 'string') {
      this.scrollEl = (0, _find.default)(scrollElement, this.wrapperEl);
    } else {
      this.scrollEl = scrollElement;
    }

    if (this.scrollEl) {
      (0, events.listen)(this.scrollEl, ['scroll'], this.checkPosition);
    } else {
      console.error('Cannot find scrollElement ' + (typeof scrollElement === 'string' ? scrollElement : 'unknown'));
    }
  };

  _proto.updateBoundaryEl = function updateBoundaryEl() {
    if (!this.wrapperEl) {
      return;
    }

    var boundaryElement = this.props.boundaryElement;
    this.boundaryEl = (0, _find.default)(boundaryElement, this.wrapperEl);

    if (this.boundaryEl === window || this.boundaryEl === document) {
      // such objects can't be used as boundary
      // and in fact there is no point in such a case
      this.boundaryEl = null;
    }
  };

  _proto.initialize = function initialize() {
    var _this$props3 = this.props,
        positionRecheckInterval = _this$props3.positionRecheckInterval,
        disabled = _this$props3.disabled;
    this.disabled = disabled; // we should always listen to window events because they will affect the layout of the whole page

    (0, events.listen)(window, ['scroll', 'resize', 'pageshow', 'load'], this.checkPosition);
    this.checkPosition();

    if (positionRecheckInterval) {
      this.checkPositionIntervalId = setInterval(this.checkPosition, positionRecheckInterval);
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(_ref) {
    var scrollElement = _ref.scrollElement,
        boundaryElement = _ref.boundaryElement,
        disabled = _ref.disabled;

    if (scrollElement !== this.props.scrollElement) {
      this.updateScrollEl();
    }

    if (boundaryElement !== this.props.boundaryElement) {
      this.updateBoundaryEl();
    }

    if (disabled !== this.props.disabled) {
      this.disabled = this.props.disabled;
      this.checkPosition();
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    this.initialize();

    if (this.wrapperEl === null) {
      console.error("Wrapper element is missing, please make sure that you have assigned refs correctly");
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.scrollEl) {
      (0, events.unlisten)(this.scrollEl, ['scroll'], this.checkPosition);
    }

    (0, events.unlisten)(window, ['scroll', 'resize', 'pageshow', 'load'], this.checkPosition);
    this.boundaryEl = null;
    this.scrollEl = null;
    clearInterval(this.checkPositionIntervalId);
  };

  _proto.render = function render() {
    var holderRef = this.holderRef,
        wrapperRef = this.wrapperRef;
    var _this$state = this.state,
        isFixed = _this$state.isFixed,
        wrapperStyles = _this$state.wrapperStyles,
        holderStyles = _this$state.holderStyles;
    return this.props.children({
      holderRef: holderRef,
      wrapperRef: wrapperRef,
      isFixed: isFixed,
      wrapperStyles: wrapperStyles,
      holderStyles: holderStyles
    });
  };

  return Sticky;
}(React__default["default"].Component);

Sticky.defaultProps = {
  mode: 'top',
  topOffset: 0,
  bottomOffset: 0,
  isIOSFixEnabled: true,
  disabled: false,
  onFixedToggle: null,
  boundaryElement: null,
  scrollElement: 'window',
  dontUpdateHolderHeightWhenSticky: false
};
var _default = Sticky;
exports.default = _default;
module.exports = exports.default;
});

unwrapExports(renderPropsVersion);

var basicVersion = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(React__default["default"]);

var _renderPropsVersion = _interopRequireDefault(renderPropsVersion);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Sticky(props) {
  var mode = props.mode,
      onFixedToggle = props.onFixedToggle,
      hideOnBoundaryHit = props.hideOnBoundaryHit,
      offsetTransforms = props.offsetTransforms,
      disabled = props.disabled,
      boundaryElement = props.boundaryElement,
      scrollElement = props.scrollElement,
      bottomOffset = props.bottomOffset,
      topOffset = props.topOffset,
      positionRecheckInterval = props.positionRecheckInterval,
      children = props.children,
      isIOSFixEnabled = props.isIOSFixEnabled,
      dontUpdateHolderHeightWhenSticky = props.dontUpdateHolderHeightWhenSticky,
      wrapperClassName = props.wrapperClassName,
      stickyClassName = props.stickyClassName,
      stickyStyle = props.stickyStyle,
      rest = _objectWithoutPropertiesLoose(props, ["mode", "onFixedToggle", "hideOnBoundaryHit", "offsetTransforms", "disabled", "boundaryElement", "scrollElement", "bottomOffset", "topOffset", "positionRecheckInterval", "children", "isIOSFixEnabled", "dontUpdateHolderHeightWhenSticky", "wrapperClassName", "stickyClassName", "stickyStyle"]);

  return /*#__PURE__*/_react.default.createElement(_renderPropsVersion.default, {
    mode: mode,
    onFixedToggle: onFixedToggle,
    hideOnBoundaryHit: hideOnBoundaryHit,
    offsetTransforms: offsetTransforms,
    disabled: disabled,
    boundaryElement: boundaryElement,
    scrollElement: scrollElement,
    bottomOffset: bottomOffset,
    topOffset: topOffset,
    positionRecheckInterval: positionRecheckInterval,
    isIOSFixEnabled: isIOSFixEnabled,
    dontUpdateHolderHeightWhenSticky: dontUpdateHolderHeightWhenSticky
  }, function (_ref) {
    var isFixed = _ref.isFixed,
        wrapperStyles = _ref.wrapperStyles,
        wrapperRef = _ref.wrapperRef,
        holderStyles = _ref.holderStyles,
        holderRef = _ref.holderRef;
    return /*#__PURE__*/_react.default.createElement("div", _extends({}, rest, {
      ref: holderRef,
      style: holderStyles
    }), /*#__PURE__*/_react.default.createElement("div", _extends({}, rest, {
      className: wrapperClassName + " " + (isFixed ? stickyClassName : ''),
      style: // $FlowFixMe - flow does not like when we merge 2 inexact objects
      isFixed ? _extends({}, wrapperStyles, stickyStyle) : wrapperStyles,
      ref: wrapperRef
    }), children));
  });
}

Sticky.defaultProps = {
  stickyClassName: 'sticky',
  wrapperClassName: '',
  stickyStyle: {}
};
var _default = Sticky;
exports.default = _default;
module.exports = exports.default;
});

unwrapExports(basicVersion);

var lib = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = void 0;

var _renderPropsVersion = _interopRequireDefault(renderPropsVersion);

exports.RenderPropSticky = _renderPropsVersion.default;

var _basicVersion = _interopRequireDefault(basicVersion);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _basicVersion.default;
exports.default = _default;
});

var Sticky = unwrapExports(lib);
lib.RenderPropSticky;

var _templateObject$4, _templateObject2$3, _templateObject3$2;
var Styles$1 = {
  StyledSticky: styled__default["default"](Sticky)(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteral(["\n    position: relative;\n    & > div {\n      transition: all 0.1s ease;\n      padding: 0;\n    }\n    .sticky {\n      padding: 125px 0 300px;\n    }\n  "]))),
  HeroImageCarouselWrapper: styled__default["default"].div(_templateObject2$3 || (_templateObject2$3 = _taggedTemplateLiteral(["\n    height: auto;\n    width: 100%;\n    max-width: 400px;\n    box-sizing: content-box;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin: auto;\n    ", "\n    ", "\n  "])), function (p) {
    return p.isInModal && !p.isMobile && " \n        max-width: 250px;\n        padding: 35px 0 0 10px;\n      ";
  }, function (p) {
    return p.isInModal && p.isMobile && " \n        max-width: 250px;\n      ";
  }),
  StyledImg: styled__default["default"].img(_templateObject3$2 || (_templateObject3$2 = _taggedTemplateLiteral(["\n    height: auto;\n    width: 100%;\n    max-width: 400px;\n  "])))
};

var ShareIconWrapper = web.withTheme(styled__default["default"].div(templateObject_2$j || (templateObject_2$j = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var coreTheme = _a.coreTheme;
    return styled.css(templateObject_1$l || (templateObject_1$l = __makeTemplateObject(["\n    width: 32px;\n    height: 32px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 50%;\n    background-color: #f7f7f7;\n    overflow: hidden;\n    cursor: pointer;\n    @media (min-width: ", ") {\n      width: 48px;\n      height: 48px;\n    }\n  "], ["\n    width: 32px;\n    height: 32px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 50%;\n    background-color: #f7f7f7;\n    overflow: hidden;\n    cursor: pointer;\n    @media (min-width: ", ") {\n      width: 48px;\n      height: 48px;\n    }\n  "])), coreTheme.brk_md);
}));
var StyledShareIcon = web.withTheme(styled__default["default"](Share_1)(templateObject_4$b || (templateObject_4$b = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var coreTheme = _a.coreTheme;
    return styled.css(templateObject_3$c || (templateObject_3$c = __makeTemplateObject(["\n    width: 16px;\n    height: 16px;\n    @media (min-width: ", ") {\n      width: 24px;\n      height: 24px;\n    }\n  "], ["\n    width: 16px;\n    height: 16px;\n    @media (min-width: ", ") {\n      width: 24px;\n      height: 24px;\n    }\n  "])), coreTheme.brk_md);
}));
var EquipmentGallery = React.memo(function (props) {
    var _a, _b;
    var isMobile = web.useDevice().isMobile;
    var equipmentContext = React__default["default"].useContext(EquipmentContext);
    var _c = props.imageGallery, imageGallery = _c === void 0 ? [] : _c, limit = props.limit; props.imageHeight; var _e = props.isLoading; _e === void 0 ? (_a = equipmentContext === null || equipmentContext === void 0 ? void 0 : equipmentContext.configs) === null || _a === void 0 ? void 0 : _a.isLoading : _e; var stickyBoundaryElement = props.stickyBoundaryElement, _f = props.isSticky, isSticky = _f === void 0 ? false : _f, _g = props.isInModal, isInModal = _g === void 0 ? false : _g, seoTag = props.seoTag;
    var showShareBtn = (_b = equipmentContext === null || equipmentContext === void 0 ? void 0 : equipmentContext.configs) === null || _b === void 0 ? void 0 : _b.showShareBtn;
    var carouselRef = React.useRef(null);
    var carouselRefMobile = React.useRef(null);
    var getImageWithinLimit = function () {
        if (limit) {
            return imageGallery.slice(0, limit);
        }
        return imageGallery;
    };
    var _h = React.useState({
        selectedIndex: 0,
        imageList: getImageWithinLimit()
    }), state = _h[0], _setState = _h[1];
    var setState = function (params) {
        _setState(__assign(__assign({}, state), params));
    };
    React.useEffect(function () {
        var _a, _b, _c;
        if (imageGallery.length) {
            setState({ selectedIndex: 0, imageList: getImageWithinLimit() });
            if ((_a = state === null || state === void 0 ? void 0 : state.imageList) === null || _a === void 0 ? void 0 : _a.length) {
                (_b = carouselRef === null || carouselRef === void 0 ? void 0 : carouselRef.current) === null || _b === void 0 ? void 0 : _b.resetCarousel();
                (_c = carouselRefMobile === null || carouselRefMobile === void 0 ? void 0 : carouselRefMobile.current) === null || _c === void 0 ? void 0 : _c.resetCarousel();
            }
        }
    }, [imageGallery]);
    var renderImage = function () {
        return (React__default["default"].createElement(Styles$1.HeroImageCarouselWrapper, { isInModal: isInModal, isMobile: isMobile },
            React__default["default"].createElement(web.Carousel, { type: "image", "data-testid": "carousel-testid", ref: carouselRefMobile }, imageGallery === null || imageGallery === void 0 ? void 0 : imageGallery.map(function (imageData, index) {
                var imageFile = imageData.imageFile, alt = imageData.alt;
                var renderMainImage = function () {
                    var _a, _b;
                    return (React__default["default"].createElement(Styles$1.StyledImg, { key: "main-" + index, src: "" + ((_b = (_a = imageFile === null || imageFile === void 0 ? void 0 : imageFile.childImageSharp) === null || _a === void 0 ? void 0 : _a.fixed) === null || _b === void 0 ? void 0 : _b.src), alt: alt || seoTag }));
                };
                var renderAccessoryImage = function () {
                    return (React__default["default"].createElement(Styles$1.StyledImg, { key: "accessory-" + index, src: "" + (imageData === null || imageData === void 0 ? void 0 : imageData.src), alt: 'Image of accessory' }));
                };
                return imageFile ? renderMainImage() : renderAccessoryImage();
            }))));
    };
    var renderEquipmentGallery = function () {
        var _a;
        var gallery = (React__default["default"].createElement(React__default["default"].Fragment, null,
            !isInModal &&
                showShareBtn &&
                ((_a = equipmentContext === null || equipmentContext === void 0 ? void 0 : equipmentContext.callbacks) === null || _a === void 0 ? void 0 : _a.onShareClick) && (React__default["default"].createElement(React__default["default"].Fragment, null,
                React__default["default"].createElement(ShareIconWrapper, null,
                    React__default["default"].createElement(StyledShareIcon, { "data-testid": "share-icon", onClick: equipmentContext.callbacks.onShareClick })))),
            renderImage()));
        if (isSticky && !isMobile)
            return (React__default["default"].createElement(Styles$1.StyledSticky, { boundaryElement: stickyBoundaryElement }, gallery));
        return gallery;
    };
    return React__default["default"].createElement(XSSpacing, { right: 3 }, renderEquipmentGallery());
});
var templateObject_1$l, templateObject_2$j, templateObject_3$c, templateObject_4$b;

var _templateObject$3, _templateObject2$2;
var Dots = styled__default["default"].div(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteral(["\n  display: flex;\n  margin: 0 auto;\n  width: 100%;\n  flex-wrap: wrap;\n"])));
styled__default["default"](web.Text)(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteral(["\n  width: 40px;\n  text-align: center;\n"])));

var ColorItem = web.withTheme(styled__default["default"](web.Layout.Stack)(templateObject_2$i || (templateObject_2$i = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var coreTheme = _a.coreTheme;
    return styled.css(templateObject_1$k || (templateObject_1$k = __makeTemplateObject(["\n    margin: 0 16px 16px 0;\n    @media (min-width: ", ") {\n      min-width: calc(25% - 12px);\n      &:nth-child(4n) {\n        margin-right: 0px;\n      }\n    }\n\n    @media (max-width: ", ") {\n      min-width: calc(33.3% - 11px);\n      &:nth-child(3n) {\n        margin-right: 0px;\n      }\n    }\n  "], ["\n    margin: 0 16px 16px 0;\n    @media (min-width: ", ") {\n      min-width: calc(25% - 12px);\n      &:nth-child(4n) {\n        margin-right: 0px;\n      }\n    }\n\n    @media (max-width: ", ") {\n      min-width: calc(33.3% - 11px);\n      &:nth-child(3n) {\n        margin-right: 0px;\n      }\n    }\n  "])), coreTheme.brk_md, coreTheme.brk_md);
}));
var DeviceColourPicker = function (props) {
    var _a;
    var equipmentContext = React__default["default"].useContext(EquipmentContext);
    web.useDevice().isMobile;
    var _b = props.colours, colours = _b === void 0 ? [] : _b, onSelectColor = props.onSelectColor, selectedColor = props.selectedColor, preSelectionOptions = props.preSelectionOptions;
    var defaultColor = getDefaultColor(colours, preSelectionOptions === null || preSelectionOptions === void 0 ? void 0 : preSelectionOptions.color, false);
    var t = useTranslation().t;
    var renderColors = function () {
        return colours.map(function (colour, index) {
            var colorHexCode = colour.colorHexCode, colorCode = colour.colorCode;
            return (React__default["default"].createElement(ColorItem, { key: 'stack' + colorCode + colorHexCode, "data-testid": "device-colour-picker" },
                React__default["default"].createElement(web.Selector, { alignment: "column", autoHeight: true, value: colorCode, selected: colorCode === (selectedColor === null || selectedColor === void 0 ? void 0 : selectedColor.colorCode), onClick: function () {
                        onSelectColor(colour);
                    } },
                    React__default["default"].createElement(web.Selector.Color, { hexCode: colorHexCode === null || colorHexCode === void 0 ? void 0 : colorHexCode.toLocaleUpperCase(), slash: !(colour === null || colour === void 0 ? void 0 : colour.hasStock) }))));
        });
    };
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement(web.Spacing, { bottom: 2 },
            React__default["default"].createElement(web.Text, { type: "header" }, t('EQUIPMENT_DETAILS_COLOR_TITLE') +
                (selectedColor
                    ? ': ' + selectedColor.colorDescription
                    : defaultColor === null || defaultColor === void 0 ? void 0 : defaultColor.colorDescription))),
        React__default["default"].createElement(SkeletonGrid, { numberOfColumn: 3, numberOfRow: 1, isLoading: (_a = equipmentContext.configs) === null || _a === void 0 ? void 0 : _a.isLoading },
            React__default["default"].createElement(React__default["default"].Fragment, null,
                React__default["default"].createElement(Dots, null, renderColors()),
                !(selectedColor === null || selectedColor === void 0 ? void 0 : selectedColor.hasStock) && (React__default["default"].createElement(web.Spacing, { top: 0.2 },
                    React__default["default"].createElement(web.Text, { type: "smallBody" }, t('OUT_OF_STOCK'))))))));
};
var templateObject_1$k, templateObject_2$i;

var StorageWrapper = styled__default["default"].div(templateObject_1$j || (templateObject_1$j = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n  width: 100%;\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  width: 100%;\n"])));
var StorageItem = web.withTheme(styled__default["default"](web.Layout.Stack)(templateObject_3$b || (templateObject_3$b = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var coreTheme = _a.coreTheme;
    return styled.css(templateObject_2$h || (templateObject_2$h = __makeTemplateObject(["\n    min-width: 164px;\n    margin: 0 16px 16px 0;\n    @media (max-width: ", ") {\n      min-width: calc(50% - 8px);\n      margin-right: 0;\n      &:nth-child(odd) {\n        margin-right: 16px;\n      }\n    }\n  "], ["\n    min-width: 164px;\n    margin: 0 16px 16px 0;\n    @media (max-width: ", ") {\n      min-width: calc(50% - 8px);\n      margin-right: 0;\n      &:nth-child(odd) {\n        margin-right: 16px;\n      }\n    }\n  "])), coreTheme.brk_xs);
}));
var templateObject_1$j, templateObject_2$h, templateObject_3$b;

var StorageSelector = function (props) {
    var _a;
    var equipmentContext = React__default["default"].useContext(EquipmentContext);
    var selectedStorage = props.selectedStorage, storages = props.storages, _b = props.onStorageChanged, onStorageChanged = _b === void 0 ? function () { } : _b, _c = props.headerText, headerText = _c === void 0 ? trans('EQUIPMENT_DETAILS_STORAGE_TITLE') : _c, _d = props.isLoading, isLoading = _d === void 0 ? (_a = equipmentContext === null || equipmentContext === void 0 ? void 0 : equipmentContext.configs) === null || _a === void 0 ? void 0 : _a.isLoading : _d, selectedColor = props.selectedColor;
    var renderStorageDescription = function (storage) {
        var _a, _b, _c, _d, _e;
        var description = function (text) { return (React__default["default"].createElement(web.Spacing, { top: '4px' },
            React__default["default"].createElement(web.Text, { type: "smallBody" }, text))); };
        if (!storage.stockCount || storage.stockCount <= 0) {
            return description(trans('OUT_OF_STOCK'));
        }
        if ((_a = storage.variantInfo) === null || _a === void 0 ? void 0 : _a.isBackOrder) {
            return description(trans('PRE_ODER_TEXT'));
        }
        if ((_b = storage.variantInfo) === null || _b === void 0 ? void 0 : _b.storageDescriptionText) {
            return description((_c = storage.variantInfo) === null || _c === void 0 ? void 0 : _c.storageDescriptionText);
        }
        if ((_d = storage.variantInfo) === null || _d === void 0 ? void 0 : _d.storageHighlightText) {
            return (React__default["default"].createElement(web.Spacing, { top: '4px' },
                React__default["default"].createElement(web.Ribbon.Variant1, null, (_e = storage.variantInfo) === null || _e === void 0 ? void 0 : _e.storageHighlightText)));
        }
        return null;
    };
    React.useEffect(function () {
        if (selectedStorage === null || selectedStorage === void 0 ? void 0 : selectedStorage.value) {
            var selectedStorageData = storages.find(function (storage) { return storage.value === (selectedStorage === null || selectedStorage === void 0 ? void 0 : selectedStorage.value); });
            selectedStorageData && onStorageChanged(selectedStorageData);
        }
    }, [selectedStorage === null || selectedStorage === void 0 ? void 0 : selectedStorage.value, selectedColor]);
    var renderStorage = function () {
        return (React__default["default"].createElement(StorageWrapper, null, storages.map(function (storage, storageIndex) {
            var isSelected = (selectedStorage === null || selectedStorage === void 0 ? void 0 : selectedStorage.value) === storage.value;
            var disable = !(storage === null || storage === void 0 ? void 0 : storage.stockCount) || (storage === null || storage === void 0 ? void 0 : storage.stockCount) <= 0;
            return (React__default["default"].createElement(StorageItem, { key: storageIndex },
                React__default["default"].createElement(web.Selector, { alignment: "row", onClick: function () {
                        if (isLoading)
                            return;
                        onStorageChanged(__assign(__assign({}, storage), { userSelected: true }));
                    }, disabled: disable, selected: isSelected && (storage === null || storage === void 0 ? void 0 : storage.stockCount) > 0, "data-testid": 'storage-item' },
                    React__default["default"].createElement(web.Selector.Body, { disabled: disable || isLoading, title: storage.value, align: "start" })),
                renderStorageDescription(storage)));
        })));
    };
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement(web.Spacing, { bottom: 2 },
            React__default["default"].createElement(web.Text, { type: "header" }, headerText)),
        React__default["default"].createElement(web.Row, { noGutter: true }, renderStorage())));
};

var _templateObject$2, _templateObject2$1, _templateObject3$1, _templateObject4$1, _templateObject5$1, _templateObject6$1, _templateObject7$1, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14;
var TechSpecWrapper = web.withTheme(styled__default["default"].div(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n  background-color: ", ";\n"])), function (_ref) {
  var coreTheme = _ref.coreTheme;
  return coreTheme.cl_white;
}));
var WrapperRow = styled__default["default"](web.Row)(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n  padding: 20px 0;\n"])));
var AccordionWrapper$1 = styled__default["default"].div(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteral(["\n  &.accordionwrapper {\n    & > div:last-child {\n      display: none;\n    }\n  }\n"])));
var StyledText$1 = styled__default["default"](web.Text)(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteral(["\n  margin: 10px 0;\n  text-align: start;\n"])));
var StyledDescriptionText = styled__default["default"](web.Text)(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteral(["\n  margin: 12px 0;\n  text-align: start;\n"])));
var StyledDiv$1 = styled__default["default"].div(_templateObject6$1 || (_templateObject6$1 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: 15px;\n"])));
var StyledMdDiv = styled__default["default"].div(_templateObject7$1 || (_templateObject7$1 = _taggedTemplateLiteral(["\n  text-align: left;\n"])));
var StyledImg$1 = styled__default["default"].img(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  max-height: 32px;\n  max-width: 32px;\n"])));
var StyledMDDisplayDiv = web.withTheme(styled__default["default"].div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref2) {
  var coreTheme = _ref2.coreTheme;
  return styled.css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n    @media (max-width: ", ") {\n      display: none;\n    }\n  "])), coreTheme.brk_sm);
}));
var StyledSMDisplayDiv = web.withTheme(styled__default["default"].div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref3) {
  var coreTheme = _ref3.coreTheme;
  return styled.css(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n    display: none;\n    @media (max-width: ", ") {\n      display: block;\n    }\n  "])), coreTheme.brk_sm);
}));
var TextWrapper = styled__default["default"](web.Text)(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  text-align: left;\n"])));
var InlineWrapper = styled__default["default"](web.Layout.Inline)(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  flex-wrap: nowrap;\n"])));

var TechSpecWidget = function (_a) {
    var data = _a.data;
    var renderTitle = function (item) { return (React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement(StyledText$1, { type: "header" }, item.title),
        item.icon && React__default["default"].createElement(StyledImg$1, { src: item.icon }))); };
    var renderDescription = function (item) { return (React__default["default"].createElement(web.Column, { xs: 12, md: 8, lg: 8, noGutter: true },
        React__default["default"].createElement(StyledDescriptionText, { type: "body" },
            React__default["default"].createElement("p", { dangerouslySetInnerHTML: {
                    __html: item.description
                } })))); };
    var renderTechItems = function (item) {
        return (React__default["default"].createElement(React__default["default"].Fragment, null,
            React__default["default"].createElement(StyledSMDisplayDiv, null,
                React__default["default"].createElement(WrapperRow, { noGutter: true },
                    React__default["default"].createElement(web.Column, { xs: 12, md: 4, lg: 4, noGutter: true },
                        React__default["default"].createElement(web.Spacing, { bottom: 1 },
                            React__default["default"].createElement(StyledDiv$1, null, renderTitle(item)))),
                    renderDescription(item))),
            React__default["default"].createElement(StyledMDDisplayDiv, null,
                React__default["default"].createElement(WrapperRow, { noGutter: true },
                    React__default["default"].createElement(web.Column, { xs: 12, md: 4, lg: 4, noGutter: true },
                        React__default["default"].createElement(web.Spacing, { bottom: 1 },
                            React__default["default"].createElement(StyledMdDiv, null, renderTitle(item)))),
                    renderDescription(item)))));
    };
    return (React__default["default"].createElement(TechSpecWrapper, null, (data || []).map(function (item, itemIndex) {
        return (React__default["default"].createElement("div", { key: item.title + itemIndex },
            itemIndex === 0 ? React__default["default"].createElement(web.Divider, null) : null,
            item && item.description
                ? renderTechItems(item)
                : null,
            data.length !== itemIndex + 1 && item.description ? React__default["default"].createElement(web.Divider, null) : null));
    })));
};
TechSpecWidget.defaultProps = {
    data: []
};
TechSpecWidget.propTypes = {
    data: propTypes.arrayOf(propTypes.shape({
        /** Item title*/
        title: propTypes.string,
        /** Item description*/
        description: propTypes.string
    }))
};

var getSpecification = function (fields) {
    return fields.reduce(function (data, item) { return "" + data + (item.value || ''); }, '');
};
var SpecBox = function (_a) {
    var specifications = _a.specifications, whatsInTheBox = _a.whatsInTheBox, techExpand = _a.techExpand, setTechExpand = _a.setTechExpand, productDetails = _a.productDetails;
    var _b = React.useState(-1), index = _b[0], setIndex = _b[1];
    var _c = React.useState([]), specs = _c[0], setSpecs = _c[1];
    var equipmentContext = React__default["default"].useContext(EquipmentContext);
    var handleClick = function (e, value) {
        setIndex(index === value ? -1 : value);
        setTechExpand();
    };
    React.useEffect(function () {
        setIndex(techExpand ? 0 : -1);
    }, [techExpand]);
    React.useEffect(function () {
        var result = (specifications || []).map(function (specItem) {
            var _a;
            var groupTitle = specItem.groupTitle, fields = specItem.fields, iconImage = specItem.iconImage;
            var iconPath = iconImage
                ? "" + ((_a = equipmentContext === null || equipmentContext === void 0 ? void 0 : equipmentContext.configs) === null || _a === void 0 ? void 0 : _a.baseUrl) + iconImage.childImageSharp.fixed.src
                : null;
            return {
                title: groupTitle,
                description: getSpecification(fields),
                icon: iconPath
            };
        });
        setSpecs(result);
    }, [specifications]);
    var renderEquipmentDetailsContent = function () {
        if (whatsInTheBox === null || whatsInTheBox === void 0 ? void 0 : whatsInTheBox.length) {
            return (React__default["default"].createElement(web.Spacing, { topBottom: 2 }, (whatsInTheBox || []).map(function (item, itemIndex) {
                return (React__default["default"].createElement(web.Row, { noGutter: true, key: itemIndex },
                    React__default["default"].createElement(InlineWrapper, null,
                        React__default["default"].createElement(Tick_1, { size: "24", color: "black" }),
                        React__default["default"].createElement(TextWrapper, { type: "body" }, item))));
            })));
        }
        if (productDetails) {
            return (React__default["default"].createElement(web.Spacing, { bottom: 2 },
                React__default["default"].createElement(web.Row, null,
                    React__default["default"].createElement(StyledMdDiv, null,
                        React__default["default"].createElement(web.Text, { type: "body" },
                            React__default["default"].createElement("div", { dangerouslySetInnerHTML: {
                                    __html: productDetails
                                } }))))));
        }
        return null;
    };
    var renderEquipmentDetails = function () {
        if (!productDetails && !(whatsInTheBox === null || whatsInTheBox === void 0 ? void 0 : whatsInTheBox.length))
            return null;
        return (React__default["default"].createElement(web.Grid, null,
            React__default["default"].createElement(web.Row, { center: "xs" },
                React__default["default"].createElement(web.Column, { xs: 12, id: !(specifications === null || specifications === void 0 ? void 0 : specifications.length)
                        ? PRODUCT_DETAILS.ELEMENT_IDS.TECH_SPECS
                        : null },
                    React__default["default"].createElement(AccordionWrapper$1, { className: "accordionwrapper" },
                        React__default["default"].createElement(web.Accordion, { title: React__default["default"].createElement(web.Text, { type: "boldBody", tag: "h2" }, trans('EQUIPMENT_DETAILS_BOX_TITLE')), desc: renderEquipmentDetailsContent(), selected: index === 1 || (!(specifications === null || specifications === void 0 ? void 0 : specifications.length) && index === 0), value: 1, onClick: handleClick }))))));
    };
    var renderSpecs = function () {
        if (!(specifications === null || specifications === void 0 ? void 0 : specifications.length))
            return null;
        return (React__default["default"].createElement(React__default["default"].Fragment, null,
            React__default["default"].createElement(web.Grid, null,
                React__default["default"].createElement(web.Row, null,
                    React__default["default"].createElement(web.Column, { xs: 12, center: "xs", id: PRODUCT_DETAILS.ELEMENT_IDS.TECH_SPECS },
                        React__default["default"].createElement(AccordionWrapper$1, { className: "accordionwrapper" },
                            React__default["default"].createElement(web.Accordion, { title: React__default["default"].createElement(web.Text, { type: "boldBody", tag: "h2" }, trans('EQUIPMENT_DETAILS_TECH_SPECS')), desc: React__default["default"].createElement(web.Spacing, { top: 2 },
                                    React__default["default"].createElement(TechSpecWidget, { data: specs })), selected: index === 0, value: 0, onClick: handleClick }))))),
            React__default["default"].createElement(web.Divider, null)));
    };
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        renderSpecs(),
        renderEquipmentDetails()));
};
SpecBox.defaultProps = {
    whatsInTheBox: [],
    specifications: []
};
SpecBox.propTypes = {
    whatsInTheBox: propTypes.array,
    specifications: propTypes.array
};

var StyledVideo = web.withTheme(styled__default["default"].div(templateObject_2$g || (templateObject_2$g = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var coreTheme = _a.coreTheme;
    return styled.css(templateObject_1$i || (templateObject_1$i = __makeTemplateObject(["\n    position: relative;\n    width: 100%;\n    overflow: hidden;\n    margin: auto;\n    @media (min-width: ", ") {\n      width: 75%;\n    }\n    &::after {\n      content: '';\n      display: block;\n      padding-bottom: 56.25%;\n    }\n\n    iframe {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      margin: auto;\n    }\n  "], ["\n    position: relative;\n    width: 100%;\n    overflow: hidden;\n    margin: auto;\n    @media (min-width: ", ") {\n      width: 75%;\n    }\n    &::after {\n      content: '';\n      display: block;\n      padding-bottom: 56.25%;\n    }\n\n    iframe {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      margin: auto;\n    }\n  "])), coreTheme.brk_sm);
}));
web.withTheme(styled__default["default"](web.Spacing)(templateObject_4$a || (templateObject_4$a = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var coreTheme = _a.coreTheme;
    return styled.css(templateObject_3$a || (templateObject_3$a = __makeTemplateObject(["\n    @media (max-width: ", ") {\n      padding-top: 16px;\n      padding-bottom: 16px;\n    }\n  "], ["\n    @media (max-width: ", ") {\n      padding-top: 16px;\n      padding-bottom: 16px;\n    }\n  "])), coreTheme.brk_sm);
}));
var templateObject_1$i, templateObject_2$g, templateObject_3$a, templateObject_4$a;

var DetailsVideo = function (_a) {
    var title = _a.title, videoUrl = _a.videoUrl, isLoading = _a.isLoading;
    React__default["default"].useContext(EquipmentContext);
    var getYoutubeId = function (url) {
        var videoId;
        if (url && url.match(/youtube.com/)) {
            videoId = url.split('/watch?v=')[1];
        }
        if (url && url.match(/youtu.be/)) {
            videoId = url.split('youtu.be/')[1];
        }
        return videoId;
    };
    if (!isValidYoutubeLink(videoUrl)) {
        return null;
    }
    var videoId = getYoutubeId(videoUrl);
    return (React__default["default"].createElement(web.SkeletonLoader, { preset: "CardWithBanner", loading: isLoading },
        React__default["default"].createElement(web.Grid, null,
            React__default["default"].createElement(web.Row, { center: "sm" },
                React__default["default"].createElement(web.Column, { sm: 12, md: 8 }, title && React__default["default"].createElement(web.Text, { type: "sectionTitle" }, title))),
            React__default["default"].createElement(web.Row, null,
                React__default["default"].createElement(web.Column, { sx: 12 },
                    React__default["default"].createElement(StyledVideo, null,
                        React__default["default"].createElement("iframe", { src: "https://www.youtube.com/embed/" + videoId, title: title, frameBorder: 0, allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture", allowFullScreen: true })))))));
};

var getBaseImageHostName = function () {
    if (typeof window !== 'undefined') {
        return window.location.origin;
    }
    return '';
};
var scrollToSection = function (id, yOffset) {
    var _a;
    if (yOffset === void 0) { yOffset = -PRODUCT_DETAILS.SUMMARY_BAR_HEIGHT; }
    var element = document.getElementById(id);
    if (element) {
        var y = ((_a = element.getBoundingClientRect()) === null || _a === void 0 ? void 0 : _a.top) + window.scrollY + yOffset;
        window.scrollTo({ top: y, behavior: 'smooth' });
    }
};

var useOptions = function (_a) {
    var _b, _c;
    var _d = _a.variants, variants = _d === void 0 ? [] : _d, _e = _a.plans, plans = _e === void 0 ? [] : _e, _f = _a.planGroups, planGroups = _f === void 0 ? [] : _f, _g = _a.preSelectionOptions, preSelectionOptions = _g === void 0 ? {} : _g;
    var _h = getPreselectPlanAndGroup(planGroups, plans, preSelectionOptions === null || preSelectionOptions === void 0 ? void 0 : preSelectionOptions.plan), preselectedPlanGroup = _h.preselectedPlanGroup, preSelectedPlan = _h.preSelectedPlan;
    var _j = React.useState({
        colorList: [],
        storageList: [],
        selectedVariant: {},
        plansForCurrentVariant: [],
        selectedPlanGroup: preselectedPlanGroup,
        monthlyTerms: [],
        selectedPlan: preSelectedPlan,
        totalStockAvailable: 0,
        planGroups: planGroups,
        paymentTerms: [],
        quantity: 1
    }), state = _j[0], _setState = _j[1];
    var _k = React.useState({
        color: true,
        storage: true,
        plan: true,
        model: true
    }), scroll = _k[0], setScroll = _k[1];
    var setState = function (params) {
        _setState(__assign(__assign({}, state), params));
    };
    var equipmentContext = React__default["default"].useContext(EquipmentContext);
    var configs = (equipmentContext || {}).configs;
    var cartBox = (configs || {}).cartBox;
    var maxLimit = (_b = cartBox === null || cartBox === void 0 ? void 0 : cartBox.quantity) === null || _b === void 0 ? void 0 : _b.maxValue;
    React.useEffect(function () {
        if (!variants.length)
            return;
        var colorList = getColorList(variants);
        var totalStockAvailable = colorList.reduce(function (acc, color) {
            var _a;
            return (acc +
                (color.totalStockFromStorage || ((_a = color.variantInfo) === null || _a === void 0 ? void 0 : _a.stockCount) || 0));
        }, 0);
        var defaultColor = getDefaultColor(colorList, preSelectionOptions === null || preSelectionOptions === void 0 ? void 0 : preSelectionOptions.color);
        selectColor({
            selectedColor: defaultColor,
            extraParams: { colorList: colorList, totalStockAvailable: totalStockAvailable },
            preSelectedPlan: preSelectedPlan,
            preSelectedMonthlyTerm: preSelectionOptions === null || preSelectionOptions === void 0 ? void 0 : preSelectionOptions.monthlyTerm
        });
    }, [variants]);
    React.useEffect(function () {
        var _a;
        if (state.selectedColor &&
            (configs === null || configs === void 0 ? void 0 : configs.hasPaymentTerms) &&
            state.totalStockAvailable) {
            var defaultQuantity = getDefaultQuantity({
                paymentTermType: (_a = state.selectedPaymentTerm) === null || _a === void 0 ? void 0 : _a.value,
                maxLimit: maxLimit
            });
            var _b = getPaymentTerms({
                variants: variants,
                selectedStorage: state.selectedStorage,
                selectedColor: state.selectedColor,
                selectedPaymentTerm: state.selectedPaymentTerm,
                preselectPaymentTerm: preSelectionOptions === null || preSelectionOptions === void 0 ? void 0 : preSelectionOptions.paymentTerm,
                hasStock: state.totalStockAvailable > 0
            }), paymentTerms = _b.paymentTerms, selectedPaymentTerm = _b.selectedPaymentTerm;
            setState({
                paymentTerms: paymentTerms,
                selectedPaymentTerm: selectedPaymentTerm,
                quantity: defaultQuantity,
                selectedVariant: (selectedPaymentTerm === null || selectedPaymentTerm === void 0 ? void 0 : selectedPaymentTerm.variant) || state.selectedVariant
            });
        }
    }, [
        state.selectedColor,
        state.selectedStorage,
        variants,
        (_c = state.selectedPaymentTerm) === null || _c === void 0 ? void 0 : _c.value,
        maxLimit,
        state.totalStockAvailable
    ]);
    var selectColor = function (_a) {
        var _b, _c;
        var selectedColor = _a.selectedColor, extraParams = _a.extraParams, preSelectedPlan = _a.preSelectedPlan, preSelectedMonthlyTerm = _a.preSelectedMonthlyTerm, currentPlanGroup = _a.currentPlanGroup, userSelected = _a.userSelected;
        var _d = getSelectedVariantAndStorageToDisplay({
            variants: variants,
            selectedColor: selectedColor,
            preSelectStorageValue: preSelectionOptions === null || preSelectionOptions === void 0 ? void 0 : preSelectionOptions.storage,
            currentStorage: state.selectedStorage
        }), selectedVariantToDisplay = _d.selectedVariant, selectedStorage = _d.selectedStorage;
        var monthlyTerms = getMonthlyTerms(variants, state.selectedPlanGroup);
        var _e = filterStorageAndPlanGroup({
            storages: selectedColor.storages,
            variants: variants,
            currenPlanGroup: currentPlanGroup || state.selectedPlanGroup,
            currentStorage: selectedStorage,
            planGroups: planGroups
        }), selectedStorageByPlanGroup = _e.selectedStorage, filteredStorages = _e.storages, filterPlanGroups = _e.filterPlanGroups;
        var selectedMonthlyTerm = state.selectedMonthlyTerm || preSelectedMonthlyTerm || monthlyTerms[0];
        var _f = filterPlans({
            selectedColor: selectedColor,
            selectedStorage: selectedStorageByPlanGroup,
            selectedPlanGroup: state.selectedPlanGroup,
            plans: plans,
            variants: variants,
            monthlyTerm: selectedMonthlyTerm,
            preSelectedPlan: preSelectedPlan,
            currentPlan: state.selectedPlan
        }), plansForCurrentVariant = _f.plansForCurrentVariant, selectedPlan = _f.selectedPlan;
        setState(__assign({ selectedPlan: selectedPlan, selectedColor: selectedColor, selectedVariant: (_b = selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.variantInfo) !== null && _b !== void 0 ? _b : selectedVariantToDisplay, storageList: filteredStorages, selectedStorage: selectedStorageByPlanGroup, plansForCurrentVariant: plansForCurrentVariant, monthlyTerms: monthlyTerms, selectedMonthlyTerm: selectedMonthlyTerm, planGroups: filterPlanGroups }, extraParams));
        if (userSelected) {
            if ((_c = selectedColor.storages) === null || _c === void 0 ? void 0 : _c.length) {
                scroll.color &&
                    scrollToSection(PRODUCT_DETAILS.ELEMENT_IDS.DEVICE_STORAGE_SECTION);
                setScroll(function (prev) { return (__assign(__assign({}, prev), { color: false })); });
            }
            else {
                scroll.color &&
                    scrollToSection(PRODUCT_DETAILS.ELEMENT_IDS.FULFILMENT_SECTION);
                setScroll(function (prev) { return (__assign(__assign({}, prev), { color: false })); });
            }
        }
    };
    var selectStorage = function (selectedStorage) {
        if (!plans.length) {
            var selectedVariantByStorage = getSelectedVariantAndStorageToDisplay({
                variants: variants,
                selectedColor: state.selectedColor,
                preSelectStorageValue: selectedStorage === null || selectedStorage === void 0 ? void 0 : selectedStorage.value
            }).selectedVariant;
            return setState({
                selectedStorage: selectedStorage,
                selectedVariant: selectedVariantByStorage
            });
        }
        var _a = filterPlans({
            selectedColor: state.selectedColor,
            selectedStorage: selectedStorage,
            selectedPlanGroup: state.selectedPlanGroup,
            plans: plans,
            variants: variants,
            monthlyTerm: state.selectedMonthlyTerm,
            currentPlan: state.selectedPlan
        }), plansForCurrentVariant = _a.plansForCurrentVariant, selectedPlan = _a.selectedPlan;
        setState({
            selectedStorage: selectedStorage,
            plansForCurrentVariant: plansForCurrentVariant,
            selectedPlan: selectedPlan,
            selectedVariant: selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.variantInfo
        });
        if (selectedStorage.userSelected) {
            scroll.storage &&
                scrollToSection(PRODUCT_DETAILS.ELEMENT_IDS.FULFILMENT_SECTION);
            setScroll(function (prev) { return (__assign(__assign({}, prev), { storage: false })); });
        }
    };
    var selectPlan = function (selectedPlan) {
        setState({ selectedPlan: selectedPlan, selectedVariant: selectedPlan.variantInfo });
        scroll.plan &&
            scrollToSection(PRODUCT_DETAILS.ELEMENT_IDS.ACCESSORIES_SESSION);
        setScroll(function (prev) { return (__assign(__assign({}, prev), { plan: false })); });
    };
    var scrollToSectionOnce = function (scrollFrom, scrollTo) {
        if (!scrollFrom && !(scrollFrom in scroll)) {
            return;
        }
        if (scroll[scrollFrom]) {
            scrollToSection(scrollTo);
            setScroll(function (prev) {
                var _a;
                return (__assign(__assign({}, prev), (_a = {}, _a[scrollFrom] = false, _a)));
            });
        }
    };
    var selectPlanGroup = function (selectedPlanGroup) {
        var _a = filterStorageAndPlanGroup({
            storages: state.selectedColor.storages,
            variants: variants,
            currenPlanGroup: selectedPlanGroup,
            currentStorage: state.selectedStorage,
            planGroups: planGroups
        }), selectedStorage = _a.selectedStorage, filteredStorages = _a.storages;
        var monthlyTerms = getMonthlyTerms(variants, selectedPlanGroup);
        var _b = filterPlans({
            selectedColor: state.selectedColor,
            selectedStorage: selectedStorage,
            selectedPlanGroup: selectedPlanGroup,
            plans: plans,
            variants: variants,
            monthlyTerm: monthlyTerms[0]
        }), plansForCurrentVariant = _b.plansForCurrentVariant, selectedPlan = _b.selectedPlan;
        setState({
            selectedPlanGroup: selectedPlanGroup,
            plansForCurrentVariant: plansForCurrentVariant,
            selectedPlan: selectedPlan,
            monthlyTerms: monthlyTerms,
            selectedMonthlyTerm: monthlyTerms[0],
            storageList: filteredStorages,
            selectedStorage: selectedStorage,
            selectedVariant: selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.variantInfo
        });
    };
    var selectMonthlyTerm = function (selectedMonthlyTerm) {
        var _a = filterPlans({
            selectedColor: state.selectedColor,
            selectedStorage: state.selectedStorage,
            selectedPlanGroup: state.selectedPlanGroup,
            plans: plans,
            variants: variants,
            monthlyTerm: selectedMonthlyTerm,
            currentPlan: state.selectedPlan
        }), plansForCurrentVariant = _a.plansForCurrentVariant, selectedPlan = _a.selectedPlan;
        setState({
            selectedMonthlyTerm: selectedMonthlyTerm,
            plansForCurrentVariant: plansForCurrentVariant,
            selectedPlan: selectedPlan,
            selectedVariant: selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.variantInfo
        });
    };
    var selectPaymentTerm = function (paymentTerm) {
        var selectedPaymentTerm;
        var newPaymentTerms = state.paymentTerms.map(function (p) {
            if (p.id === paymentTerm.id) {
                selectedPaymentTerm = p;
                p.selected = true;
            }
            else {
                p.selected = false;
            }
            return p;
        });
        setState({
            paymentTerms: newPaymentTerms,
            selectedVariant: paymentTerm.variant,
            selectedPaymentTerm: selectedPaymentTerm
        });
    };
    var setQuantity = function (quantity) {
        setState({ quantity: quantity });
    };
    return {
        paymentTerms: state.paymentTerms,
        storageList: state.storageList,
        colorList: state.colorList,
        selectedColor: state.selectedColor,
        selectedVariant: state.selectedVariant,
        selectedStorage: state.selectedStorage,
        plansForCurrentVariant: state.plansForCurrentVariant,
        selectedPlan: state.selectedPlan,
        selectedPlanGroup: state.selectedPlanGroup,
        monthlyTerms: state.monthlyTerms,
        selectedMonthTerm: state.selectedMonthlyTerm,
        totalStockAvailable: state.totalStockAvailable,
        selectColor: selectColor,
        selectStorage: selectStorage,
        selectPlan: selectPlan,
        selectPlanGroup: selectPlanGroup,
        selectMonthlyTerm: selectMonthlyTerm,
        planGroups: state.planGroups,
        scrollToSectionOnce: scrollToSectionOnce,
        selectPaymentTerm: selectPaymentTerm,
        setQuantity: setQuantity,
        selectedPaymentTerm: state.selectedPaymentTerm,
        quantity: state.quantity
    };
};

var _templateObject$1, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
styled__default["default"](web.Grid)(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n  padding: 0;\n"])));
var Title = styled__default["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  padding-right: 10px;\n"])));
var StyledLayout$1 = styled__default["default"](web.Layout.Stack)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  & div:empty {\n    margin-bottom: 0;\n  }\n"])));
var StyledRef = web.withTheme(styled__default["default"].div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
  var coreTheme = _ref.coreTheme;
  return styled.css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    @media (max-width: ", ") {\n      position: absolute;\n      left: 0;\n      right: 0;\n    }\n  "])), coreTheme.brk_xs);
}));
var StyledOrderSummaryPlaceHolder = styled__default["default"].div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  height: ", ";\n"])), function (props) {
  return "".concat(props.height, "px");
});
var InlineCenter = styled__default["default"].div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"])));

var Styles = {
    BannerWrapper: web.withTheme(styled__default["default"].div(templateObject_1$h || (templateObject_1$h = __makeTemplateObject(["\n    width: 100%;\n    border-radius: 8px;\n    background-color: ", ";\n    display: flex;\n  "], ["\n    width: 100%;\n    border-radius: 8px;\n    background-color: ", ";\n    display: flex;\n  "])), function (_a) {
        var coreTheme = _a.coreTheme;
        return coreTheme.cl_sec_l2;
    })),
    BannerMinWrapper: web.withTheme(styled__default["default"].div(templateObject_2$f || (templateObject_2$f = __makeTemplateObject(["\n    width: auto;\n    border-radius: 8px;\n    background-color: ", ";\n    display: flex;\n    margin: 10px 10px 20px 10px;\n  "], ["\n    width: auto;\n    border-radius: 8px;\n    background-color: ", ";\n    display: flex;\n    margin: 10px 10px 20px 10px;\n  "])), function (_a) {
        var coreTheme = _a.coreTheme;
        return coreTheme.cl_sec_l2;
    })),
    Inline: styled__default["default"](web.Layout.Inline)(templateObject_3$9 || (templateObject_3$9 = __makeTemplateObject(["\n    flex-wrap: nowrap;\n  "], ["\n    flex-wrap: nowrap;\n  "]))),
    CenterSpacing: styled__default["default"](web.Spacing)(templateObject_4$9 || (templateObject_4$9 = __makeTemplateObject(["\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n  "], ["\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n  "]))),
    CenterText: styled__default["default"](web.Text)(templateObject_5$6 || (templateObject_5$6 = __makeTemplateObject(["\n    text-align: center;\n  "], ["\n    text-align: center;\n  "]))),
    TextDivider: web.withTheme(styled__default["default"].div(templateObject_6$6 || (templateObject_6$6 = __makeTemplateObject(["\n    display: flex;\n\n    &:before,\n    &:after {\n      content: '';\n      flex: 1 1;\n      border-bottom: 1px solid ", ";\n      margin: auto;\n    }\n\n    &:before {\n      margin-right: 10px;\n    }\n\n    &:after {\n      margin-left: 10px;\n    }\n  "], ["\n    display: flex;\n\n    &:before,\n    &:after {\n      content: '';\n      flex: 1 1;\n      border-bottom: 1px solid ", ";\n      margin: auto;\n    }\n\n    &:before {\n      margin-right: 10px;\n    }\n\n    &:after {\n      margin-left: 10px;\n    }\n  "])), function (_a) {
        var coreTheme = _a.coreTheme;
        return coreTheme.cl_divider;
    })),
    XSSpacing: web.withTheme(styled__default["default"](web.Spacing)(templateObject_8$6 || (templateObject_8$6 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
        var coreTheme = _a.coreTheme;
        return styled.css(templateObject_7$6 || (templateObject_7$6 = __makeTemplateObject(["\n      @media (max-width: ", ") {\n        padding-left: 0;\n        padding-right: 0;\n      }\n    "], ["\n      @media (max-width: ", ") {\n        padding-left: 0;\n        padding-right: 0;\n      }\n    "])), coreTheme.brk_xs);
    }))
};
var templateObject_1$h, templateObject_2$f, templateObject_3$9, templateObject_4$9, templateObject_5$6, templateObject_6$6, templateObject_7$6, templateObject_8$6;

var PromoModal = function (props) {
    var t = useTranslation().t;
    var showPromotion = props.showPromotion, setShowPromotion = props.setShowPromotion, promotions = props.promotions;
    var promotionsData = promotions.promotions;
    var renderPromos = function (promos, withDivider) {
        if (withDivider === void 0) { withDivider = false; }
        return (React__default["default"].createElement(React__default["default"].Fragment, null, promos.map(function (promo, promoIndex) {
            var isNotLastElement = promos.length !== promoIndex + 1;
            return (React__default["default"].createElement(React.Fragment, { key: "promo_item_" + promoIndex },
                React__default["default"].createElement(Styles.CenterSpacing, null,
                    React__default["default"].createElement(Styles.BannerMinWrapper, null,
                        React__default["default"].createElement(web.Spacing, { leftRight: 4, topBottom: 1 },
                            React__default["default"].createElement(Styles.Inline, null,
                                React__default["default"].createElement(Styles.CenterText, { type: "boldBody" }, promo.title)))),
                    React__default["default"].createElement(Styles.CenterText, { type: "boldBody" }, promo.subtitle),
                    React__default["default"].createElement(Styles.CenterText, { type: "smallBody" }, promo.description)),
                withDivider && isNotLastElement ? (React__default["default"].createElement(web.Spacing, { leftRight: 2, topBottom: 2 },
                    React__default["default"].createElement(Styles.TextDivider, null, t('EQUIPMENT_DETAILS_OR')))) : null));
        })));
    };
    var renderModalContent = function () {
        return (React__default["default"].createElement(React__default["default"].Fragment, null,
            React__default["default"].createElement(web.Grid, null,
                React__default["default"].createElement(Styles.XSSpacing, { top: 2, leftRight: 3 },
                    React__default["default"].createElement(Styles.CenterText, { type: "header", tag: "header" }, promotions.secondaryTitle),
                    React__default["default"].createElement(Styles.CenterText, { type: "smallBody" }, promotions.secondaryDescription),
                    React__default["default"].createElement(web.Spacing, { topBottom: 2 },
                        React__default["default"].createElement(web.Divider, null)),
                    promotionsData.map(function (promotions, index) {
                        var isNotLastElement = promotionsData.length !== index + 1;
                        if (promotions.type === PromoType.TYPE_ONE) {
                            return (React__default["default"].createElement(React.Fragment, { key: "promoGroup_" + promotions.type + "_" + index },
                                renderPromos(promotions.promos),
                                isNotLastElement && (React__default["default"].createElement(Styles.CenterSpacing, { topBottom: 2 },
                                    React__default["default"].createElement(AddGeneric_1, { size: 26 })))));
                        }
                        return (React__default["default"].createElement(React.Fragment, { key: "promoGroup_" + promotions.type + "_" + index },
                            React__default["default"].createElement(web.Card, { shadow: "sm", radius: "sm", padding: "sm" },
                                React__default["default"].createElement(web.Card.Content, null, renderPromos(promotions.promos, true))),
                            isNotLastElement && (React__default["default"].createElement(Styles.CenterSpacing, { top: 2, bottom: 1 },
                                React__default["default"].createElement(AddGeneric_1, { size: 26 })))));
                    })))));
    };
    return (React__default["default"].createElement(web.Modal, { visible: showPromotion, title: '', onClose: function () { return setShowPromotion(false); }, bgColor: "white", wide: true, scrollable: true },
        React__default["default"].createElement(web.Modal.Content, null, renderModalContent())));
};

var PromotionalBanner = React.memo(function (props) {
    var _a = React.useState(false), showPromotion = _a[0], setShowPromotion = _a[1];
    var title = props.title, linkText = props.linkText, promotions = props.promotions;
    var renderPromotionBanner = function () {
        var showPromotionModal = function () {
            setShowPromotion(true);
        };
        return (React__default["default"].createElement(React__default["default"].Fragment, null,
            React__default["default"].createElement(Styles.BannerWrapper, null,
                React__default["default"].createElement(web.Notification, __assign({ type: "promo", title: title, icon: React__default["default"].createElement(Discount_1, null) }, (linkText
                    ? {
                        action: {
                            type: 'link',
                            text: linkText,
                            onClick: showPromotionModal
                        }
                    }
                    : {})))),
            promotions && (React__default["default"].createElement(PromoModal, { showPromotion: showPromotion, setShowPromotion: setShowPromotion, promotions: promotions }))));
    };
    return renderPromotionBanner();
});

var _path;

function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

function SvgTick(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1({
    width: 15,
    height: 11,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React__namespace.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.824 10.01l8.588-8.587A.834.834 0 0013.233.244l-8.02 8.02-3.79-3.79a.834.834 0 00-1.179 1.18l4.38 4.379a.835.835 0 001.2-.022z",
    fill: "#0CAA8F"
  })));
}

var SelectorWrapper = web.withTheme(styled__default["default"](web.Spacing)(templateObject_2$e || (templateObject_2$e = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var coreTheme = _a.coreTheme;
    return styled.css(templateObject_1$g || (templateObject_1$g = __makeTemplateObject(["\n    position: relative;\n    padding-bottom: 16px;\n    & * div[data-testid='plan-item'] {\n      display: block;\n    }\n    @media (max-width: ", ") {\n      padding-top: 12px;\n      padding-bottom: 12px;\n    }\n  "], ["\n    position: relative;\n    padding-bottom: 16px;\n    & * div[data-testid='plan-item'] {\n      display: block;\n    }\n    @media (max-width: ", ") {\n      padding-top: 12px;\n      padding-bottom: 12px;\n    }\n  "])), coreTheme.brk_sm);
}));
styled__default["default"].div(templateObject_3$8 || (templateObject_3$8 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(255, 255, 255, 0.3);\n  z-index: 10;\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(255, 255, 255, 0.3);\n  z-index: 10;\n"])));
var Inline = styled__default["default"](web.Layout.Inline)(templateObject_4$8 || (templateObject_4$8 = __makeTemplateObject(["\n  flex-wrap: nowrap;\n"], ["\n  flex-wrap: nowrap;\n"])));
var StyledTick = web.withTheme(styled__default["default"](SvgTick)(templateObject_6$5 || (templateObject_6$5 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var coreTheme = _a.coreTheme;
    return styled.css(templateObject_5$5 || (templateObject_5$5 = __makeTemplateObject(["\n    width: 16px;\n    height: 12px;\n    margin-top: 8px;\n    @media (max-width: ", ") {\n      margin-top: 8px;\n      width: 15px;\n      height: 11px;\n    }\n    @media (max-width: ", ") {\n      margin-top: 6px;\n      width: 14px;\n      height: 10px;\n    }\n  "], ["\n    width: 16px;\n    height: 12px;\n    margin-top: 8px;\n    @media (max-width: ", ") {\n      margin-top: 8px;\n      width: 15px;\n      height: 11px;\n    }\n    @media (max-width: ", ") {\n      margin-top: 6px;\n      width: 14px;\n      height: 10px;\n    }\n  "])), coreTheme.brk_md, coreTheme.brk_xs);
}));
var StyledImg = web.withTheme(styled__default["default"].img(templateObject_8$5 || (templateObject_8$5 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var coreTheme = _a.coreTheme;
    return styled.css(templateObject_7$5 || (templateObject_7$5 = __makeTemplateObject(["\n    width: 80px;\n    height: 80px;\n    @media (max-width: ", ") {\n      margin-left: 16px;\n    }\n  "], ["\n    width: 80px;\n    height: 80px;\n    @media (max-width: ", ") {\n      margin-left: 16px;\n    }\n  "])), coreTheme.brk_sm);
}));
var StyledImgPlus = web.withTheme(styled__default["default"].img(templateObject_10$4 || (templateObject_10$4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var coreTheme = _a.coreTheme;
    return styled.css(templateObject_9$4 || (templateObject_9$4 = __makeTemplateObject(["\n    width: 60%;\n    margin: 0;\n    @media (max-width: ", ") {\n      width: 50%;\n    }\n  "], ["\n    width: 60%;\n    margin: 0;\n    @media (max-width: ", ") {\n      width: 50%;\n    }\n  "])), coreTheme.brk_sm);
}));
var StyledText = web.withTheme(styled__default["default"](web.Text)(templateObject_12$1 || (templateObject_12$1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var coreTheme = _a.coreTheme;
    return styled.css(templateObject_11$2 || (templateObject_11$2 = __makeTemplateObject(["\n    text-align: start;\n    margin-left: 12px;\n    @media (max-width: ", ") {\n      margin: 0px;\n      text-align: center;\n      margin-left: -8px;\n    }\n  "], ["\n    text-align: start;\n    margin-left: 12px;\n    @media (max-width: ", ") {\n      margin: 0px;\n      text-align: center;\n      margin-left: -8px;\n    }\n  "])), coreTheme.brk_sm);
}));
var StyledColumn$3 = web.withTheme(styled__default["default"](web.Column)(templateObject_14$1 || (templateObject_14$1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var coreTheme = _a.coreTheme;
    return styled.css(templateObject_13$1 || (templateObject_13$1 = __makeTemplateObject(["\n    margin-right: 20px;\n    @media (max-width: ", ") {\n      margin-top: 25px;\n      margin-right: 0px;\n      margin-left: 30px;\n    }\n  "], ["\n    margin-right: 20px;\n    @media (max-width: ", ") {\n      margin-top: 25px;\n      margin-right: 0px;\n      margin-left: 30px;\n    }\n  "])), coreTheme.brk_sm);
}));
var StyledRow$1 = web.withTheme(styled__default["default"](web.Row)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var coreTheme = _a.coreTheme;
    return styled.css(templateObject_15$1 || (templateObject_15$1 = __makeTemplateObject(["\n    @media (max-width: ", ") {\n      margin-left: -16px;\n    }\n  "], ["\n    @media (max-width: ", ") {\n      margin-left: -16px;\n    }\n  "])), coreTheme.brk_xs);
}));
var StyledCarouselCardWrapper = web.withTheme(styled__default["default"].div(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var coreTheme = _a.coreTheme, props = __rest(_a, ["coreTheme"]);
    return styled.css(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    height: 97%;\n\n    > div {\n      display: flex;\n      flex-direction: column;\n\n      > div:nth-child(1) {\n        height: 100%;\n        display: flex;\n        flex-direction: column;\n      }\n    }\n\n    width: ", ";\n    margin-top: 10px;\n    margin-left: 1%;\n    margin-right: ", ";\n\n    @media (max-width: ", ") {\n      margin-top: 2px;\n    }\n  "], ["\n    height: 97%;\n\n    > div {\n      display: flex;\n      flex-direction: column;\n\n      > div:nth-child(1) {\n        height: 100%;\n        display: flex;\n        flex-direction: column;\n      }\n    }\n\n    width: ", ";\n    margin-top: 10px;\n    margin-left: 1%;\n    margin-right: ", ";\n\n    @media (max-width: ", ") {\n      margin-top: 2px;\n    }\n  "])), props.width + "px", "calc(" + props.width + "px * 0.055)", coreTheme.brk_xs);
}));
var StyledCardContent = web.withTheme(styled__default["default"].div(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var coreTheme = _a.coreTheme;
    return styled.css(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n    padding: 32px;\n    @media (max-width: ", ") {\n      padding: 16px;\n    }\n  "], ["\n    padding: 32px;\n    @media (max-width: ", ") {\n      padding: 16px;\n    }\n  "])), coreTheme.brk_xs);
}));
var StyledPlanDescriptionWrapper = styled__default["default"].div(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n  flex: 1;\n"], ["\n  flex: 1;\n"])));
var StyledProductPriceWrapper = styled__default["default"].div(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n  float: right;\n"], ["\n  float: right;\n"])));
var SelectorButtonWrapper = web.withTheme(styled__default["default"].div(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n  & button {\n    &:hover {\n      ", "\n    }\n  }\n"], ["\n  & button {\n    &:hover {\n      ", "\n    }\n  }\n"])), function (_a) {
    var status = _a.status, coreTheme = _a.coreTheme;
    return status === 'success' && styled.css(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n          background-color: ", " !important;\n        "], ["\n          background-color: ", " !important;\n        "])), coreTheme.cl_successGreen);
}));
var templateObject_1$g, templateObject_2$e, templateObject_3$8, templateObject_4$8, templateObject_5$5, templateObject_6$5, templateObject_7$5, templateObject_8$5, templateObject_9$4, templateObject_10$4, templateObject_11$2, templateObject_12$1, templateObject_13$1, templateObject_14$1, templateObject_15$1, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24;

var img$2 = "data:image/png;base64,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";

var img$1 = "data:image/png;base64,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";

var img = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAASABIAAD/4QBARXhpZgAATU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAANKADAAQAAAABAAAANAAAAAD/7QA4UGhvdG9zaG9wIDMuMAA4QklNBAQAAAAAAAA4QklNBCUAAAAAABDUHYzZjwCyBOmACZjs+EJ+/8AAEQgANAA0AwERAAIRAQMRAf/EAB8AAAEFAQEBAQEBAAAAAAAAAAABAgMEBQYHCAkKC//EALUQAAIBAwMCBAMFBQQEAAABfQECAwAEEQUSITFBBhNRYQcicRQygZGhCCNCscEVUtHwJDNicoIJChYXGBkaJSYnKCkqNDU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6g4SFhoeIiYqSk5SVlpeYmZqio6Slpqeoqaqys7S1tre4ubrCw8TFxsfIycrS09TV1tfY2drh4uPk5ebn6Onq8fLz9PX29/j5+v/EAB8BAAMBAQEBAQEBAQEAAAAAAAABAgMEBQYHCAkKC//EALURAAIBAgQEAwQHBQQEAAECdwABAgMRBAUhMQYSQVEHYXETIjKBCBRCkaGxwQkjM1LwFWJy0QoWJDThJfEXGBkaJicoKSo1Njc4OTpDREVGR0hJSlNUVVZXWFlaY2RlZmdoaWpzdHV2d3h5eoKDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uLj5OXm5+jp6vLz9PX29/j5+v/bAEMAAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAf/bAEMBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAf/dAAQAB//aAAwDAQACEQMRAD8A/v4oAKACgD+D/wD4Mlfij8SPiL/w9J/4T7x54u8Z+d4u/ZW8fS/8JP4g1PW9/jb4g/8ADTn/AAnPitv7RubjPiDxd/wjPh7/AISLVf8Aj81f+xNL+3SzfYrfYAf3gUAFABQB/9D+/igAoAKAP4A/+DGL/nKL/wB2Tf8Av3FAH9/lABQAUAf/0f7+KACgAoA/gD/4MYv+cov/AHZN/wC/cUAf3+UAFABQB//S7j4o/wDBkr/wsX4kePPH3/D0nxdN/wAJn4u8QeJ/N8ffsrf8LB8bP/bep3Oo7vFfjn/hprw1/wAJd4g/0j/ia+Iv+Ee0T+17zzb3+y7Lzfs8QBwf/EDF/wBZRf8AzSf/APK1oAP+IGL/AKyi/wDmk/8A+VrQB+AP/BDH/ghj/wAPo/8AhqL/AIyi/wCGbP8Ahmz/AIUl/wA0T/4XF/wmn/C4v+Fuf9Vb+Fv/AAjv/COf8Ks/6jv9r/27/wAwz+y/+JgAfv8Af8QMX/WUX/zSf/8AK1oAP+IGL/rKL/5pP/8Ala0Afod+yr/wakf8M3fDfUPAP/D1X9si2+3eLtT8T+V8A4f+GfPBI/tDTNF07dc+Bv8AhPPiZ9q8QH+yP9O8Rf8ACQwfb7P+zrL+y7b+zPtF2Af/0/7+KACgAoA/gD/4MYv+cov/AHZN/wC/cUAf3+UAFABQB//U/v4oAKACgD+AP/gxi/5yi/8Adk3/AL9xQB/f5QAUAFAH/9X+/igAoAKAP5Ef+DUj9lT4b/s3f8PVf+EB1DxdffZv2yIfgHF/wk+p6ZqP/FE/s+f8J5/wg1y39naJpGfEF1/ws3xD/wAJFff8ed/5Ol/YdP037NcfawD+u6gAoAKAP//Z";

var extractStrings = function (children) {
    var extractedStrings = '';
    React__default["default"].Children.forEach(children, function (child) {
        if (typeof child === 'string' || typeof child === 'number') {
            extractedStrings += child;
        }
        else if (React__default["default"].isValidElement(child)) {
            var nestedString = extractStrings(child.props.children);
            if (nestedString || nestedString === '') {
                extractedStrings += nestedString;
            }
        }
    });
    return extractedStrings;
};
var H1 = function (props) { return React__default["default"].createElement(web.Text, __assign({}, props, { type: "bannerTitle" })); };
var H2 = function (props) { return React__default["default"].createElement(web.Text, __assign({}, props, { type: "pageTitle" })); };
var H3 = function (props) { return React__default["default"].createElement(web.Text, __assign({}, props, { type: "sectionTitle" })); };
var H4 = function (props) { return React__default["default"].createElement(web.Text, __assign({}, props, { type: "header" })); };
var H5 = function (props) { return React__default["default"].createElement(web.Text, __assign({}, props, { type: "boldBody" })); };
var BoldBody = function (props) {
    return React__default["default"].createElement(web.Text, __assign({}, props, { type: "boldBody", tag: "span" }));
};
var BodySecondary = function (props) { return (React__default["default"].createElement(web.Text, __assign({}, props, { tag: "div", type: "body" }))); };
var Link = function (props) {
    var _a = props || {}, children = _a.children, restProps = __rest(_a, ["children"]);
    var linkText = extractStrings(children);
    return (React__default["default"].createElement(web.Text, __assign({ type: "link", style: { whiteSpace: 'pre-wrap' } }, restProps), linkText));
};
var BulletList = function (_a) {
    var children = _a.children;
    return (React__default["default"].createElement(React__default["default"].Fragment, null, React.Children.map(children, function (child, index) {
        if (React.isValidElement(child)) {
            return (React__default["default"].createElement(web.BulletList, __assign({}, child.props, { key: index }), child.props.children));
        }
        return null;
    })));
};
var dlsComponentMapper = {
    h1: H1,
    h2: H2,
    h3: H3,
    h4: H4,
    h5: H5,
    p: BodySecondary,
    a: Link,
    ul: BulletList,
    b: BoldBody
};

var ComesWithBox = web.withTheme(styled__default["default"].div(templateObject_2$d || (templateObject_2$d = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var _b, _c;
    var coreTheme = _a.coreTheme;
    return styled.css(templateObject_1$f || (templateObject_1$f = __makeTemplateObject(["\n    background: ", ";\n    box-sizing: border-box;\n    padding: 16px;\n    border-radius: 8px;\n    @media (max-width: ", ") {\n      border-radius: 4px;\n      padding: 8px;\n    }\n  "], ["\n    background: ", ";\n    box-sizing: border-box;\n    padding: 16px;\n    border-radius: 8px;\n    @media (max-width: ", ") {\n      border-radius: 4px;\n      padding: 8px;\n    }\n  "])), (_c = (_b = coreTheme.color) === null || _b === void 0 ? void 0 : _b.background) === null || _c === void 0 ? void 0 : _c.subtle, coreTheme.brk_xs);
}));
var StyledSpacing = styled__default["default"](web.Spacing)(templateObject_3$7 || (templateObject_3$7 = __makeTemplateObject(["\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n"], ["\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n"])));
var FlexRow = styled__default["default"].div(templateObject_4$7 || (templateObject_4$7 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  gap: 8px;\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 8px;\n"])));
var PriceContainer = styled__default["default"].div(templateObject_5$4 || (templateObject_5$4 = __makeTemplateObject(["\n  display: flex;\n  margin: 16px 0;\n  width: 100%;\n"], ["\n  display: flex;\n  margin: 16px 0;\n  width: 100%;\n"])));
var PriceSection = styled__default["default"].div(templateObject_6$4 || (templateObject_6$4 = __makeTemplateObject(["\n  flex: 1;\n"], ["\n  flex: 1;\n"])));
var PriceSectionWithBorder = styled__default["default"](PriceSection)(templateObject_7$4 || (templateObject_7$4 = __makeTemplateObject(["\n  padding-left: ", ";\n  border-left: 1px solid #ccc;\n"], ["\n  padding-left: ", ";\n  border-left: 1px solid #ccc;\n"])), function (_a) {
    var isMobile = _a.isMobile, isTablet = _a.isTablet;
    return isMobile || isTablet ? '8px' : '16px';
});
var StyledTag = styled__default["default"](web.Tag)(templateObject_8$4 || (templateObject_8$4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (props) {
    return props.bgColor &&
        "\n      background-color: " + props.bgColor + ";\n    ";
});
var renderTag = function (plan) {
    var tags = plan.tags;
    var tagType = function (text, tagBgColor) {
        return (React__default["default"].createElement(StyledTag, { type: "secondary", customStyle: {
                borderBottomLeftRadius: '8px',
                borderBottomRightRadius: '8px',
                borderTopLeftRadius: '8px',
                borderTopRightRadius: '8px',
                backgroundColor: 'color.text.neutral'
            }, bgColor: tagBgColor }, text));
    };
    if (plan.tagConfig) {
        var _a = plan.tagConfig, tagText = _a.tagText, tagBgColor = _a.tagBgColor;
        return tagType(tagText, tagBgColor);
    }
    if (plan.tag)
        return tagType(plan.tag);
    // keep as fallback
    switch (true) {
        case findTag(tags, PRODUCT_DETAILS.TAGS.FIVE_G): {
            return tagType('5G+');
        }
        case findTag(tags, PRODUCT_DETAILS.TAGS.FOUR_G): {
            return tagType('4G');
        }
        default: {
            return null;
        }
    }
};
var renderPlanDescription = function (smsAndTalkTimeLiner, descriptions, isCarousel) {
    if (isCarousel === void 0) { isCarousel = false; }
    return (React__default["default"].createElement(web.Spacing, { bottom: isCarousel ? 0.5 : 3 },
        smsAndTalkTimeLiner && (React__default["default"].createElement(React__default["default"].Fragment, null, isCarousel ? (React__default["default"].createElement(web.BulletList, { noSpace: true }, smsAndTalkTimeLiner)) : (React__default["default"].createElement(Inline, { key: smsAndTalkTimeLiner },
            React__default["default"].createElement(StyledTick, null),
            React__default["default"].createElement(web.Text, { type: "body" }, smsAndTalkTimeLiner))))),
        descriptions &&
            getDescriptions(descriptions).map(function (description, index) {
                return (React__default["default"].createElement(React__default["default"].Fragment, null, isCarousel ? (React__default["default"].createElement(web.BulletList, { key: index, noSpace: true }, description)) : (React__default["default"].createElement(Inline, { key: index },
                    React__default["default"].createElement(StyledTick, null),
                    React__default["default"].createElement(web.Text, { type: "body" }, description)))));
            })));
};
var renderPrices = function (priceType, sellingPrice, originalPrice, hasDiscount, isMobile, displayOriginalPrice) {
    if (displayOriginalPrice === void 0) { displayOriginalPrice = true; }
    if (hasDiscount) {
        return (React__default["default"].createElement(React__default["default"].Fragment, null,
            React__default["default"].createElement(web.Text, { type: "smallBody" }, trans(priceType)),
            React__default["default"].createElement(web.Text, { type: isMobile ? 'boldBody' : 'header' },
                sellingPrice,
                displayOriginalPrice && (React__default["default"].createElement(web.Text, { type: "smallBody", strikeThrough: true }, originalPrice)))));
    }
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement(web.Text, { type: "smallBody" }, trans(priceType)),
        React__default["default"].createElement(web.Text, { type: isMobile ? 'boldBody' : 'header' }, sellingPrice)));
};
var PlansCardCarousel = function (_a) {
    var plans = _a.plans, selectedPlan = _a.selectedPlan, onPlanSelected = _a.onPlanSelected, planGroups = _a.planGroups, displayFooterLiner = _a.displayFooterLiner;
    var isMobile = web.useDevice().isMobile;
    var plansRef = React.useRef(null);
    var _b = React.useState(0), width = _b[0], setWidth = _b[1];
    React.useEffect(function () {
        var _a;
        setWidth((_a = plansRef === null || plansRef === void 0 ? void 0 : plansRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth);
        var getwidth = function () {
            var _a;
            setWidth((_a = plansRef === null || plansRef === void 0 ? void 0 : plansRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth);
        };
        window.addEventListener('resize', getwidth);
        return function () { return window.removeEventListener('resize', getwidth); };
    }, []);
    var renderButton = function (plan) {
        return (React__default["default"].createElement(SelectorButtonWrapper, { status: plan.mecId === (selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.mecId) ? 'success' : 'default' },
            React__default["default"].createElement(web.Button, __assign({ "data-testid": 'plan-carousel-button', fullWidth: true, disabled: plan.disabled, text: plan.disabled ? trans('OUT_OF_STOCK') : trans('SELECT'), onClick: function () {
                    onPlanSelected(plan);
                } }, (plan.mecId === (selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.mecId) && {
                loading: 'success'
            })))));
    };
    var foundPlan = displayFooterLiner &&
        Array.isArray(planGroups) &&
        planGroups.find(function (p) { return (selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.groupName) === (p === null || p === void 0 ? void 0 : p.groupName) && p.footerLiner; });
    return (React__default["default"].createElement("div", { ref: plansRef, "data-testid": "plan-carousel-wrapper" },
        React__default["default"].createElement(web.Carousel, { infiniteLoop: false, outsideButtons: false, fullWidth: true, shouldHandlePointerMove: isMobile ? true : false }, plans === null || plans === void 0 ? void 0 : plans.filter(function (plan) { return plan.disabled !== true; }).map(function (plan, idx) {
            var _a, _b;
            return (React__default["default"].createElement(StyledCarouselCardWrapper, { key: idx, width: width * 0.95 },
                React__default["default"].createElement(web.Card, { shadow: "sm", radius: "sm", padding: "sm" },
                    React__default["default"].createElement(StyledCardContent, null,
                        plan.ribbon && (React__default["default"].createElement(web.Ribbon.Variant1, null, plan.ribbon)),
                        React__default["default"].createElement(web.Spacing, { topBottom: 1 },
                            React__default["default"].createElement(web.Layout.Inline, null,
                                React__default["default"].createElement(web.Text, { type: "sectionTitle" }, (_a = plan.data) === null || _a === void 0 ? void 0 :
                                    _a.quantity,
                                    " ", (_b = plan.data) === null || _b === void 0 ? void 0 :
                                    _b.unit),
                                React__default["default"].createElement(web.Spacing, { top: isMobile ? 0.7 : 0.1 }, renderTag(plan)))),
                        React__default["default"].createElement(web.Spacing, { bottom: 1 },
                            React__default["default"].createElement(web.Text, { type: "body" }, plan.planName)),
                        React__default["default"].createElement(StyledPlanDescriptionWrapper, null, renderPlanDescription(plan.smsAndTalkTimeLiner, plan.planDescSubLiner, true)),
                        React__default["default"].createElement(web.Divider, null),
                        React__default["default"].createElement(web.Spacing, { top: 3, bottom: plan.sellingPrice ? 0 : 2 },
                            React__default["default"].createElement(web.Row, { noGutter: true },
                                React__default["default"].createElement(web.Column, { xs: plan.sellingPrice ? 8 : 6, sm: 9, noGutter: true },
                                    renderPrices(plan.sellingPrice && trans('PLAN'), plan.sellingMonthlyCharges, plan.originalMonthlyCharges, plan.hasDiscountMonthlyCharges, isMobile),
                                    React__default["default"].createElement(web.Text, { type: "smallBody" }, plan.discountedLiner)),
                                plan.sellingPrice ? (React__default["default"].createElement(web.Column, { xs: 4, sm: 3, noGutter: true },
                                    React__default["default"].createElement(StyledProductPriceWrapper, null, renderPrices(trans('PRODUCT'), plan.sellingPrice, plan.originalPrice, plan.hasDiscount, isMobile)))) : (React__default["default"].createElement(web.Column, { xs: 6, sm: 3, noGutter: true }, renderButton(plan))))),
                        plan.sellingPrice && (React__default["default"].createElement(web.Spacing, { top: 2, bottom: 1.5 }, renderButton(plan)))))));
        })),
        foundPlan && (React__default["default"].createElement(web.Spacing, { top: 5, bottom: 1 }, React__default["default"].createElement(web.Notification, { type: "info", content: React__default["default"].createElement(web.Text, { type: "smallBody" },
                React__default["default"].createElement(helpers.DynamicComponent, { htmlString: foundPlan === null || foundPlan === void 0 ? void 0 : foundPlan.footerLiner, componentsToMap: __assign({}, dlsComponentMapper) })) })))));
};
var PlansCardSimlane = function (_a) {
    var _b, _c;
    var plans = _a.plans, selectedPlan = _a.selectedPlan, onPlanSelected = _a.onPlanSelected, planGroups = _a.planGroups, displayFooterLiner = _a.displayFooterLiner;
    var _d = web.useDevice(), isMobile = _d.isMobile, isTablet = _d.isTablet;
    var plansRef = React.useRef(null);
    var theme = web.useTheme().theme;
    var equipmentContext = React__default["default"].useContext(EquipmentContext);
    var isLoading = ((_b = equipmentContext.configs) === null || _b === void 0 ? void 0 : _b.isLoading) || false;
    var renderButton = function (plan) {
        var existingPlanSelection = plan.mecId === (selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.mecId);
        var btnState = isLoading
            ? { loading: 'inProgress' }
            : existingPlanSelection
                ? { loading: 'success' }
                : {};
        return (React__default["default"].createElement(web.Button, __assign({ "data-testid": 'plan-carousel-swimlane', fullWidth: true, disabled: plan.disabled, text: plan.disabled ? trans('OUT_OF_STOCK') : trans('SELECT'), onClick: function () {
                onPlanSelected(plan);
            } }, btnState)));
    };
    var foundPlan = displayFooterLiner &&
        Array.isArray(planGroups) &&
        planGroups.find(function (p) { return (selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.groupName) === (p === null || p === void 0 ? void 0 : p.groupName) && p.footerLiner; });
    var FeatureCard = function (props) {
        var _a, _b;
        var plan = props.plan;
        return (React__default["default"].createElement(web.Card, null,
            React__default["default"].createElement(web.Card.Content, null,
                plan.ribbon && React__default["default"].createElement(web.Ribbon.Variant1, null, plan.ribbon),
                React__default["default"].createElement(FlexRow, null,
                    React__default["default"].createElement(web.Text, { type: "header" }, plan.displayName || plan.planName),
                    renderTag(plan)),
                React__default["default"].createElement(PriceContainer, null,
                    React__default["default"].createElement(PriceSection, null,
                        renderPrices(trans('PLAN'), plan.sellingMonthlyCharges, plan.originalMonthlyCharges, plan.hasDiscountMonthlyCharges, isMobile, false),
                        React__default["default"].createElement(web.Text, { type: "smallBody", strikeThrough: true }, plan.originalMonthlyCharges),
                        React__default["default"].createElement(web.Text, { type: "smallBody", color: (_b = (_a = theme === null || theme === void 0 ? void 0 : theme.color) === null || _a === void 0 ? void 0 : _a.text) === null || _b === void 0 ? void 0 : _b.strikethrough }, plan.discountedLiner)),
                    React__default["default"].createElement(PriceSectionWithBorder, { isMobile: isMobile, isTablet: isTablet },
                        renderPrices(trans('PRODUCT'), plan.sellingPrice, plan.originalPrice, plan.hasDiscount, isMobile, false),
                        React__default["default"].createElement(web.Text, { type: "smallBody", strikeThrough: true }, plan.originalPrice))),
                React__default["default"].createElement(StyledSpacing, null,
                    React__default["default"].createElement(ComesWithBox, null, renderPlanDescription(plan.smsAndTalkTimeLiner, plan.planDescSubLiner, true))),
                React__default["default"].createElement(web.Spacing, { top: 1, bottom: 1.5 }, renderButton(plan)))));
    };
    var featureCards = plans === null || plans === void 0 ? void 0 : plans.map(function (plan, idx) { return (React__default["default"].createElement(StyledCarouselCardWrapper, { key: idx },
        React__default["default"].createElement(FeatureCard, { plan: plan, key: idx }))); });
    return (React__default["default"].createElement("div", { ref: plansRef },
        React__default["default"].createElement(web.Carousel, { type: "card", swimlaneChildrenConfig: { sm: 1, md: 1, lg: 1, xl: 1 } }, featureCards),
        foundPlan && (React__default["default"].createElement(React__default["default"].Fragment, null,
            React__default["default"].createElement(web.Spacing, { top: 2, bottom: 1 },
                React__default["default"].createElement(web.Notification, { horizontalPadding: "lg", content: React__default["default"].createElement(web.Spacing, { leftRight: 1 },
                        React__default["default"].createElement(Inline, null,
                            React__default["default"].createElement(web.Spacing, { top: "2px", right: '4px' },
                                React__default["default"].createElement(Simcard_1, { size: 26 })),
                            React__default["default"].createElement(web.Layout.Stack, null,
                                React__default["default"].createElement(web.Text, { type: "smallBody" },
                                    React__default["default"].createElement("span", { dangerouslySetInnerHTML: {
                                            __html: foundPlan === null || foundPlan === void 0 ? void 0 : foundPlan.footerLiner
                                        } }))))), type: 'info' })),
            ((_c = equipmentContext === null || equipmentContext === void 0 ? void 0 : equipmentContext.configs) === null || _c === void 0 ? void 0 : _c.isGroupPlanTncRequired) && (React__default["default"].createElement(web.TextLink, { onClick: function () {
                    var _a;
                    (_a = equipmentContext === null || equipmentContext === void 0 ? void 0 : equipmentContext.callbacks) === null || _a === void 0 ? void 0 : _a.onGroupPlansTncLinkClick();
                } }, trans('GROUP_PLANS_FOOTER_LINER_TNC')))))));
};
var PlanSelector = React.memo(function (props) {
    var isMobile = web.useDevice().isMobile;
    var planGroups = props.planGroups, _a = props.title, title = _a === void 0 ? trans('CHOOSE_YOUR_PLAN') : _a, plans = props.plans, selectedPlanGroup = props.selectedPlanGroup, monthlyTerms = props.monthlyTerms, _b = props.onSelectedPlanGroup, onSelectedPlanGroup = _b === void 0 ? function () { } : _b, _c = props.onPlanSelected, onPlanSelected = _c === void 0 ? function () { } : _c, _d = props.selectMonthTerm, selectMonthTerm = _d === void 0 ? function () { } : _d, selectedMonthTerm = props.selectedMonthTerm, selectedPlan = props.selectedPlan, _e = props.isCarousel, isCarousel = _e === void 0 ? false : _e, _f = props.showPlansInSwimlane, showPlansInSwimlane = _f === void 0 ? false : _f;
    var equipmentContext = React__default["default"].useContext(EquipmentContext);
    var getPlanCard = function () {
        if (isCarousel) {
            return (React__default["default"].createElement(PlansCardCarousel, { plans: plans, selectedPlan: selectedPlan, onPlanSelected: onPlanSelected, planGroups: planGroups, displayFooterLiner: true }));
        }
        else if (showPlansInSwimlane) {
            return (React__default["default"].createElement(PlansCardSimlane, { plans: plans, selectedPlan: selectedPlan, onPlanSelected: onPlanSelected, planGroups: planGroups, displayFooterLiner: true }));
        }
        else {
            return renderPlans();
        }
    };
    var renderContent = function () {
        if (monthlyTerms === null || monthlyTerms === void 0 ? void 0 : monthlyTerms.length) {
            return React__default["default"].createElement(web.Spacing, { top: 3 }, renderPlanWithMonthlyTerms());
        }
        return (React__default["default"].createElement(web.Spacing, { top: 3, bottom: 1 }, getPlanCard()));
    };
    var renderMonthlyTerms = function () {
        var options = monthlyTerms.map(function (monthlyTerm) {
            return {
                label: monthlyTerm + " " + trans('MONTHS'),
                value: monthlyTerm,
                id: monthlyTerm
            };
        });
        return (React__default["default"].createElement(React__default["default"].Fragment, null,
            React__default["default"].createElement(web.Text, { type: "header" }, trans('SINGTEL_PAY_LATER_ZERO_INSTEREST_INSTALMENT_PLAN')),
            React__default["default"].createElement(web.Spacing, { top: 2 },
                React__default["default"].createElement(web.Radio.InputGroup, { name: "", onChange: function (e, result) {
                        selectMonthTerm(result === null || result === void 0 ? void 0 : result.value);
                    }, options: options, value: selectedMonthTerm, groupDirection: "horizontal" })),
            React__default["default"].createElement(web.Spacing, { top: 3, bottom: 1 }, getPlanCard())));
    };
    var getSelectedGroupIndex = function () {
        var selectedTabIndex = planGroups.findIndex(function (group) { return group.groupName === (selectedPlanGroup === null || selectedPlanGroup === void 0 ? void 0 : selectedPlanGroup.groupName); }) || 0;
        if (selectedTabIndex >= 0) {
            return selectedTabIndex;
        }
        return 0;
    };
    var getTabs = function () {
        return planGroups.map(function (planGroup) {
            return {
                title: planGroup.groupDisplayName
            };
        });
    };
    var renderGroupPlanLiner = function (planGroups, plan) {
        var _a;
        var foundPlan = planGroups.find(function (p) { return (plan === null || plan === void 0 ? void 0 : plan.groupName) === (p === null || p === void 0 ? void 0 : p.groupName) && p.footerLiner; });
        if (foundPlan) {
            return (React__default["default"].createElement(React__default["default"].Fragment, null,
                React__default["default"].createElement(web.Spacing, { top: 2, bottom: 1 },
                    React__default["default"].createElement(web.Notification, { horizontalPadding: "lg", content: React__default["default"].createElement(web.Spacing, { leftRight: 1 },
                            React__default["default"].createElement(Inline, null,
                                React__default["default"].createElement(web.Spacing, { top: "2px", right: '4px' },
                                    React__default["default"].createElement(Simcard_1, { size: 26 })),
                                React__default["default"].createElement(web.Layout.Stack, null,
                                    React__default["default"].createElement(web.Text, { type: "smallBody" },
                                        React__default["default"].createElement("span", { dangerouslySetInnerHTML: {
                                                __html: foundPlan === null || foundPlan === void 0 ? void 0 : foundPlan.footerLiner
                                            } }))))), type: 'info' })),
                ((_a = equipmentContext === null || equipmentContext === void 0 ? void 0 : equipmentContext.configs) === null || _a === void 0 ? void 0 : _a.isGroupPlanTncRequired) && (React__default["default"].createElement(web.TextLink, { onClick: function () {
                        var _a;
                        (_a = equipmentContext === null || equipmentContext === void 0 ? void 0 : equipmentContext.callbacks) === null || _a === void 0 ? void 0 : _a.onGroupPlansTncLinkClick();
                    } }, trans('GROUP_PLANS_FOOTER_LINER_TNC')))));
        }
    };
    var renderPlans = function () {
        return plans.map(function (plan, idx) {
            var _a;
            return (React__default["default"].createElement(SelectorWrapper, { key: plan.mecId, topBottom: 2 },
                React__default["default"].createElement(web.Selector, { "data-testid": 'plan-item', disabled: plan.disabled, selected: plan.mecId === (selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.mecId), onClick: function () {
                        if (!plan.disabled) {
                            onPlanSelected(plan);
                        }
                    } },
                    React__default["default"].createElement(web.Spacing, { topBottom: 1, leftRight: 1 },
                        plan.ribbon && React__default["default"].createElement(web.Ribbon.Variant1, null, plan.ribbon),
                        React__default["default"].createElement(web.Text, { type: "body" }, plan.planName),
                        React__default["default"].createElement(web.Spacing, { topBottom: 1 },
                            React__default["default"].createElement(web.Layout.Inline, null,
                                React__default["default"].createElement(web.Text, { type: "sectionTitle" }, (_a = plan.data) === null || _a === void 0 ? void 0 :
                                    _a.quantity,
                                    " ",
                                    plan.data.unit),
                                React__default["default"].createElement(web.Spacing, { top: isMobile ? 0.7 : 0.1 }, renderTag(plan)))),
                        renderPlanDescription(plan.smsAndTalkTimeLiner, plan.planDescSubLiner),
                        React__default["default"].createElement(web.Divider, null),
                        React__default["default"].createElement(web.Spacing, { top: 3, right: 3 },
                            React__default["default"].createElement(web.Row, { noGutter: true },
                                React__default["default"].createElement(web.Column, { xs: 7, sm: 8, md: 8, noGutter: true },
                                    renderPrices(trans('PLAN'), plan.sellingMonthlyCharges, plan.originalMonthlyCharges, plan.hasDiscountMonthlyCharges, isMobile),
                                    React__default["default"].createElement(web.Text, { type: "smallBody" }, plan.discountedLiner)),
                                React__default["default"].createElement(web.Column, { xs: 5, sm: 4, md: 4, noGutter: true }, renderPrices(trans('PRODUCT'), plan.sellingPrice, plan.originalPrice, plan.hasDiscount, isMobile)))))),
                idx === plans.length - 1 && renderGroupPlanLiner(planGroups, plan)));
        });
    };
    var renderPlanWithMonthlyTerms = function () {
        var _a;
        var upsellRibbon = (selectedPlan || {}).upsellRibbon;
        return (React__default["default"].createElement(React__default["default"].Fragment, null,
            React__default["default"].createElement(web.Row, { center: "sm" },
                React__default["default"].createElement(web.Column, null,
                    React__default["default"].createElement(web.Row, { middle: "sm" },
                        React__default["default"].createElement(StyledImg, { src: img$2, alt: "Image of Sim Only" }),
                        React__default["default"].createElement(web.Column, { sm: 12, lg: true },
                            React__default["default"].createElement(StyledText, null, trans('SIM_ONLY_PLUS_PLAN'))))),
                React__default["default"].createElement(web.Row, { middle: "md" },
                    React__default["default"].createElement(StyledColumn$3, null,
                        React__default["default"].createElement(StyledImgPlus, { src: img, alt: "Image of Plus icon" }))),
                React__default["default"].createElement(web.Column, null,
                    React__default["default"].createElement(StyledRow$1, { middle: "sm" },
                        React__default["default"].createElement(StyledImg, { src: img$1, alt: "Image of Pay Later Icon" }),
                        React__default["default"].createElement(web.Column, { sm: 12, lg: true },
                            upsellRibbon && (React__default["default"].createElement(web.Ribbon.Variant1, null, upsellRibbon)),
                            React__default["default"].createElement(StyledText, null, trans('DEVICE_INSTALLMENT_PLAN')))))),
            React__default["default"].createElement(web.Text, null,
                trans('SIM_ONLY_PLUS_UPSELL_DESCRIPTION'),
                React__default["default"].createElement(web.Text, { type: "link", href: (_a = equipmentContext === null || equipmentContext === void 0 ? void 0 : equipmentContext.configs) === null || _a === void 0 ? void 0 : _a.simOnlyTncUrl, target: "_blank" }, trans('TERMS_CONDITIONS'))),
            React__default["default"].createElement(web.Spacing, { top: 6 }, renderMonthlyTerms())));
    };
    var renderTabs = function () {
        var tabs = getTabs();
        if ((tabs === null || tabs === void 0 ? void 0 : tabs.length) <= 1)
            return;
        return (React__default["default"].createElement(web.Spacing, { top: 4, responsive: false },
            React__default["default"].createElement(web.Tabs, { selected: getSelectedGroupIndex(), onTabItemClick: function (e, index) {
                    onSelectedPlanGroup(planGroups[index]);
                }, tabs: getTabs() })));
    };
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        title && React__default["default"].createElement(web.Text, { type: "header" }, title),
        renderTabs(),
        renderContent()));
});
var templateObject_1$f, templateObject_2$d, templateObject_3$7, templateObject_4$7, templateObject_5$4, templateObject_6$4, templateObject_7$4, templateObject_8$4;

var FreeGifts = React.memo(function (props) {
    var t = useTranslation().t;
    var freeGiftsList = props.freeGiftsList;
    var _a = React.useState(true), giftsOpen = _a[0], setGiftsOpen = _a[1];
    var setGiftsState = function () { return setGiftsOpen(!giftsOpen); };
    return (React__default["default"].createElement(web.Accordion, { selected: giftsOpen, onClick: setGiftsState, title: React__default["default"].createElement(React__default["default"].Fragment, null,
            React__default["default"].createElement(web.Layout.Inline, { alignY: "center" },
                React__default["default"].createElement(web.Text, { type: "boldBody" },
                    t('EQUIPMENT_DETAILS_FREE_GIFTS'),
                    " (", freeGiftsList === null || freeGiftsList === void 0 ? void 0 :
                    freeGiftsList.length,
                    ")"))), desc: React__default["default"].createElement(React__default["default"].Fragment, null, freeGiftsList === null || freeGiftsList === void 0 ? void 0 : freeGiftsList.map(function (_a, index) {
            var text = _a.text, available = _a.available;
            return available && (React__default["default"].createElement(web.BulletList, { key: "free_gift_" + index }, text));
        })), dividerNeeded: false }));
});

var WrapperColumn = styled__default["default"](web.Spacing)(templateObject_1$e || (templateObject_1$e = __makeTemplateObject(["\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  display: flex;\n"], ["\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  display: flex;\n"])));
var StyledButton = web.withTheme(styled__default["default"].div(templateObject_3$6 || (templateObject_3$6 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var coreTheme = _a.coreTheme;
    return styled.css(templateObject_2$c || (templateObject_2$c = __makeTemplateObject(["\n    @media (max-width: ", ") {\n      & > button {\n        min-width: 90px !important;\n      }\n    }\n  "], ["\n    @media (max-width: ", ") {\n      & > button {\n        min-width: 90px !important;\n      }\n    }\n  "])), coreTheme.brk_xs);
}));
var StyledSticky = styled__default["default"](Sticky)(templateObject_4$6 || (templateObject_4$6 = __makeTemplateObject(["\n  position: relative;\n  z-index: 9;\n"], ["\n  position: relative;\n  z-index: 9;\n"])));
var Wrapper$1 = web.withTheme(styled__default["default"](web.Spacing)(templateObject_5$3 || (templateObject_5$3 = __makeTemplateObject(["\n  background-color: #fff;\n  z-index: 9999;\n  border: 0;\n  border-top: 1px solid ", ";\n  box-shadow: ", ";\n"], ["\n  background-color: #fff;\n  z-index: 9999;\n  border: 0;\n  border-top: 1px solid ", ";\n  box-shadow: ", ";\n"])), function (_a) {
    var coreTheme = _a.coreTheme;
    return coreTheme.cl_ter_l5;
}, function (props) {
    return props.hasShadow ? '0px 8px 16px -16px rgba(0, 0, 0, 0.7)' : null;
}));
var DisclaimerMobile = web.withTheme(styled__default["default"](web.Spacing)(templateObject_7$3 || (templateObject_7$3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var coreTheme = _a.coreTheme;
    return styled.css(templateObject_6$3 || (templateObject_6$3 = __makeTemplateObject(["\n    display: none;\n    text-align: ", ";\n    width: 100%;\n    @media (max-width: ", ") {\n      display: block;\n    }\n  "], ["\n    display: none;\n    text-align: ", ";\n    width: 100%;\n    @media (max-width: ", ") {\n      display: block;\n    }\n  "])), function (props) { return props.align || 'left'; }, coreTheme.brk_xs);
}));
var Disclaimer = web.withTheme(styled__default["default"](web.Spacing)(templateObject_9$3 || (templateObject_9$3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var coreTheme = _a.coreTheme;
    return styled.css(templateObject_8$3 || (templateObject_8$3 = __makeTemplateObject(["\n    display: block;\n    @media (max-width: ", ") {\n      display: none;\n    }\n  "], ["\n    display: block;\n    @media (max-width: ", ") {\n      display: none;\n    }\n  "])), coreTheme.brk_xs);
}));
styled__default["default"].div(templateObject_10$3 || (templateObject_10$3 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background-color: rgba(255, 255, 255, 0.8);\n"], ["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background-color: rgba(255, 255, 255, 0.8);\n"])));
var templateObject_1$e, templateObject_2$c, templateObject_3$6, templateObject_4$6, templateObject_5$3, templateObject_6$3, templateObject_7$3, templateObject_8$3, templateObject_9$3, templateObject_10$3;

var SummaryBar = React.memo(function (props) {
    var _a = props.prices, prices = _a === void 0 ? [] : _a, _b = props.onClick, onClick = _b === void 0 ? function () { } : _b, _c = props.disabled, disabled = _c === void 0 ? false : _c, proceedText = props.proceedText;
    var equipmentContext = React__default["default"].useContext(EquipmentContext);
    var configs = (equipmentContext || {}).configs;
    var _d = configs.miniCartPosition, miniCartPosition = _d === void 0 ? 'top' : _d;
    var disclaimerText = (React__default["default"].createElement(web.Text, { type: "smallBody" }, trans('DISCOUNT_DISCLAIMER')));
    var renderPrices = function () {
        if (!prices.length)
            return null;
        return prices.map(function (price, index) {
            return (React__default["default"].createElement(web.Spacing, { "data-testid": "price-item", key: price.label, right: index < prices.length - 1 ? 4 : 0 },
                React__default["default"].createElement(web.Text, { type: "smallBody" }, price.label),
                React__default["default"].createElement(web.Text, { type: "header" },
                    formatPrice(price.amount),
                    price.prefix)));
        });
    };
    return (React__default["default"].createElement(StyledSticky, { mode: miniCartPosition },
        React__default["default"].createElement(Wrapper$1, { hasShadow: miniCartPosition === 'top', topBottom: 1, responsive: false },
            React__default["default"].createElement(web.Grid, null,
                React__default["default"].createElement(WrapperColumn, { leftRight: 1 },
                    React__default["default"].createElement(web.Layout.Inline, null, renderPrices()),
                    React__default["default"].createElement(web.Layout.Inline, { alignY: "center", space: 3 },
                        React__default["default"].createElement(Disclaimer, null, disclaimerText),
                        React__default["default"].createElement(StyledButton, null,
                            React__default["default"].createElement(web.Button, { disabled: disabled, "data-testid": "action-button-next", onClick: onClick }, proceedText || trans('ACTION_BUTTON_NEXT')))),
                    React__default["default"].createElement(DisclaimerMobile, { align: prices.length ? 'left' : 'right', top: 1 }, disclaimerText))))));
});

var CardContentWrapper = styled__default["default"].div(templateObject_1$d || (templateObject_1$d = __makeTemplateObject(["\n  min-height: 160px;\n"], ["\n  min-height: 160px;\n"])));
var ImageWrapper$1 = styled__default["default"].div(templateObject_2$b || (templateObject_2$b = __makeTemplateObject(["\n  picture > img {\n    object-fit: contain;\n  }\n"], ["\n  picture > img {\n    object-fit: contain;\n  }\n"])));
var SpacingWrapper = web.withTheme(styled__default["default"](web.Spacing)(templateObject_4$5 || (templateObject_4$5 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var coreTheme = _a.coreTheme;
    return styled.css(templateObject_3$5 || (templateObject_3$5 = __makeTemplateObject(["\n    @media (max-width: ", ") {\n      padding-left: 16px;\n    }\n  "], ["\n    @media (max-width: ", ") {\n      padding-left: 16px;\n    }\n  "])), coreTheme.brk_xs);
}));
var ButtonWrapper$1 = web.withTheme(styled__default["default"](web.Spacing)(templateObject_6$2 || (templateObject_6$2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var coreTheme = _a.coreTheme;
    return styled.css(templateObject_5$2 || (templateObject_5$2 = __makeTemplateObject(["\n    @media (max-width: ", ") {\n      padding-bottom: 0px;\n    }\n  "], ["\n    @media (max-width: ", ") {\n      padding-bottom: 0px;\n    }\n  "])), coreTheme.brk_xs);
}));
var ListText = web.withTheme(styled__default["default"](web.Text)(templateObject_8$2 || (templateObject_8$2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var coreTheme = _a.coreTheme;
    return styled.css(templateObject_7$2 || (templateObject_7$2 = __makeTemplateObject(["\n  display: flex;\n  align-items: flex-start;\n  &::before {\n    content: ' ';\n    padding: 3px;\n    border-radius: 3px;\n    display: block;\n    background-color: ", ";\n    margin-right: 8px;\n    margin-top: 10px;\n  @media (min-width: ", ") {\n    margin-top: 12px;\n      padding: 4px;\n      border-radius: 4px;\n  }\n"], ["\n  display: flex;\n  align-items: flex-start;\n  &::before {\n    content: ' ';\n    padding: 3px;\n    border-radius: 3px;\n    display: block;\n    background-color: ", ";\n    margin-right: 8px;\n    margin-top: 10px;\n  @media (min-width: ", ") {\n    margin-top: 12px;\n      padding: 4px;\n      border-radius: 4px;\n  }\n"])), coreTheme.cl_ter_base, coreTheme.brk_md);
}));
var TwoLineText = styled__default["default"](web.Text)(templateObject_9$2 || (templateObject_9$2 = __makeTemplateObject(["\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n\n  // ellipsis for 2 line, most of modern browser support this, if not fallback to 1 line ellipsis.\n  @supports (-webkit-line-clamp: 2) {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: initial;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n  }\n"], ["\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n\n  // ellipsis for 2 line, most of modern browser support this, if not fallback to 1 line ellipsis.\n  @supports (-webkit-line-clamp: 2) {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: initial;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n  }\n"])));
styled__default["default"](web.Spacing)(templateObject_10$2 || (templateObject_10$2 = __makeTemplateObject(["\n  min-height: 25px;\n"], ["\n  min-height: 25px;\n"])));
var templateObject_1$d, templateObject_2$b, templateObject_3$5, templateObject_4$5, templateObject_5$2, templateObject_6$2, templateObject_7$2, templateObject_8$2, templateObject_9$2, templateObject_10$2;

var Price = function (_a) {
    var variant = _a.variant, _b = _a.priceType, priceType = _b === void 0 ? 'body' : _b, _c = _a.usualPriceType, usualPriceType = _c === void 0 ? 'smallBody' : _c;
    var usualPrice = variant === null || variant === void 0 ? void 0 : variant.usualPrice;
    var price = variant === null || variant === void 0 ? void 0 : variant.price;
    return (React__default["default"].createElement(web.Layout.Inline, { alignY: "center" },
        React__default["default"].createElement(web.Text, { type: priceType }, formatPrice(price)),
        usualPrice > price && (React__default["default"].createElement(StrikeThroughText, { type: usualPriceType }, formatPrice(usualPrice)))));
};

var AccessoryCard = React.memo(function (props) {
    var _a, _b, _c, _d, _e;
    var equipmentContext = React__default["default"].useContext(EquipmentContext);
    var isListLoading = props.isListLoading, accessory = props.accessory, onRemoveAccessory = props.onRemoveAccessory, showAccessoryDetails = props.showAccessoryDetails, _f = props.onSelectAccessory, onSelectAccessory = _f === void 0 ? function () { } : _f, _g = props.isLoading; _g === void 0 ? ((_a = equipmentContext === null || equipmentContext === void 0 ? void 0 : equipmentContext.configs) === null || _a === void 0 ? void 0 : _a.isLoading) ||
        ((_c = (_b = equipmentContext === null || equipmentContext === void 0 ? void 0 : equipmentContext.configs) === null || _b === void 0 ? void 0 : _b.moduleLoaders) === null || _c === void 0 ? void 0 : _c.accessory) : _g; var accessoryRibbon = props.accessoryRibbon;
    var selectedVariant = accessory.selectedVariant;
    var t = useTranslation().t;
    var isMobile = web.useDevice().isMobile;
    var renderButton = function (accessory) {
        var _a;
        if (isListLoading) {
            return (React__default["default"].createElement(web.Spacing, { leftRight: 1, responsive: false },
                React__default["default"].createElement(web.SkeletonLoader, { "data-testid": 'skeleton-accessory-card', preset: "ListItem", loading: true })));
        }
        var isSingleSkuAccessory = ((_a = accessory.variants) === null || _a === void 0 ? void 0 : _a.length) < 2;
        var buttonText = isSingleSkuAccessory ? t('ADD') : t('VIEW_MORE_OPTIONS');
        var onClick = function () {
            if (accessory.selected) {
                return onRemoveAccessory(accessory);
            }
            if (isSingleSkuAccessory) {
                onSelectAccessory(accessory.selectedVariant);
            }
            else {
                showAccessoryDetails(accessory);
            }
        };
        if (accessory.selected) {
            return (React__default["default"].createElement("div", { onClick: onClick },
                React__default["default"].createElement(web.Button, { "data-testid": "accessory-cta", loading: "success", fullWidth: true })));
        }
        return (React__default["default"].createElement(web.Button, { "data-testid": "accessory-cta", onClick: onClick, fullWidth: true, secondary: true }, buttonText));
    };
    return (React__default["default"].createElement(web.Spacing, { topBottom: 1, right: isMobile ? 0 : 1 },
        React__default["default"].createElement(web.Card, { "data-testid": "accessory-card", shadow: "sm", radius: "sm", padding: "sm" },
            React__default["default"].createElement(web.Spacing, { top: 2 },
                React__default["default"].createElement(ImageWrapper$1, null,
                    React__default["default"].createElement(web.Card.Image, { heidht: 128, src: {
                            url: (equipmentContext === null || equipmentContext === void 0 ? void 0 : equipmentContext.configs.baseUrl) +
                                ((_e = (_d = selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.images) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.src),
                            alt: accessory.title
                        }, ratio: '16:9' }))),
            React__default["default"].createElement(web.Card.Content, null,
                React__default["default"].createElement(CardContentWrapper, null,
                    React__default["default"].createElement(web.Ribbon.Variant1, null, accessoryRibbon(accessory)),
                    React__default["default"].createElement(TwoLineText, { type: "header" }, accessory.title),
                    React__default["default"].createElement(Price, { variant: selectedVariant })),
                React__default["default"].createElement(ButtonWrapper$1, { bottom: 1 }, renderButton(accessory))))));
});

var OutOfStockMessage = function (props) {
    var t = useTranslation().t;
    var onClick = props.onClick, testId = props.testId;
    return (React__default["default"].createElement(web.Text, { type: "smallBody" },
        t('OUT_OF_STOCK_MESSAGE_LINK'),
        React__default["default"].createElement(web.TextLink, { inline: true, onClick: onClick, "data-testid": testId }, t('OUT_OF_STOCK_MESSAGE_HERE')),
        t('OUT_OF_STOCK_MESSAGE_CHOOSE')));
};

var AccessoryModal = React.memo(function (props) {
    var _a, _b, _c;
    var _d = props.visible, visible = _d === void 0 ? false : _d, accessory = props.accessory, _e = props.onCloseModal, onCloseModal = _e === void 0 ? function () { } : _e, _f = props.onSelectAccessory, onSelectAccessory = _f === void 0 ? function () { } : _f, _g = props.isLoading, isLoading = _g === void 0 ? false : _g;
    var t = useTranslation().t;
    var isMobile = web.useDevice().isMobile;
    var _h = useOptions({
        variants: (_a = accessory === null || accessory === void 0 ? void 0 : accessory.variants) !== null && _a !== void 0 ? _a : [],
        preSelectionOptions: {
            color: (_b = accessory === null || accessory === void 0 ? void 0 : accessory.selectedVariant) === null || _b === void 0 ? void 0 : _b.colorCode,
            storage: (_c = accessory === null || accessory === void 0 ? void 0 : accessory.selectedVariant) === null || _c === void 0 ? void 0 : _c.memorySize
        }
    }), colorList = _h.colorList, selectedColor = _h.selectedColor, selectColor = _h.selectColor, selectedVariant = _h.selectedVariant, selectedStorage = _h.selectedStorage, selectStorage = _h.selectStorage, storageList = _h.storageList;
    React.useEffect(function () {
        setDescriptionExtended(false);
    }, [accessory]);
    var onSelectColor = React.useCallback(function (color) {
        selectColor({ selectedColor: color });
    }, [colorList, selectedStorage]);
    var _j = React.useState(false), descriptionExtended = _j[0], setDescriptionExtended = _j[1];
    if (!accessory || !visible)
        return null;
    var TextSubstring = function (_a) {
        var text = _a.text, maxLength = _a.maxLength;
        if (text.length > maxLength) {
            return React__default["default"].createElement(TwoLineText, { dangerouslySetInnerHTML: { __html: text } });
        }
        return React__default["default"].createElement(web.Text, { dangerouslySetInnerHTML: { __html: text } });
    };
    var renderDescItem = function (text, numberOfDesc, maxLength) {
        if (numberOfDesc === 1) {
            return descriptionExtended ? (React__default["default"].createElement(web.Text, { type: "body", dangerouslySetInnerHTML: { __html: text } })) : (React__default["default"].createElement(TextSubstring, { text: text, maxLength: maxLength }));
        }
        return descriptionExtended ? (React__default["default"].createElement(ListText, { type: "body" },
            React__default["default"].createElement(web.Text, { type: "body", dangerouslySetInnerHTML: { __html: text } }))) : (React__default["default"].createElement(ListText, null,
            React__default["default"].createElement(TextSubstring, { text: text, maxLength: maxLength })));
    };
    var renderDescription = function () {
        var _a;
        if (!(accessory === null || accessory === void 0 ? void 0 : accessory.description))
            return null;
        var formattedDescription = getDescriptions(accessory.description);
        var maxDescLength = isMobile
            ? PRODUCT_DETAILS.ACCESSORY.DESC_SHOW_MORE_MOBILE_THRESHOLD
            : PRODUCT_DETAILS.ACCESSORY.DESC_SHOW_MORE_THRESHOLD;
        var fistDescExceededLength = ((_a = formattedDescription[0]) === null || _a === void 0 ? void 0 : _a.length) > maxDescLength;
        var needShowMore = fistDescExceededLength || formattedDescription.length > 2;
        var shownDescriptions = descriptionExtended
            ? formattedDescription
            : formattedDescription.slice(0, fistDescExceededLength ? 1 : 2);
        return (React__default["default"].createElement(web.Spacing, { top: 2 },
            shownDescriptions.map(function (description, index) {
                return renderDescItem(description, formattedDescription.length, maxDescLength);
            }),
            needShowMore && (React__default["default"].createElement(web.Spacing, { top: 0.5 },
                React__default["default"].createElement(web.TextLink, { onClick: function () {
                        setDescriptionExtended(!descriptionExtended);
                    } }, descriptionExtended ? t('SHOW_LESS') : t('SHOW_MORE'))))));
    };
    var renderStorage = function () {
        if (!(storageList === null || storageList === void 0 ? void 0 : storageList.length))
            return null;
        return (React__default["default"].createElement(React__default["default"].Fragment, null,
            React__default["default"].createElement(web.Spacing, { top: 3 },
                React__default["default"].createElement(StorageSelector, { headerText: t('ACCESSORY_SIZE_HEADER_TEXT'), selectedStorage: selectedStorage, storages: storageList, onStorageChanged: selectStorage, isLoading: isLoading, selectedColor: selectedColor }))));
    };
    var renderOutOfStockNotification = function () {
        if (isProductHasStock(accessory.variants) || isLoading)
            return null;
        return (React__default["default"].createElement(web.Spacing, { bottom: 1 },
            React__default["default"].createElement(web.Notification, { type: "info", content: React__default["default"].createElement(OutOfStockMessage, { onClick: onCloseModal }) })));
    };
    var renderPrice = function () {
        return React__default["default"].createElement(Price, { variant: selectedVariant, priceType: "header" });
    };
    var renderButton = function () {
        var isOOS = !(selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.stockCount) || (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.stockCount) <= 0;
        return (React__default["default"].createElement(React__default["default"].Fragment, null, !isOOS && (React__default["default"].createElement(web.Spacing, { top: isMobile && 3 },
            React__default["default"].createElement(web.Button, { fullWidth: isMobile ? true : false, "data-testid": "accessory-modal-cta", onClick: function () {
                    onSelectAccessory(selectedVariant);
                } }, t('ADD'))))));
    };
    var renderFooter = function () {
        if (isLoading)
            return;
        return (React__default["default"].createElement(React__default["default"].Fragment, null,
            React__default["default"].createElement(web.Spacing, { top: isMobile ? 1 : 2, bottom: 3 },
                React__default["default"].createElement(web.Divider, null)),
            !isMobile ? (React__default["default"].createElement(web.Layout.Inline, { alignY: "center", align: "spaceBetween" },
                renderPrice(),
                renderButton())) : (React__default["default"].createElement(React__default["default"].Fragment, null,
                renderPrice(),
                " ",
                renderButton(),
                ' '))));
    };
    var renderModalContent = function () {
        var imageGallery = (selectedVariant.images || []).filter(function (image) {
            return Boolean(image.src);
        });
        return (React__default["default"].createElement(web.Row, null,
            React__default["default"].createElement(web.Column, { xs: 12, sm: 6, md: 5 },
                React__default["default"].createElement(EquipmentGallery, { isLoading: isLoading, imageHeight: 250, isInModal: true, imageGallery: imageGallery })),
            React__default["default"].createElement(web.Column, { xs: 12, sm: 6, md: 7 },
                React__default["default"].createElement(web.Row, null,
                    React__default["default"].createElement(web.Column, { md: 10, noGutter: true }, renderOutOfStockNotification())),
                React__default["default"].createElement("div", null,
                    React__default["default"].createElement(web.SkeletonLoader, { preset: "ListItem", loading: isLoading },
                        React__default["default"].createElement(web.Ribbon.Variant1, null, accessory.ribbon),
                        React__default["default"].createElement(web.Text, { type: "sectionTitle" }, accessory.title),
                        renderDescription())),
                React__default["default"].createElement(web.Spacing, { top: 2, bottom: 3 },
                    React__default["default"].createElement(web.Divider, null)),
                React__default["default"].createElement("div", null,
                    React__default["default"].createElement(DeviceColourPicker, { colours: colorList, onSelectColor: onSelectColor, selectedColor: selectedColor, isLoading: isLoading })),
                renderStorage(),
                renderFooter())));
    };
    return (React__default["default"].createElement(web.Modal, { "data-testid": "accessory-modal", visible: visible, title: '', onClose: onCloseModal, bgColor: "white", wide: true, scrollable: true },
        React__default["default"].createElement(web.Modal.Content, null, renderModalContent())));
});

var AccessoryList = React.memo(function (props) {
    var accessories = props.accessories, headerText = props.headerText, onSelectAccessory = props.onSelectAccessory, onRemoveAccessory = props.onRemoveAccessory, _a = props.onViewMore, onViewMore = _a === void 0 ? function () { } : _a, selectedAccessory = props.selectedAccessory, isListLoading = props.isListLoading, isModalLoading = props.isModalLoading, accessoryRibbon = props.accessoryRibbon, _b = props.pagination, pagination = _b === void 0 ? 4 : _b;
    var _c = React.useState({}), state = _c[0], _setState = _c[1];
    var setState = function (params) {
        _setState(__assign(__assign({}, state), params));
    };
    var showAccessoryDetails = React.useCallback(function (accessory) {
        onViewMore(accessory);
        setState({ isModalVisible: true });
    }, [accessories]);
    var selectAccessory = React.useCallback(function (variant) {
        onSelectAccessory(variant);
        setState({ isModalVisible: false });
    }, [accessories]);
    var onCloseModal = React.useCallback(function () {
        setState({ isModalVisible: false });
    }, [accessories]);
    var renderCarousel = function (accessories, isLoading) {
        return (React__default["default"].createElement(web.Carousel, { infiniteLoop: false, outsideButtons: true, shouldHandlePointerMove: false, onSlideIndexChanged: function () { }, pagination: pagination, type: "card" }, accessories === null || accessories === void 0 ? void 0 : accessories.map(function (accessory) {
            return (React__default["default"].createElement(AccessoryCard, { isListLoading: isListLoading, isLoading: isLoading, key: accessory.title, accessory: accessory, onSelectAccessory: selectAccessory, onRemoveAccessory: onRemoveAccessory, showAccessoryDetails: showAccessoryDetails, accessoryRibbon: accessoryRibbon }));
        })));
    };
    var renderAccessoryList = function () {
        return renderCarousel(accessories);
    };
    if (!isListLoading && !accessories.length) {
        return null;
    }
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement(web.Spacing, { id: PRODUCT_DETAILS.ELEMENT_IDS.ACCESSORIES_SESSION },
            React__default["default"].createElement(SpacingWrapper, { topBottom: 2, left: 8.5 },
                React__default["default"].createElement(web.Text, { type: "sectionTitle" }, headerText)),
            React__default["default"].createElement(web.Spacing, { left: 1 }, renderAccessoryList()),
            React__default["default"].createElement(AccessoryModal, { onSelectAccessory: selectAccessory, onCloseModal: onCloseModal, accessory: selectedAccessory, visible: state.isModalVisible, isLoading: isModalLoading }))));
});

var useAccessory = function (_a) {
    var accessories = _a.accessories, preselectAccessories = _a.preselectAccessories, checkStockFn = _a.checkStock;
    var _b = React.useState({
        accessories: [],
        isLoading: false,
        totalPrice: 0
    }), state = _b[0], _setState = _b[1];
    var equipmentContext = React__default["default"].useContext(EquipmentContext);
    var setState = function (params) {
        _setState(__assign(__assign({}, state), params));
    };
    React.useEffect(function () {
        var _a;
        if (accessories === null || accessories === void 0 ? void 0 : accessories.length) {
            var sortedAndFilteredAccessories = sortAndFilterItems(accessories, ((_a = equipmentContext === null || equipmentContext === void 0 ? void 0 : equipmentContext.configs) === null || _a === void 0 ? void 0 : _a.maxNumberOfAccessories) ||
                PRODUCT_DETAILS.MAX_NUMBER_OF_ACCESSORIES);
            if (preselectAccessories) {
                var preselectedAccessories = setPreselectAccessories(preselectAccessories, sortedAndFilteredAccessories);
                var totalPrice = calculateAccessoryPrice(preselectedAccessories);
                setState({
                    accessories: preselectedAccessories,
                    totalPrice: totalPrice
                });
            }
            else {
                setState({
                    accessories: sortedAndFilteredAccessories
                });
            }
        }
    }, [accessories]);
    var removeAccessory = React.useCallback(function (accessory) {
        updateAccessory(__assign(__assign({}, accessory), { selected: false }));
    }, [state.accessories]);
    var selectAccessory = React.useCallback(function (selectedVariant) {
        var selectedAccessory = state.accessories.find(function (accessory) { return accessory.deviceId === selectedVariant.deviceId; });
        if (!selectedAccessory)
            return;
        var newAccessory = __assign(__assign({}, selectedAccessory), { selectedVariant: selectedVariant, selected: true });
        updateAccessory(newAccessory);
    }, [state.accessories]);
    var updateAccessory = function (selectedAccessory, extraPrams) {
        var index = state.accessories.findIndex(function (accessory) { return accessory.deviceId === selectedAccessory.deviceId; });
        if (index < 0)
            return;
        state.accessories.splice(index, 1, __assign({}, selectedAccessory));
        var totalPrice = calculateAccessoryPrice(state.accessories);
        setState(__assign({ accessories: state.accessories, isLoading: false, selectedAccessory: selectedAccessory, totalPrice: totalPrice }, extraPrams));
    };
    var viewAccessory = React.useCallback(function (accessory) { return __awaiter(void 0, void 0, void 0, function () {
        var variants, checkStock, skus, stockAvailability_1, variantsWithStockCount, newAccessory;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    variants = accessory.variants;
                    if (((_a = variants[0]) === null || _a === void 0 ? void 0 : _a.stockCount) !== undefined) {
                        return [2 /*return*/, updateAccessory(accessory)];
                    }
                    checkStock = checkStockFn || ((_b = equipmentContext === null || equipmentContext === void 0 ? void 0 : equipmentContext.callbacks) === null || _b === void 0 ? void 0 : _b.checkStock);
                    if (!checkStock) return [3 /*break*/, 5];
                    updateAccessory(accessory, { isLoading: true });
                    skus = variants.map(function (variant) { return variant.deviceCode; });
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, checkStock(skus)];
                case 2:
                    stockAvailability_1 = _c.sent();
                    return [3 /*break*/, 4];
                case 3:
                    _c.sent();
                    stockAvailability_1 = [];
                    return [3 /*break*/, 4];
                case 4:
                    variantsWithStockCount = variants.map(function (variant) {
                        var _a;
                        var stockCount = (_a = stockAvailability_1 === null || stockAvailability_1 === void 0 ? void 0 : stockAvailability_1.find(function (stock) { return stock.itemCode === variant.deviceCode; })) === null || _a === void 0 ? void 0 : _a.availableQty;
                        return __assign(__assign({}, variant), { stockCount: stockCount });
                    });
                    newAccessory = __assign(__assign({}, accessory), { variants: variantsWithStockCount });
                    updateAccessory(newAccessory);
                    return [3 /*break*/, 6];
                case 5:
                    updateAccessory(accessory);
                    _c.label = 6;
                case 6: return [2 /*return*/];
            }
        });
    }); }, [state.accessories]);
    return {
        accessories: state.accessories,
        selectAccessory: selectAccessory,
        removeAccessory: removeAccessory,
        viewAccessory: viewAccessory,
        selectedAccessory: state.selectedAccessory,
        isLoading: state.isLoading,
        totalPrice: state.totalPrice
    };
};

var _rect, _rect2, _rect3, _rect4, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgPopStation(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends({
    width: 21,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React__namespace.createElement("rect", {
    x: 1,
    y: 1,
    width: 8.083,
    height: 8.083,
    rx: 1,
    fill: "#fff",
    stroke: "#222",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React__namespace.createElement("rect", {
    x: 1,
    y: 11.916,
    width: 8.083,
    height: 8.083,
    rx: 1,
    fill: "#fff",
    stroke: "#222",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React__namespace.createElement("rect", {
    x: 11.916,
    y: 1,
    width: 8.083,
    height: 8.083,
    rx: 1,
    fill: "#fff",
    stroke: "#222",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React__namespace.createElement("rect", {
    x: 11.916,
    y: 11.916,
    width: 8.083,
    height: 8.083,
    rx: 1,
    fill: "#fff",
    stroke: "#222",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React__namespace.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 1,
    fill: "#222"
  })));
}

var IconWrapper = styled__default["default"].div(templateObject_1$c || (templateObject_1$c = __makeTemplateObject(["\n  margin-top: 4px;\n  width: 40px;\n  min-width: 40px;\n"], ["\n  margin-top: 4px;\n  width: 40px;\n  min-width: 40px;\n"])));
var HighLightText = web.withTheme(styled__default["default"](web.Text)(templateObject_2$a || (templateObject_2$a = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
    var coreTheme = _a.coreTheme;
    return coreTheme.cl_pri_d2;
}));
var templateObject_1$c, templateObject_2$a;

var StyledDiv = styled__default["default"].div(templateObject_1$b || (templateObject_1$b = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: nowrap;\n  flex-direction: row;\n  justify-content: flex-start;\n  gap: 5px;\n"], ["\n  display: flex;\n  flex-wrap: nowrap;\n  flex-direction: row;\n  justify-content: flex-start;\n  gap: 5px;\n"])));
var StyledColumn$2 = styled__default["default"](web.Column)(templateObject_2$9 || (templateObject_2$9 = __makeTemplateObject(["\n  margin: 10px 0;\n"], ["\n  margin: 10px 0;\n"])));
var Fulfilment = React.memo(function (props) {
    var selectedVariant = props.selectedVariant, _a = props.deliveryOptions, deliveryOptions = _a === void 0 ? {} : _a;
    var _b = deliveryOptions, extraLiner = _b.extraLiner, _c = _b.fulfilmentList, fulfilmentList = _c === void 0 ? [] : _c, preOrderLiner = _b.preOrderLiner, backOrderLiner = _b.backOrderLiner;
    var t = useTranslation().t;
    var renderShippingLiner = function () {
        var shippingLiner = extraLiner;
        if (selectedVariant.isPreOrder) {
            shippingLiner = preOrderLiner;
        }
        if (selectedVariant.isBackOrder) {
            shippingLiner = backOrderLiner;
        }
        if (typeof shippingLiner !== 'string')
            return null;
        return (React__default["default"].createElement(web.Spacing, { bottom: 2 },
            React__default["default"].createElement(web.Notification, { horizontalPadding: "lg", content: React__default["default"].createElement(web.Text, { type: "smallBody" },
                    React__default["default"].createElement("span", { dangerouslySetInnerHTML: {
                            __html: shippingLiner
                        } })), type: 'info' })));
    };
    var renderCost = function (cost) {
        if (parseInt(cost) === 0) {
            return (React__default["default"].createElement(HighLightText, { type: "boldBody", tag: "span" }, t('FREE')));
        }
        return cost;
    };
    var getFulfilmentIconAndStatus = function (fulfilment, variant) {
        var isDoorStep = fulfilment.type === PRODUCT_DETAILS.FULFILMENT_TYPES.DOOR_STEP_DELIVERY;
        var isCollectAtStore = fulfilment.type === PRODUCT_DETAILS.FULFILMENT_TYPES.COLLECT_AT_STORE;
        var isPopStation = fulfilment.type === PRODUCT_DETAILS.FULFILMENT_TYPES.POP_STATION;
        switch (true) {
            case isDoorStep: {
                return {
                    enabled: !fulfilment.disabled && variant.hasOnlineStock,
                    icon: React__default["default"].createElement(Delivery_1, { width: 25, height: 25 })
                };
            }
            case isCollectAtStore: {
                return {
                    enabled: !fulfilment.disabled &&
                        variant.hasOfflineStock &&
                        !variant.isBackOrder,
                    icon: React__default["default"].createElement(Store_1, { width: 25, height: 25 })
                };
            }
            case isPopStation: {
                return {
                    enabled: !fulfilment.disabled && variant.hasOnlineStock,
                    icon: React__default["default"].createElement(SvgPopStation, { width: 25, height: 25 })
                };
            }
        }
    };
    var getDeliveryOptions = function (variant) {
        var isPreOrderOrBackOrder = variant.isPreOrder || variant.isBackOrder;
        var getSubTitle = function (text) {
            if (isPreOrderOrBackOrder || !text)
                return '';
            return text;
        };
        return fulfilmentList.map(function (fulfilment) {
            var iconAnStatus = getFulfilmentIconAndStatus(fulfilment, variant);
            return {
                enabled: iconAnStatus === null || iconAnStatus === void 0 ? void 0 : iconAnStatus.enabled,
                title: (React__default["default"].createElement(React__default["default"].Fragment, null,
                    fulfilment.title,
                    " - ",
                    renderCost(fulfilment.cost))),
                subTitle: getSubTitle(fulfilment.liner),
                icon: iconAnStatus === null || iconAnStatus === void 0 ? void 0 : iconAnStatus.icon
            };
        });
    };
    var renderFulfilment = function () {
        if (!selectedVariant.stockCount || selectedVariant.stockCount <= 0) {
            return null;
        }
        return (React__default["default"].createElement(React__default["default"].Fragment, null,
            renderShippingLiner(),
            React__default["default"].createElement(web.Row, null, getDeliveryOptions(selectedVariant).map(function (deliveryOption, index) {
                if (!deliveryOption.enabled)
                    return null;
                return (React__default["default"].createElement(StyledColumn$2, { xs: 12, md: 6, key: index, "data-testid": "fulfilment-item", noGutter: true },
                    React__default["default"].createElement(web.Row, { align: "top" },
                        React__default["default"].createElement(StyledDiv, null,
                            deliveryOption.icon ? (React__default["default"].createElement(IconWrapper, null, deliveryOption.icon)) : null,
                            React__default["default"].createElement("div", null,
                                ' ',
                                React__default["default"].createElement(web.Text, { type: "boldBody" }, deliveryOption.title),
                                ' ',
                                React__default["default"].createElement(web.Text, { type: "smallBody" }, deliveryOption.subTitle),
                                ' ')))));
            }))));
    };
    return React__default["default"].createElement(web.Spacing, { bottom: 1 }, renderFulfilment());
});
var templateObject_1$b, templateObject_2$9;

var QuantityInput = function (_a) {
    var _b = _a.error, error = _b === void 0 ? false : _b, _c = _a.interval, interval = _c === void 0 ? 1 : _c, value = _a.value, minValue = _a.minValue, maxValue = _a.maxValue, onValueChange = _a.onValueChange, errorMessage = _a.errorMessage, text = _a.text;
    var theme = web.useTheme().theme;
    return (React__default["default"].createElement("div", { "data-testid": "QuantityInput" },
        React__default["default"].createElement(web.QuantityInput, __assign({ variant: "haze", text: text, value: value, minValue: minValue, maxValue: maxValue }, (typeof onValueChange === 'function' && {
            onValueChange: function (value) {
                onValueChange(value);
            }
        }), { interval: interval })),
        error && errorMessage && (React__default["default"].createElement(web.Spacing, { top: 1 },
            React__default["default"].createElement(web.Text, { color: theme.cl_pri_base }, errorMessage)))));
};

var BUTTON_TYPE_PROPS = {
    secondary: { secondary: true },
    primary: { secondary: false },
    link: { link: true }
};

var StyledColumn$1 = web.withTheme(styled__default["default"](web.Column)(templateObject_2$8 || (templateObject_2$8 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var coreTheme = _a.coreTheme;
    return styled.css(templateObject_1$a || (templateObject_1$a = __makeTemplateObject(["\n    &:nth-child(odd) {\n      padding-left: 0;\n    }\n\n    &:nth-child(even) {\n      padding-right: 0;\n    }\n    @media (max-width: ", ") {\n      padding-right: 0;\n      padding-left: 0;\n    }\n  "], ["\n    &:nth-child(odd) {\n      padding-left: 0;\n    }\n\n    &:nth-child(even) {\n      padding-right: 0;\n    }\n    @media (max-width: ", ") {\n      padding-right: 0;\n      padding-left: 0;\n    }\n  "])), coreTheme.brk_xs);
}));
var makeButtonProps = function (configs) {
    configs.type; var _b = configs.fullWidth, fullWidth = _b === void 0 ? true : _b, rest = __rest(configs, ["type", "fullWidth"]);
    var buttonType = BUTTON_TYPE_PROPS[configs.type] || BUTTON_TYPE_PROPS.primary;
    return __assign(__assign(__assign({}, rest), buttonType), { fullWidth: fullWidth });
};
var ActionButtonGroup = function (_a) {
    var buttons = _a.buttons;
    return (React__default["default"].createElement(web.Row, { "data-testid": "ActionButtonGroup" }, buttons.map(function (button, index) {
        var text = button.text, buttonConfig = __rest(button, ["text"]);
        var props = makeButtonProps(buttonConfig);
        return (React__default["default"].createElement(StyledColumn$1, { key: index, xs: 12, md: 6 },
            React__default["default"].createElement(web.Button, __assign({ "data-testid": "action-button-" + index }, props), text)));
    })));
};
var templateObject_1$a, templateObject_2$8;

var _a$1;
var titleSectionVariant = {
    top: 'top',
    bottom: 'bottom'
};
var variantProps = (_a$1 = {},
    _a$1[titleSectionVariant.bottom] = {
        spacing: {},
        text: {
            type: 'pageTitle'
        }
    },
    _a$1[titleSectionVariant.top] = {
        spacing: { bottom: 1 },
        text: {
            type: 'sectionTitle'
        }
    },
    _a$1);
var TitleSection = function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? titleSectionVariant.bottom : _b, ribbon = _a.ribbon, title = _a.title;
    var props = variantProps[variant] || variantProps[titleSectionVariant.bottom];
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        ribbon && React__default["default"].createElement(web.Ribbon.Variant1, null, ribbon),
        React__default["default"].createElement(web.Spacing, __assign({}, props.spacing),
            React__default["default"].createElement(Title, null,
                React__default["default"].createElement(web.Text, { type: props.text.type, "data-testid": "phone-name", tag: "h1" }, title)))));
};

var ModelSelector = function (_a) {
    var models = _a.models, title = _a.title, selectedModel = _a.selectedModel, onClick = _a.onClick;
    var _b = React.useState(), selected = _b[0], setSelected = _b[1];
    var onSelectorClick = function (item) {
        setSelected(item.id);
        onClick(item);
    };
    React.useEffect(function () {
        setSelected(selectedModel);
    }, [selectedModel]);
    return (React__default["default"].createElement(web.Layout.Stack, { space: 2, "data-testid": "model-selector" },
        React__default["default"].createElement(web.Text, { type: "header" }, title),
        models.map(function (item, key) {
            return (React__default["default"].createElement(React.Fragment, { key: item.id },
                React__default["default"].createElement(web.Selector, { alignment: "row", "data-testid": "selector-" + key, selected: item.id === selected, onClick: function () { return onSelectorClick(item); } },
                    React__default["default"].createElement(web.Selector.Body, { title: item.displayName, align: "start" }))));
        })));
};

var StyledGrid = web.withTheme(styled__default["default"](web.Grid)(templateObject_2$7 || (templateObject_2$7 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var coreTheme = _a.coreTheme, bgColor = _a.bgColor, noHorizontalPadding = _a.noHorizontalPadding;
    return styled.css(templateObject_1$9 || (templateObject_1$9 = __makeTemplateObject(["\n    background-color: ", ";\n    padding: 1.5rem;\n    @media (max-width: ", ") {\n      padding: ", ";\n    }\n  "], ["\n    background-color: ", ";\n    padding: 1.5rem;\n    @media (max-width: ", ") {\n      padding: ", ";\n    }\n  "])), bgColor === 'white'
        ? coreTheme.cl_white
        : coreTheme.cl_ter_l6, coreTheme.brk_md, "1.5rem " + (noHorizontalPadding ? 0 : 1.5) + "rem ");
}));
var StyledWrapper = styled__default["default"].div(templateObject_3$4 || (templateObject_3$4 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n"])));
var StyledImageWrapper = web.withTheme(styled__default["default"].div(templateObject_5$1 || (templateObject_5$1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var coreTheme = _a.coreTheme;
    return styled.css(templateObject_4$4 || (templateObject_4$4 = __makeTemplateObject(["\n    flex-basis: 10%;\n    @media (max-width: ", ") {\n      flex-basis: 25%;\n    }\n  "], ["\n    flex-basis: 10%;\n    @media (max-width: ", ") {\n      flex-basis: 25%;\n    }\n  "])), coreTheme.brk_xs);
}));
var StyledImage = styled__default["default"].img(templateObject_6$1 || (templateObject_6$1 = __makeTemplateObject(["\n  width: 80px;\n  height: 80px;\n"], ["\n  width: 80px;\n  height: 80px;\n"])));
var StyledVariantInfoWrapper = web.withTheme(styled__default["default"].div(templateObject_8$1 || (templateObject_8$1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var coreTheme = _a.coreTheme;
    return styled.css(templateObject_7$1 || (templateObject_7$1 = __makeTemplateObject(["\n    flex-basis: 60%;\n    @media (max-width: ", ") {\n      flex-basis: 40%;\n    }\n  "], ["\n    flex-basis: 60%;\n    @media (max-width: ", ") {\n      flex-basis: 40%;\n    }\n  "])), coreTheme.xs);
}));
var StyledModelDescriptionText = web.withTheme(styled__default["default"](web.Text)(templateObject_10$1 || (templateObject_10$1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var coreTheme = _a.coreTheme;
    return styled.css(templateObject_9$1 || (templateObject_9$1 = __makeTemplateObject(["\n    @media (max-width: ", ") {\n      max-width: 150px;\n    }\n  "], ["\n    @media (max-width: ", ") {\n      max-width: 150px;\n    }\n  "])), coreTheme.brk_xs);
}));
var StyledSellingPriceWrapper = web.withTheme(styled__default["default"].div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var coreTheme = _a.coreTheme;
    return styled.css(templateObject_11$1 || (templateObject_11$1 = __makeTemplateObject(["\n    flex-basis: 20%;\n    text-align: right;\n\n    @media (max-width: ", ") {\n      flex-basis: 25%;\n    }\n  "], ["\n    flex-basis: 20%;\n    text-align: right;\n\n    @media (max-width: ", ") {\n      flex-basis: 25%;\n    }\n  "])), coreTheme.brk_xs);
}));
var StyledPlanGroupWrapper = styled__default["default"].div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  flex-basis: 60%;\n"], ["\n  flex-basis: 60%;\n"])));
var StyledMonthlyChargesWrapper = styled__default["default"].div(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  flex-basis: 30%;\n  text-align: right;\n"], ["\n  flex-basis: 30%;\n  text-align: right;\n"])));
var StyledPlanDescriptionText = styled__default["default"](web.Text)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n  width: 60%;\n"], ["\n  width: 60%;\n"])));
var templateObject_1$9, templateObject_2$7, templateObject_3$4, templateObject_4$4, templateObject_5$1, templateObject_6$1, templateObject_7$1, templateObject_8$1, templateObject_9$1, templateObject_10$1, templateObject_11$1, templateObject_12, templateObject_13, templateObject_14, templateObject_15;

var OrderSummary = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var title = _a.title, _h = _a.bgColor, bgColor = _h === void 0 ? 'haze' : _h, selectedPlan = _a.selectedPlan, ctaButtonText = _a.ctaButtonText, onCtaButtonClick = _a.onCtaButtonClick, noHorizontalPadding = _a.noHorizontalPadding;
    return (React__default["default"].createElement("div", { "data-testid": "order-summary" },
        React__default["default"].createElement(StyledGrid, { bgColor: bgColor, noHorizontalPadding: noHorizontalPadding },
            React__default["default"].createElement(web.Spacing, { top: 1 },
                React__default["default"].createElement(web.Text, { type: "header" }, title)),
            (selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.variantInfo) && (React__default["default"].createElement(web.Spacing, { top: 3 },
                React__default["default"].createElement(StyledWrapper, null,
                    React__default["default"].createElement(StyledImageWrapper, null,
                        React__default["default"].createElement(StyledImage, { src: "" + ((_e = (_d = (_c = (_b = selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.variantInfo.images[0]) === null || _b === void 0 ? void 0 : _b.imageFile) === null || _c === void 0 ? void 0 : _c.childImageSharp) === null || _d === void 0 ? void 0 : _d.fixed) === null || _e === void 0 ? void 0 : _e.src), alt: 'Image of phone' })),
                    React__default["default"].createElement(StyledVariantInfoWrapper, null,
                        React__default["default"].createElement(StyledModelDescriptionText, { type: "boldBody" }, selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.variantInfo.modelDescription),
                        React__default["default"].createElement(web.Text, { type: "smallBody" }, selectedPlan === null || selectedPlan === void 0 ? void 0 :
                            selectedPlan.variantInfo.colorDescription,
                            ",",
                            ' ', selectedPlan === null || selectedPlan === void 0 ? void 0 :
                            selectedPlan.variantInfo.memorySize)),
                    React__default["default"].createElement(StyledSellingPriceWrapper, null,
                        React__default["default"].createElement(web.Text, { type: "boldBody" }, selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.sellingPrice))))),
            React__default["default"].createElement(web.Spacing, { top: 2 },
                React__default["default"].createElement(StyledWrapper, null,
                    React__default["default"].createElement(StyledPlanGroupWrapper, null,
                        React__default["default"].createElement(web.Text, { type: "boldBody" }, selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.planName)),
                    React__default["default"].createElement(StyledMonthlyChargesWrapper, null,
                        React__default["default"].createElement(web.Text, { type: "boldBody" }, selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.sellingMonthlyCharges))),
                React__default["default"].createElement(StyledPlanDescriptionText, { type: "smallBody" }, (_f = selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.data) === null || _f === void 0 ? void 0 :
                    _f.quantity, (_g = selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.data) === null || _g === void 0 ? void 0 :
                    _g.unit,
                    " data, ", selectedPlan === null || selectedPlan === void 0 ? void 0 :
                    selectedPlan.smsAndTalkTimeLiner)),
            ctaButtonText && (React__default["default"].createElement(web.Spacing, { top: 4, bottom: 2 },
                React__default["default"].createElement(web.Button, { "data-testid": "order-summary-button", fullWidth: true, onClick: function () { return onCtaButtonClick(selectedPlan); } }, ctaButtonText))))));
};

var _templateObject;
var CartBoxWrapper = styled__default["default"](web.Spacing)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-radius: ", ";\n  margin: ", ";\n"])), web.theme.main.colours.tertiary.l6, function (props) {
  return props.isMobile ? 0 : '8px';
}, function (props) {
  return props.isMobile ? '0 -24px' : 0;
});

var PaymentTerms = function (props) {
    var _a;
    var equipmentContext = React__default["default"].useContext(EquipmentContext);
    var paymentTerms = props.paymentTerms; props.isMobile; var onPaymentTermChanged = props.onPaymentTermChanged, _b = props.headerText, headerText = _b === void 0 ? trans('EQUIPMENT_DETAILS_PAYMENT_TERMS') : _b, _c = props.isLoading, isLoading = _c === void 0 ? (_a = equipmentContext.configs) === null || _a === void 0 ? void 0 : _a.isLoading : _c;
    var renderPaymentTerms = function () {
        return (React__default["default"].createElement(StorageWrapper, null, paymentTerms.map(function (term, index) {
            return (React__default["default"].createElement(StorageItem, { key: term.id + "-" + index },
                React__default["default"].createElement(web.Selector, { alignment: "row", onClick: function () {
                        var _a;
                        ((_a = term.variant) === null || _a === void 0 ? void 0 : _a.stockCount) > 0 &&
                            onPaymentTermChanged &&
                            onPaymentTermChanged(term);
                    }, selected: term.selected, disabled: term.disabled, "data-testid": "payment-term-" + term.value },
                    React__default["default"].createElement(web.Selector.Body, { align: "start", disabled: term.disabled, title: "" + formatPrice(term.price) + term.priceSuffix, subtitle: term.description }))));
        })));
    };
    return (React__default["default"].createElement("div", null,
        React__default["default"].createElement(web.SkeletonLoader, { preset: "ListItem", loading: isLoading },
            React__default["default"].createElement(web.Spacing, { bottom: 2 },
                React__default["default"].createElement(web.Text, { type: "header" }, headerText)),
            React__default["default"].createElement(web.Row, { noGutter: true }, renderPaymentTerms()))));
};

var AddToCartBox = React.memo(function (props) {
    var _a, _b, _c;
    var equipmentContext = React__default["default"].useContext(EquipmentContext);
    var _d = equipmentContext || {}, callbacks = _d.callbacks, configs = _d.configs;
    var cartBox = (configs || {}).cartBox;
    var maxLimit = (_a = cartBox === null || cartBox === void 0 ? void 0 : cartBox.quantity) === null || _a === void 0 ? void 0 : _a.maxValue;
    var animationTimeout = React.useRef(null);
    var shouldDoAnimation = React.useRef(false);
    var _e = React.useState({
        secondaryButtonStatus: null
    }), state = _e[0], _setState = _e[1];
    var cartBoxContent = {
        priceSuffix: '/mth',
        description: trans('CART_BOX_DESCRIPTION'),
        ippDescription: trans('CART_BOX_IPP_DESCRIPTION'),
        primaryButtonText: trans('CART_BOX_PRIMARY_BUTTON_TEXT'),
        ippPrimaryButtonText: trans('CART_BOX_IPP_PRIMARY_BUTTON_TEXT'),
        secondaryButtonText: trans('CART_BOX_SECONDARY_BUTTON_TEXT'),
        customContent: ''
    };
    var isLoading = (_b = equipmentContext === null || equipmentContext === void 0 ? void 0 : equipmentContext.configs) === null || _b === void 0 ? void 0 : _b.isLoading;
    var isMobile = props.isMobile, product = props.product, paymentTerms = props.paymentTerms, onPaymentTermChanged = props.onPaymentTermChanged, selectedPaymentTerm = props.selectedPaymentTerm, _f = props.quantity, quantity = _f === void 0 ? 0 : _f, setQuantity = props.setQuantity;
    var setState = function (params) {
        _setState(__assign(__assign({}, state), params));
    };
    var clearAnimation = function () {
        shouldDoAnimation.current = false;
        if (animationTimeout.current) {
            clearTimeout(animationTimeout.current);
        }
    };
    React.useEffect(function () {
        return function () {
            clearAnimation();
        };
    }, []);
    React.useEffect(function () {
        var _a;
        if ((_a = configs.cartBox) === null || _a === void 0 ? void 0 : _a.status) {
            var defaultQuantity_1 = getDefaultQuantity({
                paymentTermType: selectedPaymentTerm === null || selectedPaymentTerm === void 0 ? void 0 : selectedPaymentTerm.value,
                maxLimit: maxLimit
            });
            setState({ secondaryButtonStatus: configs.cartBox.status });
            if (configs.cartBox.status === 'success' && shouldDoAnimation.current) {
                animationTimeout.current = setTimeout(function () {
                    setState({ secondaryButtonStatus: null });
                    setQuantity(defaultQuantity_1);
                    clearAnimation();
                }, 1000);
            }
        }
    }, [(_c = configs.cartBox) === null || _c === void 0 ? void 0 : _c.status]);
    var renderPaymentTerms = function () {
        return (React__default["default"].createElement(web.Spacing, { bottom: 2, responsive: false },
            React__default["default"].createElement(PaymentTerms, { paymentTerms: paymentTerms, onPaymentTermChanged: onPaymentTermChanged, isMobile: isMobile })));
    };
    var onQuantityChanged = function (quantity) {
        setQuantity && setQuantity(quantity);
    };
    var renderQuantity = function () {
        var _a, _b, _c;
        return (React__default["default"].createElement(QuantityInput, { text: trans('EQUIPMENT_DETAILS_QUANTITY_TITLE'), value: quantity, minValue: (_a = cartBox === null || cartBox === void 0 ? void 0 : cartBox.quantity) === null || _a === void 0 ? void 0 : _a.minValue, maxValue: (_b = cartBox === null || cartBox === void 0 ? void 0 : cartBox.quantity) === null || _b === void 0 ? void 0 : _b.maxValue, onValueChange: onQuantityChanged, interval: (_c = cartBox === null || cartBox === void 0 ? void 0 : cartBox.quantity) === null || _c === void 0 ? void 0 : _c.interval, errorMessage: trans('EQUIPMENT_DETAILS_QUANTITY_ERROR') }));
    };
    var getCartReturnData = function () {
        return {
            quantity: quantity,
            product: product,
            selectedPaymentTerm: selectedPaymentTerm
        };
    };
    var isFullPrice = function () {
        return (selectedPaymentTerm.id === PRODUCT_DETAILS.PAYMENT_TERM_TYPE.FULL_PRICE);
    };
    var renderCartBoxGeneric = function (_a) {
        var _b;
        var description = _a.description, priceSuffix = _a.priceSuffix, buttonText = _a.buttonText, price = _a.price, hasSecondaryButton = _a.hasSecondaryButton;
        return (React__default["default"].createElement(React__default["default"].Fragment, null,
            React__default["default"].createElement(InlineCenter, null,
                React__default["default"].createElement(web.Text, { type: "sectionTitle" },
                    formatPrice(price * quantity),
                    priceSuffix),
                product.usualPrice &&
                    ((_b = configs.cartBox) === null || _b === void 0 ? void 0 : _b.hasPriceSlash) &&
                    product.usualPrice > price && (React__default["default"].createElement(StrikeThroughText, { type: 'body' }, formatPrice(product.usualPrice * quantity)))),
            React__default["default"].createElement(web.Text, { type: "smallBody" }, description),
            React__default["default"].createElement(web.Spacing, { top: 2 },
                React__default["default"].createElement(web.Row, null,
                    React__default["default"].createElement(web.Column, { noGutter: true, xs: 12, sm: isFullPrice() ? 6 : 12 },
                        React__default["default"].createElement(web.Spacing, { bottom: 2, responsive: false, right: !isMobile && isFullPrice() ? 1 : 0 },
                            React__default["default"].createElement(web.Button, { fullWidth: isFullPrice() ? true : isMobile, onClick: function () {
                                    callbacks.cartBoxPrimaryClick(getCartReturnData());
                                } }, buttonText))),
                    hasSecondaryButton && (React__default["default"].createElement(web.Column, { noGutter: true, xs: 12, sm: 6 },
                        React__default["default"].createElement(web.Spacing, { left: !isMobile && isFullPrice() ? 1 : 0 },
                            React__default["default"].createElement(web.Button, { loading: shouldDoAnimation.current && state.secondaryButtonStatus, fullWidth: true, onClick: function () {
                                    shouldDoAnimation.current = true;
                                    callbacks.cartBoxSecondaryClick(getCartReturnData());
                                }, secondary: true }, cartBoxContent.secondaryButtonText))))))));
    };
    var renderFullPriceBox = function () {
        return (React__default["default"].createElement(CartBoxWrapper, { isMobile: isMobile, top: 2, bottom: 3, leftRight: 1, responsive: false },
            renderQuantity(),
            React__default["default"].createElement(web.Spacing, { leftRight: 2, responsive: false },
                React__default["default"].createElement(web.Divider, null),
                React__default["default"].createElement(web.Spacing, { top: 2, responsive: false }, renderCartBoxGeneric({
                    description: cartBoxContent.description,
                    buttonText: cartBoxContent.primaryButtonText,
                    price: product.price,
                    hasSecondaryButton: true
                })))));
    };
    var renderIppBox = function () {
        var _a;
        return (React__default["default"].createElement(CartBoxWrapper, { isMobile: isMobile, topBottom: 3, leftRight: 3, responsive: false },
            renderCartBoxGeneric({
                description: cartBoxContent.ippDescription,
                priceSuffix: cartBoxContent.priceSuffix,
                buttonText: cartBoxContent.ippPrimaryButtonText,
                price: selectedPaymentTerm.price
            }),
            ((_a = configs.cartBox) === null || _a === void 0 ? void 0 : _a.customIppLiner) && (React__default["default"].createElement(web.Spacing, null, configs.cartBox.customIppLiner))));
    };
    var renderCartBox = function () {
        if (!selectedPaymentTerm)
            return null;
        if (isFullPrice()) {
            return renderFullPriceBox();
        }
        return renderIppBox();
    };
    var render = function () {
        if (isLoading)
            return null;
        return (React__default["default"].createElement(web.Spacing, { bottom: 6 },
            renderPaymentTerms(),
            renderCartBox()));
    };
    return (React__default["default"].createElement("div", null,
        React__default["default"].createElement(web.SkeletonLoader, { preset: "ListItem", loading: isLoading }, render())));
});

var EquipmentDetails = function (_a) {
    var _b, _c, _d, _e, _f;
    var _g = _a.productDetails, productDetails = _g === void 0 ? {} : _g, localisation = _a.localisation, _h = _a.currentDataModel, currentDataModel = _h === void 0 ? {} : _h; _a.isQuantityRequired; _a.quantityLimit; var accessoryRibbon = _a.accessoryRibbon;
    var orderSummaryRef = React.useRef(null);
    var isMobile = web.useDevice().isMobile;
    updateMessages(localisation);
    var equipmentContext = React__default["default"].useContext(EquipmentContext);
    var variants = productDetails.variants, freeGiftsBySku = productDetails.freeGiftsBySku, _j = productDetails.freeGiftsByDevice, freeGiftsByDevice = _j === void 0 ? [] : _j, _k = productDetails.freeGiftStockAvail, freeGiftStockAvail = _k === void 0 ? [] : _k, promotions = productDetails.promotions, plan = productDetails.plan, preSelectionOptions = productDetails.preSelectionOptions, _l = productDetails.accessories, propAccessories = _l === void 0 ? [] : _l, deliveryOptions = productDetails.deliveryOptions, quantitySelector = productDetails.quantitySelector, models = productDetails.models, deviceNotification = productDetails.deviceNotification, orderSummary = productDetails.orderSummary;
    var _m = equipmentContext || {}, callbacks = _m.callbacks, configs = _m.configs;
    var _o = useOptions({
        variants: variants,
        plans: plan.allPlans,
        planGroups: plan.planGroups,
        preSelectionOptions: preSelectionOptions
    }), colorList = _o.colorList, storageList = _o.storageList, selectedColor = _o.selectedColor, selectedVariant = _o.selectedVariant, selectedStorage = _o.selectedStorage, selectedPlan = _o.selectedPlan, plansForCurrentVariant = _o.plansForCurrentVariant, selectedPlanGroup = _o.selectedPlanGroup, monthlyTerms = _o.monthlyTerms, selectedMonthTerm = _o.selectedMonthTerm, planGroups = _o.planGroups, selectColor = _o.selectColor, selectStorage = _o.selectStorage, selectPlan = _o.selectPlan, selectPlanGroup = _o.selectPlanGroup, selectMonthlyTerm = _o.selectMonthlyTerm, totalStockAvailable = _o.totalStockAvailable, scrollToSectionOnce = _o.scrollToSectionOnce, selectPaymentTerm = _o.selectPaymentTerm, paymentTerms = _o.paymentTerms, quantity = _o.quantity, setQuantity = _o.setQuantity, selectedPaymentTerm = _o.selectedPaymentTerm;
    var isColorHasStockAvailable = selectedColor && isColorHasStock(selectedColor);
    var _p = useAccessory({
        accessories: propAccessories,
        preselectAccessories: preSelectionOptions.accessories
    }), accessories = _p.accessories, selectAccessory = _p.selectAccessory, removeAccessory = _p.removeAccessory, viewAccessory = _p.viewAccessory, selectedAccessory = _p.selectedAccessory, isLoading = _p.isLoading, accessoryTotalPrice = _p.totalPrice;
    var _q = React.useState(0), placeholderHeight = _q[0], setPlaceholderHeight = _q[1];
    React.useEffect(function () {
        var _a;
        if (selectedVariant) {
            (_a = equipmentContext === null || equipmentContext === void 0 ? void 0 : equipmentContext.callbacks) === null || _a === void 0 ? void 0 : _a.onChangeVariant(__assign(__assign({}, selectedVariant), { colorCode: selectedColor === null || selectedColor === void 0 ? void 0 : selectedColor.colorCode, memorySize: selectedStorage === null || selectedStorage === void 0 ? void 0 : selectedStorage.value, planName: selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.planName, monthlyTerm: selectedMonthTerm, paymentTerm: selectedPaymentTerm === null || selectedPaymentTerm === void 0 ? void 0 : selectedPaymentTerm.id }));
        }
    }, [
        selectedColor,
        selectedStorage,
        selectedPlan,
        selectedMonthTerm,
        selectedPaymentTerm
    ]);
    var onNexClick = function () {
        var _a, _b, _c;
        var hasNoStock = null;
        if (!selectedPlan && totalStockAvailable === 0) {
            hasNoStock = 'PRODUCT';
        }
        else if (!selectedPlan && !isColorHasStockAvailable) {
            hasNoStock = 'COLOUR';
        }
        if ((_a = plan === null || plan === void 0 ? void 0 : plan.allPlans) === null || _a === void 0 ? void 0 : _a.length) {
            ((_b = equipmentContext.callbacks) === null || _b === void 0 ? void 0 : _b.onNextClick)(selectedVariant, selectedPlan, getSelectedAccessories(accessories), hasNoStock);
        }
        else {
            ((_c = equipmentContext.callbacks) === null || _c === void 0 ? void 0 : _c.onNextClick)({
                product: selectedVariant,
                selectedPaymentTerm: selectedPaymentTerm,
                quantity: quantity
            });
        }
    };
    var _r = configs || {}, _s = _r.hasSummaryPrice, hasSummaryPrice = _s === void 0 ? true : _s, _t = _r.miniCartPosition, miniCartPosition = _t === void 0 ? 'top' : _t;
    var onSelectColor = React.useCallback(function (color) {
        // no default color selection event - hence sending user selection as true on click
        selectColor({ selectedColor: color, userSelected: true });
    }, [
        colorList,
        selectedStorage,
        selectedPlan,
        selectedPlanGroup,
        selectedPaymentTerm,
        paymentTerms
    ]);
    var onOOSLinkClick = function () {
        var _a;
        (_a = equipmentContext.callbacks) === null || _a === void 0 ? void 0 : _a.onOOSLinkClick();
    };
    var _u = React.useState(!!((_b = equipmentContext === null || equipmentContext === void 0 ? void 0 : equipmentContext.configs) === null || _b === void 0 ? void 0 : _b.extendSpecsByDefault)), techExpand = _u[0], setTechExpand = _u[1];
    var summaryPrices = React.useMemo(function () {
        if (!hasSummaryPrice)
            return [];
        var priceSummary = getSummaryPrice(selectedPlan, accessoryTotalPrice, selectedVariant, quantity);
        var displayPrices = [];
        if (selectedPlan || priceSummary.upfrontAmount) {
            displayPrices.push({
                label: trans('TODAY'),
                amount: priceSummary.upfrontAmount
            });
        }
        if (selectedPlan || priceSummary.monthlyAmount) {
            displayPrices.push({
                label: trans('MONTHLY'),
                amount: priceSummary.monthlyAmount,
                prefix: '/mth'
            });
        }
        return displayPrices;
    }, [selectedPlan, accessoryTotalPrice, selectedVariant, quantity]);
    var productHasStock = selectedVariant && selectedVariant.stockCount > 0;
    var mobileSpacing = isMobile
        ? 0
        : productHasStock || totalStockAvailable > 0
            ? 3
            : 2;
    (freeGiftsBySku === null || freeGiftsBySku === void 0 ? void 0 : freeGiftsBySku.filter(function (gift) { return gift.colour; }).length) > 0;
    promotions === null || promotions === void 0 ? void 0 : promotions.primaryLiner;
    var freeGiftsList = getFreeGiftsList(freeGiftsByDevice, freeGiftStockAvail);
    var availableGifts = freeGiftsList === null || freeGiftsList === void 0 ? void 0 : freeGiftsList.filter(function (item) { return item.available; });
    React.useEffect(function () {
        var _a;
        setPlaceholderHeight((_a = orderSummaryRef === null || orderSummaryRef === void 0 ? void 0 : orderSummaryRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight);
        var getPlaceholderHeight = function () {
            var _a;
            setPlaceholderHeight((_a = orderSummaryRef === null || orderSummaryRef === void 0 ? void 0 : orderSummaryRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight);
        };
        window.addEventListener('resize', getPlaceholderHeight);
        return function () { return window.removeEventListener('resize', getPlaceholderHeight); };
    }, [productHasStock]);
    var renderSummaryBar = function () {
        var _a, _b;
        if (!((_a = equipmentContext === null || equipmentContext === void 0 ? void 0 : equipmentContext.configs) === null || _a === void 0 ? void 0 : _a.showSummaryBar) ||
            ((_b = equipmentContext === null || equipmentContext === void 0 ? void 0 : equipmentContext.configs) === null || _b === void 0 ? void 0 : _b.isLoading))
            return null;
        var proceedText = selectedPaymentTerm ? trans('TEXT_BUY_NOW') : null;
        return (React__default["default"].createElement(SummaryBar, { proceedText: proceedText, onClick: onNexClick, prices: summaryPrices }));
    };
    var renderNotification = function () {
        var _a;
        if (!((_a = equipmentContext === null || equipmentContext === void 0 ? void 0 : equipmentContext.configs) === null || _a === void 0 ? void 0 : _a.showOOSNotification) ||
            productHasStock ||
            totalStockAvailable > 0) {
            return null;
        }
        var notificationMessage = (React__default["default"].createElement(OutOfStockMessage, { onClick: onOOSLinkClick, testId: "oos-redirect-link" }));
        return (React__default["default"].createElement(web.Spacing, { top: 1, bottom: 1 },
            React__default["default"].createElement(web.Notification, { type: "info", content: notificationMessage })));
    };
    var renderEquipmentGallery = function () {
        return (React__default["default"].createElement(EquipmentGallery, { stickyBoundaryElement: ".stickyBoundary", isSticky: true, imageGallery: selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.images, seoTag: selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.seoImageTag }));
    };
    var renderTitleSection = function () {
        var _a;
        return (React__default["default"].createElement(TitleSection, { variant: (_a = equipmentContext.configs) === null || _a === void 0 ? void 0 : _a.titleSectionVariant, ribbon: productDetails.ribbon, title: (currentDataModel === null || currentDataModel === void 0 ? void 0 : currentDataModel.displayName) || (currentDataModel === null || currentDataModel === void 0 ? void 0 : currentDataModel.deviceTitle) }));
    };
    var renderBasicInfo = function () {
        var _a, _b;
        return (React__default["default"].createElement(React__default["default"].Fragment, null,
            (!isMobile ||
                ((_a = equipmentContext.configs) === null || _a === void 0 ? void 0 : _a.titleSectionVariant) ===
                    titleSectionVariant.bottom) &&
                renderTitleSection(),
            ((_b = equipmentContext.configs) === null || _b === void 0 ? void 0 : _b.showTechSpecsAnchor) && (React__default["default"].createElement(web.Spacing, { top: 2 },
                React__default["default"].createElement(web.TextLink, { onClick: handleTechAnchor, "data-testid": "tech-specs" },
                    React__default["default"].createElement(web.TextLink.Icon, { icon: Settings_1 }),
                    React__default["default"].createElement(web.TextLink.Text, null, trans('EQUIPMENT_DETAILS_TECH_SPECS'))))),
            (promotions === null || promotions === void 0 ? void 0 : promotions.primaryLiner) && (React__default["default"].createElement(web.Spacing, { top: 2 },
                React__default["default"].createElement(PromotionalBanner, { promotions: promotions, title: promotions === null || promotions === void 0 ? void 0 : promotions.primaryLiner, linkText: trans('PROMOTE_LINK_TEXT') }))),
            totalStockAvailable > 0 && (availableGifts === null || availableGifts === void 0 ? void 0 : availableGifts.length) ? (React__default["default"].createElement(React__default["default"].Fragment, null,
                React__default["default"].createElement(FreeGifts, { freeGiftsList: availableGifts }),
                React__default["default"].createElement(web.Spacing, { top: (freeGiftsList === null || freeGiftsList === void 0 ? void 0 : freeGiftsList.length) ? 0 : 3 },
                    React__default["default"].createElement(web.Divider, null)))) : null));
    };
    var handleTechAnchor = function () {
        scrollToSection(PRODUCT_DETAILS.ELEMENT_IDS.TECH_SPECS);
        setTechExpand(true);
    };
    var renderHTMLDescription = function () {
        return (React__default["default"].createElement(web.Text, { type: "smallBody" },
            React__default["default"].createElement("span", { dangerouslySetInnerHTML: {
                    __html: currentDataModel === null || currentDataModel === void 0 ? void 0 : currentDataModel.description
                } })));
    };
    var renderStorage = function () {
        if (!storageList.length)
            return (configs === null || configs === void 0 ? void 0 : configs.showStorageDivider) ? React__default["default"].createElement(web.Spacing, { top: 3 }) : null;
        return (React__default["default"].createElement(web.Spacing, { top: 3, bottom: 1, id: PRODUCT_DETAILS.ELEMENT_IDS.DEVICE_STORAGE_SECTION },
            React__default["default"].createElement(StorageSelector, { onStorageChanged: selectStorage, selectedStorage: selectedStorage, storages: storageList })));
    };
    var renderColourPickerAndStorage = function () {
        var _a;
        return (React__default["default"].createElement(React__default["default"].Fragment, null,
            React__default["default"].createElement(web.Spacing, { id: PRODUCT_DETAILS.ELEMENT_IDS.DEVICE_COLOR_SECTION },
                React__default["default"].createElement(DeviceColourPicker, { onSelectColor: onSelectColor, selectedColor: selectedColor, colours: colorList, deviceId: currentDataModel.deviceId, preSelectionOptions: preSelectionOptions })),
            renderStorage(),
            React__default["default"].createElement(web.Spacing, { id: PRODUCT_DETAILS.ELEMENT_IDS.FULFILMENT_SECTION }, ((_a = equipmentContext.configs) === null || _a === void 0 ? void 0 : _a.showStorageDivider) && React__default["default"].createElement(web.Divider, null))));
    };
    var renderFulfilment = function () {
        if (!(deliveryOptions === null || deliveryOptions === void 0 ? void 0 : deliveryOptions.fulfilmentList) || !productHasStock)
            return null;
        return (React__default["default"].createElement(React__default["default"].Fragment, null,
            React__default["default"].createElement(web.Spacing, { top: 0, bottom: isMobile ? 1 : 0.25, id: PRODUCT_DETAILS.ELEMENT_IDS.FULFILMENT_SECTION },
                React__default["default"].createElement(Fulfilment, { selectedVariant: selectedVariant, deliveryOptions: deliveryOptions })),
            !deliveryOptions.rrp && (React__default["default"].createElement(web.Divider, null))));
    };
    var renderPlan = function (isCarousel, showPlansInSwimlane) {
        var _a;
        if (showPlansInSwimlane === void 0) { showPlansInSwimlane = false; }
        if (isCarousel && !productHasStock)
            return;
        if (!((_a = plan === null || plan === void 0 ? void 0 : plan.planGroups) === null || _a === void 0 ? void 0 : _a.length))
            return;
        return (React__default["default"].createElement(web.Spacing, { top: '8px', bottom: isCarousel ? 0 : 2, id: PRODUCT_DETAILS.ELEMENT_IDS.PLAN_SECTION },
            React__default["default"].createElement(PlanSelector, { title: plan.title, plans: plansForCurrentVariant, planGroups: planGroups, monthlyTerms: monthlyTerms, selectedPlan: selectedPlan, selectedMonthTerm: selectedMonthTerm, selectMonthTerm: selectMonthlyTerm, onPlanSelected: selectPlan, selectedPlanGroup: selectedPlanGroup, onSelectedPlanGroup: selectPlanGroup, isCarousel: isCarousel, showPlansInSwimlane: showPlansInSwimlane })));
    };
    var renderAccessories = function () {
        var _a, _b, _c, _d, _e;
        var showAccessories = equipmentContext.configs.showAccessories;
        if (!showAccessories ||
            !productHasStock ||
            (!accessories.length &&
                !((_b = (_a = equipmentContext === null || equipmentContext === void 0 ? void 0 : equipmentContext.configs) === null || _a === void 0 ? void 0 : _a.moduleLoaders) === null || _b === void 0 ? void 0 : _b.accessory)))
            return null;
        return (React__default["default"].createElement(React__default["default"].Fragment, null,
            React__default["default"].createElement(web.Divider, null),
            React__default["default"].createElement(web.Spacing, { topBottom: 3 },
                React__default["default"].createElement(AccessoryList, { selectedAccessory: selectedAccessory, isModalLoading: isLoading, isListLoading: ((_c = equipmentContext === null || equipmentContext === void 0 ? void 0 : equipmentContext.configs) === null || _c === void 0 ? void 0 : _c.isLoading) ||
                        ((_e = (_d = equipmentContext === null || equipmentContext === void 0 ? void 0 : equipmentContext.configs) === null || _d === void 0 ? void 0 : _d.moduleLoaders) === null || _e === void 0 ? void 0 : _e.accessory), onViewMore: viewAccessory, onRemoveAccessory: removeAccessory, onSelectAccessory: selectAccessory, headerText: trans('ACCESSORY_HEADER_TEXT', {
                        deviceTitle: currentDataModel.deviceTitle
                    }), accessories: accessories, accessoryRibbon: accessoryRibbon }))));
    };
    var renderVideo = function () {
        return (React__default["default"].createElement(React__default["default"].Fragment, null,
            React__default["default"].createElement(web.Spacing, { top: 3 },
                React__default["default"].createElement(web.Divider, null)),
            React__default["default"].createElement(web.Spacing, { top: 3, bottom: isMobile ? 0 : 3 },
                React__default["default"].createElement(DetailsVideo, { title: "Introducing the " + currentDataModel.deviceTitle + " experience with Singtel", videoUrl: productDetails.videoUrl }))));
    };
    var renderWhatsInTheBox = function () {
        return (React__default["default"].createElement("article", null,
            React__default["default"].createElement(web.Spacing, { top: isMobile ? 2 : 3 },
                React__default["default"].createElement(web.Divider, null),
                React__default["default"].createElement(SpecBox, { whatsInTheBox: currentDataModel.whatsInTheBox, specifications: currentDataModel.specifications, techExpand: techExpand, setTechExpand: function () { return setTechExpand(false); }, productDetails: currentDataModel.productDetails }))));
    };
    var renderQuantity = function () {
        return (React__default["default"].createElement(QuantityInput, { text: trans('EQUIPMENT_DETAILS_QUANTITY_TITLE'), value: quantitySelector.value, minValue: quantitySelector.minValue, maxValue: quantitySelector.maxValue, onValueChange: callbacks === null || callbacks === void 0 ? void 0 : callbacks.onQuantityChange, interval: quantitySelector.interval, error: quantitySelector.error, errorMessage: trans('EQUIPMENT_DETAILS_QUANTITY_ERROR') }));
    };
    var renderActionButtons = function () {
        var _a;
        var _b = equipmentContext || {}, callbacks = _b.callbacks, configs = _b.configs;
        var transformToProps = configs.actionButtons.map(function (item) {
            var onClickName = item.onClickName, rest = __rest(item, ["onClickName"]);
            var fn = callbacks[onClickName];
            return __assign(__assign({}, rest), (typeof fn === 'function' && {
                onClick: function () { return fn({ selectedVariant: selectedVariant, selectedColor: selectedColor, selectedStorage: selectedStorage }); }
            }));
        });
        return (React__default["default"].createElement(web.SkeletonLoader, { preset: "ListItem", loading: (_a = equipmentContext.configs) === null || _a === void 0 ? void 0 : _a.isLoading },
            React__default["default"].createElement(ActionButtonGroup, { buttons: transformToProps })));
    };
    var renderModelSelector = function () {
        var _a;
        if (!models) {
            return null;
        }
        var onModelClick = function (model) {
            var _a;
            var DEVICE_COLOR_SECTION = PRODUCT_DETAILS.ELEMENT_IDS.DEVICE_COLOR_SECTION;
            (_a = equipmentContext === null || equipmentContext === void 0 ? void 0 : equipmentContext.callbacks) === null || _a === void 0 ? void 0 : _a.onModelSelectorClick(model);
            scrollToSectionOnce('model', DEVICE_COLOR_SECTION);
        };
        return (React__default["default"].createElement(web.SkeletonLoader, { preset: "ListItem", loading: (_a = equipmentContext.configs) === null || _a === void 0 ? void 0 : _a.isLoading },
            React__default["default"].createElement(ModelSelector, { models: models.data, onClick: onModelClick, selectedModel: models.selected, title: trans('EQUIPMENT_DETAILS_CHOOSE_MODEL') })));
    };
    var renderDeviceNotification = function () {
        var _a = equipmentContext.configs; _a.isLoading; var deviceNotificationSettings = _a.deviceNotificationSettings;
        if (!deviceNotification && !deviceNotificationSettings) {
            return null;
        }
        var _b = deviceNotificationSettings.type, type = _b === void 0 ? 'info' : _b, action = deviceNotificationSettings.action, style = deviceNotificationSettings.style;
        return (React__default["default"].createElement("div", __assign({ "data-testid": "device-notification" }, (style && {
            style: {
                marginTop: style.marginTop,
                marginBottom: style.marginBottom
            }
        })),
            React__default["default"].createElement(web.Notification, __assign({ type: type, content: deviceNotification.content, title: deviceNotification.title }, (action &&
                action.text && {
                action: {
                    type: action.type || 'button',
                    text: action.text,
                    onClick: equipmentContext.callbacks[action.onClickAction]
                }
            })))));
    };
    var renderOrderSummary = function () {
        var _a = equipmentContext.configs, isLoading = _a.isLoading, showOrderSummary = _a.showOrderSummary;
        if (!showOrderSummary || !productHasStock)
            return null;
        var onCtaButtonClick = function (selectedPlan) {
            var _a;
            (_a = equipmentContext === null || equipmentContext === void 0 ? void 0 : equipmentContext.callbacks) === null || _a === void 0 ? void 0 : _a.onOrderSummaryClick(selectedPlan);
        };
        return (React__default["default"].createElement(web.SkeletonLoader, { preset: "ListItem", loading: isLoading },
            React__default["default"].createElement(StyledRef, { ref: orderSummaryRef },
                React__default["default"].createElement(OrderSummary, { title: trans('ORDER_SUMMARY_TITLE'), ctaButtonText: orderSummary === null || orderSummary === void 0 ? void 0 : orderSummary.ctaButtonText, onCtaButtonClick: onCtaButtonClick, selectedPlan: selectedPlan }))));
    };
    var renderCartBox = function () {
        var _a;
        if (!((_a = configs.cartBox) === null || _a === void 0 ? void 0 : _a.showCartBox)) {
            return null;
        }
        return (React__default["default"].createElement(AddToCartBox, { setQuantity: setQuantity, selectedPaymentTerm: selectedPaymentTerm, onPaymentTermChanged: selectPaymentTerm, paymentTerms: paymentTerms, product: selectedVariant, isMobile: isMobile, quantity: quantity }));
    };
    var renderQuantityAndActionButtons = function () {
        var showQuantity = configs.showQuantitySelector && quantitySelector;
        var showActionButton = Array.isArray(configs === null || configs === void 0 ? void 0 : configs.actionButtons);
        if (!showActionButton && !showQuantity)
            return null;
        return (React__default["default"].createElement(web.Spacing, { top: 3 },
            React__default["default"].createElement(StyledLayout$1, { space: 3 },
                showQuantity && renderQuantity(),
                showActionButton && renderActionButtons())));
    };
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        miniCartPosition === 'top' && renderSummaryBar(),
        React__default["default"].createElement(web.Spacing, { top: mobileSpacing },
            React__default["default"].createElement(web.Layout.Stack, { space: 0, "data-testid": currentDataModel === null || currentDataModel === void 0 ? void 0 : currentDataModel.deviceId },
                React__default["default"].createElement("section", null,
                    React__default["default"].createElement(web.Grid, null,
                        React__default["default"].createElement(web.Row, null,
                            React__default["default"].createElement(web.Column, { xs: 12 }, renderNotification())),
                        React__default["default"].createElement("div", { className: "stickyBoundary" },
                            React__default["default"].createElement(web.Row, null,
                                React__default["default"].createElement(web.Column, { xs: 12, sm: 6, md: 5 },
                                    isMobile &&
                                        ((_c = equipmentContext.configs) === null || _c === void 0 ? void 0 : _c.titleSectionVariant) ===
                                            titleSectionVariant.top &&
                                        renderTitleSection(),
                                    React__default["default"].createElement(web.Spacing, { left: isMobile ? 0 : 7 }, renderEquipmentGallery())),
                                React__default["default"].createElement(web.Column, { xs: 12, sm: 6, md: 7 },
                                    React__default["default"].createElement(StyledLayout$1, { space: 3 },
                                        React__default["default"].createElement(React__default["default"].Fragment, null,
                                            renderBasicInfo(),
                                            renderHTMLDescription()),
                                        deliveryOptions && deliveryOptions.rrp &&
                                            renderFulfilment(),
                                        renderModelSelector(),
                                        renderColourPickerAndStorage(),
                                        deliveryOptions && !deliveryOptions.rrp &&
                                            renderFulfilment(),
                                        renderPlan((_d = equipmentContext.configs) === null || _d === void 0 ? void 0 : _d.isPlansCarousel, (_e = equipmentContext.configs) === null || _e === void 0 ? void 0 : _e.showPlansInSwimlane),
                                        renderDeviceNotification(),
                                        renderOrderSummary()),
                                    isMobile &&
                                        productHasStock &&
                                        ((_f = equipmentContext.configs) === null || _f === void 0 ? void 0 : _f.showOrderSummary) &&
                                        placeholderHeight && (React__default["default"].createElement(StyledOrderSummaryPlaceHolder, { className: "order-summary-placeholder", height: placeholderHeight })),
                                    renderQuantityAndActionButtons(),
                                    renderCartBox()))),
                        renderAccessories(),
                        productDetails.videoUrl && renderVideo())),
                renderWhatsInTheBox())),
        miniCartPosition === 'bottom' && renderSummaryBar()));
};

var defaultConfigProps = {
    showQuantitySelector: false,
    showStorageDivider: true,
    showSummaryBar: true,
    showTechSpecsAnchor: true,
    showOOSNotification: true,
    titleSectionVariant: titleSectionVariant.bottom
};

var EquipmentContext = React__default["default"].createContext(null);
var ProductDetails = function (_a) {
    var _b, _c;
    var data = _a.data, configs = _a.configs, localisation = _a.localisation, callbacks = _a.callbacks;
    var productDetails = data.productDetails, productModel = data.productModel;
    var _d = configs || {}, isQuantityRequired = _d.isQuantityRequired, fixedQuantity = _d.fixedQuantity, _e = _d.enableMultiSelection, enableMultiSelection = _e === void 0 ? false : _e, isLoading = _d.isLoading, dataMapping = _d.dataMapping; _d.simOnlyTncUrl;
    configs.baseUrl = configs.baseUrl || getBaseImageHostName();
    var renderAccessoryRibbon = (callbacks || {}).renderAccessoryRibbon;
    var _f = useDataMapping$1([productModel, (_b = productDetails === null || productDetails === void 0 ? void 0 : productDetails.plan) === null || _b === void 0 ? void 0 : _b.allPlans], dataMapping).mappedDataSets, mappedModel = _f[0], mappedPlans = _f[1];
    return (React__default["default"].createElement(EquipmentContext.Provider, { value: {
            configs: __assign(__assign({}, defaultConfigProps), configs),
            callbacks: callbacks
        } },
        React__default["default"].createElement(EquipmentDetails, { productDetails: __assign(__assign({}, productDetails), { variants: productDetails.variants, plan: {
                    planGroups: (_c = productDetails === null || productDetails === void 0 ? void 0 : productDetails.plan) === null || _c === void 0 ? void 0 : _c.planGroups,
                    allPlans: mappedPlans
                } }), onChange: function () { }, localisation: localisation, currentDataModel: mappedModel, multiple: enableMultiSelection, quantityLimit: fixedQuantity, isLoading: isLoading, isQuantityRequired: isQuantityRequired, accessoryRibbon: renderAccessoryRibbon })));
};

var VARIANT_PROPS_DEFAULT = {
    bordered: false,
    maxTitleLine: 2,
    leftContent: null,
    rightContent: { text: 'Add' }
};

var Tag = function (_a) {
    var _b = _a.color, color = _b === void 0 ? '#0082FF' : _b, content = _a.content, restDlsTagProps = __rest(_a, ["color", "content"]);
    return (React__default["default"].createElement(web.Tag, __assign({ size: "tall", color: color, customStyle: {
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
            borderTopRightRadius: 0
        } }, restDlsTagProps), content));
};

var ButtonWrapper = web.withTheme(styled__default["default"].div(templateObject_2$6 || (templateObject_2$6 = __makeTemplateObject(["\n  & button {\n    min-width: 90px !important;\n    pointer-events: visible !important;\n\n    &:hover {\n      ", "\n    }\n  }\n"], ["\n  & button {\n    min-width: 90px !important;\n    pointer-events: visible !important;\n\n    &:hover {\n      ", "\n    }\n  }\n"])), function (p) {
    return p.status === 'success' && styled.css(templateObject_1$8 || (templateObject_1$8 = __makeTemplateObject(["\n          background-color: ", " !important;\n        "], ["\n          background-color: ", " !important;\n        "])), function (_a) {
        var coreTheme = _a.coreTheme;
        return coreTheme.cl_successGreen;
    });
}));
var AddToCart = function (_a) {
    var itemInCart = _a.itemInCart, buttonProps = __rest(_a, ["itemInCart"]);
    var onClick = buttonProps.onClick, _b = buttonProps.secondary, secondary = _b === void 0 ? !itemInCart : _b, text = buttonProps.text, _c = buttonProps.fullWidth, fullWidth = _c === void 0 ? false : _c;
    return (React__default["default"].createElement(ButtonWrapper, { status: itemInCart ? 'success' : 'default' },
        React__default["default"].createElement(web.Button, __assign({ "data-testid": "add-cart", text: text, secondary: secondary, onClick: onClick, fullWidth: fullWidth }, (itemInCart && {
            loading: 'success'
        })))));
};
var templateObject_1$8, templateObject_2$6;

var AccordionWrapper = styled__default["default"].div(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject(["\n  padding-top: 20px;\n  padding-bottom: 4px;\n"], ["\n  padding-top: 20px;\n  padding-bottom: 4px;\n"])));
var Accordions = function (_a) {
    var data = _a.data, title = _a.title, link = _a.link, linkText = _a.linkText, _b = _a.linkTarget, linkTarget = _b === void 0 ? '_self' : _b, _c = _a.dlsComponentMapper, dlsComponentMapper$1 = _c === void 0 ? {} : _c, onClick = _a.onClick, onLinkClick = _a.onLinkClick, rest = __rest(_a, ["data", "title", "link", "linkText", "linkTarget", "dlsComponentMapper", "onClick", "onLinkClick"]);
    var _d = React.useState(-1), active = _d[0], setIndex = _d[1];
    var handleClick = function (value, item) {
        setIndex(active === value ? -1 : value);
        if (typeof onClick === 'function') {
            onClick(active, value, item);
        }
    };
    var handleLinkClick = function () {
        if (typeof onLinkClick === 'function') {
            onLinkClick();
        }
    };
    return (React__default["default"].createElement(AccordionWrapper, __assign({ "data-testid": "Accordion" }, rest),
        React__default["default"].createElement(web.Text, { type: "sectionTitle", tag: "h2" }, title),
        React__default["default"].createElement(web.Spacing, { bottom: 2, responsive: false }, data.map(function (item, index) {
            return (React__default["default"].createElement(web.Accordion, { key: index, title: React__default["default"].createElement(web.Text, { tag: "h3", type: "boldBody" }, item.title), desc: React__default["default"].createElement(web.Text, { tag: "div" },
                    React__default["default"].createElement(helpers.DynamicComponent, { htmlString: item.description, componentsToMap: __assign(__assign({}, dlsComponentMapper), dlsComponentMapper$1) })), selected: index === active, value: index, onClick: function (e, value) { return handleClick(value, item); } }));
        })),
        linkText && (React__default["default"].createElement(web.Spacing, { "data-testid": "accordion-link", bottom: 2, responsive: false },
            React__default["default"].createElement(web.Text, { type: "link", href: link, target: linkTarget, onClick: handleLinkClick }, linkText)))));
};
var templateObject_1$7;

var ImageWrapper = styled__default["default"].img(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n"], ["\n  width: 100%;\n  height: 100%;\n"])));
var Image = function (_a) {
    var Component = _a.component, src = _a.src, alt = _a.alt, rest = __rest(_a, ["component", "src", "alt"]);
    if (React.isValidElement(Component)) {
        return Component;
    }
    if (typeof Component === 'function') {
        return React__default["default"].createElement(Component, __assign({ src: src, alt: alt }, rest));
    }
    return src ? (React__default["default"].createElement(ImageWrapper, __assign({ "data-testid": "image", src: src, alt: alt }, rest))) : null;
};
var templateObject_1$6;

var StyledLayout = web.withTheme(styled__default["default"].div(templateObject_2$5 || (templateObject_2$5 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var coreTheme = _a.coreTheme;
    return styled.css(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject(["\n    padding-bottom: 16px;\n    padding-top: 24px;\n    display: flex;\n    flex-wrap: nowrap;\n    @media (min-width: ", ") {\n      padding-top: 0;\n    }\n  "], ["\n    padding-bottom: 16px;\n    padding-top: 24px;\n    display: flex;\n    flex-wrap: nowrap;\n    @media (min-width: ", ") {\n      padding-top: 0;\n    }\n  "])), coreTheme.brk_xs);
}));
var DescriptionSpace = web.withTheme(styled__default["default"](web.Spacing)(templateObject_4$3 || (templateObject_4$3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var coreTheme = _a.coreTheme;
    return styled.css(templateObject_3$3 || (templateObject_3$3 = __makeTemplateObject(["\n    @media (max-width: ", ") {\n      padding-bottom: 0;\n    }\n  "], ["\n    @media (max-width: ", ") {\n      padding-bottom: 0;\n    }\n  "])), coreTheme.brk_xs);
}));
var ProductDescription = function (_a) {
    var name = _a.name, alt = _a.alt, src = _a.src, description = _a.description, imageComponent = _a.imageComponent, dlsComponentMapper$1 = _a.dlsComponentMapper;
    return (React__default["default"].createElement("div", { "data-testid": "product-description" },
        React__default["default"].createElement(StyledLayout, null,
            (imageComponent || src) && (React__default["default"].createElement(LogoWrapper, { inline: true },
                React__default["default"].createElement(Image, { component: imageComponent, src: src, alt: alt }))),
            name && (React__default["default"].createElement(web.Spacing, { top: 0.3, responsive: false },
                React__default["default"].createElement(web.Text, { type: "pageTitle", tag: "h1" }, name)))),
        description && (React__default["default"].createElement(DescriptionSpace, { bottom: 4, responsive: true },
            React__default["default"].createElement(helpers.DynamicComponent, { htmlString: description, componentsToMap: __assign(__assign({}, dlsComponentMapper), dlsComponentMapper$1) })))));
};
var templateObject_1$5, templateObject_2$5, templateObject_3$3, templateObject_4$3;

var BannerWrapper = web.withTheme(styled__default["default"].div(templateObject_2$4 || (templateObject_2$4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var coreTheme = _a.coreTheme;
    return styled.css(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject(["\n    aspect-ratio: 1 / 1;\n    max-width: 327px;\n    & img {\n      width: 100%;\n      height: 100%;\n      border-radius: 8px;\n      box-shadow: ", ";\n    }\n    @media (max-width: ", ") {\n      max-width: none;\n    }\n  "], ["\n    aspect-ratio: 1 / 1;\n    max-width: 327px;\n    & img {\n      width: 100%;\n      height: 100%;\n      border-radius: 8px;\n      box-shadow: ", ";\n    }\n    @media (max-width: ", ") {\n      max-width: none;\n    }\n  "])), coreTheme.sd_size_1, coreTheme.brk_xs);
}));
var Banner = function (_a) {
    var imageComponent = _a.imageComponent, src = _a.src, alt = _a.alt;
    return (React__default["default"].createElement(BannerWrapper, null,
        React__default["default"].createElement(Image, { component: imageComponent, src: src, alt: alt })));
};
var templateObject_1$4, templateObject_2$4;

var StyledRow = styled__default["default"](web.Row)(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n  padding-top: 24px;\n"], ["\n  padding-top: 24px;\n"])));
var StyledInline = styled__default["default"].div(templateObject_2$3 || (templateObject_2$3 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var StyledColumn = web.withTheme(styled__default["default"](web.Column)(templateObject_4$2 || (templateObject_4$2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var coreTheme = _a.coreTheme;
    return styled.css(templateObject_3$2 || (templateObject_3$2 = __makeTemplateObject(["\n    padding-right: 1rem;\n\n    &:last-child {\n      padding-right: 0;\n    }\n\n    @media (max-width: ", ") {\n      padding-right: 0;\n    }\n  "], ["\n    padding-right: 1rem;\n\n    &:last-child {\n      padding-right: 0;\n    }\n\n    @media (max-width: ", ") {\n      padding-right: 0;\n    }\n  "])), coreTheme.brk_xs);
}));
var FeatureList = function (_a) {
    var title = _a.title, list = _a.list;
    return (React__default["default"].createElement(StyledRow, { "data-testid": "feature-list" },
        title && (React__default["default"].createElement(web.Column, { xs: 12, noGutter: true },
            React__default["default"].createElement(web.Spacing, { bottom: 2 },
                React__default["default"].createElement(web.Text, { type: "sectionTitle", tag: "h2" }, title)))),
        list.map(function (item, index) {
            var _a, _b, _c, _d, _e;
            return (React__default["default"].createElement(StyledColumn, { key: index, xs: 12, sm: 4, noGutter: true },
                React__default["default"].createElement(web.Spacing, { bottom: 3, responsive: false },
                    React__default["default"].createElement(StyledInline, { space: 2 },
                        (((_a = item.image) === null || _a === void 0 ? void 0 : _a.src) || ((_b = item.image) === null || _b === void 0 ? void 0 : _b.component)) && (React__default["default"].createElement(LogoWrapper, { "data-testid": "icon-logo", inline: true },
                            React__default["default"].createElement(Image, { component: (_c = item.image) === null || _c === void 0 ? void 0 : _c.component, src: (_d = item.image) === null || _d === void 0 ? void 0 : _d.src, alt: (_e = item.image) === null || _e === void 0 ? void 0 : _e.alt }))),
                        React__default["default"].createElement("div", null,
                            React__default["default"].createElement(web.Text, { type: "boldBody", tag: "h3" }, item.title),
                            React__default["default"].createElement(web.Text, null, item.description))))));
        })));
};
var templateObject_1$3, templateObject_2$3, templateObject_3$2, templateObject_4$2;

var Wrapper = web.withTheme(styled__default["default"].div(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var coreTheme = _a.coreTheme;
    return styled.css(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n    background: ", ";\n    padding-top: 1.5rem;\n    padding-bottom: 0.5rem;\n    @media (min-width: ", ") {\n      padding-top: 4.5rem;\n      padding-bottom: 3.5rem;\n    }\n  "], ["\n    background: ", ";\n    padding-top: 1.5rem;\n    padding-bottom: 0.5rem;\n    @media (min-width: ", ") {\n      padding-top: 4.5rem;\n      padding-bottom: 3.5rem;\n    }\n  "])), coreTheme.cl_ter_l6, coreTheme.brk_xs);
}));
var VariantWrapper = web.withTheme(styled__default["default"](web.Spacing)(templateObject_4$1 || (templateObject_4$1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var coreTheme = _a.coreTheme;
    return styled.css(templateObject_3$1 || (templateObject_3$1 = __makeTemplateObject(["\n    @media (min-width: ", ") {\n      padding-top: 2.5rem;\n    }\n  "], ["\n    @media (min-width: ", ") {\n      padding-top: 2.5rem;\n    }\n  "])), coreTheme.brk_xs);
}));
var DividerWrapper = web.withTheme(styled__default["default"].div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var coreTheme = _a.coreTheme;
    return styled.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: none;\n    @media (min-width: ", ") {\n      display: block;\n    }\n  "], ["\n    display: none;\n    @media (min-width: ", ") {\n      display: block;\n    }\n  "])), coreTheme.brk_xs);
}));
var ColumnStyled = web.withTheme(styled__default["default"](web.Column)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var coreTheme = _a.coreTheme;
    return styled.css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    @media (min-width: ", ") {\n      padding-left: 0.5rem;\n    }\n  "], ["\n    @media (min-width: ", ") {\n      padding-left: 0.5rem;\n    }\n  "])), coreTheme.brk_xs);
}));
var GridStyled = styled__default["default"](web.Grid)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  padding-right: 1.5rem;\n  padding-left: 1.5rem;\n"], ["\n  padding-right: 1.5rem;\n  padding-left: 1.5rem;\n"])));
var AccordionSection = web.withTheme(styled__default["default"](GridStyled)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var coreTheme = _a.coreTheme;
    return styled.css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    padding-top: 1.25rem;\n    padding-bottom: 1.25rem;\n    @media (min-width: ", ") {\n      padding-top: 3.75rem;\n      padding-bottom: 3.75rem;\n      padding-right: 0px;\n      padding-left: 0px;\n    }\n  "], ["\n    padding-top: 1.25rem;\n    padding-bottom: 1.25rem;\n    @media (min-width: ", ") {\n      padding-top: 3.75rem;\n      padding-bottom: 3.75rem;\n      padding-right: 0px;\n      padding-left: 0px;\n    }\n  "])), coreTheme.brk_xs);
}));
var Subscription = function (props) {
    var data = props.data, config = props.config, _a = props.callbacks, callbacks = _a === void 0 ? {} : _a, _b = props.dlsComponentMapper, dlsComponentMapper = _b === void 0 ? {} : _b;
    var name = data.name, description = data.description, _c = data.variantsTitle, variantsTitle = _c === void 0 ? 'Choose a plan' : _c, _d = data.variants, variants = _d === void 0 ? [] : _d, _e = data.accordions, accordions = _e === void 0 ? [] : _e, feature = data.feature;
    var _f = config.bannerProps, bannerProps = _f === void 0 ? {} : _f, _g = config.thumbnailProps, thumbnailProps = _g === void 0 ? {} : _g, _h = config.tagProps, tagProps = _h === void 0 ? {} : _h, _j = config.variantProps, initialvariantProps = _j === void 0 ? {} : _j;
    var variantProps = __assign(__assign({}, VARIANT_PROPS_DEFAULT), initialvariantProps);
    return (React__default["default"].createElement("div", { "data-testid": "subscription-details" },
        React__default["default"].createElement(Wrapper, null,
            React__default["default"].createElement(GridStyled, null,
                React__default["default"].createElement(web.Row, null,
                    React__default["default"].createElement(web.Column, { xs: 12, sm: 4, noGutter: true },
                        React__default["default"].createElement(Banner, { imageComponent: bannerProps.component, src: data.banner, alt: data.bannerAlt || data.name })),
                    React__default["default"].createElement(ColumnStyled, { xs: 12, sm: 8, noGutter: true },
                        React__default["default"].createElement(ProductDescription, { name: name, description: description, alt: name, src: data.thumbnail, dlsComponentMapper: dlsComponentMapper, imageComponent: thumbnailProps.component }),
                        React__default["default"].createElement(DividerWrapper, null,
                            React__default["default"].createElement(web.Divider, null)),
                        React__default["default"].createElement(VariantWrapper, { top: 3, responsive: false },
                            React__default["default"].createElement(web.Spacing, { bottom: 2, responsive: false },
                                React__default["default"].createElement(web.Text, { type: "header" }, variantsTitle)),
                            variants.map(function (variant) {
                                return (React__default["default"].createElement(web.Spacing, { key: variant.id, bottom: 2, responsive: false },
                                    React__default["default"].createElement(web.Card, { padding: "md" },
                                        variant.tagline && (React__default["default"].createElement(Tag, __assign({}, tagProps, { content: variant.tagline }))),
                                        React__default["default"].createElement(web.Spacing, { leftRight: 3, topBottom: 2, responsive: false },
                                            React__default["default"].createElement(web.ListItem, { bordered: false, body: [
                                                    { title: variant.title },
                                                    { subTitle: variant.subtitle }
                                                ], maxTitleLine: variantProps.maxTitleLine, leftContent: null, rightContent: React__default["default"].createElement(AddToCart, { itemInCart: callbacks[variantProps.isItemInCart](variant), onClick: function (e) {
                                                        callbacks[variantProps.onAddToCart](variant);
                                                    }, text: variantProps.rightContent.text ||
                                                        VARIANT_PROPS_DEFAULT.rightContent.text }) })))));
                            })))),
                feature && React__default["default"].createElement(FeatureList, { title: feature.title, list: feature.list }))),
        React__default["default"].createElement(AccordionSection, { noGutter: true }, accordions.map(function (accordion) {
            return (React__default["default"].createElement(web.Row, null,
                React__default["default"].createElement(web.Column, { noGutter: true, xs: false, sm: 2 }),
                React__default["default"].createElement(web.Column, { noGutter: true, sm: 8 },
                    React__default["default"].createElement(Accordions, { dlsComponentMapper: dlsComponentMapper, data: accordion.items, title: accordion.title, linkText: accordion.linkText, link: accordion.link, linkTarget: accordion.linkTarget, onClick: accordion.onClick, onLinkClick: accordion.onLinkClick })),
                React__default["default"].createElement(web.Column, { noGutter: true, xs: false, sm: 2 })));
        }))));
};
var templateObject_1$2, templateObject_2$2, templateObject_3$1, templateObject_4$1, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;

var _a;
var VARIANT_TYPE = {
    product: 'product',
    subscription: 'subscription'
};
var ProductDetailVariant = (_a = {},
    _a[VARIANT_TYPE.product] = ProductDetails,
    _a[VARIANT_TYPE.subscription] = Subscription,
    _a);
var ProductDetailsWrapper = function (props) {
    var _a = props.type, type = _a === void 0 ? VARIANT_TYPE.product : _a, rest = __rest(props, ["type"]);
    var Component = ProductDetailVariant[type];
    //@ts-ignore
    return Component ? (React__default["default"].createElement(Component, __assign({ "data-testid": "product-details-wrapper" }, rest))) : null;
};

var Accessories = function (_a) {
    var data = _a.data, preselectAccessories = _a.preselectAccessories, accessoryRibbon = _a.accessoryRibbon, configs = _a.configs, callbacks = _a.callbacks, localisation = _a.localisation;
    var propAccessories = data.accessories, deviceTitle = data.deviceTitle;
    var isListLoading = (configs || {}).isLoading;
    var _b = useAccessory({
        accessories: propAccessories,
        preselectAccessories: preselectAccessories,
        checkStock: callbacks === null || callbacks === void 0 ? void 0 : callbacks.checkStock
    }), accessories = _b.accessories, viewAccessory = _b.viewAccessory, selectedAccessory = _b.selectedAccessory, isLoading = _b.isLoading;
    updateMessages(localisation);
    var renderAccessories = function () {
        if (!accessories.length)
            return null;
        return (React__default["default"].createElement(React__default["default"].Fragment, null,
            React__default["default"].createElement(web.Divider, null),
            React__default["default"].createElement(web.Spacing, { topBottom: 3 },
                React__default["default"].createElement(EquipmentContext.Provider, { value: {
                        configs: __assign({}, configs),
                        callbacks: callbacks
                    } },
                    React__default["default"].createElement(AccessoryList, { pagination: configs.pagination, selectedAccessory: selectedAccessory, isModalLoading: isLoading, isListLoading: isListLoading, onViewMore: viewAccessory, onRemoveAccessory: callbacks.onRemove, onSelectAccessory: callbacks.onAdd, headerText: trans('ACCESSORY_HEADER_TEXT', {
                            deviceTitle: deviceTitle
                        }), accessories: accessories, accessoryRibbon: accessoryRibbon })))));
    };
    return renderAccessories();
};

var ELocalisation;
(function (ELocalisation) {
    ELocalisation["ADDONS_CATALOGUE_TITLE"] = "ADDONS_CATALOGUE_TITLE";
    ELocalisation["ACTION_BUTTON_ADD"] = "ACTION_BUTTON_ADD";
    ELocalisation["ACTION_BUTTON_REMOVE"] = "ACTION_BUTTON_REMOVE";
    ELocalisation["ACTION_BUTTON_UPGRADE"] = "ACTION_BUTTON_UPGRADE";
    ELocalisation["ACTION_BUTTON_SHOWMORE"] = "ACTION_BUTTON_SHOWMORE";
    ELocalisation["ACTION_BUTTON_SHOW_LESS"] = "ACTION_BUTTON_SHOW_LESS";
    ELocalisation["ADDONS_NOT_FOUND"] = "ADDONS_NOT_FOUND";
    ELocalisation["NO_CONTRACT_TEXT"] = "NO_CONTRACT_TEXT";
    ELocalisation["MTH_CONTRACT_TEXT"] = "MTH_CONTRACT_TEXT";
    ELocalisation["SETUP_FEE"] = "SETUP_FEE";
    ELocalisation["UPSIZE_SMS"] = "UPSIZE_SMS";
    ELocalisation["UPSIZE_DATA"] = "UPSIZE_DATA";
    ELocalisation["UPSIZE_TALKTIME"] = "UPSIZE_TALKTIME";
})(ELocalisation || (ELocalisation = {}));

var AllowedActionTypes;
(function (AllowedActionTypes) {
    AllowedActionTypes["ADD"] = "AD";
    AllowedActionTypes["REMOVE"] = "RM";
    AllowedActionTypes["UPGRADE"] = "UP";
})(AllowedActionTypes || (AllowedActionTypes = {}));

var dataXDynamicProductTitle = "{{ productTitle }}";
var addonConstants = {
    DEFAULT_SHOW_ADDONS_COUNT: 5,
    ERRORS: {
        '11982': {
            message: 'Free trial is applicable for first-time users only'
        },
        '9722': {
            message: 'To remove this add-on, please go to My Singtel app > Manage plan and add-ons'
        },
        '8472632': {
            message: 'Maximum 3 subscriptions reached. To add another subscription, please remove one MobileSwop subscription via My Singtel app > ‘Manage plan and add-ons’ first'
        },
        '14438091': {
            message: "To remove your existing " + dataXDynamicProductTitle + " add-on, please go to My Singtel app > Manage plan and add-ons"
        }
    },
    PRODUCT_SPEC_ID: {
        DATA_X_PRODUCT_SPEC_CHARACTERISTIC_ID: '14438091'
    },
    SIM_ONLY_ADDON_KEYS: {
        DATA: 'data',
        SMS: 'sms',
        TALKTIME: 'talktime'
    }
};
var ADDON_ACTIONS;
(function (ADDON_ACTIONS) {
    ADDON_ACTIONS["ADD"] = "ADD";
    ADDON_ACTIONS["REMOVE"] = "REMOVE";
    ADDON_ACTIONS["UPGRADE"] = "UPGRADE";
})(ADDON_ACTIONS || (ADDON_ACTIONS = {}));

var addonHelpers = {
    canAdd: function (allowedActions) {
        if (!allowedActions || !allowedActions.length)
            return false;
        var canAdd = allowedActions === null || allowedActions === void 0 ? void 0 : allowedActions.find(function (action) { return action.type === AllowedActionTypes.ADD && action.allowed; });
        return !!canAdd;
    },
    canUpgrade: function (allowedActions) {
        if (!allowedActions || !allowedActions.length)
            return false;
        var canUpgrade = allowedActions.find(function (action) { return action.type === AllowedActionTypes.UPGRADE && action.allowed; });
        return !!canUpgrade;
    },
    hasConfiguredActions: function (addOn) {
        var _a;
        return ((_a = addOn === null || addOn === void 0 ? void 0 : addOn.allowedActions) === null || _a === void 0 ? void 0 : _a.length) > 0;
    },
    isAddonWithoutGroup: function (addonGroup) {
        var _a;
        return !!(addonGroup.isAddonWithoutGroup &&
            ((_a = addonGroup === null || addonGroup === void 0 ? void 0 : addonGroup.groupAddOns) === null || _a === void 0 ? void 0 : _a.length) === 1);
    },
    isDataXProductSpec: function (productSpecContainmentID) {
        return (productSpecContainmentID ===
            addonConstants.PRODUCT_SPEC_ID.DATA_X_PRODUCT_SPEC_CHARACTERISTIC_ID);
    },
    getAddOnErrorNotification: function (addonGroup) {
        var firstAddon = (addonGroup === null || addonGroup === void 0 ? void 0 : addonGroup.groupAddOns) && addonGroup.groupAddOns[0];
        //@ts-ignore
        var selectedAddonError = addonConstants.ERRORS[addonGroup.productSpecContainmentID];
        var addonErrorMessage = selectedAddonError && selectedAddonError.message;
        var addonInContract = firstAddon === null || firstAddon === void 0 ? void 0 : firstAddon.addonInContract;
        if (addonInContract &&
            addonHelpers.isDataXProductSpec(addonGroup.productSpecContainmentID)) {
            addonErrorMessage = selectedAddonError.message.replace(dataXDynamicProductTitle, addonInContract.productTitle);
        }
        if (addonInContract || addonGroup.disabled) {
            return addonErrorMessage;
        }
    },
    formatCurrency: function (number) {
        if (number === undefined) {
            return "0.00";
        }
        return parseFloat(number.toString()).toFixed(2);
    }
};

var AddOnItemStyle = {
    AddonItemWrapper: styled__default["default"].div(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n    opacity: ", ";\n  "], ["\n    opacity: ", ";\n  "])), function (p) { return (p.disabled ? 0.2 : 1); }),
    StyledRibbon: styled__default["default"].div(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["\n    padding: 14px 0px 0px 7px;\n  "], ["\n    padding: 14px 0px 0px 7px;\n  "])))
};
var templateObject_1$1, templateObject_2$1;

var AddonItem = function (props) {
    var _a;
    var _b;
    var data = props.data, groupInfo = props.groupInfo, localisation = props.localisation, callback = props.callback, isInGroup = props.isInGroup;
    var _c = data.addonData, addOnId = _c.addOnId, addOnTitle = _c.addOnTitle, addOnRibbon = _c.addOnRibbon, _d = _c.addOnPlans, addOnPlans = _d === void 0 ? [] : _d;
    var groupId = groupInfo.groupId;
    var t = useTranslation(localisation).t;
    var _e = React.useState(0), renderCount = _e[0], setRenderCount = _e[1];
    var _f = React.useState(false), isAdded = _f[0], setIsAdded = _f[1];
    var itemObj = {
        groupId: groupId,
        addonId: addOnId,
        planId: ''
    };
    var handleFirstClick = function (isAddedItem) {
        setRenderCount(function (current) { return current + 1; });
        setIsAdded(!isAddedItem);
    };
    var handleSubsequentClicks = function (isAddedItem) {
        setIsAdded(!isAddedItem);
    };
    React.useEffect(function () {
        renderCount > 0
            ? isAdded
                ? addItemToArray(itemObj)
                : removeItemFromArray(itemObj)
            : null;
    }, [renderCount, isAdded]);
    var addItemToArray = function (itemToAdd) {
        callback.onButtonClicked(itemToAdd, ADDON_ACTIONS.ADD);
    };
    var removeItemFromArray = function (itemToRemove) {
        callback.onButtonClicked(itemToRemove, ADDON_ACTIONS.REMOVE);
    };
    var ACTION = (_a = {},
        _a[ADDON_ACTIONS.ADD] = {
            text: t(ELocalisation.ACTION_BUTTON_ADD),
            onClick: function () {
                callback.onButtonClicked && callback.onButtonClicked(data.addonData, ADDON_ACTIONS.ADD);
            }
        },
        _a[ADDON_ACTIONS.REMOVE] = {
            text: t(ELocalisation.ACTION_BUTTON_REMOVE),
            onClick: function () {
                callback.onButtonClicked && callback.onButtonClicked(data.addonData, ADDON_ACTIONS.REMOVE);
            }
        },
        _a[ADDON_ACTIONS.UPGRADE] = {
            text: t(ELocalisation.ACTION_BUTTON_UPGRADE),
            onClick: function () {
                callback.onButtonClicked && callback.onButtonClicked(data.addonData, ADDON_ACTIONS.UPGRADE);
            }
        },
        _a);
    var getAction = function () {
        var addon = data.addonData;
        return addonHelpers.canUpgrade(addon.allowedActions)
            ? ADDON_ACTIONS.UPGRADE
            : addonHelpers.canAdd(addon.allowedActions)
                ? ADDON_ACTIONS.ADD
                : ADDON_ACTIONS.REMOVE;
    };
    var renderAddons = function () {
        var addon = data.addonData;
        var contractText;
        if (addon.contract) {
            contractText =
                !isInGroup && addon.contract === '0'
                    ? ''
                    : addon.contract === '0'
                        ? t(ELocalisation.NO_CONTRACT_TEXT)
                        : addon.contractText
                            ? addon.contractText
                            : addon.contract + "-" + t(ELocalisation.MTH_CONTRACT_TEXT);
        }
        var addonPrice = addon.price !== '0' ? addonHelpers.formatCurrency(addon.price) + "/mth" : addonHelpers.formatCurrency(addon.onetimePrice);
        return renderAddon({
            title: isInGroup ? addon.addOnTitle : '',
            subTitle: '',
            contractText: contractText,
            price: addonPrice
        });
    };
    var renderAddon = function (_a) {
        var contractText = _a.contractText, title = _a.title, subTitle = _a.subTitle, price = _a.price, _b = _a.isPrevAdded, isPrevAdded = _b === void 0 ? false : _b;
        return (React__default["default"].createElement(React__default["default"].Fragment, null,
            React__default["default"].createElement(web.Column, { xs: 12, sm: 6, md: 6 },
                React__default["default"].createElement(web.Text, null, title),
                React__default["default"].createElement(web.Text, null, subTitle),
                React__default["default"].createElement(web.Text, null, contractText)),
            price && (React__default["default"].createElement(web.Column, { xs: 8, sm: 3, md: 3 },
                React__default["default"].createElement(web.Row, { end: "xs" },
                    React__default["default"].createElement(web.Text, null,
                        "$",
                        price)))),
            React__default["default"].createElement(web.Column, { xs: 4, sm: 3, md: 3 },
                React__default["default"].createElement(web.Row, { end: "xs" }, renderButton(isPrevAdded)))));
    };
    var renderPlan = function () {
        return (addOnPlans || []).map(function (plan) {
            itemObj.planId = plan.planId;
            var isPrevAdded = data.prev.findIndex(function (item) { return item.planId === plan.planId; }) > -1;
            renderCount < 1 && isPrevAdded ? addItemToArray(itemObj) : null;
            renderCount > 0 && isAdded ? addItemToArray(itemObj) : null;
            return renderAddon({
                title: addOnTitle,
                subTitle: plan.planTitle,
                contractText: plan.planContract,
                price: plan.planPrice + "/mth",
                isPrevAdded: isPrevAdded
            });
        });
    };
    var renderButton = function (isPrevAdded) {
        if (addonHelpers.hasConfiguredActions(data.addonData)) {
            return renderConfiguredButton();
        }
        return renderAddBtn(isPrevAdded);
    };
    var renderConfiguredButton = function () {
        return (React__default["default"].createElement(web.Button, { "data-testid": "addon-button", secondary: true, disabled: data.addonData.disabled, onClick: ACTION[getAction()].onClick }, ACTION[getAction()].text));
    };
    var renderAddBtn = function (isPrevAdded) {
        return (React__default["default"].createElement(React__default["default"].Fragment, null, renderCount < 1 ? (React__default["default"].createElement(web.Button, { secondary: !isPrevAdded, onClick: function () { return handleFirstClick(isPrevAdded); }, "data-testid": "render-add-button" }, isPrevAdded
            ? t(ELocalisation.ACTION_BUTTON_REMOVE)
            : t(ELocalisation.ACTION_BUTTON_ADD))) : (React__default["default"].createElement(web.Button, { secondary: !isAdded, onClick: function () { return handleSubsequentClicks(isAdded); } }, isAdded
            ? t(ELocalisation.ACTION_BUTTON_REMOVE)
            : t(ELocalisation.ACTION_BUTTON_ADD)))));
    };
    var renderAddOnContent = function () {
        var _a, _b;
        if ((_b = (_a = data.addonData) === null || _a === void 0 ? void 0 : _a.addOnPlans) === null || _b === void 0 ? void 0 : _b.length) {
            return renderPlan();
        }
        return renderAddons();
    };
    var renderRibbon = function () {
        if (!addOnRibbon) {
            return null;
        }
        var addon = data.addonData;
        var ribbonText;
        if (addonHelpers.hasConfiguredActions(addon)) {
            ribbonText = addon.promoDescription
                ? addon.promoDescription
                : addon.promotionText && addon.atomic
                    ? addon.promotionText
                    : '';
        }
        else {
            ribbonText = addOnRibbon;
        }
        if (!ribbonText) {
            return null;
        }
        return (React__default["default"].createElement(AddOnItemStyle.StyledRibbon, null,
            React__default["default"].createElement(web.Ribbon.Variant1, null, ribbonText)));
    };
    return (React__default["default"].createElement(AddOnItemStyle.AddonItemWrapper, { "data-testid": "addon-item", disabled: (_b = data.addonData) === null || _b === void 0 ? void 0 : _b.disabled },
        renderRibbon(),
        React__default["default"].createElement(web.Row, null, renderAddOnContent())));
};

var AddOnGroup = {
    GroupIcon: web.withTheme(styled__default["default"].div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 80px;\n    height: 80px;\n    border-radius: ", ";\n    margin-right: 16px;\n    overflow: hidden;\n  "], ["\n    width: 80px;\n    height: 80px;\n    border-radius: ", ";\n    margin-right: 16px;\n    overflow: hidden;\n  "])), function (_a) {
        var coreTheme = _a.coreTheme;
        return coreTheme.rad_lg;
    })),
    GroupContent: styled__default["default"].div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    flex: 1;\n  "], ["\n    flex: 1;\n  "]))),
    GroupWrapper: styled__default["default"].div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n  "], ["\n    display: flex;\n  "]))),
    NotificationWrapper: styled__default["default"].div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    padding: 8px;\n  "], ["\n    padding: 8px;\n  "])))
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;

var AddonGroup = function (props) {
    var data = props.data, groupInfo = props.groupInfo, localisation = props.localisation, callback = props.callback;
    var _a = data.groupData, groupName = _a.groupName, groupDescription = _a.groupDescription, _b = _a.groupAddOns, groupAddOns = _b === void 0 ? [] : _b;
    var t = useTranslation(localisation).t;
    var renderImage = function () {
        var _a, _b, _c;
        var image = (_c = (_b = (_a = data.groupData) === null || _a === void 0 ? void 0 : _a.iconImage) === null || _b === void 0 ? void 0 : _b.childImageSharp) === null || _c === void 0 ? void 0 : _c.fixed;
        if (!image) {
            return null;
        }
        return (React__default["default"].createElement(AddOnGroup.GroupIcon, null,
            React__default["default"].createElement(Img, { fixed: image })));
    };
    var renderErrorNotification = function () {
        var errorNotification = addonHelpers.getAddOnErrorNotification(data.groupData);
        if (errorNotification) {
            return (React__default["default"].createElement(AddOnGroup.NotificationWrapper, { "data-testid": "addon-notification" },
                React__default["default"].createElement(web.Notification, { horizontalPadding: 'lg', content: errorNotification, type: 'info' })));
        }
        return null;
    };
    var renderGroup = function () {
        var getGroupDescription = function () {
            var _a, _b, _c;
            var addons = (_a = data === null || data === void 0 ? void 0 : data.groupData) === null || _a === void 0 ? void 0 : _a.groupAddOns;
            if (isAddonWithoutGroup()) {
                return {
                    title: (_b = addons[0]) === null || _b === void 0 ? void 0 : _b.addOnTitle,
                    description: (_c = addons[0]) === null || _c === void 0 ? void 0 : _c.addOnDescription
                };
            }
            return {
                title: groupName,
                description: groupDescription
            };
        };
        var renderSetupFee = function () {
            return !isAddonWithoutGroup() && (groupInfo === null || groupInfo === void 0 ? void 0 : groupInfo.setupFee) ? (React__default["default"].createElement(web.Text, { "data-testid": "setup-fee" },
                t(ELocalisation.SETUP_FEE),
                ": ",
                groupInfo.setupFee)) : null;
        };
        var groupDescriptions = getGroupDescription();
        return (React__default["default"].createElement(React__default["default"].Fragment, null,
            React__default["default"].createElement(web.Card.Content, null,
                React__default["default"].createElement(AddOnGroup.GroupWrapper, null,
                    renderImage(),
                    React__default["default"].createElement(AddOnGroup.GroupContent, null,
                        React__default["default"].createElement(web.Card.Title, null, groupDescriptions.title),
                        React__default["default"].createElement(web.Card.Body, null, groupDescriptions.description),
                        renderSetupFee())))));
    };
    var isAddonWithoutGroup = function () {
        return addonHelpers.isAddonWithoutGroup(data.groupData);
    };
    var renderAddon = function () {
        return (groupAddOns || []).map(function (addon, i, arr) {
            return (React__default["default"].createElement(React__default["default"].Fragment, null,
                React__default["default"].createElement(AddonItem, { key: addon.addOnId, isInGroup: !isAddonWithoutGroup(), data: {
                        addonData: addon,
                        prev: data.prev
                    }, groupInfo: groupInfo, localisation: localisation, callback: callback }),
                (arr || []).length === i + 1 ? null : (React__default["default"].createElement(web.Column, null,
                    React__default["default"].createElement(web.Divider, { key: addon.addOnId })))));
        });
    };
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement(web.Column, { "data-testid": "addon-group" },
            React__default["default"].createElement(web.Card, null,
                React__default["default"].createElement(web.Row, null,
                    React__default["default"].createElement(web.Column, { xs: 12, sm: 12, md: 5 }, renderGroup()),
                    React__default["default"].createElement(web.Column, { xs: 12, sm: 12, md: 7 },
                        renderErrorNotification(),
                        renderAddon()))))));
};

var attributeList = [
    'groupId',
    'groupName',
    'isBundled',
    'groupDescription',
    'addOnId',
    'addOnTitle',
    'addOnDescription',
    'addOnImage',
    'addOnType',
    'addOnRibbon',
    'planId',
    'planTitle',
    'planPrice',
    'planContract',
    'groupAddOns'
];
var getMappedData = function (dataSrc, dataMapping, validMapping) {
    if (!validMapping.length)
        return dataSrc;
    var getNewObj = function (obj) {
        validMapping.forEach(function (attr) {
            var attrInSrc = dataMapping[attr];
            var value = obj[attrInSrc];
            if (!value)
                return;
            //assign new attribute value to newObj
            obj[attr] = value;
        });
        Object.keys(obj).forEach(function (item) {
            var value = obj[item];
            if (Array.isArray(value)) {
                value = getMappedData(value, dataMapping, validMapping);
                obj[item] = value;
            }
        });
        return obj;
    };
    if (Array.isArray(dataSrc)) {
        return dataSrc.map(function (item) {
            var newObj = __assign({}, item);
            return getNewObj(newObj);
        });
    }
    else if (typeof dataSrc === 'object') {
        return getNewObj(__assign({}, dataSrc));
    }
    else {
        return dataSrc;
    }
};
/**
 *
 *
 * @export
 * @param {*} [dataSets=[]]
 * @param {object} [dataMapping={}]
 * @returns
 */
function useDataMapping(dataSets, dataMapping) {
    var validMappingList = React.useMemo(function () {
        return Object.keys(dataMapping).filter(function (attr) {
            return attributeList.indexOf(attr) > -1;
        });
    }, [dataMapping]);
    var mappedDataSets = React.useMemo(function () {
        return dataSets.map(function (item) {
            return getMappedData(item, dataMapping, validMappingList);
        });
    }, [dataSets, dataMapping]);
    return { mappedDataSets: mappedDataSets };
}

var EPaginationBehaviour;
(function (EPaginationBehaviour) {
    EPaginationBehaviour["SHOW_ALL"] = "SHOW_ALL";
    EPaginationBehaviour["LAZY_LOAD"] = "LAZY_LOAD";
})(EPaginationBehaviour || (EPaginationBehaviour = {}));

var ConfigContext = React__default["default"].createContext({
    dataMapping: {}
});

var AddonsCatalogue = function (props) {
    var config = props.config, data = props.data, localisation = props.localisation, callback = props.callback;
    var _a = config || {}, dataMapping = _a.dataMapping, _b = _a.pagination, pagination = _b === void 0 ? {} : _b;
    var _c = React.useState(false), isDisplayedMore = _c[0], setDisplayMore = _c[1];
    var _d = pagination.enabled, paginationEnabled = _d === void 0 ? false : _d, _e = pagination.behaviour, paginationBehaviour = _e === void 0 ? EPaginationBehaviour.LAZY_LOAD : _e, _f = pagination.defaultPageSize, defaultPageSize = _f === void 0 ? addonConstants.DEFAULT_SHOW_ADDONS_COUNT : _f;
    var t = useTranslation(localisation).t;
    var addedItemsArr = [];
    var mappedCatalogueData = useDataMapping([data.catalogueData], dataMapping).mappedDataSets[0];
    var handleAdd = function (objToAdd) {
        var index = addedItemsArr.findIndex(function (item) {
            return item.groupId === objToAdd.groupId &&
                item.addonId === objToAdd.addonId &&
                item.planId === objToAdd.planId;
        });
        index < 0 && addedItemsArr.push(objToAdd);
        callback.onButtonClicked(objToAdd, ADDON_ACTIONS.ADD);
        callback.getSelectedItemsArray(addedItemsArr);
    };
    var handleRemove = function (objToRemove) {
        var index = addedItemsArr.findIndex(function (item) {
            return item.groupId === objToRemove.groupId &&
                item.addonId === objToRemove.addonId &&
                item.planId === objToRemove.planId;
        });
        index > -1 &&
            (addedItemsArr = __spreadArray(__spreadArray([], (addedItemsArr || []).slice(0, index), true), (addedItemsArr || []).slice(index + 1), true));
        callback.onButtonClicked(objToRemove, ADDON_ACTIONS.REMOVE);
        callback.getSelectedItemsArray(addedItemsArr);
    };
    var _g = React.useState(1), visibleGroup = _g[0]; _g[1];
    (mappedCatalogueData || []).slice(0, visibleGroup);
    var renderCatalogue = function () {
        return (React__default["default"].createElement(React__default["default"].Fragment, null,
            renderAddonGroups(),
            renderShowMoreBtn()));
    };
    var handleCallback = function (group) {
        if (addonHelpers.hasConfiguredActions(group === null || group === void 0 ? void 0 : group.groupAddOns[0])) {
            return callback;
        }
        return {
            onButtonClicked: function (addon, type) {
                type === ADDON_ACTIONS.ADD
                    ? handleAdd(addon)
                    : // console.log(addon)
                        handleRemove(addon);
            },
            getSelectedItemsArray: function () { }
        };
    };
    var renderAddonGroups = function () {
        var displayedGroups = mappedCatalogueData;
        if (paginationEnabled) {
            switch (paginationBehaviour) {
                case EPaginationBehaviour.SHOW_ALL: {
                    if (isDisplayedMore) {
                        displayedGroups = mappedCatalogueData;
                    }
                    else {
                        displayedGroups = mappedCatalogueData.slice(0, defaultPageSize);
                    }
                    break;
                }
            }
        }
        return renderGroups(displayedGroups);
    };
    var showMoreAddons = function () {
        switch (paginationBehaviour) {
            case EPaginationBehaviour.SHOW_ALL: {
                setDisplayMore(!isDisplayedMore);
            }
        }
    };
    // TODO:
    // const renderGroups = () => (displayGroup || []).map((group: Group) => {
    var renderGroups = function (groups) {
        return (groups || []).map(function (group) {
            return (React__default["default"].createElement(AddonGroup, { key: group.groupId, data: {
                    groupData: group,
                    prev: data.prev
                }, groupInfo: group, localisation: localisation, callback: handleCallback(group) }));
        });
    };
    var renderShowMoreBtn = function () {
        var _a;
        if (!paginationEnabled ||
            ((_a = data.catalogueData) === null || _a === void 0 ? void 0 : _a.length) <= addonConstants.DEFAULT_SHOW_ADDONS_COUNT)
            return null;
        var getShowMoreText = function () {
            switch (paginationBehaviour) {
                case EPaginationBehaviour.SHOW_ALL: {
                    if (isDisplayedMore) {
                        return t(ELocalisation.ACTION_BUTTON_SHOW_LESS);
                    }
                    return t(ELocalisation.ACTION_BUTTON_SHOWMORE);
                }
                default: {
                    return t(ELocalisation.ACTION_BUTTON_SHOWMORE);
                }
            }
        };
        return (React__default["default"].createElement(web.Row, { center: "xs" },
            React__default["default"].createElement(web.Button, { "data-testid": "show-more-button", secondary: "true", center: "xs", onClick: showMoreAddons }, getShowMoreText())));
    };
    return (React__default["default"].createElement(ConfigContext.Provider, { value: config },
        React__default["default"].createElement(web.Text, { type: "header" }, t(ELocalisation.ADDONS_CATALOGUE_TITLE)),
        (data.catalogueData || []).length > 0 ? (renderCatalogue()) : (React__default["default"].createElement("h1", null, t(ELocalisation.ADDONS_NOT_FOUND)))));
};

exports.Accessories = Accessories;
exports.AddToCart = AddToCart;
exports.AddonsCatalogue = AddonsCatalogue;
exports.EquipmentCard = EquipmentCardWithoutColumn;
exports.OrderSummary = OrderSummary;
exports.PRODUCT_CATALOG = PRODUCT_CATALOG;
exports.PlansCardCarousel = PlansCardCarousel;
exports.ProductCatalogue = ProductCatalogue;
exports.ProductDetails = ProductDetailsWrapper;
exports.ProductList = ProductList;
exports.scrollToSection = scrollToSection;
